import { h, Component, Fragment } from 'preact';
import { useState, useEffect, useContext, useRef } from "preact/hooks";
import { route } from "preact-router";

import axios from "axios";
import toastr from "toastr";
import moment from "moment";
import io from 'socket.io-client';
import imageCompression from 'browser-image-compression';
import { State, City } from 'country-state-city';
import pincodeDirectory from 'india-pincode-lookup';

import PDFSTYLE from "../../lib/pdfGenerationConfig";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import CONSTANTS from '../../lib/constants';
import { callAPI, reportException, generateCancelTokenSource } from '../../lib/transceiver';
import { setItem, getItem, removeAll } from '../../lib/myStore';
import { modelMapping, getInitials, getDay, getMonth, getFormattedAmount, typeOfEnquiryMappingClassColor, deepCopy, fuelTypeMapper, isAllowedFileType, debounce, getDifferenceInDays, vinNumberValidation, downloadCSV, formatDateTime , getCitiesOfStateWithExtras, digitalPanelAccess} from '../../lib/utils';
import { sendNotification } from '../../lib/sendNotification';

import creta from "../../assets/images/Hyundai-Creta.jpeg";
import alcazar from "../../assets/images/alcazer.jpg";
import santro from "../../assets/images/santro.jpg";
import aura from "../../assets/images/aura.jpg";
import venue from "../../assets/images/venue.jpeg";
import nextGenVerna from "../../assets/images/verna.jpg";
import allNewi20 from "../../assets/images/i20.jpg";
import elantra from "../../assets/images/verna.jpg";
import grandi10Nios from "../../assets/images/i10.jpg";
import i20Nline from "../../assets/images/i20NLine.jpg";
import hyundaikona from "../../assets/images/kona.jpeg";
import tucson from "../../assets/images/tuscon.jpg";
import HyundaiXcent from "../../assets/images/xcentprime.png";
import hyundaiX from "../../assets/images/hyundaiX.jpeg";
import hyundaiLogo from "../../assets/images/hyundai_logo_check.jpeg";
import carLogo from "../../assets/images/car.png";

import { ACTIONS } from "../../components/reducerStore";
import { Modal, ModalBody } from '../../components/rightDrawer';
import { Home, Search, Clipboard, Cases, AddCall, PriceList, AddCase, ReceivePayment, Folder, Hyundai, Finance, Car, Accessories, Insurance, Vas, OngoingCall, Target, Visit, Courior, Rupee, Vas2, Chair2, RoundStar, ViewedRecently, Calculator, Approval, NuclearTaskIcon, Upload, VB, Generate, AddCallV2, ChatIcon, Notification, Stock, AddCaseV2, Digital, AllV2 } from '../../components/svgs';
import { NewPopupModal, NewPopupModalBody } from '../../components/newPopupModal';
import CreateEditForm from '../../components/createEditForm';
import FormWizard from '../../components/formWizard';
import SemiInfoDetailCard from '../../components/semiInfoDetailCard';
import SemiInfoDetailCardV2 from '../../components/semiInfoDetailCardV2';
import SearchInputSuggestion from '../../components/searchInputSuggestion';
import CallingCard from "../../components/callingCard";
import Createvisitmodal from "../../components/createvisitmodal";
import Courierworkspacemodal from "../../components/courierworkspacemodal";
import ContextOne from "../../components/context";
import DraggableCalculator from '../../components/draggableCalculator';
import RecentlyViewed from '../../components/recentlyViewed';
import TicketGeneration from '../../components/ticketGeneration';
import TicketGenerationV2 from '../../components/ticketGenerationV2';
import ShowNotification from '../../components/showNotification';
import SocketAlert from '../../components/socketAlert';
import AddNuclearTaskModal from '../../components/addNuclearTaskModal';
import StockRightDrawer from '../../components/stockRightDrawer';
import NewListV2 from '../../components/newListV2';
import TaskErrorModal from "../../components/taskErrorModal";
import ReceivePaymentModal from "../../components/receivePaymentModal";

const awsBucketLink = "https://price-list-kdms-v1-tech.s3.ap-south-1.amazonaws.com";
/*
  Modification: Added socketio
  By: Komal Wable
  Date: 18/04/2023
*/

const RightPanel = (props) => {
  const fileName = 'rightPanel';
  let userInfo = getItem('userinfo');
  const socket = io(`${CONSTANTS.SOCKETAPI_URL}`);
  /*********************************************************************************/
  let videoTypeExtension = ['mov', 'mp4', 'mkv', 'm4v', 'mpeg', 'webm'];
  let audioTypeExtension = ['mp3', 'aac', 'm4a', 'f4a', 'ogg', 'oga'];
  let documentTypeExtension = ['ppt', 'pdf', 'docx'];
  let imageTypeExtension = ['png', 'jpg', 'jpeg', 'gif'];
  let fileTypeExtension = ['csv'];
  let storedFileCsv;
  let errorCountFile;
  let failRecordCount;
  let failRecordDetails;
  let endorsementTypes = {
    // ncbCertificate: 'New NCB',
    cancellationApproval: 'Cancellation',
    ncbCertificate: 'NCB Refund',
    correction: 'Correction',
    accessories: 'Accessories',
    cng: 'CNG',
    newVehicleNo: 'New vehicle no',
    ncbRecoveryRequest: 'NCB Recovery',
    ownerTransfer: 'Owner Transfer'
  };
  const todaysDate = new Date();
  let [isOpenCaseFormPopover, setIsOpenCaseFormPopover] = useState(false);
  let [isEditCaseFormPopover, setIsEditCaseFormPopover] = useState(false);
  let [searchResults, setSearchResults] = useState([]);
  let [createInsuranceCaseLoader, setCreateInsuranceCaseLoader] = useState(false);
  let [endorsementLoader, setEndorsementLoader] = useState(false);
  let [endorsementObj, setEndorsementObj] = useState({
    searchQuery: '',
    endorsementFileID: '',
    endorsementRemark: '',
    ncbCertificateID: '',
    isNoClaimBonus: '',
    typeOfEndorsement: '',
    typeOfCase: '',
    selectedManagerID: '',
    endorsementFileIDSignedURL: '',
    ncbCertificateIDSignedURL: '',
    reasonForNCBRecovery: '',
    recoveryAmount: 0,
    cancellationReason: '',
    otherCancellationReason: '',
    ncbPercentage: 0,
    endorsementRequestDate: null,
    chargesPercentage: '',
    ownerTransferDate: null,
    paymentMode: '',
    transactionID: '',
    paymentDate: null,
    invoiceDate: null,
    vehicleNumber: '',
    checkingDate: null,
    mailSentDate: null,
    callDate: null,
    insuranceCompany: '',
    approvalDate: null,
    cancelChequeID: '',
    cancelChequeIDSignedURL: '',
    panID: '',
    panIDSignedURL: '',
    electricityBillID: '',
    electricityBillIDSignedURL: '',
    nomineePanID: '',
    nomineePanIDSignedURL: '',
    sanctionLetterID: '',
    sanctionLetterIDSignedURL: '',
    accessoriesInvoiceID: '',
    accessoriesInvoiceIDSignedURL: '',
    inspectionPhotoID: '',
    inspectionPhotoIDSignedURL: '',
    inspectionReportID: '',
    inspectionReportIDSignedURL: '',
    rcCopyID: '',
    rcCopyIDSignedURL: '',
    paymentProofID: '',
    paymentProofIDSignedURL: '',
    bextractCopyID: '',
    bextractCopyIDSignedURL: '',
    cngInvoiceID: '',
    cngInvoiceIDSignedURL: '',
    phoneBillID: '',
    phoneBillIDSignedURL: '',
    nameCorrection: false,
    addressCorrection: false,
    nomineeNameCorrection: false,
    relationCorrection: false,
    hypoticationCorrection: false,
    emailCorrection: false,
    accessoriesCost: 0
  });
  let [isCreateEditFormPopover, setIsCreateEditFormPopover] = useState(false); // state to check if any process is selected to edit or to create new process and show CreateEditForm
  let [formOperation, setFormOperation] = useState();
  let [formEntityName, setFormEntityName] = useState();
  let [formEntityObject, setFormEntityObject] = useState(); // state to store data of selected process object
  let [formDynamicProps, setFormDynamicProps] = useState();
  let [isComponentFormUpdated, setIsComponentFormUpdated] = useState(false);
  let [isEntityFormObjectUpdated, setIsEntityFormObjectUpdated] = useState(false);
  let [currentUpdatedPropName, setCurrentUpdatedPropName] = useState('');
  let formValidation = false;
  let requestTypes = {
    // policy: "Policy Endorsement",
    // ncbCertificate: "New NCB",
    ncbRecoveryRequest: "NCB Recovery",
    cancellationApproval: "Cancellation",
    ncbCertificate: "NCB Refund",
    correction: "Correction",
    ownerTransfer: "Owner Transfer",
    accessories: "Accessories",
    cng: "CNG",
    newVehicleNo: "New vehicle no.",
  };
  let [pathName, setPathName] = useState(window.location.pathname);
  let [caseDetail, setCaseDetail] = useState("New");
  /*********************************************************************************/
  let [isPriceListModalOpen, setIsPriceListModalOpen] = useState(false);
  let [disablePDFButton, setDisablePDFButton] = useState(true);
  let [modelVariantName, setModelVariantName] = useState('');
  let [isFormUpdated, setIsFormUpdated] = useState(false);
  let [actions, setActions] = useState([{
    dynamicProps: []
  }]);
  let [allnewi20tableHeader, setAllNewi20TableHeader] = useState([
    { text: '', alignment: "center", fontSize: 18, bold: false }]);
  let [carVariantTableData, setCarVariantTableData] = useState([{ text: "PARTICULARS", bold: false }]);
  let [pdfWidthForCarVariant, setPdfWidthForCarVariant] = useState([]);
  let [pdfWidthForCarVariantDiesel, setPdfWidthForCarVariantDiesel] = useState([]);
  let [pdfWidthForCarVariantCNG, setPdfWidthForCarVariantCNG] = useState([]);
  let [pdfWidthForCarVariantEV, setPdfWidthForCarVariantEV] = useState([]);
  let [exShowroomTableData, setExShowroomTableData] = useState([{ text: "EX - SHOWROOM PRICE", bold: false }]);
  let [tcsExShowroomTableData, setTcsExShowroomTableData] = useState([{ text: "TCS 1% EX-SHOWROOM", bold: false }]);
  let [insuranceTableData, setInsuranceTableData] = useState([{ text: "INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", bold: false }]);
  let [rtoCompanyTableData, setRtoCompanyTableData] = useState([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Company', bold: false }]);
  let [rtoBHPassingTableData, setRtoBHPassingTableData] = useState([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing', bold: false }]);
  let [rtoIndividualTableData, setRtoIndividualTableData] = useState([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Individual', bold: false }]);
  let [fourFifthExtendedWarrantyTableData, setFourFifthExtendedWarrantyTableData] = useState([{ text: '4th & 5th YEAR EXTENDED WARRANTY', bold: false }]);
  let [rmkTableData, setRmkTableData] = useState([{ text: 'RMK', bold: false }]);
  let [basicAccessoriesKitTableData, setBasicAccessoriesKitTableData] = useState([{ text: 'BASIC ACCESSORIES KIT', bold: false }]);
  let [rsaTableData, setRsaTableData] = useState([{ text: 'RSA', bold: false }]);
  let [additionalPremiumForEngineProtectionTableData, setAdditionalPremiumForEngineProtectionTableData] = useState([{ text: 'ADDL PREMIUM FOR ENGINE PROTECTION', bold: false }]);
  let [additionalPremiumforReturnToInvoiceTableData, setAdditionalPremiumforReturnToInvoiceTableData] = useState([{ text: 'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', bold: false }]);
  let [totalIndividualTableData, setTotalIndividualTableData] = useState([{ text: 'TOTAL INDIVIDUAL', bold: false }]);
  let [totalCompanyTableData, setTotalCompanyTableData] = useState([{ text: 'TOTAL COMPANY', bold: false }]);
  let [sheildOfTrustTableData, setSheildOfTrustTableData] = useState([{ text: 'T5 YR/60K SHIELD OF TRUST', bold: false }]);
  let [effectiveDateFrom, setEffectiveDateFrom] = useState([{ text: 'Effective Date From', bold: false }]);
  let [effectiveDateCNGFrom, setEffectiveDateCNGFrom] = useState([{ text: 'Effective Date From', bold: false }]);
  let [effectiveDateDieselFrom, setEffectiveDateDieselFrom] = useState([{ text: 'Effective Date From', bold: false }]);
  let [effectiveDateEVFrom, setEffectiveDateEVFrom] = useState([{ text: 'Effective Date From', bold: false }]);


  let [catalogueCarVariantDiesel, setCatalogueCarVariantDiesel] = useState([]);
  let [solidColourTableHeader, setSolidColourTableHeader] = useState([{ text: 'COLOUR : SOLID COLOUR = ', bold: false }]);
  let [solidColourDieselTableData, setSolidColourDieselTableData] = useState([{ text: 'COLOUR : SOLID COLOUR = ', bold: false }]);
  let [solidColourCNGTableData, setSolidColourCNGTableData] = useState([{ text: 'COLOUR : SOLID COLOUR = ', bold: false }]);
  let [solidColourEVTableData, setSolidColourEVTableData] = useState([{ text: 'COLOUR : SOLID COLOUR = ', bold: false }]);
  let [noCashPaymentTableHeader, setNoCashPaymentTableHeader] = useState([{ text: 'Note : NO CASH PAYMENT ABOVE RS 200000/- WILL BE ACCEPTED', bold: false }]);
  let [termsAndConitionsTableHeader, setTermsAndConitionsTableHeader] = useState([{ text: 'Terms & Conditions Details Overleaf', bold: false }]);
  let [termsAndConditionsTableData, setTermsAndConitionsTableData] = useState([{ text: 'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi', bold: false }]);
  let [termsAndConditionsDetailsTableData, setTermsAndConitionsDetailsTableData] = useState([{
    bold: false,
    fontSize: 12,
    ol: [
      // 'Payment by DD/PO to be drawn in the name of KOTHARI CARS PVT.LTD payable at Pune.',
      // "Customer request is not to pay any advance / part payment in cash to the consultant. Any such trasaction's done will be customer at his own risk for which company will not be responsible.",
      // "The prices mentioned are  subject to change without  prior notice and will be charged as applicable  at the time of Registration / delivery.",
      // "Model specifiction, features & Colours are subject to change without prior notice.",
      // "Delivery - Subject to realisation of  DD / Cheque.",
      // "RMK=Cost of Rubber Mat kit include GST. +RSA -Road Service assistance include GST for 1 year",
      // "Subject to jurisdiction of Pune Court only",
      // "Two schemes cannot be clubbed together.",
      // "Basic Accessories Kit Not Included Labour Charges",
      // "Hyundai Motor India Ltd. reserves the right to change the booking procedure","equipment specifications and discontinue models without notice.",
      // "Force majeure clause would be applicable to all deliveries.",
      // "The retail schemes (If Any) given alongwith this pricelist will be applicable on the physical stock and scheme period only.",
      // "Retail scheme,Price applicable will be valid only on receipt of full Ex showroom price. ",
      // "The Insurance premium is calculated @ 95 %of Exshowroom Price.",
      // "Incase of cancellation of booking, Cancellation charges will be charged as per written in  booking form",
      // "Income tax Pan no and address proof in original are necessary at the time of Booking.",
      // "Purchase of Insurance Policy and Accessories from Dealer are optional.",
      // "Value of discount given shall be netted off from the vehicle invoice amount, insurance and registration.",
      // "Vechicle Register in PCMC or OUT Side area then CRTM Charges Rs. 200 Extra.",
      // "Extended Warranty & Miscellaneous Expenses amount includes GST @ 18%",              "RTO tax 2% charged extra as per intinmated by RTO department will be applied as per confirmation receive by RTO department as the time registation.",              "Shield of Trust Price for 5yr/60 km inclusing GST 18% also this product get single year also"
    ]

  }]);
  let [ShowroomITableData, setShowroomITableData] = useState([{ text: 'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.', bold: false }]);
  let [ShowroomIITableData, setShowroomIITableData] = useState([{ text: 'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.', bold: false }]);
  let [ShowroomIIITableData, setShowroomIIITableData] = useState([{ text: 'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100', bold: false }]);
  let [ShowroomIVTableData, setShowroomIVTableData] = useState([{ text: 'Showroom IV: Gat No. 15,49/1 , Nagar-Pune road, Opp Manikchand Company, Saradwadi, Shirur 412210 Phone 02138-602525', bold: false }]);
  let [ShowroomVTableData, setShowroomVTableData] = useState([{ text: "Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205", bold: false }]);
  let [ShowroomVITableData, setShowroomVITableData] = useState([{ text: "Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.", bold: false }]);
  let [work1TableData, setWork1TableData] = useState([{ text: 'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96', bold: false }]);
  let [work2TableData, setWork2TableData] = useState([{ text: 'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ', bold: false }]);
  let [work3TableData, setWork3TableData] = useState([{ text: 'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506', bold: false }]);
  let [work4TableData, setWork4TableData] = useState([{ text: 'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ', bold: false }]);
  let [depotTableData, setDepotTableData] = useState([{ text: 'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ', bold: false }]);

  let [modelDieseltableHeader, setModelDieselTableHeader] = useState([{ text: '', alignment: "center", fontSize: 18, bold: false }]);
  let [carVariantDieselTableData, setCarVariantDieselTableData] = useState([{ text: "PARTICULARS", bold: false }]);
  let [exShowroomDieselTableData, setExShowroomDieselTableData] = useState([{ text: "EX - SHOWROOM PRICE", bold: false }]);
  let [tcsExShowroomDieselTableData, setTcsExShowroomDieselTableData] = useState([{ text: "TCS 1% EX-SHOWROOM", bold: false }]);
  let [insuranceDieselTableData, setInsuranceDieselTableData] = useState([{ text: "INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", bold: false }]);
  let [rtoCompanyDieselTableData, setRtoCompanyDieselTableData] = useState([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Company', bold: false }]);
  let [rtoIndividualDieselTableData, setRtoIndividualDieselTableData] = useState([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Individual', bold: false }]);
  let [rtoBHPassingDieselTableData, setRtoBHPassingDieselTableData] = useState([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR BH Passing', bold: false }]);
  let [fourFifthExtendedWarrantyDieselTableData, setFourFifthExtendedWarrantyDieselTableData] = useState([{ text: '4th & 5th YEAR EXTENDED WARRANTY', bold: false }]);
  let [rmkDieselTableData, setRmkDieselTableData] = useState([{ text: 'RMK', bold: false }]);
  let [basicAccessoriesKitDieselTableData, setBasicAccessoriesKitDieselTableData] = useState([{ text: 'BASIC ACCESSORIES KIT', bold: false }]);
  let [rsaDieselTableData, setRsaDieselTableData] = useState([{ text: 'RSA', bold: false }]);
  let [additionalPremiumForEngineProtectionDieselTableData, setAdditionalPremiumForEngineProtectionDieselTableData] = useState([{ text: 'ADDL PREMIUM FOR ENGINE PROTECTION', bold: false }]);
  let [additionalPremiumforReturnToInvoiceDieselTableData, setAdditionalPremiumforReturnToInvoiceDieselTableData] = useState([{ text: 'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', bold: false }]);
  let [totalIndividualDieselTableData, setTotalIndividualDieselTableData] = useState([{ text: 'TOTAL INDIVIDUAL', bold: false }]);
  let [totalCompanyDieselTableData, setTotalCompanyDieselTableData] = useState([{ text: 'TOTAL COMPANY', bold: false }]);
  let [sheildOfTrustDieselTableData, setSheildOfTrustDieselTableData] = useState([{ text: 'T5 YR/60K SHIELD OF TRUST', bold: false }]);


  let [catalogueCarVariantCNG, setCatalogueCarVariantCNG] = useState([]);
  let [modelCNGtableHeader, setModelCNGTableHeader] = useState([{ text: '', alignment: "center", fontSize: 18, bold: false }]);
  let [carVariantCNGTableData, setCarVariantCNGTableData] = useState([{ text: "PARTICULARS", bold: false }]);
  let [exShowroomCNGTableData, setExShowroomCNGTableData] = useState([{ text: "EX - SHOWROOM PRICE", bold: false }]);
  let [tcsExShowroomCNGTableData, setTcsExShowroomCNGTableData] = useState([{ text: "TCS 1% EX-SHOWROOM", bold: false }]);
  let [insuranceCNGTableData, setInsuranceCNGTableData] = useState([{ text: "INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", bold: false }]);
  let [rtoCompanyCNGTableData, setRtoCompanyCNGTableData] = useState([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Company', bold: false }]);
  let [rtoIndividualCNGTableData, setRtoIndividualCNGTableData] = useState([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Individual', bold: false }]);
  let [rtoBHPassingCNGTableData, setRtoBHPassingCNGTableData] = useState([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR BH Passing', bold: false }]);
  let [fourFifthExtendedWarrantyCNGTableData, setFourFifthExtendedWarrantyCNGTableData] = useState([{ text: '4th & 5th YEAR EXTENDED WARRANTY', bold: false }]);
  let [rmkCNGTableData, setRmkCNGTableData] = useState([{ text: 'RMK', bold: false }]);
  let [basicAccessoriesKitCNGTableData, setBasicAccessoriesKitCNGTableData] = useState([{ text: 'BASIC ACCESSORIES KIT', bold: false }]);
  let [rsaCNGTableData, setRsaCNGTableData] = useState([{ text: 'RSA', bold: false }]);
  let [additionalPremiumForEngineProtectionCNGTableData, setAdditionalPremiumForEngineProtectionCNGTableData] = useState([{ text: 'ADDL PREMIUM FOR ENGINE PROTECTION', bold: false }]);
  let [additionalPremiumforReturnToInvoiceCNGTableData, setAdditionalPremiumforReturnToInvoiceCNGTableData] = useState([{ text: 'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', bold: false }]);
  let [totalIndividualCNGTableData, setTotalIndividualCNGTableData] = useState([{ text: 'TOTAL INDIVIDUAL', bold: false }]);
  let [totalCompanyCNGTableData, setTotalCompanyCNGTableData] = useState([{ text: 'TOTAL COMPANY', bold: false }]);
  let [sheildOfTrustCNGTableData, setSheildOfTrustCNGTableData] = useState([{ text: 'T5 YR/60K SHIELD OF TRUST', bold: false }]);


  let [catalogueCarVariantEV, setCatalogueCarVariantEV] = useState([]);
  let [modelEVtableHeader, setModelEVTableHeader] = useState([{ text: '', alignment: "center", fontSize: 18, bold: false }]);
  let [carVariantEVTableData, setCarVariantEVTableData] = useState([{ text: "PARTICULARS", bold: false }]);
  let [exShowroomEVTableData, setExShowroomEVTableData] = useState([{ text: "EX - SHOWROOM PRICE", bold: false }]);
  let [tcsExShowroomEVTableData, setTcsExShowroomEVTableData] = useState([{ text: "TCS 1% EX-SHOWROOM", bold: false }]);
  let [insuranceEVTableData, setInsuranceEVTableData] = useState([{ text: "INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", bold: false }]);
  let [rtoCompanyEVTableData, setRtoCompanyEVTableData] = useState([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Company', bold: false }]);
  let [rtoIndividualEVTableData, setRtoIndividualEVTableData] = useState([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Individual', bold: false }]);
  let [rtoBHPassingEVTableData, setRtoBHPassingEVTableData] = useState([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR BH Passing', bold: false }]);
  let [fourFifthExtendedWarrantyEVTableData, setFourFifthExtendedWarrantyEVTableData] = useState([{ text: '4th & 5th YEAR EXTENDED WARRANTY', bold: false }]);
  let [rmkEVTableData, setRmkEVTableData] = useState([{ text: 'RMK', bold: false }]);
  let [basicAccessoriesKitEVTableData, setBasicAccessoriesKitEVTableData] = useState([{ text: 'BASIC ACCESSORIES KIT', bold: false }]);
  let [rsaEVTableData, setRsaEVTableData] = useState([{ text: 'RSA', bold: false }]);
  let [additionalPremiumForEngineProtectionEVTableData, setAdditionalPremiumForEngineProtectionEVTableData] = useState([{ text: 'ADDL PREMIUM FOR ENGINE PROTECTION', bold: false }]);
  let [additionalPremiumforReturnToInvoiceEVTableData, setAdditionalPremiumforReturnToInvoiceEVTableData] = useState([{ text: 'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', bold: false }]);
  let [totalIndividualEVTableData, setTotalIndividualEVTableData] = useState([{ text: 'TOTAL INDIVIDUAL', bold: false }]);
  let [totalCompanyEVTableData, setTotalCompanyEVTableData] = useState([{ text: 'TOTAL COMPANY', bold: false }]);
  let [sheildOfTrustEVTableData, setSheildOfTrustEVTableData] = useState([{ text: 'T5 YR/60K SHIELD OF TRUST', bold: false }]);

  let [catalogueCarVariant, setCatalogueCarVariant] = useState([]);
  let [priceListForPmc, setPriceListForPmc] = useState([{ text: 'PRICE LIST FOR KDMS', fontSize: 18, bold: false, alignment: "center" }]);
  let [PDFCarImages, setPDFCarImages] = useState("");
  let [isOpenFormPopover, setIsOpenFormPopover] = useState(false);
  let [callResponse, setCallResponse] = useState('');
  let [callResponseText, setCallResponseText] = useState('');
  let [callResponseObj, setCallResponseObj] = useState({});
  let [callResponseData, setCallResponseData] = useState('');
  let [isFollowUpModalOpen, setFollowUpModalOpen] = useState(false);
  let [isReceivePaymentModalOpen, setReceivePaymentModalOpen] = useState(false);
  let [isCallModalOpen, setCallModalOpen] = useState(false);
  const [isCallNumberRejected, setIsCallNumberRejected] = useState(false);
  const [callNumberValidationError, setCallNumberValidationError] = useState('');
  const [isNewCallSubmitting, setIsNewCallSubmitting] = useState(false);
  const [ongoingCallID, setOngoingCallID] = useState('');
  const [currentCallStatus, setCurrentCallStatus] = useState('');
  const [isCallFinished, setIsCallFinished] = useState(false);
   const [callTimes, setCallTimes] = useState({});
  let [isCreateCaseModalOpen, setCreateCaseModalOpen] = useState(false);
  let [isCaseCreationLoaderShown, setCaseCreationLoader] = useState(false);
  let [isCaseCreated, setIsCaseCreated] = useState(false);
  let [isViewCreatedCaseModalOpen, setIsViewCreatedCaseModalOpen] = useState(false);
  let [createdCase, setCreatedCase] = useState({});
  let [createdInteraction, setCreatedInteraction] = useState({});
  let [contactCreatedUuid, setContactCreatedUuid] = useState('')
  let [contactData, setContactData] = useState({});
  let [salutation, setSalutation] = useState('Mr.');
  let [customerName, setCustomerName] = useState('');
  let [lastName, setCustomerLastName] = useState('');
  /*
    Bug: T1687 - 24 - Add New Case - Middle Name field - Middle Name field is missing
    Modification: Added state for middleName
    By: Devang
    Date: 10/04/2024
  */
  let [customerMiddleName, setCustomerMiddleName] = useState('');
  let [typeOfCase, setTypeOfCase] = useState('');
  let [contactList, setContactList] = useState([]);
  let [mobileNumberEntered, setMobileNumberEntered] = useState('');
  let [verificationCodeField, setVerificationCodeField] = useState(false);
  let [mobNumber, setMobNumber] = useState(null);
  let [verificationOTP, setVerificationOTP] = useState('');
  let [mobileVerificationResendButton, setMobileVerificationResendButton] = useState(false);
  let [disableVerificationMessageButton, setDisableVerificationMessageButton] = useState(false);
  let [VerificationCodeMesage, setVerificationCodeMesage] = useState(false);
  let [disableResendButtonMobile, setDisableResendButtonMobile] = useState(false);
  let [isSubmitDisable, setIsSubmitDisable] = useState(true);
  let [assignedTo, setAssignedTo] = useState('');
  let [disableMobileVerifyButton, setDisableMobileVerifyButton] = useState(true);
  let [assignUserList, setAssignUserList] = useState([]);
  let [currentTask, setCurrentTask] = useState({});
  let [selectedModel, setSelectedModel] = useState('');
  let [currentAction, setCurrentAction] = useState({});
  let [interactionObj, setInteraction] = useState({});
  let [listofManufacturers, setListOfManufacturers] = useState([])
  let [exchangEvaluators, setExchangeEvaluators] = useState([]);
  let [creList, setCREList] = useState([]);
  let [offers, setOffers] = useState([]);
  let [schemes, setSchemes] = useState([]);
  let [scDetails, setScDetails] = useState({});
  let [cartNumber, setCartNumber] = useState(0);
  let [lastQuotation, setLastQuotation] = useState({});
  let [catalogoueItemList, setCatalogoueItemList] = useState([]);
  let [modelsList, setModelsList] = useState([]);
  let [isCallOriginated, setIsCallOriginated] = useState(false);
  let [isCallOriginatedByUser, setIsCallOriginatedByUser] = useState(false);
  let [testDriveCars, setTestDriveCars] = useState([]);
  let [accessoriesList, setAccessoriesList] = useState([]);
  let [assignResposiblePerson, setAssignResposiblePerson] = useState('');
  let [branchName, setBranchName] = useState('');
  let [selectedArrayForDynamicProps, setSelectedArrayForDynamicProps] = useState([]);
  let [selectedActionIndex, setSelectedActionIndex] = useState(0);
  let [cartValue, setCartValue] = useState(0);
  let [assignToType, setAssignToType] = useState('');
  let [isFormEditable, setIsFormEditable] = useState(true);
  let [cases, setCases] = useState([]);
  let [selectedCase, setSelectedCase] = useState('');
  let [selectedCaseObj, setSelectedCaseObj] = useState({});
  let [followupDate, setFollowupDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
  let [isFollowupDone, setIsFollowupDone] = useState(false);
  let [remark, setRemark] = useState('');
  let [dynamicProps, setDynamicProps] = useState([]);
  let [completedActions, setCompletedActions] = useState([]);
  let [dynamicPropsData, setDynamicPropsData] = useState([]);
  let [dynamicPropsWithValues, setDynamicPropsWithValues] = useState([]);
  let [progress, setProgress] = useState(0);
  let [isScrolledToTheBottom, setIsScrolledToTheBottom] = useState(false);
  let [areaList, setAreaList] = useState([]);
  let [userDesignation, setUserDesignation] = useState(userInfo.userDesignation ? userInfo.userDesignation : '');
  let [userDepartmentName, setUserDepartmentName] = useState(userInfo.userDepartmentName ? userInfo.userDepartmentName : '');
  /*
    BN:959
    Modification: Role-wise right panel access for Digital team
    Date: 15/10/26
    By: Priya
  */
  // null => not a digital role, so every tab keeps its existing behaviour
  const digitalRightAccess = digitalPanelAccess(userDesignation, userDepartmentName, 'right');
  const hasDigitalRightAccess = (tab) => !digitalRightAccess || digitalRightAccess.includes(tab);

  let [triggeredUnassignedTaskList, setTriggeredUnassignedTaskList] = useState([])
  const [isOpenAssignUsersTriggeredTask, setIsOpenAssignUsersTriggeredTask] = useState(false);
  const [modelForPriceList, setModelForPriceList] = useState('');
  /*
    Bug: T1738 - BG_FN: Data is auto populated when add new case is added - Remark, Dealer code
    Modification: Commented action and added name key-value instead
    By: Devang
    Date: 15/04/2024
  */
  let [caseTypes, setCaseTypes] = useState([
    {
      icon: 'Hyundai', identifier: "Hyundai-Card", text: 'Vehicle', cardBgColor: '#dbeae1', classes: 'bg-light-grey',
      // action: (e) => setCaseType(e, 'Hyundai')
      name: 'Hyundai'
    },
    {
      icon: 'Finance', identifier: "Finance-Card", text: 'Finance', cardBgColor: '#dbeae1', classes: 'bg-light-grey',
      // action: (e) => setCaseType(e, 'Finance')
      name: 'Finance'
    },
    {
      icon: 'Accessories', identifier: "Accessories-Card", text: 'Accessories', cardBgColor: '#dbeae1', classes: 'bg-light-grey',
      // action: (e) => setCaseType(e, 'Accessories')
      name: 'Accessories'
    },
    {
      icon: 'Car', identifier: "Car-Card", text: 'Used Car', cardBgColor: '#ececec', classes: 'bg-light-grey',
      // action: (e) => setCaseType(e, 'Car')
      name: 'Car'
    },
    {
      icon: 'Vas2', identifier: "Vas-Card", text: 'VAS', cardBgColor: '#ececec', classes: 'bg-light-grey',
      // action: (e) => setCaseType(e, 'Vas')
      name: 'Vas'
    }
  ]);
  let [selectedCaseTypes, setSelectedCaseTypes] = useState([]);
  let [type, setType] = useState('First Time Buyer');
  let [isCaseTypeSelected, setIsCaseTypeSelected] = useState(false);
  let [referredBy, setRefferedBy] = useState(userInfo.displayName);
  let [dealerCode, setDealerCode] = useState('');
  let [wantsPriceList, setWantsPriceList] = useState(false);
  let [isVIPCustomer, setIsVIPCustomer] = useState(false);
  let [wantsBrochure, setWantsBrochure] = useState(false);
  let [skipPayment, setSkipPayment] = useState(false);
  let [model, setModel] = useState('');
  let [variantList, setVariantList] = useState([])
  let [fuelTypes, setFuelTypes] = useState([])
  let [selectedVariant, setSelectedVariant] = useState([])
  let [typeOfFuel, setTypeOfFuel] = useState('')
  let [variant, setVariant] = useState('')
  let [CNGCarVariant, setCNGCarVariant] = useState(false);
  let [isOngoingCallWindowOpen, setOngoingCallWindowOpen] = useState(false);
  let [isOngoingCallWindowClose, setOngoingCallWindowClose] = useState(false);
  let [reasonForCalling, setReasonForCalling] = useState('');
  let [followUpFor, setFollowUpFor] = useState('');
  let [isGlobalSearchVisible, setIsGlobalSearchVisible] = useState(false);
  let [isVisitModalOpen, setVisitModalVisibility] = useState(false);
  let [isDigitalLeadModalOpen, setDigitalLeadModalVisibility] = useState(false);
  let [isCourierModalOpen, setCourierModalVisibility] = useState(false);
  let [isCalculatorModalOpen, setCalculatorModalOpen] = useState(false);
  let [isRecentlyViewedModalVisible, setRecentlyViewedModalVisibility] = useState(false);
  let [isFollowedCasesModalVisible, setFollowedCasesModalVisibility] = useState(false);

  // socket state----------------- start
  let [isLoading, setIsLoading] = useState(true);
  let [showSlideNotification, setShowSlideNotification] = useState(true);
  // let [state,dispatch] = useContext(ContextOne);
  let [nudges, setNudges] = useState('');
  let [message, setMessage] = useState('CASE created and assigned to You');
  let [isSound, setIsSound] = useState(false);
  let [isAcknowledge, setIsAcknowledge] = useState(false);
  let [socketTriggeredFor, setSocketTriggeredFor] = useState('alert');
  // socket state-----------------end

  const [isAddNuclearTaskModalVisible, setIsAddNuclearTaskModalVisible] = useState(false);
  /****************************************************************************/
  let [typeOfCaseInsurance, setTypeOfCaseInsurance] = useState('');
  /*
    Bug: T1843 - EN - Insurance -Add New Insurance Renewal Case - While adding a case System should check if VIN is already existing.
    Modification: Added states to handle vin and vin error
    By: Devang
    Date: 02/07/2024
  */
  let [vinNumber, setVinNumber] = useState('');
  let [isCaseErrorMsg, setIsCaseErrorMsg] = useState(false);

  let [isCreateInsuranceCaseModalOpen, setCreateInsuranceCaseModalOpen] = useState(false);
  let [insuranceCompanies, setInsuranceCompanies] = useState([]);
  let [stateList, setStateList] = useState(State.getStatesOfCountry('IN'));
  let [cityList, setCityList] = useState([]);
  let [cartProducts, setCartProducts] = useState([]);
  let [currentRow, setCurrentRow] = useState({});
  let [courierData, setCourierData] = useState({});
  let [testDriveQueue, setTestDriveQueue] = useState(0);
  let [selectedProducts, setSelectedProducts] = useState([]);
  let [selectedColor, setSelectedColor] = useState('');
  let [availableStock, setAvailableStock] = useState(0);
  let [allUserList, setAllUserList] = useState([])
  let [isHandoverDocket, setIsHandoverDocket] = useState(false);
  let [isEditDocket, setIsEditDocket] = useState(false);
  let [courierImgDelete, setCourierImgDelete] = useState(false)
  let [isBackModalDisable, setIsBackModalDisable] = useState(false)
  let [isNextModalDisable, setIsNextModalDisable] = useState(false)
  let [isSaveModalDisable, setIsSaveModalDisable] = useState(false);
  let [financeExecutives, setFinanceExecutives] = useState([]);
  let [isDataSaving, setIsDataSaving] = useState(false);
  let [exteriorColor, setExteriorColor] = useState('');
  let [isStockDetailModalOpen, setIsStockDetailModal] = useState(false);
  let [activeStockTab, setActiveStockTab] = useState('');
  let [selectedStockType, setSelectedStockType] = useState('');
  /*
    modification : T319 (Change Taken From Comp's caseSemiDetailViewV3) states added
    modified : Ashutosh G
    modified : 29/05/2024
  */
  const [isShowTaskCompletionError, setIsShowTaskCompletionError] = useState(false);
  const [taskCompletionErrorHeader, setTaskCompletionErrorHeader] = useState('');
  const [taskCompletionError, setTaskCompletionError] = useState('');
    /*
    BN:13
    Modification:  Duplicate Lead Popup
    By: Priya Gupta
    Date: 01/10/26
  */
  const [isDuplicateLeadModalOpen, setIsDuplicateLeadModalOpen] = useState(false);
  const [duplicateLeadInfo, setDuplicateLeadInfo] = useState({ subSource: '', creName: '', duplicateInteractions: [] });
  let [isSaveDisabled, setIsSaveDisabled] = useState(false)
  /*
    Modification: T319 (Change Taken From Comp's caseSemiDetailViewV3) - Added isBatchExists ref and debounceSave function to handle task update
    By: Ashutosh G
    Date: 29/05/2024
  */
  const isBatchExists = useRef(false);
  const [isFormToBeSaved, setIsFormToBeSaved] = useState(false);
  const isFirstTimeHandleTaskUpdateInvoke = useRef(true);

  /*
   Feature: Unsaved Changes Warning
   By: Priya Gupta
   Date: 04/08/26
 */
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showUnsavedChangesWarning, setShowUnsavedChangesWarning] = useState(false);
  const debouncedSave = useRef(debounce(() => {
    /*
      modified : Ashutosh G
      modified : 05/06/2024
      modification : preventing calling handleTaskUpdate when defining debouncedSave
    */
    if (isFirstTimeHandleTaskUpdateInvoke.current) {
      isFirstTimeHandleTaskUpdateInvoke.current = false;
      return;
    }
    handleTaskUpdate();
  }, 3000));
  const isFirstTimeFormUpdatedChange = useRef(true);

  /*
    Bug: KH_BG_676 Receptionist , Sales Consultant	Sales Case View - Click here to view all tasks	When clicked on "Click here to view all tasks" icon, the process view takes more time to load
    Modification: Added a state to determine if the case and interaction are instantiated
    By: Devang
    Date: 31/01/2024
  */
  let [isCaseInteractionInstantiated, setIsCaseInteractionInstantiated] = useState(false);

  /*
    By: Yashvi
    On: 22nd June 2024
    Loaders for searching and creating the legacy active case.
  */

  let [schedulerSearchLoader, setSchedulerSearchLoader] = useState(false);
  let [schedulerCreationLoader, setSchedulerCreationLoader] = useState(false);
  let [schedulerCaseCreatedLoader, setSchedulerCaseCreatedLoader] = useState(false);
  let [isSchedulerLegacyFormPopover, setIsSchedulerLegacyFormPopover] = useState(false);
  let [searchQuery, setSearchQuery] = useState('');
  let [schedulerLegacyCases, setSchedulerLegacyCases] = useState([]);
    /*
    Modification: User Extension required for placing a call
    By: Priya Gupta
    Date: 17/10/26
  */
  let [userExtension, setUserExtension] = useState('');
  let [isExtensionLoading, setIsExtensionLoading] = useState(false);

  let [basicAccessoriesList, setBasicAccessoriesList] = useState([
    { displayName: 'Floor Lamination', sellingCost: 4599 },
    { displayName: 'Sun Control Filming', sellingCost: 3999 },
    { displayName: 'Chrome Side Moulding', sellingCost: 2599 },
    { displayName: 'Door Scuff Plate Light', sellingCost: 3499 },
    { displayName: 'Car Body Cover', sellingCost: 1607 },
    { displayName: 'Premium Cushion Pillows', sellingCost: 1562 },
    { displayName: 'Door Edge Guard', sellingCost: 298 },
    { displayName: 'Rear Reflector Led', sellingCost: 3499 },
    { displayName: 'Door Visor', sellingCost: 1799 },
    { displayName: 'Perfume Gel', sellingCost: 404 }
  ])
  let [threeMPackages, setThreeMPackages] = useState([])
  let [shieldOfTrustPackages, setShieldOfTrustPackages] = useState([])
  let [rsaPackages, setRsaPackages] = useState([])
  let [extendedWarrantyPackages, setExtendedWarrantyPackages] = useState([])
  let [isCreateBookingCaseModalOpen, setIsCreateBookingCaseModalOpen] = useState(false);
  let [isErrorValidationInCsv, setIsErrorValidationInCsv] = useState(false);
  let [errorValidationInCsv, setErrorValidationInCsv] = useState([]);
  let [termsAndConditionsData, setTermsAndConditionsData] = useState([]);
  let [termsAndConditionsDataCNG, setTermsAndConditionsDataCNG] = useState([]);
  let [termsAndConditionsDataDiesel, setTermsAndConditionsDataDiesel] = useState([]);
  let [termsAndConditionsDataEV, setTermsAndConditionsDataEV] = useState([]);
  const [effectivePriceListDate, setEffectivePriceListDate] = useState('');
  const [duplicateRecords, setDuplicateRecords] = useState([]);
  const [isEmptyPetrolData, setIsEmptyPetrolData] = useState(false);
  const [isEmptyDieselData, setIsEmptyDieselData] = useState(false);
  const [isEmptyCNGData, setIsEmptyCNGData] = useState(false);
  const [isEmptyEVData, setIsEmptyEVData] = useState(false);

  const routeToResultRowPage = (row, entityName) => {
    window.open(`/processView/${row.uuid}`, '_blank');
  };

  function toggleEditSchedulerLegacyFormPopover(e) {
    e.preventDefault();
    setIsSchedulerLegacyFormPopover(!isSchedulerLegacyFormPopover);
    setSchedulerSearchLoader(false);
    setSchedulerCreationLoader(false);
    setSchedulerCaseCreatedLoader(false);
    setSearchQuery('');
    setSchedulerLegacyCases([]);
  }

  async function searchCaseForScheduler(type, interactionID) {
    await setSchedulerSearchLoader(true);
    try {
      let Response = await axios.get(`${CONSTANTS.API_URL}/api/v1/findCase?q=${searchQuery}`);
      await getLegacyCaseSearchResults(Response.data);
      await setSchedulerSearchLoader(false);
    } catch (HTTPException) {
      if (HTTPException && HTTPException.config && HTTPException.config.url) {
        let payload = {
          apiURL: HTTPException.config.url,
          errorObject: HTTPException,
          statusCode: (HTTPException && HTTPException.response && HTTPException.response.status) ? HTTPException.response.status : 0,
          errorMessage: HTTPException.message,
          functionName: "searchCaseForScheduler",
          fileName: "rightPanel",
          pageName: "rightPanel",
          userID: userInfo.uuid,
          userName: userInfo.displayName
        };
        await axios.post(`${CONSTANTS.API_URL}/api/v1/exception`, payload);
        await setSchedulerSearchLoader(false);
      }
      return HTTPException;
    }
  }

  const getLegacyCaseSearchResults = async (results) => {
    const rowList = results.map((row) => {
      let uuid = row.uuid;
      let caseNo = row.uniqueID;
      let customerName = row.dynamicProperties_customerName;
      let currentStage = row.currentStage;
      let owner = row.assignedToUserName ? row.assignedToUserName : row.dynamicProperties_salesConsultant;
      let openSinceDate = row.createdAt && new Date(row.createdAt);
      let openSince = row.createdAt && `${getDifferenceInDays(row.createdAt)} Days`;
      let status = row.dynamicProperties_caseStatus;
      let mobile = row.dynamicProperties_mobile ? row.dynamicProperties_mobile : '';
      let vin = row.dynamicProperties_vin ? row.dynamicProperties_vin : '';
      let registrationNo = row.dynamicProperties_registrationNo ? row.dynamicProperties_registrationNo : '';

      let obj = { uuid, caseNo, customerName, currentStage, owner, openSinceDate, openSince, status, mobile, vin, registrationNo };
      return obj;
    });

    const listObj = {
      columns: [
        { label: 'Customer Name', field: 'customerName', classes: 'w-20p' },
        { label: 'Mobile', field: 'mobile', classes: 'w-16p' },
        { label: 'Owner', field: 'owner', classes: 'w-16p' },
        { label: 'Chassis no.', field: 'vin', classes: 'w-16p' },
        { label: 'Vehicle no.', field: 'registrationNo', classes: 'w-16p' },
        { label: 'Current Stage', field: 'currentStage', classes: 'w-16p' }
      ], rows: rowList
    };
    await setSchedulerLegacyCases(listObj);

  };

    const stampCallTimes = (keys) => {
    const now = new Date();
    setCallTimes(prev => {
      const next = { ...prev };
      keys.forEach(k => { if (!next[k]) next[k] = now; });
      return next;
    });
  };

  async function runSchedulerForLegacyCase(e) {
    e.preventDefault();
    try {
      await setSchedulerCreationLoader(true);
      let Response = await axios.put(`${CONSTANTS.API_URL}/api/v1/createLegacyActiveCase/${schedulerLegacyCases.rows[0].uuid}`);
      if (Response.data && Response.data.length) {
        await setSchedulerCreationLoader(false);
        await setSchedulerCaseCreatedLoader(true);
        getLegacyCaseSearchResults(Response.data);
        toastr.info('Case Created!');
      } else {
        toastr.error('An error occured. Try again later.');
      }
    } catch (HTTPException) {
      await setSchedulerCreationLoader(false);
      if (HTTPException && HTTPException.config && HTTPException.config.url) {
        let payload = {
          apiURL: HTTPException.config.url,
          errorObject: HTTPException,
          statusCode: (HTTPException && HTTPException.response && HTTPException.response.status) ? HTTPException.response.status : 0,
          errorMessage: HTTPException.message,
          functionName: "generateQuotation",
          fileName: "rightPanel",
          pageName: "rightPanel",
          userID: userInfo.uuid,
          userName: userInfo.displayName
        };
        await axios.post(`${CONSTANTS.API_URL}/api/v1/exception`, payload);
      }
      return HTTPException;
    }
  }

  /* Add source and sub-source in create case modal */
  let [source, setSource] = useState('');
  let [subSources, setSubSources] = useState([]);
  let [subSubSources, setSubSubSources] = useState([]);
  let [subSource, setSubSource] = useState('');
  let [subSubSource, setSubSubSource] = useState('');

  /* End of Add source and sub-source in create case modal*/

  function scrollToTheBottom(elementName) {
    let element = document.getElementById(elementName);
    // element.scrollTop = element.scrollHeight;
    element.scrollTo({
      top: element.scrollHeight,
      behavior: 'smooth',
    })
  }

  async function getAreaByPincode(pincode, field) {
    let areaList = pincodeDirectory.lookup(pincode);
    await setAreaList(areaList);
  }

  async function toggleInsuranceCreateCaseModal(e) {
    if (isCreateInsuranceCaseModalOpen) {
      setTypeOfCaseInsurance('');
      /*
        Bug: T1843 - EN - Insurance -Add New Insurance Renewal Case - While adding a case System should check if VIN is already existing.
        Modification: Added setstates to reset vin and vin error
        By: Devang
        Date: 02/07/2024
      */
      setIsCaseErrorMsg(false);
      setVinNumber('');
    } else {
      let catalogoueItemResponse = await axios.get(`${CONSTANTS.API_URL}/api/v1/models/catalogue?status=Active`);
      let array = catalogoueItemResponse.data
      console.log(array, 'arrayarray');

      const result = [];
      const map = new Map();
      for (const item of array) {
        if (!map.has(item.displayName)) {
          map.set(item.displayName, true);    // set any value to Map
          result.push({
            ...item
          });
        }
      }
      await setCatalogoueItemList(result)
    }
    setCreateInsuranceCaseModalOpen(!isCreateInsuranceCaseModalOpen);
  }

  async function createInsuranceCase(caseType) {
    try {
      /*
        Bug: T1843 - EN - Insurance -Add New Insurance Renewal Case - While adding a case System should check if VIN is already existing.
        Modification: Added validations for vin before creating a case
        By: Devang
        Date: 02/07/2024
      */
      if (!vinNumberValidation(vinNumber)) {
        toastr.error("Please enter the valid VIN number");
        return;
      }
      let Response = await axios.get(`${CONSTANTS.API_URL}/api/v1/findCase?q=${vinNumber}&interactionType=${typeOfCaseInsurance}`);

      if (Response.data.length) {
        setIsCaseErrorMsg(true);
        setVinNumber("");
        return
      } else {
        setCreateInsuranceCaseLoader(true);
        setVinNumber("");
        setIsCaseErrorMsg(false);
        let task = await axios.post(`${CONSTANTS.API_URL}/api/v1/processInitiation`, { caseType: typeOfCaseInsurance, userBranchID: userInfo.userBranchID, userDealershipID: userInfo.userDealershipID });
        let taskDetails = await axios.get(`${CONSTANTS.API_URL}/api/v1/taskDetails?taskID=${task.data.uuid}`);
        if (taskDetails.data) {
          currentRow = taskDetails.data;
          await setCurrentRow(currentRow);
          let designation = 'Insurance Agent';
          let exchangEvaluators = await axios.get(`${CONSTANTS.API_URL}/api/v1/userOrganization/caseManagement?dealershipID=${userInfo.userDealershipID}`);
          await setExchangeEvaluators(exchangEvaluators.data);
          let insuranceCompaniesList = await axios.get(` ${CONSTANTS.API_URL}/api/v1/thirdParty?type=insuranceCompany&dmsName=Hyundai`);
          if (insuranceCompaniesList.data && insuranceCompaniesList.data.length) {
            setInsuranceCompanies(insuranceCompaniesList.data);
          }
          await toggleFormPopover();
          setCreateInsuranceCaseModalOpen(!isCreateInsuranceCaseModalOpen);
          setCreateInsuranceCaseLoader(false)
        }
      }
    } catch (HTTPException) {
      await reportException({
        HTTPException,
        fileName,
        functionName: 'createInsuranceCase',
      });
      return HTTPException;
    }
  }

  async function toggleFormPopover(action) {
    try {
      // if (isOpenFormPopover) {
      //   await setIsOpenFormPopover(!isOpenFormPopover);
      //   if (currentRow && (!currentRow['dynamicProperties_proposerType'] || (currentRow['dynamicProperties_proposerType'] && !currentRow['dynamicProperties_proposerType'].trim()))) {
      //     await axios.put(`${CONSTANTS.API_URL}/api/v1/deleteInteraction/${currentRow.uuid}`);
      //   }
      //   // await setAssignToType('');
      //   // await setSelectedDepartment('');
      //   return;
      // }
      /*
       Feature: Unsaved Changes Warning
       Modification: Moved the unsaved-changes check to the top so it
       applies to every form opened through this popover
       By: Priya Gupta
       Date: 04/08/26
     */
      if (action && action === "close" && hasUnsavedChanges) {
        setShowUnsavedChangesWarning(true);
        return;
      }
      await setSelectedModel('');
      await setVariantList([]);
      await setCurrentAction('');
      await setDynamicProps([]);
      await setIsDataSaving(false);
      console.log(currentRow, '------------------currentRow------------------------');

      /*
        Feature: Unsaved Changes Warning
        Modification: Ask before discarding the draft instead of
        deleting it immediately on close.
        By: Priya Gupta
        Date: 04/08/26
      */
      if (currentRow && currentRow.displayName === "Create Digital Lead" && (action && action === "close")) {
        console.log('iclose create digital lead');

        if (hasUnsavedChanges) {
          setShowUnsavedChangesWarning(true);
          return;
        }
        let Response = await axios.put(`${CONSTANTS.API_URL}/api/v1/removeDraftDigitalInteraction/${currentRow.interactionID}`);
        console.log(Response, '------------Response--------');

        await setIsOpenFormPopover(!isOpenFormPopover);

        return;
      }
      if (currentRow.interactionID) {
        let Interaction = await axios.get(`${CONSTANTS.API_URL}/api/v1/interaction?uuids=${currentRow.interactionID}`);
        if (Interaction.data.length) {
          setInteraction(Interaction.data[0]);
          if (Interaction.data[0]['dynamicProperties_pincode']) {
            getAreaByPincode(Interaction.data[0]['dynamicProperties_pincode'], "pincode");
          } else if (Interaction.data[0]['dynamicProperties_companyPincode']) {
            getAreaByPincode(Interaction.data[0]['dynamicProperties_companyPincode'], "companyPincode");
          }
          if (Interaction.data[0]['dynamicProperties_state']) {
            getCityList(Interaction.data[0]['dynamicProperties_state']);
          }
          if (Interaction.data[0]['dynamicProperties_selectedModel'] && Interaction.data[0]['dynamicProperties_selectedModel'] !== 'NA') {
            setSelectedModel(Interaction.data[0]['dynamicProperties_selectedModel']);
            getVariantForSelectedModel(Interaction.data[0]['dynamicProperties_selectedModel']);
          }
        }
        // if (currentRow.displayName !== "Repair Request" && currentRow.displayName !== "Handover Courier" && currentRow.containerType === "Form" || currentRow.containerType === "Form and Approval" || currentRow.containerType === "Approval") {
        if (currentRow.containerType === "Form" || currentRow.containerType === "Form and Approval" || currentRow.containerType === "Approval") {
          let actions;
          if (currentRow.masterTaskID) {
            actions = await axios.get(`${CONSTANTS.API_URL}/api/v1/action?taskID=${currentRow.masterTaskID}&currentTaskID=${currentRow.uuid}`);
            console.log(actions, '----------------------------actions-------------------');
          }
          if (actions && actions.data && actions.data.length) {
            let totalProps = 0;
            await Promise.all(actions.data.map(async (action, index) => {
              let dynamicPropsAction = await axios.get(`${CONSTANTS.API_URL}/api/v1/properties?propertyType=dynamicProperty&actionID=${action.uuid}`);
              /*
                Modification: Handled if data exists
                By: Devang
                Date: 10/06/2022
              */
              if (dynamicPropsAction.data.Properties && dynamicPropsAction.data.Properties.length) {
                action['dynamicProps'] = dynamicPropsAction.data.Properties;
                action['dynamicPropsData'] = dynamicPropsAction.data.PropertiesByGroup;
                totalProps = totalProps + dynamicPropsAction.data.length;
                let formValidation = false;
                await Promise.all(action.dynamicProps.map(async (prop, index) => {
                  if (prop.isRequired && (Interaction.data[0]["dynamicProperties_" + prop.name] === "" || !Interaction.data[0]["dynamicProperties_" + prop.name])) {
                    if (!formValidation) {
                      formValidation = true;
                      action['isCompleted'] = false;
                    } else {
                      action['isCompleted'] = true;
                    }
                  } else if (index === action.dynamicProps.length - 1) {
                    action['isCompleted'] = true;
                  }
                  if (Interaction.data[0]["dynamicProperties_" + prop.name] && Interaction.data[0]["dynamicProperties_" + prop.name] !== "NA") {
                    currentRow["dynamicProperties_" + prop.name] = Interaction.data[0]["dynamicProperties_" + prop.name];
                  }
                  if (prop.formType && prop.formType === "select") {
                    // dynamicProp.dependentEnum
                    if (prop.dependentEnum && prop.dependentEnum.length && prop.dependentEnum[0]['nameOfProp'] === 'mainSource') {
                      await Promise.all(prop.dependentEnum.map((dependentEnumObj) => {
                        if (dependentEnumObj['valueOfProp'] === interactionObj['dynamicProperties_mainSource']) {
                          dependentEnumObj['isSelected'] = true
                        } else {
                          dependentEnumObj['isSelected'] = false
                        }
                      }));
                    }
                    // setActions(actions);
                  } else if (prop.formType && prop.formType === 'file' && (Interaction.data[0]['dynamicProperties_' + prop.name] && Interaction.data[0]['dynamicProperties_' + prop.name] !== "NA")) {
                    prop.signedUrl = await getImageSignedUrl(prop.name, Interaction.data[0], props.currentRow);
                    await Promise.all(Object.keys(action.dynamicPropsData).map(async (group) => {
                      let indexOfProp = await action.dynamicPropsData[group].findIndex((d) => d.name === prop.name);
                      if (indexOfProp > -1) {
                        action.dynamicPropsData[group][indexOfProp]['signedUrl'] = prop.signedUrl;
                      }
                    }))
                  }
                }));

                setCurrentRow(currentRow);
                if (formValidation) {
                  setIsFormEditable(true)
                  // setCurrentAction(incompleteAction)
                  // setIncompleteFieldName(incompleteFieldName)
                  // setSelectedActionIndex(incompleteActionIndex-1)
                }
              }
              // }));
              // await setActions(actions.data);
              // await setSelectedArrayForDynamicProps(actions.data);
              // await Promise.all(actions.data.map(async (action, index) => {
              /*
                Modification: Handled if source is set to something and if its sub-source exists then field will be selected
                By: Devang
                Date: 10/06/2022
              */
              if (action.dynamicProps && action.dynamicProps.length) {
                await action.dynamicProps.map(async prop => {
                  if (prop.dependentEnum && prop.dependentEnum.length) {
                    await Promise.all(prop.dependentEnum.map((dependentEnumObj) => {
                      if (dependentEnumObj['valueOfProp'] === Interaction.data[0]['dynamicProperties_' + prop.dependentEnum[0]['nameOfProp']]) {
                        dependentEnumObj['isSelected'] = true;
                      } else {
                        dependentEnumObj['isSelected'] = false;
                      }
                    }));
                  }
                });
                // }
                // if (action.dynamicProps && action.dynamicProps.length) {
                await Promise.all(action.dynamicProps.map(async (prop) => {
                  let fieldName = prop.name;
                  let indexField = dynamicPropsWithValues.findIndex((d) => d.name === fieldName);
                  if (indexField === -1 && Interaction.data[0]["dynamicProperties_" + fieldName] && (Interaction.data[0]["dynamicProperties_" + fieldName] !== "NA" && Interaction.data[0]["dynamicProperties_" + fieldName] !== "")) {
                    dynamicPropsWithValues.push({
                      name: fieldName
                    });
                    setDynamicPropsWithValues(dynamicPropsWithValues);
                    progress = dynamicPropsWithValues.length / (totalProps);
                    setProgress(progress);
                  }
                }))
              }
            }));
            await setActions(actions.data);
            await setSelectedArrayForDynamicProps(actions.data);
            await setCurrentAction(actions.data[0]);

            /*
            BN: 13
            Modification: Completed Create Digital Lead (duplicate case): load model options and variants so saved values display
            Date: 01/10/26
            By: Priya
            */
            if (currentRow.displayName === 'Create Digital Lead' && Interaction.data && Interaction.data[0] && Interaction.data[0]['isduplicate'] === true) {
              let modelsRes = await axios.get(`${CONSTANTS.API_URL}/api/v1/models/catalogue?brandType=Hyundai&isForInsurance=false&status=Active`);
              const seenModels = new Map();
              const modelOptions = [];
              for (const item of (modelsRes.data || [])) {
                if (!seenModels.has(item.displayName)) {
                  seenModels.set(item.displayName, true);
                  modelOptions.push({ ...item });
                }
              }
              await setCatalogoueItemList(modelOptions);
              const savedModelID = Interaction.data && Interaction.data[0] && Interaction.data[0]['dynamicProperties_selectedModel'];
              if (savedModelID) {
                await getVariantForSelectedModelFormWizard(savedModelID);
              }
            }
            /*
              Bug: Cars of the particular selected model was not fetched from database when modal is loaded for first time
              Modification: Commented out previous code and replaced currentAction with actions.data[0] because at this moment, value is not set yet
              By: Devang
              Date: 10//06/2022
            */
            let schemesResponse = await axios.get(`${CONSTANTS.API_URL}/api/v1/schemes`);
            setSchemes(schemesResponse.data);
            if (actions.data[0].displayName === "Product Selection" || actions.data[0].displayName === "Test Drive Detail" || actions.data[0].displayName === "Price Details" || actions.data[0].displayName === "Need Assessment" || actions.data[0].displayName === "Vahicle Details") {
              // if (currentAction.displayName === "Product Selection" || currentAction.displayName === "Test Drive Detail" || currentAction.displayName  === "Price Details") {
              //        let catalogoueItemResponse = await axios.get(`${CONSTANTS.API_URL}/api/v1/catalogue`);
              //        let array = catalogoueItemResponse.data
              //        const result = [];
              //        const map = new Map();
              //        for (const item of array) {
              //          if (!map.has(item.displayName)) {
              //            map.set(item.displayName, true);    // set any value to Map
              //            result.push({
              //              ...item
              //            });
              //          }
              //        }
              //        await setCatalogoueItemList(result)
              let catalogoueItemResponse = await axios.get(`${CONSTANTS.API_URL}/api/v1/models/catalogue?brandType=Hyundai&isForInsurance=false&status=Active`);
              let array = catalogoueItemResponse.data
              console.log(array, 'arrayarray');

              const result = [];
              const map = new Map();
              for (const item of array) {
                if (!map.has(item.displayName)) {
                  map.set(item.displayName, true);    // set any value to Map
                  result.push({
                    ...item
                  });
                }
              }
              await setCatalogoueItemList(result)
              /*
                Bug: Cars of the particular selected model was not fetched from database when modal is loaded for first time
                Modification: Commented out previous code and replaced selectedProducts with Interaction.data[0] because at this moment, value is not set yet
                By: Devang
                Date: 10//06/2022
              */
              if (Interaction.data && Interaction.data[0]) {
                let testDriveCarsList = await axios.get(`${CONSTANTS.API_URL}/api/v1/stockItem?typeOfStockItem=testDrive&model=${modelMapping[Interaction.data[0]['dynamicProperties_selectedModelName']]}`);
                // if (selectedProducts && selectedProducts[0]) {
                //   let testDriveCarsList = await axios.get(`${CONSTANTS.API_URL}/api/v1/stockItem?typeOfStockItem=testDrive&model=${selectedProducts[0]['model']}`);
                if (testDriveCarsList.data.length) {
                  setTestDriveCars(testDriveCarsList.data);
                } else {
                  setTestDriveCars([]);
                }
              }
            }
            console.log(actions.data[0].displayName, '----actions.data[0].displayName------');

            await setSelectedActionIndex(0);
          } else {
            await axios.get(`${CONSTANTS.API_URL}/api/v1/properties?propertyType=dynamicProperty&taskID=${currentRow.masterTaskID}`).then(async (response) => {
              let formValidation = false;
              await Promise.all(response.data.Properties.map(async (prop) => {
                if (Interaction.data[0]["dynamicProperties_" + prop.name] && Interaction.data[0]["dynamicProperties_" + prop.name] !== "NA") {
                  currentRow["dynamicProperties_" + prop.name] = Interaction.data[0]["dynamicProperties_" + prop.name];
                  await Promise.all(response.data.Properties.map(async (prop) => {
                    if (prop.isRequired && (Interaction.data[0]["dynamicProperties_" + prop.name] === "" || !Interaction.data[0]["dynamicProperties_" + prop.name])) {
                      if (!formValidation) {
                        formValidation = true;
                      }
                    }
                    if (prop.formType && prop.formType === 'file' && (Interaction.data[0]['dynamicProperties_' + prop.name] && Interaction.data[0]['dynamicProperties_' + prop.name] !== "NA")) {
                      prop.signedUrl = await getImageSignedUrl(prop.name, Interaction.data[0], props.currentRow);
                    }
                    let fieldName = prop.name;
                    let indexField = dynamicPropsWithValues.findIndex((d) => d.name === fieldName);
                    if (indexField === -1 && Interaction.data[0]["dynamicProperties_" + fieldName] && (Interaction.data[0]["dynamicProperties_" + fieldName] !== "NA" && Interaction.data[0]["dynamicProperties_" + fieldName] !== "")) {
                      dynamicPropsWithValues.push({
                        name: fieldName
                      });
                      setDynamicPropsWithValues(dynamicPropsWithValues);
                      progress = dynamicPropsWithValues.length / (response.data.length);
                      setProgress(progress);
                    }
                  }))
                }
              }));
              await setDynamicProps(response.data.Properties);
              await setDynamicPropsData(response.data.PropertiesByGroup);
              await setSelectedArrayForDynamicProps(response.data.Properties);
              await setActions([]);
              setCurrentRow(currentRow);
              if (formValidation) {
                setIsFormEditable(true)
              }
            });
          }
        }
        await setIsOpenFormPopover(!isOpenFormPopover);
      }
      if (!currentRow.interactionID) {
        await setCurrentRow(currentRow);
        await setIsOpenFormPopover(!isOpenFormPopover);
      }
      // let formModalContainerElement =  await document.getElementById("formModalContainer")
      // if(formModalContainerElement && formModalContainerElement.scrollHeight > formModalContainerElement.clientHeight) {
      //   formModalContainerElement.scrollTo({
      //    top: 0,
      //    behavior: 'smooth',
      //  })
      //   setTimeout(async () => {
      //      await setIsNextModalDisable(true);
      //      await setIsSaveModalDisable(true);
      //      await setIsBackModalDisable(true);
      //   }, 0)
      // } else {
      //      await setIsScrolledToTheBottom(true)
      //      await setIsNextModalDisable(false);
      //      await setIsSaveModalDisable(false);
      //      await setIsBackModalDisable(false);
      // }
    } catch (HTTPException) {
      await reportException({
        HTTPException,
        fileName,
        functionName: 'toggleFormPopover',
      });
      return HTTPException;
    }
  }

  /*
    Feature: Unsaved Changes Warning
    By: Priya Gupta
    Date: 04/08/26
  */
  function stayOnDigitalLeadForm() {
    setShowUnsavedChangesWarning(false);
  }
  async function confirmCloseDigitalLeadForm() {
    setShowUnsavedChangesWarning(false);
    setHasUnsavedChanges(false);
    /*
      Modification: Only Digital Lead has a draft to discard on
      close — other forms (Lead Followup, etc.) should just close.
      By: Priya Gupta
      Date: 04/08/26
    */
    if (currentRow && currentRow.displayName === "Create Digital Lead") {
      await axios.put(`${CONSTANTS.API_URL}/api/v1/removeDraftDigitalInteraction/${currentRow.interactionID}`);
    }
    // let Response = await axios.put(`${CONSTANTS.API_URL}/api/v1/removeDraftDigitalInteraction/${currentRow.interactionID}`);
    await setIsOpenFormPopover(!isOpenFormPopover);
  }

  
  /*
  BN:13
  Modification: Duplicate Lead Popup 
  Date: 01/10/26
  By: Priya
   */
   function closeDuplicateLeadModal() {
    setIsDuplicateLeadModalOpen(false);
  }

  /*
    Modification: T319 (Change Taken From Comp's caseSemiDetailViewV3) - openTaskCompletionError, toggleTaskCompletionError, checkIfTaskCanComplete added
    By: Ashutosh G
    Date: 29/05/2024
  */
  const openTaskCompletionError = () => {
    setIsShowTaskCompletionError(true);
  }
  const toggleTaskCompletionError = () => {
    setIsShowTaskCompletionError(e => !e);
  }
  const checkIfTaskCanComplete = () => {
    let canBeCompleted = true;
    if (isBatchExists.current || isDataSaving) {
      canBeCompleted = false;
      setTaskCompletionErrorHeader('Saving Changes!');
      setTaskCompletionError('Your last changes are being saved. Please wait.');
    } else if (currentRow && !currentRow.isVisited) {
      canBeCompleted = false;
      setTaskCompletionErrorHeader('Task Unchanged!');
      setTaskCompletionError('There are no changes in the task. Please update the task.');
    } else if (currentRow && currentRow.errorFields && currentRow.errorFields.length) {
      canBeCompleted = false;
      setTaskCompletionErrorHeader('Errors Found!');
      setTaskCompletionError('There are error fields in the form. Please fill all the required information.');
    }

    if (!canBeCompleted) {
      openTaskCompletionError();
    }

    return canBeCompleted;
  }

  /*
     Feature: Explicit Validation on Complete
     By: Priya Gupta
     Date: 04/08/26
   */
  async function validateTaskFormBeforeComplete() {
    try {
      // setIsDataSaving(true);
      let payload = currentRow;

      if (actions.length) payload['actionName'] = currentAction ? currentAction.displayName : '';
      if (currentRow.uuid) {
        let Response = await callAPI(`put`, `/v2/task/${currentRow.uuid}/updateForm`, payload);
        if (actions.length && Response.data.actions) {
          let actionsArr = actions;
          let newActionArr = Response.data.actions;
          actionsArr.map(action => {
            let actionObj = newActionArr.find(actionObj => actionObj.displayName === action.displayName);
            if (actionObj) {
              action['actionStatus'] = actionObj.status;
              action['isVisited'] = actionObj.isVisited;
            }
          });
          setActions(actionsArr);
        }
        if (Response.data.errorFields && Response.data.errorFields.length) {
          payload['errorFields'] = Response.data.errorFields;
          payload['isVisited'] = Response.data.isVisited;
        } else {
          payload['errorFields'] = [];
          payload['isVisited'] = Response.data.isVisited;
        }
        await setCurrentTask(payload);
      }
      setIsDataSaving(false);
      return !(payload.errorFields && payload.errorFields.length);
    } catch (HTTPException) {
      setIsDataSaving(false);
      await reportException({
        HTTPException,
        fileName,
        functionName: 'validateTaskFormBeforeComplete'
      });
      return false;
    }
  }


  async function submitFormNew(e) {
    e.preventDefault();
    /*
    BN:T4020
    Modification:
    By: Priya Gupta
    Date:10/08/26
    */
    // await saveTaskForm.current();
    /*
      BN:T3945
      Feature: Explicit Validation on Complete
      By: Priya Gupta
      Date: 04/08/26
    */
    const isFormValid = await validateTaskFormBeforeComplete();
    if (!isFormValid) {
      openTaskCompletionError();
      setTaskCompletionErrorHeader('Errors Found!');
      setTaskCompletionError('There are error fields in the form. Please fill all the required information.');
      return;
    }
    /*
       modification : T319 (Change Taken From Comp's caseSemiDetailViewV3) isTaskCanComplete not exists then returning from function
       modified : Ashutosh G
       modified : 29/05/2024
    */
    const isTaskCanComplete = checkIfTaskCanComplete();
    if (!isTaskCanComplete) return;

    try {
      /*
        modified : Ashutosh G
        modified : 24/05/2024
        modification : isSaveDisabled set to true before api start its job
      */
      await setIsSaveDisabled(true);
      // if(document.getElementById(fields.name).style.borderBottom="1px solid red")
      //   document.getElementById(fields.name).style.border= "1px solid #d1d1d1";
      // }
      // if (currentRow && currentRow.displayName === 'Create Case') {
      //   let payload = currentRow.interaction;
      //
      //   let Response = await axios.put(`${CONSTANTS.API_URL}/api/v1/contactForInteraction`, payload)
      // }
      delete currentRow.interaction;
      let payload = currentRow;
      currentRow['status'] = "Completed";
      if (currentRow.displayName === 'Create Digital Lead') {
        let Response = await axios.put(`${CONSTANTS.API_URL}/api/v4/task/${currentRow.uuid}/markComplete`, payload)

        let notificationObj = {
          typeOfNotification: "push",
          message: "Task " + currentRow.displayName + " completed",
          taskID: currentRow.uuid,
          group: "task",
          isSent: true,
          isRead: false,
          sendTo: userInfo.uuid
        };
        let taskCompletionMessage = await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, notificationObj);

        await setSelectedModel('');
        await setVariantList([]);
        await setCurrentAction('');
        await setDynamicProps([]);
        await setIsDataSaving(false);
        await setIsSaveDisabled(false);
        await setIsOpenFormPopover(!isOpenFormPopover);
        if (Response && Response.data && Response.data.isduplicate === true) {
          setDuplicateLeadInfo({
            subSource: Response.data.subSource || '',
            creName: Response.data.creName || '',
            duplicateInteractions: Response.data.duplicateInteractions || [],
          });
          setIsDuplicateLeadModalOpen(true);
        }
        toastr.success('Task ' + currentRow.displayName + " completed");
        return;
      }

      let Response = await axios.put(`${CONSTANTS.API_URL}/api/v2/task/${currentRow.uuid}/markComplete`, payload)
      let notificationObj = {
        typeOfNotification: "push",
        message: "Task " + currentRow.displayName + " completed",
        taskID: currentRow.uuid,
        group: "task",
        isSent: true,
        isRead: false,
        sendTo: userInfo.uuid
      };

      // if (Response.data.triggeredTaskList.length) {
      //   await setTriggeredUnassignedTaskList(Response.data.triggeredTaskList);
      //   await toggleOpenAssignUsersTriggeredTask();
      // }
      // if (Response.data.triggeredTaskListForApproval.length) {
      //   await setTriggeredUnassignedApprovalTaskList(Response.data.triggeredTaskListForApproval);
      //   await toggleOpenAssignApprovalUsersTriggeredTask();
      // }
      let taskCompletionMessage = await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, notificationObj);
      // if (taskCompletionMessage.status === 200) {
      //   triggerNotifications(true)
      // }
      await axios.post(`${CONSTANTS.API_URL}/api/v1/sendWhatsappMessageWithMIM`, {
        "templateName": "task_complete_demo",
        "parameters": currentTask.displayName,
        "phoneNumber": "9904695543"
      });
      toastr.success('Task ' + currentRow.displayName + " completed");
      if (Response.data.messageResponses && Response.data.messageResponses.length) {
        await Promise.all(Response.data.messageResponses.map(async (messageObj) => {
          try {
            /*
              Modification: Commented out whatsapp api due to unecessary and broken whatsapp messages to users on PROD
              By: Devang
              Date: 25/08/2024
            */
            /*await axios.post(`${CONSTANTS.API_URL}/api/v1/sendWhatsappMessageWithMIM`, {
              "templateName": messageObj.whatsappTemplateName,
              "parameters": messageObj.whatsappTemplateParametes,
              "phoneNumber": messageObj.whatsappNumber ? messageObj.whatsappNumber : messageObj.mobile,
            });*/
            if (messageObj.sendTo) {
              let messageNotification = await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, messageObj);
              // if (messageNotification.status === 200) {
              //   triggerNotifications(true)
              // }
              toastr.info(messageObj.message);
            } else {
              toastr.info(messageObj.message);
            }
          } catch (e) {
            console.error(e.message);
          }
        }))
        await toggleFormPopover();
      }

      /*
        modified : Ashutosh G
        modified : 24/05/2024
        modification : isSaveDisabled set to false after api done its job
      */
      await setIsSaveDisabled(false);
    } catch (HTTPException) {
      await reportException({
        HTTPException,
        fileName,
        functionName: 'submitFormNew',
      });
      return HTTPException;
    }
  }

  async function setFormValueInput(e, fieldName, actionIndex , typeOfValidation) {
    e.preventDefault();
    /*
    BN:T4121 ; Gitea : 25 
    Modification: Added validation to prevent negative number
    By: Priya Gupta
    Date: 01/09/26
    */
   if (typeOfValidation === 'disableNegativeNumber' && e.target.value !== '' && Number(e.target.value) < 1) {
     e.target.value = '';
      currentRow['dynamicProperties_' + fieldName] = '';
      interactionObj['dynamicProperties_' + fieldName] = '';
      return;
    }
    if (fieldName === "amount") {
      let amountInWords = await inWords(e.target.value);
      let amountNode = document.getElementById(`amount-` + fieldName);
      if (amountNode) {
        amountNode.innerHTML = "INR " + amountInWords;
        amountNode.style.display = "block";
        amountNode.style.color = "#4949ed";
      }
    } else if (fieldName === 'discount') {
      currentRow['dynamicProperties_discountToBeAdjusted'] = e.target.value;
      interactionObj['dynamicProperties_discountToBeAdjusted'] = e.target.value;
    } else if (fieldName === 'latestQuotationPolicyIDV' && currentRow.displayName === 'Generate Renewal Quotation') {
      currentRow['dynamicProperties_latestQuotationPolicyIDV'] = e.target.value;
      interactionObj['dynamicProperties_latestQuotationPolicyIDV'] = e.target.value;
      currentRow['dynamicProperties_latestQuotationPolicyIDV2'] = e.target.value;
      interactionObj['dynamicProperties_latestQuotationPolicyIDV2'] = e.target.value;
    } else if (fieldName === 'exShowroom' && currentRow.displayName === 'Create Case') {
      currentRow['dynamicProperties_policyIDV'] = Number(e.target.value) * 0.95;
      interactionObj['dynamicProperties_policyIDV'] = Number(e.target.value) * 0.95;
    } else if (fieldName === 'premium' && currentRow.displayName === 'Buy New Policy') {
      currentRow['dynamicProperties_chequeAmount'] = e.target.value;
      interactionObj['dynamicProperties_chequeAmount'] = e.target.value;
      currentRow['dynamicProperties_transactionAmount'] = e.target.value;
      interactionObj['dynamicProperties_transactionAmount'] = e.target.value;
    } else if (["firstName", "lastName", "name", "email", "address", "dateOfBirth", "nomineeDateOfBirth", "nominee", "engineNumber", "vin", "registrationNo"].includes(fieldName)) {
      currentRow['dynamicProperties_old' + fieldName.charAt(0).toUpperCase() + fieldName.slice(1)] = e.target.value;
      interactionObj['dynamicProperties_old' + fieldName.charAt(0).toUpperCase() + fieldName.slice(1)] = e.target.value;
    }
    if (!e.target.value) {
      let successNode = document.getElementById("success-" + actionIndex + "-" + fieldName);
      if (successNode) {
        successNode.style.display = "none";
      }
    }
    // if (fieldName.substring(0, 8) === 'adjusted') {
    //   let adjustedDiscount = Number(interactionObj['dynamicProperties_'+fieldName.charAt(8).toLowerCase()+fieldName.substring(9)]) - Number(e.target.value);
    //   let remainingDiscount = Number(interactionObj['dynamicProperties_discountToBeAdjusted']) - adjustedDiscount;
    //   if (remainingDiscount >= 0) {
    //     interactionObj['dynamicProperties_discountToBeAdjusted'] = remainingDiscount;
    //     currentRow['dynamicProperties_' + fieldName] = e.target.value;
    //     interactionObj['dynamicProperties_' + fieldName] = e.target.value;
    //   }
    // } else {
    currentRow['dynamicProperties_' + fieldName] = e.target.value;
    interactionObj['dynamicProperties_' + fieldName] = e.target.value;
    // }
    if (document.getElementById(fieldName)) {
      if ((fieldName === "addressLine1" || fieldName === "companyAddress") && e.target.value.length < 4) {
        document.getElementById(fieldName).style.borderBottom = "2px solid red";
        let spanNode = document.getElementById("error-" + fieldName);
        if (spanNode) {
          spanNode.style.display = "block";
          spanNode.innerHTML = "Address should be greater than 4 characters"
        }
      } else if ((fieldName === "addressLine1" || fieldName === "companyAddress") && e.target.value.length > 50) {
        document.getElementById(fieldName).style.borderBottom = "2px solid red";
        let spanNode = document.getElementById("error-" + fieldName);
        if (spanNode) {
          spanNode.style.display = "block";
          spanNode.innerHTML = "Address should be less than 50 characters"
        }
      } else {
        document.getElementById(fieldName).style.borderBottom = "1px solid #9e9e9e";
        let node = document.getElementById("error-" + fieldName);
        if (node) {
          node.style.color = "#9e9e9e";
        }
        if (e.target.value) {
          let successNode = document.getElementById("success-" + actionIndex + "-" + fieldName);
          if (successNode) {
            successNode.style.display = "inline";
            let requiredNode = document.getElementById("required-" + actionIndex + "-" + fieldName);
            if (requiredNode) {
              requiredNode.style.display = "none";
            }
          }
        }

      }

    }
    if (fieldName === "newpincode" || fieldName === "pincode" || fieldName === "companyPincode" || fieldName === "registrationAddressPincode" || fieldName === "ownerPincode") {
      getAreaByPincode(e.target.value, fieldName);
    }
    if (fieldName === 'state') {
      getCityList(e.target.value);
    }
    // modified by Vihang
    // modified at 07/06/2022
    // modification : email verification code changes
    if (fieldName === "VerificationCode") {
      if (e.target.value.length === 6) {
        setDisableEmailVerifyButton(false)
      }
      interactionForPdf['dynamicProperties_OtpEnteredByCustomer'] = e.target.value;
    }

    let index = dynamicPropsWithValues.findIndex((d) => d.name === fieldName);
    if (index === -1) {
      dynamicPropsWithValues.push({
        name: fieldName
      });
      setDynamicPropsWithValues(dynamicPropsWithValues);
      progress = dynamicPropsWithValues.length / dynamicProps.length;
      setProgress(progress);
    }
    if (fieldName === 'quotedPrice' && interactionObj['dynamicProperties_expectedPrice']) {
      interactionObj['dynamicProperties_differenceInPrice'] = Math.abs(Number(interactionObj['dynamicProperties_quotedPrice']) - Number(interactionObj['dynamicProperties_expectedPrice']));
    } else if (fieldName === 'expectedPrice' && interactionObj['dynamicProperties_quotedPrice']) {
      interactionObj['dynamicProperties_differenceInPrice'] = Math.abs(Number(interactionObj['dynamicProperties_quotedPrice']) - Number(interactionObj['dynamicProperties_expectedPrice']));
    }
    setIsFormUpdated(!isFormUpdated);
  }

   /*
    Modification: Added handleKeyDown and handlePaste
    By: Priya
    Date: 05/09/26
  */

  function handleNumberKeyDown(e, formType) {
  if (formType !== 'number') return;
  const invalidKeys = ['-', '+', 'e', 'E', '.'];
  if (invalidKeys.includes(e.key)) {
    e.preventDefault();
  }
}

function handleNumberPaste(e, formType) {
  if (formType !== 'number') return;
  const pastedValue = (e.clipboardData || window.clipboardData).getData('text');
  if (!/^[1-9]\d*$/.test(pastedValue.trim())) {
    e.preventDefault();
  }
}


  /*
    Bug: 177 KH_BG_247 Renewal Insurance Lead Followup Complete button is not getting enabled
    Modification: Added getVariantForSelectedModelFormWizard and saveSelectedModel for formWizard to save modelName
    By: Devang
    Date: 15/08/2023
  */
  /*
    Bug: 182 KH_BG_252 Renewal Insurance Lead Followup Variant dropdown is missing
    Modification: Added saveSelectedVariant for formWizard to save variant
    By: Devang
    Date: 15/08/2023
  */
  async function saveSelectedVariant(e) {
    // setSelectedVariantName(e.target.value);
    interactionObj['dynamicProperties_selectedVariant'] = e.target.value;
    currentRow['dynamicProperties_selectedVariant'] = e.target.value;
    let Index = await variantList.findIndex(d => d.uuid === e.target.value);
    console.log(variantList, e.target.value, 'Okayyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy');
    if (Index > -1) {
      interactionObj['dynamicProperties_variantName'] = variantList[Index].variant;
      currentRow['dynamicProperties_variantName'] = variantList[Index].variant;
      interactionObj['dynamicProperties_selectedVariantName'] = variantList[Index].variant;
      currentRow['dynamicProperties_selectedVariantName'] = variantList[Index].variant;
    }
    console.log();
    setIsFormUpdated(!isFormUpdated);
  }

  async function saveSelectedFuelType(e) {
    // setSelectedVariantName(e.target.value);
    getVariantForSelectedModelFormWizard(e.target.value);
    getVariantForSelectedModel(e.target.value)
    console.log('innnnnnnnnnnnnnnn selectedFuelType', e.target.value);
    interactionObj['dynamicProperties_selectedFuelType'] = e.target.value;
    currentRow['dynamicProperties_selectedFuelType'] = e.target.value;

    // if (actions.data[0].displayName === "Final Selection") {
    let shieldOfTrustPackagesRes = await axios.get(`${CONSTANTS.API_URL}/api/v1/catalogue?noLimit=noLimit&model=${interactionObj['dynamicProperties_selectedModelName']}&type=valueAddedService&typeOfPackage=sot`);
    if (shieldOfTrustPackagesRes.data && shieldOfTrustPackagesRes.data.length) {
      setShieldOfTrustPackages(shieldOfTrustPackagesRes.data)
    }
    let rsaPackagesRes = await axios.get(`${CONSTANTS.API_URL}/api/v1/catalogue?noLimit=noLimit&model=${interactionObj['dynamicProperties_selectedModelName']}&type=valueAddedService&typeOfPackage=rsa`);
    if (rsaPackagesRes.data && rsaPackagesRes.data.length) {
      setRsaPackages(rsaPackagesRes.data)
    }
    let extendedWarrantyPackagesRes = await axios.get(`${CONSTANTS.API_URL}/api/v1/catalogue?noLimit=noLimit&model=${interactionObj['dynamicProperties_selectedModelName']}&type=valueAddedService&typeOfPackage=extendedWarranty&fuelType=${interactionObj['dynamicProperties_selectedFuelType'].toLowerCase()}`);
    if (extendedWarrantyPackagesRes.data && extendedWarrantyPackagesRes.data.length) {
      setExtendedWarrantyPackages(extendedWarrantyPackagesRes.data)
    }
    let threeMPackagesRes = await axios.get(`${CONSTANTS.API_URL}/api/v1/catalogue?noLimit=noLimit&model=${interactionObj['dynamicProperties_selectedModelName']}&type=valueAddedService&typeOfPackage=3m`);
    if (threeMPackagesRes.data && threeMPackagesRes.data.length) {
      setThreeMPackages(threeMPackagesRes.data)
    }
    // }
    // let Index = await variantList.findIndex(d => d.uuid === e.target.value);
    // console.log(variantList, e.target.value, 'Okayyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy');
    // if (Index > -1) {
    //   interactionObj['dynamicProperties_variantName'] = variantList[Index].variant;
    //   currentRow['dynamicProperties_variantName'] = variantList[Index].variant;
    //   interactionObj['dynamicProperties_selectedVariantName'] = variantList[Index].variant;
    //   currentRow['dynamicProperties_selectedVariantName'] = variantList[Index].variant;
    // }
    console.log();
    setIsFormUpdated(!isFormUpdated);
  }

  async function toggleEditForm() {
    setIsEntityFormObjectUpdated(!isEntityFormObjectUpdated);
  }

  async function getVariantForSelectedModelFormWizard(id) {
    // await axios.get((`${CONSTANTS.API_URL}/api/v1/catalogue/variants?selectedCatalogueItemID=${id}`)).then((response) => {
    //   let variantReponse = response.data;
    //   const result = [];
    //   const map = new Map();
    //   // for (const item of variantReponse) {
    //   variantReponse.map(item => {
    //     let veriantColorArray = [];
    //     veriantColorArray.push()
    //     if (!map.has(item.variant)) {
    //       item['colors'] = [];
    //       let color = (item.oemColor === '$color' || !item.oemColor) ? item.color.split(' ').join('-') : item.oemColor.split(' ').join('-')
    //       item.colors.push(color);
    //       map.set(item.variant, true);    // set any value to Map
    //       result.push(item);
    //     } else {
    //       let idx = result.findIndex(d => d.variant === item.variant);
    //       let color = (item.oemColor === '$color' || !item.oemColor) ? item.color.split(' ').join('-') : item.oemColor.split(' ').join('-')
    //       result[idx]['colors'].push(color);
    //     }
    //   })
    //   setVariantList(result)
    // })
    try {
      const response = await axios.get(
        `${CONSTANTS.API_URL}/api/v1/variants`,
        {
          params: {
            modelId: id,
            noLimit: 'noLimit',
            status: 'Active'
          }
        }
      );

      const variantResponse = response.data || [];
      console.log(variantResponse, 'variantResponse');

      const result = [];
      const map = new Map();

      variantResponse.forEach(item => {
        const colors = item.colorCodes || [];

        if (!map.has(item.variantName)) {
          map.set(item.variantName, true);

          result.push({
            ...item,
            colors: [...colors]
          });
        } else {
          const idx = result.findIndex(
            d => d.variantName === item.variantName
          );

          if (idx !== -1) {
            result[idx].colors.push(...colors);
          }
        }
      });

      console.log(result, '-------------------result');
      setVariantList(result);

    } catch (error) {
      console.error('Error fetching variants:', error);
    }
  }

  async function saveSelectedBrand(e) {
    console.log(e.target.value, 'in save selectedBrand----------');

    let catalogoueItemResponse = await axios.get(`${CONSTANTS.API_URL}/api/v1/models/catalogue?brandType=${e.target.value}&status=Active`);
    let array = catalogoueItemResponse.data;
    console.log(array, '---------------array-------------');

    const result = [];
    const map = new Map();
    for (const item of array) {
      if (!map.has(item.displayName)) {
        map.set(item.displayName, true); // set any value to Map
        result.push({
          ...item
        });
      }
    }
    console.log(result, '---------result----------');

    await setCatalogoueItemList(result);

    interactionObj['dynamicProperties_brand'] = e.target.value;
    currentTask['dynamicProperties_brand'] = e.target.value;

    interactionObj['dynamicProperties_selectedModel'] = '';
    currentTask['dynamicProperties_selectedModel'] = '';
    interactionObj['dynamicProperties_selectedModelName'] = '';
    currentTask['dynamicProperties_selectedModelName'] = '';

    interactionObj['dynamicProperties_modelName'] = '';
    currentTask['dynamicProperties_modelName'] = '';

    interactionObj['dynamicProperties_variantName'] = '';
    currentTask['dynamicProperties_variantName'] = '';
    interactionObj['dynamicProperties_selectedVariantName'] = '';
    currentTask['dynamicProperties_selectedVariantName'] = '';

    setIsFormUpdated(!isFormUpdated);
  }

  async function saveSelectedSalesLeadType(e) {
    const value = e.target.value;

    const fieldsToClear = {
      Other: [
        'dynamicProperties_salesSubLeadType',
        'dynamicProperties_typeOfBuyer',
        'dynamicProperties_additionalCarBrand',
        'dynamicProperties_additionalCarModel',
        'dynamicProperties_additionalCarManufactureYear',
        'dynamicProperties_noOfAdditionalVehicles',
        'dynamicProperties_exchangeCarBrand',
        'dynamicProperties_exchangeCarModel',
        'dynamicProperties_exchangeCarManufactureYear',
        'dynamicProperties_noOfexchangeVehicles'
      ],
      Vehicle: [
        'dynamicProperties_salesSubLeadType'
      ]
    };

    (fieldsToClear[value] || []).forEach((field) => {
      interactionObj[field] = '';
      currentRow[field] = '';
    });

    interactionObj.dynamicProperties_salesLeadType = value;
    currentRow.dynamicProperties_salesLeadType = value;

    setIsFormUpdated(!isFormUpdated);
  }


  async function saveSelectedTypeOfBuyer(e) {
    const value = e.target.value;
    const fieldsToClear = [
      'dynamicProperties_additionalCarBrand',
      'dynamicProperties_additionalCarModel',
      'dynamicProperties_additionalCarManufactureYear',
      'dynamicProperties_noOfAdditionalVehicles',
      'dynamicProperties_exchangeCarBrand',
      'dynamicProperties_exchangeCarModel',
      'dynamicProperties_exchangeCarManufactureYear',
      'dynamicProperties_noOfexchangeVehicles'
    ];

    fieldsToClear.forEach((field) => {
      interactionObj[field] = '';
      currentRow[field] = '';
    });

    interactionObj.dynamicProperties_typeOfBuyer = value;
    currentRow.dynamicProperties_typeOfBuyer = value;

    setIsFormUpdated(!isFormUpdated);
  }


  async function saveSelectedModel(e) {
    getVariantForSelectedModelFormWizard(e.target.value);
    // getFuelTypesForSelectedModel(e.target.value)
    setSelectedModel(e.target.value);
    interactionObj['dynamicProperties_selectedModel'] = e.target.value;
    let Index = await modelsList.findIndex(d => d.uuid === e.target.value);
    console.log(modelsList, e.target.value, 'yayyyyyyyyyyyyyyyyyyyyyyyyyyyy');
    if (Index > -1) {
      interactionObj['dynamicProperties_modelName'] = modelsList[Index].modelName;
      interactionObj['dynamicProperties_selectedModelName'] = modelsList[Index].modelName;
      currentRow['dynamicProperties_selectedModelName'] = modelsList[Index].modelName;
      currentRow['dynamicProperties_modelName'] = modelsList[Index].modelName;
      if (currentAction.displayName === "Accessories Selection") {
        let accessoriesCatalogueItems = await axios.get(`${CONSTANTS.API_URL}/api/v1/accessories?noLimit=noLimit&selectedModel=${interactionObj['dynamicProperties_selectedModelName']}`);
        let array = accessoriesCatalogueItems.data
        const result = [];
        const map = new Map();
        for (const item of array) {
          if (!map.has(item.nameOfPart)) {
            map.set(item.nameOfPart, true);
            result.push({
              ...item
            });
          }
        }
        await setAccessoriesList(result);
      }
    }
    console.log(currentRow['dynamicProperties_selectedModelName'], "currentRow['dynamicProperties_selectedModelName']");
    currentRow['dynamicProperties_selectedModel'] = interactionObj['dynamicProperties_selectedModel'];


    setIsFormUpdated(!isFormUpdated);
  }

  async function saveFormInput(e, fieldName, formType, index, propIndex) {
    e.preventDefault();
    if (fieldName.substring(0, 8) === 'adjusted') {
      let adjustedDiscount = Number(interactionObj['dynamicProperties_' + fieldName.charAt(8).toLowerCase() + fieldName.substring(9)]) - Number(e.target.value);
      let remainingDiscount = Number(interactionObj['dynamicProperties_discountToBeAdjusted']) - adjustedDiscount;
      if (remainingDiscount >= 0) {
        interactionObj['dynamicProperties_discountToBeAdjusted'] = remainingDiscount;
        currentRow['dynamicProperties_' + fieldName] = e.target.value;
        interactionObj['dynamicProperties_' + fieldName] = e.target.value;
      }
    } else {
      currentRow['dynamicProperties_' + fieldName] = e.target.value;
      interactionObj['dynamicProperties_' + fieldName] = e.target.value;
      if (["relation", "hypothecationBankName", "dateOfBirth", "nomineeDateOfBirth"].includes(fieldName)) {
        currentRow['dynamicProperties_old' + fieldName.charAt(0).toUpperCase() + fieldName.slice(1)] = e.target.value;
        interactionObj['dynamicProperties_old' + fieldName.charAt(0).toUpperCase() + fieldName.slice(1)] = e.target.value;
      }
    }
    let payload = {};
    payload[fieldName] = currentRow['dynamicProperties_' + fieldName];
    // await updateTask(payload);
    let indexField = dynamicPropsWithValues.findIndex((d) => d.name === fieldName);
    if (indexField === -1) {
      dynamicPropsWithValues.push({
        name: fieldName
      });
      setDynamicPropsWithValues(dynamicPropsWithValues);
      if (dynamicProps.length) {
        progress = dynamicPropsWithValues.length / dynamicProps.length;
      } else if (actions[index] && actions[index]['dynamicProps'] && actions[index]['dynamicProps'].length) {
        progress = dynamicPropsWithValues.length / actions[index]['dynamicProps'].length;
      }
      setProgress(progress);
    }
    if (formType && formType === "select") {
      // dynamicProp.dependentEnum
      if (actions.length) {
        await Promise.all(actions[index]['dynamicProps'].map(async (prop) => {
          if (prop.dependentEnum && prop.dependentEnum.length && prop.dependentEnum[0]['nameOfProp'] === fieldName) {
            await Promise.all(prop.dependentEnum.map((dependentEnumObj) => {
              if (dependentEnumObj['valueOfProp'] === e.target.value) {
                dependentEnumObj['isSelected'] = true
              } else {
                dependentEnumObj['isSelected'] = false
              }
            }));
          }
        }));
      } else if (dynamicProps.length) {
        await Promise.all(dynamicProps.map(async (prop) => {
          if (prop.dependentEnum && prop.dependentEnum.length && prop.dependentEnum[0]['nameOfProp'] === fieldName) {
            await Promise.all(prop.dependentEnum.map((dependentEnumObj) => {
              if (dependentEnumObj['valueOfProp'] === e.target.value) {
                dependentEnumObj['isSelected'] = true
              } else {
                dependentEnumObj['isSelected'] = false
              }
            }));
          }
        }));
      }

      // setActions(actions);
    }
    if (fieldName === "interestedModel") {
      currentRow['dynamicProperties_' + fieldName] = e.target.value;
      interactionObj['dynamicProperties_' + fieldName] = e.target.value;
      payload[fieldName] = currentRow['dynamicProperties_' + fieldName];
    }
    if (fieldName === "newpincode" || fieldName === "pincode" || fieldName === "companyPincode") {
      getAreaByPincode(e.target.value, fieldName);
    }
    if (fieldName === 'state') {
      getCityList(e.target.value);
    }
    setIsFormUpdated(!isFormUpdated);
  }

  async function getSelectedTypeUserList(value) {
    try {
      currentRow['dynamicProperties_lostCaseApprovalRole'] = value;
      interactionObj['dynamicProperties_lostCaseApprovalRole'] = value;
      setIsFormUpdated(!isFormUpdated);
      let response = await axios.get(`${CONSTANTS.API_URL}/api/v1/userorganizations?dealershipIDs=${userInfo.dealership}&designation=${value}&branchIDs=${userInfo.userBranchID}`);
      // let userList = response.data.filter((user) => user.roleName === value)
      await setAssignUserList(response.data)
    } catch (HTTPException) {
      await reportException({
        HTTPException,
        fileName,
        functionName: 'getSelectedTypeUserList',
      });
      return HTTPException;
    }
  }

  async function saveFormInputRadio(e, fieldName, value, index) {
    if (fieldName === "selectedScheme") {
      interactionObj["dynamicProperties_schemeDiscount"] = interactionObj["dynamicProperties_schemeDiscount"] ? interactionObj["dynamicProperties_schemeDiscount"] + schemes[index]['discountAfterGST'] : schemes[index]['discountAfterGST'];
      currentRow["dynamicProperties_schemeDiscount"] = interactionObj["dynamicProperties_schemeDiscount"] ? interactionObj["dynamicProperties_schemeDiscount"] + schemes[index]['discountAfterGST'] : schemes[index]['discountAfterGST'];
    }
    if (value) {
      currentRow['dynamicProperties_' + fieldName] = value;
      interactionObj['dynamicProperties_' + fieldName] = value;
    } else {
      currentRow['dynamicProperties_' + fieldName] = value;
      interactionObj['dynamicProperties_' + fieldName] = value;
    }
    let payload = {};
    payload[fieldName] = currentRow['dynamicProperties_' + fieldName];
    setIsFormUpdated(!isFormUpdated);

    // await updateTask(payload);
  }

  /*
  BN:1008
  Modification: Added the function from utils to add extra city Names
  Date: 29/09/26
  By: Priya
  */
  async function getCityList(stateName) {
    let stateObj = stateList.find(state => state.name === stateName);
    if (stateObj) {
      let countryCode = stateObj.countryCode ? stateObj.countryCode : '';
      let stateCode = stateObj.isoCode ? stateObj.isoCode : '';
      let cityListArr = getCitiesOfStateWithExtras(countryCode, stateCode);
      await setCityList(cityListArr);
    }
  }

  async function saveFormInputRadioDefault(e, fieldName) {
    currentRow['dynamicProperties_' + fieldName] = e.target.value;
    interactionObj['dynamicProperties_' + fieldName] = e.target.value;
    if (fieldName === 'isNoClaimBonus' && currentRow.displayName === 'Create Case' && e.target.value === 'no') {
      currentRow['dynamicProperties_ncbPercentage'] = "0";
      interactionObj['dynamicProperties_ncbPercentage'] = "0";
    } else if (fieldName === 'doyouHaveaWhatsappNumber' && e.target.value === 'no') {
      currentRow['dynamicProperties_isWhatsappNumberSameAsMobile'] = "";
      interactionObj['dynamicProperties_isWhatsappNumberSameAsMobile'] = "";
      console.log(currentRow['dynamicProperties_isWhatsappNumberSameAsMobile'], "currentRow['dynamicProperties_isWhatsappNumberSameAsMobile']currentRow['dynamicProperties_isWhatsappNumberSameAsMobile']");
    } else if (fieldName === 'contactPersondoyouHaveaWhatsappNumber' && e.target.value === 'no') {
      currentRow['dynamicProperties_contactPersonisWhatsappNumberSameAsMobile'] = "";
      interactionObj['dynamicProperties_contactPersonisWhatsappNumberSameAsMobile'] = "";
    } else if (fieldName === "hypothecation") {
      currentRow['dynamicProperties_oldHypothecation'] = e.target.value;
      interactionObj['dynamicProperties_oldHypothecation'] = e.target.value;
    }
    let payload = {};
    payload[fieldName] = currentRow['dynamicProperties_' + fieldName];
    // await updateTask(payload);
    // if (e.target.value && document.getElementById(fieldName)) {
    //   document.getElementById(fieldName).style.border = "1px solid #d1d1d1";
    // }
    setIsFormUpdated(!isFormUpdated);

  }

  async function deleteUploadedFile(e, fieldName) {
    let payload = {
      interactionID: interactionObj.uuid,
      fieldName
    };
    // let DeletedInteractionObj = await axios.put(`${CONSTANTS.API_URL}/api/v1/interaction/removeField/${interactionObj['uuid']}`, payload);
    interactionObj['dynamicProperties_' + fieldName] = '';
    currentRow['dynamicProperties_' + fieldName] = '';
    // let Response = await axios.put(`${CONSTANTS.API_URL}/api/v1/file/remove/${interactionObj['dynamicProperties_'+fieldName]}`, payload);
    setIsFormUpdated(!isFormUpdated);
  }

  async function saveFormInputCheckbox(e, fieldName, value) {
    if (fieldName === "selectedCouponID") {
      if (e.target.checked && currentRow['dynamicProperties_' + fieldName] && (!currentRow['dynamicProperties_' + fieldName] || !currentRow['dynamicProperties_' + fieldName].split(",").includes(value))) {
        currentRow['dynamicProperties_' + fieldName] = currentRow['dynamicProperties_' + fieldName] + ',' + value;
        interactionObj['dynamicProperties_' + fieldName] = interactionObj['dynamicProperties_' + fieldName] + ',' + value;
      } else if (e.target.checked && !currentRow['dynamicProperties_' + fieldName]) {
        currentRow['dynamicProperties_' + fieldName] = value;
        interactionObj['dynamicProperties_' + fieldName] = value;
      } else if (!e.target.checked && currentRow['dynamicProperties_' + fieldName].split(",").includes(value)) {
        let idx = currentRow['dynamicProperties_' + fieldName].split(",").findIndex(d => d === value);
        let tempArr = currentRow['dynamicProperties_' + fieldName].split(",");
        let deleted = tempArr.splice(idx, 1);
        currentRow['dynamicProperties_' + fieldName] = tempArr.join(",");
        interactionObj['dynamicProperties_' + fieldName] = currentRow['dynamicProperties_' + fieldName];
      }
    } else {
      if (e.target.checked && (!currentRow['dynamicProperties_' + fieldName] || !currentRow['dynamicProperties_' + fieldName].split(",").includes(value))) {
        currentRow['dynamicProperties_' + fieldName] = currentRow['dynamicProperties_' + fieldName] + ',' + value;
        interactionObj['dynamicProperties_' + fieldName] = interactionObj['dynamicProperties_' + fieldName] + ',' + value;
      } else if (!e.target.checked && currentRow['dynamicProperties_' + fieldName].split(",").includes(value)) {
        let idx = currentRow['dynamicProperties_' + fieldName].split(",").findIndex(d => d === value);
        let tempArr = currentRow['dynamicProperties_' + fieldName].split(",");
        let deleted = tempArr.splice(idx, 1);
        currentRow['dynamicProperties_' + fieldName] = tempArr.join(",");
        interactionObj['dynamicProperties_' + fieldName] = currentRow['dynamicProperties_' + fieldName];
      }
    }
    // currentRow['dynamicProperties_' + fieldName] = e.target.value;
    let payload = {};
    payload[fieldName] = currentRow['dynamicProperties_' + fieldName];
    // await updateTask(payload);
    setIsFormUpdated(!isFormUpdated);
  }

  async function saveAreaFromForm(e, name) {
    interactionObj['dynamicProperties_' + name] = e.target.value;
    currentRow['dynamicProperties_' + name] = e.target.value;
    setIsFormUpdated(!isFormUpdated);
  }

  async function getImageSignedUrl(name, interactionObj, currentRow) {
    try {
      if ((typeof currentRow['dynamicProperties_' + name] === "object" && currentRow['dynamicProperties_' + name].length) || (typeof currentRow['dynamicProperties_' + name] === "string" && currentRow['dynamicProperties_' + name])) {
        let file = await axios.get(`${CONSTANTS.API_URL}/api/v1/file/getFileFromS3?courierID=${interactionObj.uuid}&fileID=${currentRow['dynamicProperties_' + name]}&s3KeyFor=case`)
        if (file.data[0]) {
          return file.data[0].signedUrl;
        } else {
          return null;
        }
      }
    } catch (HTTPException) {
      await reportException({
        HTTPException,
        fileName,
        functionName: 'getImageSignedUrl',
      });
      return HTTPException;
    }
  }

  async function setFormEditable() {
    setIsFormEditable(!isFormEditable);
  }

  async function setBorderOnFocus(e, name) {
    let borderNode = document.getElementById(`${name}-input-box`);
    if (borderNode) {
      borderNode.style.border = "1px solid #003468";
    }
  }
  /****************************************************************************/
  /*
    Modification: Added socketio
    By: Komal Wable
    Date: 18/04/2023
  */

  useEffect(async () => {
    /*socket.on('acknowledge', async(response) => {
      if (response) {
        if (response.nudgedByID === userInfo.uuid){
          setIsSound(true)
          setIsAcknowledge(true)
          setShowSlideNotification(true)
          setNudges(response)
        }
      }
    });
    socket.on('nudges', async(response) => {
      console.log(response, 'Reponseeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee');
      if (response) {
        if (response.nudgedToID && response.nudgedToID.includes(userInfo.uuid)){
          setIsSound(true)
          setShowSlideNotification(true)
          setNudges(response)
        }
      }
    })
    socket.on('case', async(response) => {
      if (response) {
        if (response.responsibleUserIDs && response.responsibleUserIDs.includes(userInfo.uuid)) {
          setIsSound(true)
          setShowSlideNotification(true)
          setMessage(response.message)
        }
      };
    })
    socket.on('task assigned', async(response) => {
      if (response) {
        if (response.assignedUserID === userInfo.uuid) {
          setIsSound(true)
          setShowSlideNotification(true)
          setMessage(response.message)
        }
      };
    })
    socket.on('task completed', async(response) => {
      if (response) {
        if (response.assignedUserID === userInfo.uuid) {
          setIsSound(true)
          setShowSlideNotification(true)
          setMessage(response.message)
        }
      };
    })*/
    socket.on("message", async (response) => {
      console.log(response, "socket responsessssssssssssssssssssssssss");
      if (response) {
      }
    });
    socket.on("task", async (response) => {
      console.log(response, "socket responsessssssssssssssssssssssssss");
      if (response) {
      }
    });
    socket.on("case", async (response) => {
      console.log(response, "socket responsessssssssssssssssssssssssss");
      if (response) {
      }
    });
  }, [socket]);


  // const pathname = window.location.pathname;

  /******************************************************************************/

  // Function to fetch active models
  const getModelsList = async () => {
    try {
      // const response = await axios.get(`${CONSTANTS.API_URL}/api/v1/models?status=Active&noLimit=noLimit`);
      let response = await axios.get(`${CONSTANTS.API_URL}/api/v1/models/catalogue?brandType=Hyundai&isForInsurance=false&status=Active`);

      if (response.data) {
        setModelsList(response.data);
      }
    } catch (error) {
      console.error('Error fetching models:', error);
    }
  };

  // useEffect to fetch models on component mount
  useEffect(() => {
    getModelsList();
  }, []);

  useEffect(() => {
    setPathName(window.location.pathname);
  }, [window.location.pathname]);

  useEffect(() => {
    toastr.options = {
      "closeButton": true,
      "debug": false,
      "newestOnTop": true,
      "progressBar": true,
      "positionClass": "toast-bottom-left",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "600",
      "hideDuration": "1000",
      "timeOut": "5000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "slideDown",
      "hideMethod": "slideUp"
    };
  }, []);

  useEffect(async () => {
    try {
      let formName = endorsementObj.typeOfEndorsement ? endorsementObj.typeOfEndorsement : '';
      if (formEntityObject && formEntityObject.uuid && !formEntityObject.interactionID && formName) {
        let Response = await axios.put(`${CONSTANTS.API_URL}/api/v2/interaction/${formEntityObject.uuid}/${formName}/updateCreateEditForm`, formEntityObject);
        setFormEntityObject(Response.data);
        console.log(Response.data, 'Response.dataResponse.dataResponse.dataResponse.data');
      }
    } catch (HTTPException) {
      await reportException({
        HTTPException,
        fileName,
        functionName: 'useEffect',
      });
      return HTTPException;
    }
  }, [isEntityFormObjectUpdated]);

  /*
    Modification: T319 (Change Taken From Comp's caseSemiDetailViewV3) - Added handleTaskUpdate to handle task update based on if isBatchExists
    By: Ashutosh G
    Date: 29/05/2024
  */
  const handleTaskUpdate = () => {
    if (isBatchExists.current) {
      setIsFormToBeSaved(e => !e);
    }
  };

  /*
    Modification: T319 (Change Taken From Comp's caseSemiDetailViewV3) - Added refs for saveTaskForm and cancelToken
    By: Ashutosh G
    Date: 29/05/2024
  */
  const saveTaskForm = useRef();
  const cancelTokenSource = useRef(null);

  /*
    Modification: T319 (Change Taken From Comp's caseSemiDetailViewV3) - Added useEffect to handle taskUpdate on page close or url change
    By: Ashutosh G
    Date: 29/05/2024
  */
  // useEffect(() => {
  //   window.addEventListener('beforeunload', handleTaskUpdate);

  //   return () => {
  //     cancelTokenSource.current = generateCancelTokenSource(cancelTokenSource.current);
  //     saveTaskForm.current();

  //     window.removeEventListener('beforeunload', handleTaskUpdate);
  //   };
  // }, []);

  /*
    Feature: Unsaved Changes Warning
    Modification: Replaced the silent auto-save-on-close/refresh with
    the browser's native confirm dialog when there are unsaved
    changes.
    By: Priya Gupta
    Date: 04/08/26
  */
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);
  /*
    Modification: T319 (Change Taken From Comp's caseSemiDetailViewV3) - Added a useEffect to monitor signal to save form and execute saveTaskForm with new cancelToken
    By: Ashutosh G
    Date: 29/05/2024
  */
  useEffect(() => {
    cancelTokenSource.current = generateCancelTokenSource(cancelTokenSource.current);
    saveTaskForm.current();
  }, [isFormToBeSaved]);

  /*
    Modification: T319 (Change Taken From Comp's caseSemiDetailViewV3) - Commented code for updating the task and make a new function to update the task
    By: Ashutosh G
    Date: 29/05/2024
  */
  useEffect(async () => {
    try {
      // setIsDataSaving(true);
      if (actions.length) {
        setActions(actions);
        setSelectedArrayForDynamicProps(actions);
      }
      setSelectedActionIndex(selectedActionIndex);
      setCurrentRow(currentRow);
      setInteraction(interactionObj);

      /*
        modified : Ashutosh G
        modified : 05/06/2024
        modification : ignoring to change isBatchExists only first time as useEffect run by default first time
      */
      if (isFirstTimeFormUpdatedChange.current) {
        isFirstTimeFormUpdatedChange.current = false;
      } else {
        // isBatchExists.current = true;
      }
      /*
      Feature: Unsaved Changes Warning
      By: Priya Gupta
      Date: 04/08/26
    */
      if (isOpenFormPopover) {
        setHasUnsavedChanges(true);
      }

      cancelTokenSource.current = generateCancelTokenSource(cancelTokenSource.current);

      /*
       BN: T3945 
       Bug: Digital Lead form (opened from the right panel)
       was auto-saving 3s after every field edit via debouncedSave.
       Modification: Disabled — saving now only happens explicitly
       via submitFormOnStep (Next) or submitFormNew (Complete).
       By: Priya Gupta
       Date: 04/08/26
     */
      // debouncedSave.current();

      /*let payload = currentRow;
      if (actions.length) payload['actionName'] = currentAction ? currentAction.displayName : '';
      // if (isFormUpdated) {
      if (currentRow.uuid) {
        let Response = await axios.put(`${CONSTANTS.API_URL}/api/v2/task/${currentRow.uuid}/updateForm`, payload);
        if (actions.length) {
          let actionsArr = actions;
          let newActionArr = Response.data.actions;
          await Promise.all(actionsArr.map(action => {
            let actionObj = newActionArr.find(actionObj => actionObj.displayName === action.displayName);
            action['actionStatus'] = actionObj.status;
            action['isVisited'] = actionObj.isVisited;
          }));
          await setActions(actionsArr);
        }
        if (Response.data.errorFields && Response.data.errorFields.length) {
          payload['errorFields'] = Response.data.errorFields;
          await setCurrentRow(payload);
        } else {
          payload['errorFields'] = [];
          await setCurrentRow(payload);
        }
      }*/
      // }
      // setIsFormUpdated(false);
      // setIsDataSaving(false);
    } catch (HTTPException) {
      await reportException({
        HTTPException,
        fileName,
        functionName: 'useEffect_1',
      });
      return HTTPException;
    }
  }, [isFormUpdated]);

  /*
    Modification: T319 (Change Taken From Comp's caseSemiDetailViewV3) - Added function to update the task
    By: Ashutosh G
    Date: 29/05/2024
  */
  /*
     BN:T4020
     Modification:
     By: Priya Gupta
     Date: 10/08/26
   */
  saveTaskForm.current = async () => {
    try {
      isBatchExists.current = false;
      setIsDataSaving(true);

      let payload = currentRow;
      if (actions.length) payload['actionName'] = currentAction ? currentAction.displayName : '';
      // if (isFormUpdated) {
      if (currentRow.uuid) {
        let Response = await callAPI(`put`, `/v2/task/${currentRow.uuid}/updateForm`, payload, { cancelTokenSource: cancelTokenSource.current });
        if (actions.length) {
          let actionsArr = actions;
          let newActionArr = Response.data.actions;

          await Promise.all(actionsArr.map(action => {
            let actionObj = newActionArr.find(actionObj => actionObj.displayName === action.displayName);
            action['actionStatus'] = actionObj.status;
            action['isVisited'] = actionObj.isVisited;
          }));
          await setActions(actionsArr);
        }
        let currentStepDynamicProps = (currentAction && currentAction.dynamicProps) ? currentAction.dynamicProps : [];
        let mandatoryFieldNames = currentStepDynamicProps.filter(prop => prop.isRequired).map(prop => prop.name);
        let blockingErrorFields = (Response.data.errorFields || []).filter(errorField => mandatoryFieldNames.includes(errorField.fieldName));
        if (blockingErrorFields.length) {
          payload['errorFields'] = blockingErrorFields;
          payload['isVisited'] = Response.data.isVisited;
          await setCurrentRow(payload);
        } else {
          payload['errorFields'] = [];
          payload['isVisited'] = Response.data.isVisited;
          await setCurrentRow(payload);
        }
        // if (Response.data.errorFields && Response.data.errorFields.length) {
        //   payload['errorFields'] = Response.data.errorFields;
        //   payload['isVisited'] = Response.data.isVisited;
        //   await setCurrentRow(payload);
        // } else {
        //   payload['errorFields'] = [];
        //   payload['isVisited'] = Response.data.isVisited;
        //   await setCurrentRow(payload);
        // }
      }

      setIsDataSaving(false);
    } catch (HTTPException) {
      console.log(HTTPException);
      reportException({
        HTTPException,
        fileName: "globalTaskFollowupModal",
        functionName: 'saveTaskForm'
      })
    }
  }

  /*
    Modification: T319 - Added function to handle states and refs before saving in local component
    By: Ashutosh G
    Date: 29/05/2024
  */
  const handleSaveTaskOnStep = () => {
    console.log('HANDLEDD')
    isBatchExists.current = false;
    cancelTokenSource.current = generateCancelTokenSource(cancelTokenSource.current);
  }

  useEffect(async () => {
    if (isComponentFormUpdated) {
      if (isCreateEditFormPopover) {
        try {

          let payload = {};
          let uuid = formEntityObject.uuid;

          // setting payload
          formDynamicProps.length && formDynamicProps.map((dynamicProp) => {
            // payload[`dynamicProperties_${dynamicProp.name}`] = formEntityObject[dynamicProp.name];
            payload[`${dynamicProp.name}`] = formEntityObject[dynamicProp.name];
          });

          // await updateSelectedInteraction(uuid, payload);
          let currentEntityName = endorsementObj.typeOfEndorsement ? endorsementObj.typeOfEndorsement : endorsementObj.typeOfCase ? endorsementObj.typeOfCase : '';
          let parentEntityID = interactionObj.uuid;
          let parentEntityName = 'Interaction';
          await getEntityDynamicProps(currentEntityName, parentEntityID, 'parent', parentEntityName);

        } catch (error) {
          console.error(error);
        }
      }
    }
    setIsComponentFormUpdated(false);
  }, [isComponentFormUpdated]);

  async function createEndorsement(interactionID, payload) {
    // e.preventDefault();
    try {
      console.log(interactionID, 'interactionIDinteractionID', endorsementObj.typeOfEndorsement, payload);
      payload['interactionID'] = interactionID;
      payload['typeOfEndorsement'] = endorsementObj.typeOfEndorsement;
      // selectedManagerID: endorsementObj.selectedManagerID,
      if (endorsementObj.typeOfEndorsement === 'ncbRecoveryRequest') {
        payload.typeOfTask = "ncbRecoveryRequest";
      } else if (endorsementObj.typeOfEndorsement === 'cancellationApproval') {
        payload.typeOfTask = "cancellationApproval";
      }
      // payload.typeOfEndorsement = endorsementObj.typeOfEndorsement;
      // if (endorsementObj.typeOfEndorsement === 'policy') {
      //   payload.endorsementFileID = endorsementObj.endorsementFileID;
      //   payload.endorsementRemark = endorsementObj.endorsementRemark;
      // } else if (endorsementObj.typeOfEndorsement === 'ncbCertificate') {
      //   payload.isNoClaimBonus = endorsementObj.isNoClaimBonus;
      //   payload.ncbCertificateID = endorsementObj.ncbCertificateID;
      //   payload.ncbPercentage = endorsementObj.ncbPercentage;
      // } else if (endorsementObj.typeOfEndorsement === 'ncbRecoveryRequest') {
      //   payload.reasonForNCBRecovery = endorsementObj.reasonForNCBRecovery;
      //   payload.recoveryAmount = endorsementObj.recoveryAmount;
      //   payload.ncbPercentage = endorsementObj.ncbPercentage;
      //   payload.checkingDate = endorsementObj.checkingDate;
      //   payload.mailSentDate = endorsementObj.mailSentDate;
      //   payload.callDate = endorsementObj.callDate;
      //   payload.insuranceCompany = endorsementObj.insuranceCompany;
      //   payload.endorsementRequestDate = endorsementObj.endorsementRequestDate;
      //   payload.approvalDate = endorsementObj.approvalDate;
      //   payload.paymentMode = endorsementObj.paymentMode;
      //   payload.endorsementFileID = endorsementObj.endorsementFileID;
      //   payload.paymentProofID = endorsementObj.paymentProofID;
      // } else if (endorsementObj.typeOfEndorsement === 'cancellationApproval') {
      //   payload.cancellationReason = endorsementObj.cancellationReason;
      //   if (endorsementObj.cancellationReason === 'Other') {
      //     payload.otherCancellationReason = endorsementObj.otherCancellationReason;
      //   }
      // } else if (endorsementObj.typeOfEndorsement === 'ncbRefund') {
      //   payload.endorsementRequestDate = endorsementObj.endorsementRequestDate;
      //   payload.ncbPercentage = endorsementObj.ncbPercentage;
      //   payload.recoveryAmount = endorsementObj.recoveryAmount;
      //   payload.ncbCertificateID = endorsementObj.ncbCertificateID;
      //   payload.rcCopyID = endorsementObj.rcCopyID;
      //   payload.cancelChequeID = endorsementObj.cancelChequeID;
      // } else if (endorsementObj.typeOfEndorsement === 'accessories') {
      //   payload.endorsementRequestDate = endorsementObj.endorsementRequestDate;
      //   payload.chargesPercentage = endorsementObj.chargesPercentage;
      //   payload.accessoriesInvoiceID = endorsementObj.accessoriesInvoiceID;
      // } else if (endorsementObj.typeOfEndorsement === 'ownerTransfer') {
      //   payload.endorsementRequestDate = endorsementObj.endorsementRequestDate;
      //   payload.recoveryAmount = endorsementObj.recoveryAmount;
      //   payload.ownerTransferDate = endorsementObj.ownerTransferDate;
      //   payload.paymentMode = endorsementObj.paymentMode;
      //   payload.inspectionPhotoID = endorsementObj.inspectionPhotoID;
      //   payload.inspectionReportID = endorsementObj.inspectionReportID;
      //   payload.rcCopyID = endorsementObj.rcCopyID;
      //   payload.endorsementCopyID = endorsementObj.endorsementCopyID;
      //   payload.paymentProofID = endorsementObj.paymentProofID;
      //   payload.bextractCopyID = endorsementObj.bextractCopyID;
      //   payload.bextractCopyID = endorsementObj.bextractCopyID;
      //   payload.bextractCopyID = endorsementObj.bextractCopyID;
      //   payload.transactionID = endorsementObj.transactionID;
      //   payload.paymentDate = endorsementObj.paymentDate;
      // } else if (endorsementObj.typeOfEndorsement === 'correction') {
      //   payload.endorsementRequestDate = endorsementObj.endorsementRequestDate;
      //   payload.typeOfCorrection = [];
      //   if (endorsementObj.nameCorrection || endorsementObj.addressCorrection || endorsementObj.nomineeNameCorrection) {
      //     payload.aadharID = endorsementObj.aadharID;
      //   }
      //   if (endorsementObj.addressCorrection && (endorsementObj.phoneBillID || endorsementObj.electricityBillID)) {
      //     payload.phoneBillID = endorsementObj.phoneBillID;
      //     payload.electricityBillID = endorsementObj.electricityBillID;
      //   }
      //   if (endorsementObj.nomineeNameCorrection) {
      //     payload.nomineePanID = endorsementObj.nomineePanID;
      //     payload.typeOfCorrection.push('Nominee Name');
      //   }
      //   if (endorsementObj.hypoticationCorrection) {
      //     payload.sanctionLetterID = endorsementObj.sanctionLetterID;
      //     payload.typeOfCorrection.push('HP (hypotication)');
      //   }
      //   if (endorsementObj.nameCorrection) {
      //     payload.panID = endorsementObj.panID;
      //     payload.typeOfCorrection.push('Name Correction');
      //   }
      //   if (endorsementObj.addressCorrection) {
      //     payload.typeOfCorrection.push('Address');
      //   }
      //   if (endorsementObj.relationCorrection) {
      //     payload.typeOfCorrection.push('Relation');
      //   }
      //   if (endorsementObj.emailCorrection) {
      //     payload.typeOfCorrection.push('Email ID');
      //   }
      //   payload.typeOfCorrection = payload.typeOfCorrection.join(',');
      // } else if (endorsementObj.typeOfEndorsement === 'cng') {
      //   payload.endorsementRequestDate = endorsementObj.endorsementRequestDate;
      //   payload.invoiceDate = endorsementObj.invoiceDate;
      //   payload.recoveryAmount = endorsementObj.recoveryAmount;
      //   payload.paymentMode = endorsementObj.paymentMode;
      //   payload.transactionID = endorsementObj.transactionID;
      //   payload.paymentDate = endorsementObj.paymentDate;
      //   payload.inspectionPhotoID = endorsementObj.inspectionPhotoID;
      //   payload.inspectionReportID = endorsementObj.inspectionReportID;
      //   payload.cngInvoiceID = endorsementObj.cngInvoiceID;
      //   payload.rcCopyID = endorsementObj.rcCopyID;
      //   payload.endorsementCopyID = endorsementObj.endorsementCopyID;
      // } else if (endorsementObj.typeOfEndorsement === 'newVehicleNo') {
      //   payload.endorsementRequestDate = endorsementObj.endorsementRequestDate;
      //   payload.vehicleNumber = endorsementObj.vehicleNumber;
      //   payload.endorsementFileID = endorsementObj.endorsementFileID;
      // }
      let Response = await axios.put(`${CONSTANTS.API_URL}/api/v1/createEndorsement`, payload);
      if (Response.data.messageResponses && Response.data.messageResponses.length) {
        await Promise.all(Response.data.messageResponses.map(async (messageObj) => {
          if (messageObj.sendTo) {
            let messageNotification = await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, messageObj);
            // if (messageNotification.status === 200) {
            //   triggerNotifications(true)
            // }
            toastr.info(messageObj.message);
          } else {
            toastr.info(messageObj.message);
          }
        }));
        await setEndorsementObj({
          searchQuery: '',
          endorsementFileID: '',
          endorsementRemark: '',
          ncbCertificateID: '',
          isNoClaimBonus: '',
          typeOfEndorsement: endorsementObj.typeOfEndorsement,
          selectedManagerID: '',
          endorsementFileIDSignedURL: '',
          ncbCertificateIDSignedURL: '',
          reasonForNCBRecovery: '',
          recoveryAmount: 0,
          cancellationReason: '',
          otherCancellationReason: '',
          ncbPercentage: 0,
          endorsementRequestDate: null,
          chargesPercentage: '',
          ownerTransferDate: null,
          paymentMode: '',
          transactionID: '',
          paymentDate: null,
          invoiceDate: null,
          vehicleNumber: '',
          checkingDate: null,
          mailSentDate: null,
          callDate: null,
          insuranceCompany: '',
          approvalDate: null,
          cancelChequeID: '',
          cancelChequeIDSignedURL: '',
          panID: '',
          panIDSignedURL: '',
          electricityBillID: '',
          electricityBillIDSignedURL: '',
          nomineePanID: '',
          nomineePanIDSignedURL: '',
          sanctionLetterID: '',
          sanctionLetterIDSignedURL: '',
          accessoriesInvoiceID: '',
          accessoriesInvoiceIDSignedURL: '',
          inspectionPhotoID: '',
          inspectionPhotoIDSignedURL: '',
          inspectionReportID: '',
          inspectionReportIDSignedURL: '',
          rcCopyID: '',
          rcCopyIDSignedURL: '',
          paymentProofID: '',
          paymentProofIDSignedURL: '',
          bextractCopyID: '',
          bextractCopyIDSignedURL: '',
          cngInvoiceID: '',
          cngInvoiceIDSignedURL: '',
          phoneBillID: '',
          phoneBillIDSignedURL: '',
          nameCorrection: false,
          addressCorrection: false,
          nomineeNameCorrection: false,
          relationCorrection: false,
          hypoticationCorrection: false,
          emailCorrection: false,
          accessoriesCost: 0
        });
        await setInteraction({});
      }
    } catch (HTTPException) {
      await reportException({
        HTTPException,
        fileName,
        functionName: 'createEndorsement',
      });
      return HTTPException;
    }
  }

  async function searchCase(type, interactionID) {
    try {
      setEndorsementLoader(true)
      console.log('We are in guys! We are in!');
      console.log(type, interactionID, 'Oh okay this is it');
      let Response = {}
      if (interactionID) {
        Response = await axios.get(`${CONSTANTS.API_URL}/api/v1/findCase?q=${interactionID}&isForEndorsement=true`);
      } else {
        Response = await axios.get(`${CONSTANTS.API_URL}/api/v1/findCase?q=${endorsementObj.searchQuery}&interactionType=${endorsementObj.typeOfCase}&isForEndorsement=true`);
      }
      if (type === 'Input') {
        let searchResultsArr = Response.data;
        setSearchResults(searchResultsArr);
      } else {
        if (!Response.data[0] || !Response.data[0].uuid) {
          toastr.error('No Cases found. Make sure you have entered a corrected search query.');
          setEndorsementLoader(false)
          return;
        }
        await setInteraction(Response.data[0]);
        await setEndorsementObj({ ...endorsementObj, isNoClaimBonus: Response.data[0]['dynamicProperties_isNoClaimBonus'] ? Response.data[0]['dynamicProperties_isNoClaimBonus'] : '' });
        await getImageSignedUrlForEndorsement(Response.data[0]);
        let currentEntityName = endorsementObj.typeOfEndorsement ? endorsementObj.typeOfEndorsement : endorsementObj.typeOfCase ? endorsementObj.typeOfCase : '';
        let parentEntityID = Response.data[0].uuid;
        let parentEntityName = 'Interaction';
        console.log(endorsementObj, ';endorsementObjendorsementObjendorsementObj');
        console.log(currentEntityName, 'currentEntityNamecurrentEntityNamecurrentEntityName');
        if (currentEntityName) {
          await getEntityDynamicProps(currentEntityName, parentEntityID, 'parent', parentEntityName);
          setFormEntityName('Interaction');
          let formOperationName = endorsementObj.typeOfEndorsement ? requestTypes[endorsementObj.typeOfEndorsement] : endorsementObj.typeOfCase ? endorsementObj.typeOfCase : '';
          setFormOperation(formOperationName);
          setFormEntityObject(Response.data[0]);
          // setIsEntityFormObjectUpdated(!isEntityFormObjectUpdated);
          setIsCreateEditFormPopover(true);
          console.log(formOperation, 'formOperationformOperationformOperationformOperationformOperation');
          console.log(formEntityName, 'formEntityNameformEntityNameformEntityNameformEntityNameformEntityName');
          console.log(formEntityObject, 'formEntityObjectformEntityObjectformEntityObjectformEntityObjectformEntityObject');
          console.log(isCreateEditFormPopover, 'Iscreateeeeeeeeeeeee');
        }
      }
      setEndorsementLoader(false);
    } catch (HTTPException) {
      setEndorsementLoader(false);
      await reportException({
        HTTPException,
        fileName,
        functionName: 'searchCase',
      });
      return HTTPException;
    }
  }
  async function getImageSignedUrlForEndorsement(interactionObject) {
    try {
      let fileIDArray = [
        "endorsementFileID",
        "ncbCertificateID",
        "cancelChequeID",
        "electricityBillID",
        "nomineePanID",
        "sanctionLetterID",
        "accessoriesInvoiceID",
        "inspectionPhotoID",
        "inspectionReportID",
        "rcCopyID",
        "paymentProofID",
        "bextractCopyID",
        "cngInvoiceID",
        "phoneBillID"
      ];
      await Promise.all(fileIDArray.map(async fieldName => {
        if ((typeof interactionObject['dynamicProperties_' + fieldName] === "object" && interactionObject['dynamicProperties_' + fieldName].length) || (typeof interactionObject['dynamicProperties_' + fieldName] === "string" && interactionObject['dynamicProperties_' + fieldName])) {
          let file = await axios.get(`${CONSTANTS.API_URL}/api/v1/file/getFileFromS3?courierID=${interactionObject.uuid}&fileID=${interactionObject['dynamicProperties_' + fieldName]}&s3KeyFor=case`)
          if (file.data[0]) {
            //return file.data[0].signedUrl;
            await setEndorsementObj({ ...endorsementObj, [`${fieldName}SignedURL`]: file.data[0].signedUrl });
          } else {
            await setEndorsementObj({ ...endorsementObj, [`${fieldName}SignedURL`]: '' });
          }
        }
      }));
    } catch (HTTPException) {
      await reportException({
        HTTPException,
        fileName,
        functionName: 'getImageSignedUrlForEndorsement',
      });
      return HTTPException;
    }
  }

  function toggleEndorsementFormPopover(e, type) {
    // e.preventDefault();
    setEndorsementObj({
      searchQuery: '',
      endorsementFileID: '',
      endorsementRemark: '',
      ncbCertificateID: '',
      isNoClaimBonus: '',
      typeOfEndorsement: '',
      typeOfCase: '',
      selectedManagerID: '',
      endorsementFileIDSignedURL: '',
      ncbCertificateIDSignedURL: '',
      reasonForNCBRecovery: '',
      recoveryAmount: 0,
      cancellationReason: '',
      otherCancellationReason: '',
      ncbPercentage: 0,
      endorsementRequestDate: null,
      chargesPercentage: '',
      ownerTransferDate: null,
      paymentMode: '',
      transactionID: '',
      paymentDate: null,
      invoiceDate: null,
      vehicleNumber: '',
      checkingDate: null,
      mailSentDate: null,
      callDate: null,
      insuranceCompany: '',
      approvalDate: null,
      cancelChequeID: '',
      cancelChequeIDSignedURL: '',
      panID: '',
      panIDSignedURL: '',
      electricityBillID: '',
      electricityBillIDSignedURL: '',
      nomineePanID: '',
      nomineePanIDSignedURL: '',
      sanctionLetterID: '',
      sanctionLetterIDSignedURL: '',
      accessoriesInvoiceID: '',
      accessoriesInvoiceIDSignedURL: '',
      inspectionPhotoID: '',
      inspectionPhotoIDSignedURL: '',
      inspectionReportID: '',
      inspectionReportIDSignedURL: '',
      rcCopyID: '',
      rcCopyIDSignedURL: '',
      paymentProofID: '',
      paymentProofIDSignedURL: '',
      bextractCopyID: '',
      bextractCopyIDSignedURL: '',
      cngInvoiceID: '',
      cngInvoiceIDSignedURL: '',
      phoneBillID: '',
      phoneBillIDSignedURL: '',
      nameCorrection: false,
      addressCorrection: false,
      nomineeNameCorrection: false,
      relationCorrection: false,
      hypoticationCorrection: false,
      emailCorrection: false,
      accessoriesCost: 0
    });
    setInteraction({});
    setIsOpenCaseFormPopover(!isOpenCaseFormPopover);
    console.log(isOpenCaseFormPopover, 'Ohhhhh dekho dekho yeh badal gaye');
  }

  function toggleEditCaseFormPopover(e, type) {
    e.preventDefault();
    setEndorsementObj({
      searchQuery: '',
      endorsementFileID: '',
      endorsementRemark: '',
      ncbCertificateID: '',
      isNoClaimBonus: '',
      typeOfEndorsement: '',
      typeOfCase: '',
      selectedManagerID: '',
      endorsementFileIDSignedURL: '',
      ncbCertificateIDSignedURL: '',
      reasonForNCBRecovery: '',
      recoveryAmount: 0,
      cancellationReason: '',
      otherCancellationReason: '',
      ncbPercentage: 0,
      endorsementRequestDate: null,
      chargesPercentage: '',
      ownerTransferDate: null,
      paymentMode: '',
      transactionID: '',
      paymentDate: null,
      invoiceDate: null,
      vehicleNumber: '',
      checkingDate: null,
      mailSentDate: null,
      callDate: null,
      insuranceCompany: '',
      approvalDate: null,
      cancelChequeID: '',
      cancelChequeIDSignedURL: '',
      panID: '',
      panIDSignedURL: '',
      electricityBillID: '',
      electricityBillIDSignedURL: '',
      nomineePanID: '',
      nomineePanIDSignedURL: '',
      sanctionLetterID: '',
      sanctionLetterIDSignedURL: '',
      accessoriesInvoiceID: '',
      accessoriesInvoiceIDSignedURL: '',
      inspectionPhotoID: '',
      inspectionPhotoIDSignedURL: '',
      inspectionReportID: '',
      inspectionReportIDSignedURL: '',
      rcCopyID: '',
      rcCopyIDSignedURL: '',
      paymentProofID: '',
      paymentProofIDSignedURL: '',
      bextractCopyID: '',
      bextractCopyIDSignedURL: '',
      cngInvoiceID: '',
      cngInvoiceIDSignedURL: '',
      phoneBillID: '',
      phoneBillIDSignedURL: '',
      nameCorrection: false,
      addressCorrection: false,
      nomineeNameCorrection: false,
      relationCorrection: false,
      hypoticationCorrection: false,
      emailCorrection: false,
      accessoriesCost: 0
    });
    setInteraction({});
    setIsEditCaseFormPopover(!isEditCaseFormPopover);
  }

  const toggleComponentFormPopover = (e) => {
    setIsCreateEditFormPopover(!isCreateEditFormPopover);
    setIsEditCaseFormPopover(false);
    setIsOpenCaseFormPopover(false);
  };

  const resetFormValues = () => {
    setFormOperation();
    setFormEntityName();
    setFormEntityObject();
    setFormDynamicProps();
  };

  const getEntityDynamicProps = async (currentEntityName, currentEntityID, entityIDOf, parentEntityName) => {
    try {
      let url = `${CONSTANTS.API_URL}/api/v1/dynamicProperty?formName=${currentEntityName}&userDealershipID=${userInfo.userDealershipID}&userDealershipName=${userInfo.userDealershipName}&userBranchID=${userInfo.userBranchID}&activationStatus=active`;
      if (currentEntityID) {
        url += `&entityID=${currentEntityID}`;
      }
      if (entityIDOf) {
        url += `&entityIDOf=${entityIDOf}`;
      }
      if (parentEntityName) {
        url += `&parentEntityName=${parentEntityName}`;
      }
      let dynamicPropsForEntity = await axios.get(`${url}&sortBy=serialNumber`);
      if (dynamicPropsForEntity.data) {
        setFormDynamicProps(dynamicPropsForEntity.data);
      }
    } catch (HTTPException) {
      await reportException({
        HTTPException,
        fileName,
        functionName: 'getEntityDynamicProps',
      });
      return HTTPException;
    }
  };

  const updateSelectedInteraction = async (uuid, payload) => {
    try {
      await axios.put(`${CONSTANTS.API_URL}/api/v1/updateInteraction/${uuid}`, payload);
    } catch (HTTPException) {
      await reportException({
        HTTPException,
        fileName,
        functionName: 'updateSelectedInteraction',
      });
      await axios.post(`${CONSTANTS.API_URL}/api/v1/exception`, payload);
      return HTTPException;
    }
  };

  const setComponentFormValueInput = async (e, fieldName) => {
    e.preventDefault();
    let obj = JSON.parse(JSON.stringify(formEntityObject));

    if (!e.target.value) {
      obj[fieldName] = e.target.value;
      let successNode = document.getElementById("success-" + fieldName);
      if (successNode) {
        successNode.style.display = "none";
      }
    } else {
      obj[fieldName] = e.target.value;
    }
    /*if (document.getElementById(fieldName)) {
      if ((fieldName === "addressLine1" || fieldName === "companyAddress") && e.target.value.length < 4) {
        document.getElementById(fieldName).style.borderBottom = "2px solid red";
        let spanNode = document.getElementById("error-"+fieldName);
        if (spanNode) {
          spanNode.style.display ="block";
          spanNode.innerHTML = "Address should be greater than 4 characters"
        }
      } else if ((fieldName === "addressLine1" || fieldName === "companyAddress") && e.target.value.length > 50) {
        document.getElementById(fieldName).style.borderBottom = "2px solid red";
        let spanNode = document.getElementById("error-"+fieldName);
        if (spanNode) {
          spanNode.style.display ="block";
          spanNode.innerHTML = "Address should be less than 50 characters"
        }
      } else {
        document.getElementById(fieldName).style.borderBottom = "1px solid #9e9e9e";
        let node = document.getElementById("error-"+fieldName);
        if (node) {
          node.style.color = "#9e9e9e";
        }
        if (e.target.value) {
          let successNode = document.getElementById("success-"+fieldName);
          if (successNode) {
            successNode.style.display = "inline";
            let requiredNode = document.getElementById("required-"+fieldName);
            if (requiredNode) {
              requiredNode.style.display = "none";
            }
          }
        }

      }
    }*/
    // setIsFormUpdated(!isFormUpdated);
    setFormEntityObject(obj);
    /*
      By: Yashvi
      On: 21st Feb 2024
      Modification: Comment setIsEntityFormObjectUpdated state on input event. API will only be called onFocusout event
    */
    // setIsEntityFormObjectUpdated(!isEntityFormObjectUpdated);
  };

  const saveComponentFormInput = async (e, fieldName, formType, index) => {
    console.log("Hwpppen")
    e.preventDefault();

    let obj = JSON.parse(JSON.stringify(formEntityObject));
    if (formType && formType === "select") {
      /*
      Changed By Rutuja
      Changed on 24/2/23
      Set hypothecation to yes / no dependening on type of hypothecation
      */
      if (fieldName === "dynamicProperties_typeOfHypothecation" && e.target.value === "Add") {
        obj['dynamicProperties_hypothecation'] = "yes";
      } else if (fieldName === "dynamicProperties_typeOfHypothecation" && e.target.value === "Remove") {
        obj['dynamicProperties_hypothecation'] = "no";
      }
      obj[fieldName] = e.target.value;
      /*if (actions.length) {
        await Promise.all(actions[index]['dynamicProps'].map(async (prop) => {
          if (prop.dependentEnum && prop.dependentEnum.length && prop.dependentEnum[0]['nameOfProp'] === fieldName) {
            await Promise.all(prop.dependentEnum.map((dependentEnumObj) => {
              if (dependentEnumObj['valueOfProp'] === e.target.value) {
                dependentEnumObj['isSelected'] = true
              } else {
                dependentEnumObj['isSelected'] = false
              }
            }));
          }
        }));
      }
      else */
      /*if (formDynamicProps.length) {

        let formDynamicPropsIndex = formDynamicProps.findIndex(o => o.name === fieldName);
        let prop = formDynamicProps[formDynamicPropsIndex]

        if (prop.dependentEnum && prop.dependentEnum.length && prop.dependentEnum[0]['nameOfProp'] === fieldName) {
          await Promise.all(prop.dependentEnum.map((dependentEnumObj) => {
            if (dependentEnumObj['valueOfProp'] === e.target.value) {
              dependentEnumObj['isSelected'] = true
            } else {
              dependentEnumObj['isSelected'] = false
            }
          }));
        }
      }*/
    } else {
      obj[fieldName] = e.target.value;
    }
    setFormEntityObject(obj);
    setCurrentUpdatedPropName(fieldName);
    setIsEntityFormObjectUpdated(!isEntityFormObjectUpdated);
    setIsComponentFormUpdated(true);
  };

  const saveComponentFormInputRadioDefault = (e, fieldName, typeOfDBField) => {
    let obj = JSON.parse(JSON.stringify(formEntityObject));
    if (typeOfDBField === "Boolean") {
      obj[fieldName] = e.target.value.toLowerCase() === 'yes' ? true : false;
    } else {
      obj[fieldName] = e.target.value;
    }
    setFormEntityObject(obj);
    setIsEntityFormObjectUpdated(!isEntityFormObjectUpdated);
  };

  const saveComponentFormInputRadio = (e, fieldName, value, index) => {
    let obj = JSON.parse(JSON.stringify(formEntityObject));
    obj[fieldName] = e.target.value;
    setFormEntityObject(obj);
    setIsEntityFormObjectUpdated(!isEntityFormObjectUpdated);
  };

  /*
    By: Yashvi
    On: 22nd Feb 2024
    Modification: Comment setIsEntityFormObjectUpdated state on input event. API will only be called onFocusout event
  */
  const saveComponentFormInputCheckbox = (e, fieldName, value) => {
    let obj = JSON.parse(JSON.stringify(formEntityObject));

    if (e.target.checked && (!obj[fieldName] || !obj[fieldName].split(",").includes(value))) {
      obj[fieldName] = obj[fieldName] + ',' + value;
    } else if (!e.target.checked && obj[fieldName].split(",").includes(value)) {
      let idx = obj[fieldName].split(",").findIndex(d => d === value);
      let tempArr = obj[fieldName].split(",");
      let deleted = tempArr.splice(idx, 1);
      obj[fieldName] = tempArr.join(",");
    }
    setFormEntityObject(obj);
    // setIsEntityFormObjectUpdated(!isEntityFormObjectUpdated);
  };

  const saveAreaFromComponentForm = (e, name) => {
    let obj = JSON.parse(JSON.stringify(formEntityObject));
    obj[name] = e.target.value;
    setFormEntityObject(obj);
    setIsEntityFormObjectUpdated(!isEntityFormObjectUpdated);
  };

  const setFormStageValueInput = (e, key, index) => {
    let obj = JSON.parse(JSON.stringify(formDynamicProps));
    obj[index][key] = e.target.value;
    setFormDynamicProps(obj);
  };

  const setFormArrayValueInput = (e, name, value, key, index) => {
    e.preventDefault();
    let formObj = JSON.parse(JSON.stringify(formEntityObject));
    if (value.trim()) {
      if (formObj[name]) {
        formObj[name].push(value.trim())
      } else {
        formObj[name] = [];
        formObj[name].push(value.trim())
      }
    };
    setFormEntityObject(formObj);

    let dynamicPropObj = JSON.parse(JSON.stringify(formDynamicProps));
    dynamicPropObj[index][key] = "";
    setFormDynamicProps(dynamicPropObj);
  };

  const removeFormArrayValueInput = (e, key, arrRemoveIndex) => {
    let obj = JSON.parse(JSON.stringify(formEntityObject));
    obj[key].splice(arrRemoveIndex, 1);
    setFormEntityObject(obj);
  };

  const submitComponentForm = async (e) => {
    e.preventDefault();
    if (isCreateEditFormPopover) {
      try {

        let payload = {};
        let uuid = formEntityObject.uuid;

        // setting payload
        formDynamicProps.length && formDynamicProps.map((dynamicProp) => {
          payload[`dynamicProperties_${dynamicProp.name}`] = formEntityObject[dynamicProp.name];
        });
        if (endorsementObj.typeOfCase === "Payment Details") {
          payload['isPaymentDetailsUpdation'] = true;
        }
        console.log(uuid, payload, 'payloadpayloadpayloadpayloadpayload');
        await createEndorsement(uuid, payload);

        toggleComponentFormPopover();
        resetFormValues();
      } catch (error) {
        console.error(error);
      }
    }
  };
  const deleteUploadedFileCase = async (e, fieldName) => {
    // interactionObj['dynamicProperties_'+`${fieldName}`] = '';
    interactionObj[`${fieldName}`] = '';
    await setEndorsementObj({ ...endorsementObj, [fieldName]: '', [`${fieldName}SignedURL`]: '' });
    let obj = JSON.parse(JSON.stringify(formEntityObject));
    // obj['dynamicProperties_'+fieldName] = '';
    obj[fieldName] = '';
    obj[fieldName] = ''; formEntityObject = obj;
    setFormEntityObject(formEntityObject);
    setIsEntityFormObjectUpdated(!isEntityFormObjectUpdated);
  }

  async function getCompressedImageFile(fileToBeUploaded) {
    let imageFileToBeCompressed = fileToBeUploaded.files[0];
    const options = {
      maxSizeMB: 0.2,
      maxWidthOrHeight: 900
    };
    let compressedFile = await imageCompression(imageFileToBeCompressed, options);
    let fileData = '';
    let fileObj = {};
    if (fileToBeUploaded.files[0].size > 30000) {
      fileData = compressedFile;
      fileObj.name = compressedFile.name;
      fileObj.size = compressedFile.size;
      fileObj.type = imageFileToBeCompressed.type;
      fileObj.value = fileToBeUploaded.value;
    } else {
      fileData = imageFileToBeCompressed;
      fileObj.name = imageFileToBeCompressed.name;
      fileObj.size = imageFileToBeCompressed.size;
      fileObj.type = imageFileToBeCompressed.type;
      fileObj.value = fileToBeUploaded.value;
    }
    return Promise.resolve(fileData);
  }

  /*
    Bug: KH_BG_222 Renewal Insurance Generate Renewal Quotation - Previous Policy PDF	Upload File Validations missing
    Modification: Added file extension check before uploading the file
    By: Devang
    Date: 25/11/2023
  */
  const uploadFileCase = async (e, fieldName) => {
    try {
      const fileTypeError = await isAllowedFileType(e.target.files[0]);
      if (!fileTypeError) {
        toastr.warning("This file cannot be uploaded either because this is not a supported file type. Please exclude such files and try again.");
        return;
      }
      const file = {
        name: e.target.files[0].name,
        size: e.target.files[0].size,
        type: e.target.files[0].type,
        value: e.target.files[0].name,
      };
      let payload = {
        file,
        interactionID: interactionObj.uuid
      }
      let fileDetails
      await axios.post(`${CONSTANTS.API_URL}/api/v1/file/getSignedUrl`, payload).then(async res => {
        if (res && res.data) {
          fileDetails = res.data;
          try {
            //  Save File on S3
            const opts = {
              headers: {
                name: 'Content-Type',
                value: 'multipart/form-data',
              }
            };
            /*
              By: Yashvi
              On: 20th July 2022
              If file type is image only then compress the file.
            */
            let fileData = e.target.files[0];
            let fileExtension = e.target.files[0].name.split('.').pop();
            if (imageTypeExtension.includes(fileExtension)) {
              fileData = await getCompressedImageFile(e.target);
            }
            const fileUpload = await axios.put(fileDetails.signedURL, fileData, opts);

            // interactionObj['dynamicProperties_'+fieldName] = fileDetails.uuid;
            interactionObj[fieldName] = fileDetails.uuid;
            await setEndorsementObj({ ...endorsementObj, [fieldName]: fileDetails.uuid, [`${fieldName}SignedURL`]: URL.createObjectURL(e.target.files[0]) });
            let obj = JSON.parse(JSON.stringify(formEntityObject));
            // obj['dynamicProperties_'+fieldName] = fileDetails.uuid;
            obj[fieldName] = fileDetails.uuid;
            obj[fieldName] = fileDetails.uuid;
            formEntityObject = obj;
            setFormEntityObject(formEntityObject);
            setIsEntityFormObjectUpdated(!isEntityFormObjectUpdated);
          } catch (e) {
            console.error(e);
          }
        }
      });
    } catch (HTTPException) {
      await reportException({
        HTTPException,
        fileName,
        functionName: 'uploadFileCase',
      });
      return HTTPException;
    }
  }
  /******************************************************************************/
  useEffect(async () => {
    // getBothVisitsCounts()
    // getListOfVisitsCommercial()
    // getListOfVisitsNonCommercial()
    // let catalogoueItemResponse = await axios.get(`${CONSTANTS.API_URL}/api/v1/variants/catalogue?noLimit=noLimit&status=Active`);
    let catalogoueItemResponse = await axios.get(`${CONSTANTS.API_URL}/api/v1/models/catalogue?isForInsurance=false&status=Active&brandType=Hyundai`);
    let array = catalogoueItemResponse.data
    console.log(array, 'arrayarray');

    const result = [];
    const map = new Map();
    for (const item of array) {
      if (!map.has(item.displayName)) {
        map.set(item.displayName, true);    // set any value to Map
        result.push({
          ...item
        });
      }
    }
    await setCatalogoueItemList(result);
  }, [])

  useEffect(() => {
    setOngoingCallWindowOpen(props.isOngoingCallWindowOpen)
  }, [props.isOngoingCallWindowOpen])
  const useOutsideClick = (callback) => {
    const ref = useRef();
    useEffect(() => {
      const handleClick = (event) => {

        if (ref.current && !ref.current.contains(event.target)) {

          callback();
        }
      };
      document.addEventListener('click', handleClick, true);
      return () => {
        document.removeEventListener('click', handleClick, true);
      };
    }, [ref]);
    return ref;
  };
  /*
    Modification: Added event listeners for key combos and escape to open and close search
    By: Devang
    Date: 04/02/2023
  */
  useEffect(() => {
    window.onkeydown = function (event) {
      checkIfSearchKeyComboPressed(event);
      checkIfSearchCloseKeyPressed(event);
    };
  }, []);
  const checkIfSearchKeyComboPressed = (e) => {
    let evtobj = window.event ? event : e
    // combination of ctrl + K
    if (evtobj.keyCode == 75 && evtobj.ctrlKey) {
      e.preventDefault();
      setIsGlobalSearchVisible(true);
    }
  }
  const checkIfSearchCloseKeyPressed = (e) => {
    let evtobj = window.event ? event : e
    if (evtobj.keyCode == 27) setIsGlobalSearchVisible(false);
  }

  async function selectedCarModel(model) {
    console.log(exShowroomTableData, '----------------setExShowroomTableData');

    setModelForPriceList(model);
    setDisablePDFButton(true);
    setModelVariantName('');
    setCatalogueCarVariant([]);
    setCatalogueCarVariantDiesel([]);
    setCatalogueCarVariantCNG([]);
    setIsEmptyPetrolData(false);
    setIsEmptyDieselData(false);
    setIsEmptyCNGData(false);
    setIsEmptyEVData(false);
    // setSolidColourTableHeader([]);
    // setCarVariantTableData([]);
    // setExShowroomTableData([]);
    // setTcsExShowroomTableData([]);
    // setInsuranceTableData([]);
    // setRtoCompanyTableData([]);
    // setRtoIndividualTableData([]);
    // setRtoBHPassingTableData([]);
    // setFourFifthExtendedWarrantyTableData([]);
    // setRmkTableData([]);
    // setBasicAccessoriesKitTableData([]);
    // setRsaTableData([]);
    // setAdditionalPremiumForEngineProtectionTableData([]);
    // setAdditionalPremiumforReturnToInvoiceTableData([]);
    // setTotalIndividualTableData([]);
    // setTotalCompanyTableData([]);
    // setSheildOfTrustTableData([]);
    // setEffectiveDateFrom([]);




    setCarVariantTableData([{ text: "PARTICULARS", fontSize: 12, bold: false }]);
    setExShowroomTableData([{ text: "EX - SHOWROOM PRICE", fontSize: 12, bold: false }]);
    setTcsExShowroomTableData([{ text: "TCS 1% EX-SHOWROOM", fontSize: 12, bold: false }]);
    setInsuranceTableData([{ text: "INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize: 12, bold: false }]);
    setRtoBHPassingTableData([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing', fontSize: 12, bold: false }]);
    setRtoIndividualTableData([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize: 12, bold: false }]);

    setFourFifthExtendedWarrantyTableData([{ text: '4th & 5th YEAR EXTENDED WARRANTY', fontSize: 12, bold: false }]);
    setRmkTableData([{ text: 'RMK', fontSize: 12, bold: false }]);
    setBasicAccessoriesKitTableData([{ text: 'BASIC ACCESSORIES KIT', fontSize: 12, bold: false }]);
    setRsaTableData([{ text: 'RSA', fontSize: 12, bold: false }]);
    setAdditionalPremiumForEngineProtectionTableData([{ text: 'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize: 12, bold: false }]);
    setAdditionalPremiumforReturnToInvoiceTableData([{ text: 'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize: 12, bold: false }]);
    setTotalIndividualTableData([{ text: 'TOTAL INDIVIDUAL', fontSize: 12, bold: false }]);
    setTotalCompanyTableData([{ text: 'TOTAL COMPANY', fontSize: 12, bold: false }]);
    setSheildOfTrustTableData([{ text: 'T5 YR/60K SHIELD OF TRUST', fontSize: 12, bold: false }]);
    setPriceListForPmc([{ text: 'PRICE LIST FOR KDMS', fontSize: 12, bold: false, alignment: "center" }]);
    setAllNewi20TableHeader([{ text: 'All New i20', alignment: "center", fontSize: 15, bold: false }]);
    setSolidColourTableHeader([{ text: 'COLOUR : SOLID COLOUR = ', fontSize: 12, bold: false }]);
    setNoCashPaymentTableHeader([{ text: 'Note : NO CASH PAYMENT ABOVE RS 200000/- WILL BE ACCEPTED', fontSize: 12, bold: false }]);
    setTermsAndConitionsTableHeader([{ text: 'Terms & Conditions Details Overleaf', fontSize: 12, bold: false }]);
    setTermsAndConitionsTableData([{ text: 'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi', fontSize: 12, bold: false }]);
    setTermsAndConitionsDetailsTableData([{
      colSpan: 0,
      bold: false,
      ol: []

    }]);
    setShowroomITableData([{ text: 'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.', fontSize: 12, bold: false }]);
    setShowroomIITableData([{ text: 'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.', fontSize: 12, bold: false }]);
    setShowroomIIITableData([{ text: 'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100', fontSize: 12, bold: false }]);
    setShowroomIVTableData([{ text: 'Showroom IV: Gat No. 15,49/1 , Nagar-Pune road, Opp Manikchand Company, Saradwadi, Shirur 412210 Phone 02138-602525', fontSize: 12, bold: false }]);
    setShowroomVTableData([{ text: '"Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205', fontSize: 12, bold: false }]);
    setShowroomVITableData([{ text: '"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.', fontSize: 12, bold: false }]);
    setWork1TableData([{ text: 'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96', fontSize: 12, bold: false }]);
    setWork2TableData([{ text: 'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ', fontSize: 12, bold: false }]);
    setWork3TableData([{ text: 'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506', fontSize: 12, bold: false }]);
    setWork4TableData([{ text: 'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ', fontSize: 12, bold: false }]);
    setDepotTableData([{ text: 'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ', fontSize: 12, bold: false }]);
    setCarVariantDieselTableData([{ text: "PARTICULARS", fontSize: 12, bold: false }]);
    setExShowroomDieselTableData([{ text: "EX - SHOWROOM PRICE", fontSize: 12, bold: false }]);
    setTcsExShowroomDieselTableData([{ text: "TCS 1% EX-SHOWROOM", fontSize: 12, bold: false }]);
    setInsuranceDieselTableData([{ text: "INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize: 12, bold: false }]);
    setRtoCompanyDieselTableData([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize: 12, bold: false }]);
    setRtoIndividualDieselTableData([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize: 12, bold: false }]);
    setRtoBHPassingDieselTableData([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR BH Passing', fontSize: 12, bold: false }]);
    setFourFifthExtendedWarrantyDieselTableData([{ text: '4th & 5th YEAR EXTENDED WARRANTY', fontSize: 12, bold: false }]);
    setRmkDieselTableData([{ text: 'RMK', fontSize: 12, bold: false }]);
    setBasicAccessoriesKitDieselTableData([{ text: 'BASIC ACCESSORIES KIT', fontSize: 12, bold: false }]);
    setRsaDieselTableData([{ text: 'RSA', fontSize: 12, bold: false }]);
    setAdditionalPremiumForEngineProtectionDieselTableData([{ text: 'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize: 12, bold: false }]);
    setAdditionalPremiumforReturnToInvoiceDieselTableData([{ text: 'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize: 12, bold: false }]);
    setTotalIndividualDieselTableData([{ text: 'TOTAL INDIVIDUAL', fontSize: 12, bold: false }]);
    setTotalCompanyDieselTableData([{ text: 'TOTAL COMPANY', fontSize: 12, bold: false }]);
    setSheildOfTrustDieselTableData([{ text: 'T5 YR/60K SHIELD OF TRUST', fontSize: 12, bold: false }]);
    setModelDieselTableHeader([{ text: '', alignment: "center", fontSize: 12, bold: false }]);
    setCarVariantCNGTableData([{ text: "PARTICULARS", fontSize: 12, bold: false }]);
    setExShowroomCNGTableData([{ text: "EX - SHOWROOM PRICE", fontSize: 12, bold: false }]);
    setTcsExShowroomCNGTableData([{ text: "TCS 1% EX-SHOWROOM", fontSize: 12, bold: false }]);
    setInsuranceCNGTableData([{ text: "INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize: 12, bold: false }]);
    setRtoCompanyCNGTableData([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize: 12, bold: false }]);
    setRtoIndividualCNGTableData([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize: 12, bold: false }]);
    setRtoBHPassingCNGTableData([{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR BH Passing', fontSize: 12, bold: false }]);
    setFourFifthExtendedWarrantyCNGTableData([{ text: '4th & 5th YEAR EXTENDED WARRANTY', fontSize: 12, bold: false }]);
    setRmkCNGTableData([{ text: 'RMK', fontSize: 12, bold: false }]);
    setBasicAccessoriesKitCNGTableData([{ text: 'BASIC ACCESSORIES KIT', fontSize: 12, bold: false }]);
    setRsaCNGTableData([{ text: 'RSA', fontSize: 12, bold: false }]);
    setAdditionalPremiumForEngineProtectionCNGTableData([{ text: 'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize: 12, bold: false }]);
    setAdditionalPremiumforReturnToInvoiceCNGTableData([{ text: 'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize: 12, bold: false }]);
    setTotalIndividualCNGTableData([{ text: 'TOTAL INDIVIDUAL', fontSize: 12, bold: false }]);
    setTotalCompanyCNGTableData([{ text: 'TOTAL COMPANY', fontSize: 12, bold: false }]);
    setSheildOfTrustCNGTableData([{ text: 'T5 YR/60K SHIELD OF TRUST', fontSize: 12, bold: false }]);

    let catalogoueCarVariantPetrolData;
    let catalogoueCarVariantDieselData;
    let catalogoueCarVariantCNGData;
    let catalogoueCarVariantEVData;
    let termsAndConditionsData;
    let termsAndConditionsDataCNG;
    let termsAndConditionsDataDiesel;
    let termsAndConditionsDataEV;

    // if(model === "konaev") {
    //   catalogoueCarVariantPetrolData = await axios.get(`${CONSTANTS.API_URL}/api/v1/catalogue/carVariant?model=${model}&&fuelType=EV`);
    //   await setCatalogueCarVariant(catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems);
    // } else {

    //For Petrol Variants
    catalogoueCarVariantPetrolData = await axios.get(`${CONSTANTS.API_URL}/api/v1/variants/price-list-items?modelName=${model}&fuelType=Petrol&status=Active&noLimit=noLimit`);
    termsAndConditionsData = catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.termsAndConditions ? catalogoueCarVariantPetrolData.data.termsAndConditions : [];
    setTermsAndConditionsData(termsAndConditionsData);
    setEffectivePriceListDate(catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.effectivePriceListDate ? catalogoueCarVariantPetrolData.data.effectivePriceListDate : '');
    await setCatalogueCarVariant(catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems);

    // For Diesel Variants
    catalogoueCarVariantDieselData = await axios.get(`${CONSTANTS.API_URL}/api/v1/variants/price-list-items?modelName=${model}&fuelType=Diesel&status=Active&noLimit=noLimit`);
    await setCatalogueCarVariantDiesel(catalogoueCarVariantDieselData.data && catalogoueCarVariantDieselData.data.priceListItems);
    termsAndConditionsDataDiesel = catalogoueCarVariantDieselData.data && catalogoueCarVariantDieselData.data.termsAndConditions ? catalogoueCarVariantDieselData.data.termsAndConditions : termsAndConditionsDataDiesel;
    setTermsAndConditionsDataDiesel(termsAndConditionsDataDiesel);

    // For CNG Variants
    catalogoueCarVariantCNGData = await axios.get(`${CONSTANTS.API_URL}/api/v1/variants/price-list-items?modelName=${model}&fuelType=CNG&status=Active&noLimit=noLimit`);
    await setCatalogueCarVariantCNG(catalogoueCarVariantCNGData.data && catalogoueCarVariantCNGData.data.priceListItems);
    termsAndConditionsDataCNG = catalogoueCarVariantCNGData.data && catalogoueCarVariantCNGData.data.termsAndConditions ? catalogoueCarVariantCNGData.data.termsAndConditions : termsAndConditionsDataCNG;
    setTermsAndConditionsDataCNG(termsAndConditionsDataCNG);

    // For EV Variants
    catalogoueCarVariantEVData = await axios.get(`${CONSTANTS.API_URL}/api/v1/variants/price-list-items?modelName=${model}&fuelType=EV&status=Active&noLimit=noLimit`);
    await setCatalogueCarVariantEV(catalogoueCarVariantEVData.data && catalogoueCarVariantEVData.data.priceListItems);
    termsAndConditionsDataEV = catalogoueCarVariantEVData.data && catalogoueCarVariantEVData.data.termsAndConditions ? catalogoueCarVariantEVData.data.termsAndConditions : termsAndConditionsDataEV;
    setTermsAndConditionsDataEV(termsAndConditionsDataEV);
    // }

    if (catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.isFromThrow) {
      await setIsEmptyPetrolData(true);
    }
    if (catalogoueCarVariantDieselData.data && catalogoueCarVariantDieselData.data.isFromThrow) {
      await setIsEmptyDieselData(true);
    }
    if (catalogoueCarVariantCNGData.data && catalogoueCarVariantCNGData.data.isFromThrow) {
      await setIsEmptyCNGData(true);
    }
    if (catalogoueCarVariantEVData.data && catalogoueCarVariantEVData.data.isFromThrow) {
      await setIsEmptyEVData(true);
    }


    let mapModel = model.toLowerCase();
    await setPDFCarImages(carLogo);

    if (mapModel === "alcazar") {
      await setPDFCarImages(alcazar);
    } else if (mapModel === "santro") {
      await setPDFCarImages(santro);
    } else if (mapModel === "aura") {
      await setPDFCarImages(aura);
    } else if (mapModel === "venue") {
      await setPDFCarImages(venue);
    } else if (mapModel === "newcreta") {
      await setPDFCarImages(creta);
    } else if (mapModel === "nextgenverna") {
      await setPDFCarImages(nextGenVerna);
    } else if (mapModel === "allnewi20") {
      await setPDFCarImages(allNewi20);
    } else if (mapModel === "elantra") {
      await setPDFCarImages(elantra);
    } else if (mapModel === "grandi10nios") {
      await setPDFCarImages(grandi10Nios);
    } else if (mapModel === "i20nline") {
      await setPDFCarImages(i20Nline);
    } else if (mapModel === "konaev") {
      await setPDFCarImages(hyundaikona);
    } else if (mapModel === "hyundai tucson") {
      await setPDFCarImages(tucson);
    } else if (mapModel === "xcentprime") {
      await setPDFCarImages(HyundaiXcent);
    } else if (mapModel === "venuenline") {
      await setPDFCarImages(venue);
    } else if (mapModel === "newtucson") {
      await setPDFCarImages(tucson);
    }
    let solidColors = [];

    if (catalogoueCarVariantPetrolData && catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems && catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems.length > 0) {

      await catalogoueCarVariantPetrolData && catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems.map((car) => solidColors.push(car.color));
      let uniqueColors = await Array.from(new Set(solidColors))
      let pdfWidth = ['auto'];
      catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems.map(i => {
        pdfWidth.push('*');
      });
      await setPdfWidthForCarVariant(pdfWidth);
      // await setAllNewi20TableHeader(allnewi20tableHeader);
      let FT = model.toLowerCase() === "konaev" ? "EV" : "Petrol";


      await setAllNewi20TableHeader([{ text: model + " " + FT, alignment: "center", fontSize: 18, bold: false }]);

      let solidColorOnce = true;

      let carVariantTableDataArray = [{ text: "PARTICULARS", fontSize: 12, bold: false }];
      let exShowroomTableDataArray = [{ text: "EX - SHOWROOM PRICE", fontSize: 12, bold: false }];
      let tcsExShowroomTableDataArray = [{ text: "TCS 1% EX-SHOWROOM", fontSize: 12, bold: false }];
      let insuranceTableDataArray = [{ text: "INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize: 12, bold: false }];
      let rtoCompanyTableDataArray = [{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize: 12, bold: false }];
      let rtoIndividualTableDataArray = [{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize: 12, bold: false }];
      let rtoBHPassingTableDataArray = [{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing', fontSize: 12, bold: false }];
      let fourFifthExtendedWarrantyTableDataArray = [{ text: '4th & 5th YEAR EXTENDED WARRANTY', fontSize: 12, bold: false }];
      let rmkTableDataArray = [{ text: 'RMK', fontSize: 12, bold: false }];
      let basicAccessoriesKitTableDataArray = [{ text: 'BASIC ACCESSORIES KIT', fontSize: 12, bold: false }];
      let rsaTableDataArray = [{ text: 'RSA', fontSize: 12, bold: false }];
      let additionalPremiumForEngineProtectionTableDataArray = [{ text: 'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize: 12, bold: false }];
      let additionalPremiumforReturnToInvoiceTableDataArray = [{ text: 'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize: 12, bold: false }];
      let totalIndividualTableDataArray = [{ text: 'TOTAL INDIVIDUAL', fontSize: 12, bold: false }];
      let totalCompanyTableDataArray = [{ text: 'TOTAL COMPANY', fontSize: 12, bold: false }];
      let sheildOfTrustTableDataArray = [{ text: 'T5 YR/60K SHIELD OF TRUST', fontSize: 12, bold: false }];
      let effectiveDateFromArray = [{ text: 'Effective Date', fontSize: 12, bold: false }];

      await catalogoueCarVariantPetrolData.data && catalogoueCarVariantPetrolData.data.priceListItems.map(async (car) => {

        let carVariant;
        if (car && car.variantName) {
          carVariant = await car.variantName[0].toUpperCase() + car.variantName.substring(1);
        }
        // modified by Vihang
        // modified at 16/05/2022
        // modification : new amount format added for all the prices and solid color changes
        // carVariantTableData.push({text:car.variantName ? carVariant : "0",bold:false});
        // exShowroomTableData.push(car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0" );
        console.log(exShowroomTableData, '----------------exShowroomTableData');

        carVariantTableDataArray.push({ text: car.variantName ? carVariant : "0", bold: false });
        exShowroomTableDataArray.push(car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0");
        tcsExShowroomTableDataArray.push(car.tcs ? getFormattedAmount(car.tcs) : "₹" + "0");
        insuranceTableDataArray.push(car.insuranceInclude0DepCbKppbEpRtiTyrEahc ? getFormattedAmount(car.insuranceInclude0DepCbKppbEpRtiTyrEahc) : "₹" + "0");
        rtoCompanyTableDataArray.push(car.rtoTaxIncludingFastagCompany ? getFormattedAmount(car.rtoTaxIncludingFastagCompany) : "₹" + "0");
        rtoIndividualTableDataArray.push(car.rtoTaxIncludingFastagIndividual ? getFormattedAmount(car.rtoTaxIncludingFastagIndividual) : "₹" + "0");
        rtoBHPassingTableDataArray.push(car.rtoTaxIncludingFastagBhPassing ? getFormattedAmount(car.rtoTaxIncludingFastagBhPassing) : "₹" + "0");
        fourFifthExtendedWarrantyTableDataArray.push(car.extendedWarranty4Yr80K ? getFormattedAmount(car.extendedWarranty4Yr80K) : "₹" + "0");
        rmkTableDataArray.push(car.rmKit ? getFormattedAmount(car.rmKit) : "₹" + "0");
        basicAccessoriesKitTableDataArray.push(car.stdAccKit ? getFormattedAmount(car.stdAccKit) : "₹" + "0");
        rsaTableDataArray.push(car.rsa ? getFormattedAmount(car.rsa) : "₹" + "0");
        additionalPremiumForEngineProtectionTableDataArray.push(car.eahc ? getFormattedAmount(car.eahc) : "₹" + "0");
        additionalPremiumforReturnToInvoiceTableDataArray.push(car.additionalPremiumForRTI ? getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0");
        totalIndividualTableDataArray.push(car.totalOnRoadIndividual ? getFormattedAmount(car.totalOnRoadIndividual) : "₹" + "0");
        totalCompanyTableDataArray.push(car.totalOnRoadCompany ? getFormattedAmount(car.totalOnRoadCompany) : "₹" + "0");
        sheildOfTrustTableDataArray.push(car.shieldOfTrust3Yr45K ? getFormattedAmount(car.shieldOfTrust3Yr45K) : "₹" + "0");
        effectiveDateFromArray.push(car.effectiveFrom ? formatDateTime(car.effectiveFrom) : "NA");

        setCarVariantTableData(carVariantTableDataArray);
        setExShowroomTableData(exShowroomTableDataArray);
        setTcsExShowroomTableData(tcsExShowroomTableDataArray);
        setInsuranceTableData(insuranceTableDataArray);
        setRtoBHPassingTableData(rtoBHPassingTableDataArray);
        setRtoIndividualTableData(rtoIndividualTableDataArray);
        setRtoCompanyTableData(rtoCompanyTableDataArray);
        setFourFifthExtendedWarrantyTableData(fourFifthExtendedWarrantyTableDataArray);
        setRmkTableData(rmkTableDataArray);
        setBasicAccessoriesKitTableData(basicAccessoriesKitTableDataArray);
        setRsaTableData(rsaTableDataArray);
        setAdditionalPremiumForEngineProtectionTableData(additionalPremiumForEngineProtectionTableDataArray);
        setAdditionalPremiumforReturnToInvoiceTableData(additionalPremiumforReturnToInvoiceTableDataArray);
        setTotalIndividualTableData(totalIndividualTableDataArray);
        setTotalCompanyTableData(totalCompanyTableDataArray);
        setSheildOfTrustTableData(sheildOfTrustTableDataArray);
        setEffectiveDateFrom(effectiveDateFromArray);

        // setCarVariantTableData([{text:"PARTICULARS", fontSize:12,bold:false}, {text:car.variantName ? carVariant : "0",bold:false}]);
        // setExShowroomTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}, car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0" ]);
        // setTcsExShowroomTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}, car.tcs ? getFormattedAmount(car.tcs) : "₹" + "0"]);
        // setInsuranceTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}, car.insuranceInclude0DepCbKppbEpRtiTyrEahc ? getFormattedAmount(car.insuranceInclude0DepCbKppbEpRtiTyrEahc) : "₹" + "0"]);
        // setRtoBHPassingTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing', fontSize:12,bold:false}, car.rtoTaxIncludingFastagBhPassing ? getFormattedAmount(car.rtoTaxIncludingFastagBhPassing) : "₹" +  "0"]);
        // setRtoIndividualTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}, car.rtoTaxIncludingFastagIndividual ? getFormattedAmount(car.rtoTaxIncludingFastagIndividual) : "₹" +  "0"]);
        // setRtoCompanyTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}, car.rtoTaxIncludingFastagCompany ? getFormattedAmount(car.rtoTaxIncludingFastagCompany) : "₹" +  "0"]);
        // setFourFifthExtendedWarrantyTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}, car.extendedWarranty4Yr80K ? getFormattedAmount(car.extendedWarranty4Yr80K) : "₹" + "0"]);
        // setRmkTableData([{text:'RMK', fontSize:12,bold:false}, car.rmKit ? getFormattedAmount(car.rmKit) :  "₹" +"0"]);
        // setBasicAccessoriesKitTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}, car.stdAccKit ? getFormattedAmount(car.stdAccKit) : "₹" + "0"]);
        // setRsaTableData([{text:'RSA', fontSize:12,bold:false}, car.rsa ? getFormattedAmount(car.rsa) : "₹" + "0"]);
        // setAdditionalPremiumForEngineProtectionTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}, car.eahc ? getFormattedAmount(car.eahc) :  "₹" + "0"]);
        // setAdditionalPremiumforReturnToInvoiceTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}, car.additionalPremiumForRTI ? getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0"]);
        // setTotalIndividualTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}, car.totalOnRoadIndividual ? getFormattedAmount(car.totalOnRoadIndividual) : "₹" + "0"]);
        // setTotalCompanyTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}, car.totalOnRoadCompany ? getFormattedAmount(car.totalOnRoadCompany) : "₹" + "0"]);
        // setSheildOfTrustTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}, car.shieldOfTrust3Yr45K ? getFormattedAmount(car.shieldOfTrust3Yr45K) : "₹" + "0"]);
        // setEffectiveDateFrom([{text:'Effective Date', fontSize:12,bold:false}, car.effectiveFrom ? formatDateTime(car.effectiveFrom) : "NA"]);

      }
      );
    }

    if (catalogoueCarVariantDieselData && catalogoueCarVariantDieselData.data && catalogoueCarVariantDieselData.data.priceListItems && catalogoueCarVariantDieselData.data.priceListItems.length > 0) {
      let pdfWidth = ['auto'];
      catalogoueCarVariantDieselData.data.priceListItems.map(i => {
        pdfWidth.push('*');
      });
      await setPdfWidthForCarVariantDiesel(pdfWidth);
      modelDieseltableHeader[0].text = model + " Diesel";
      await setModelDieselTableHeader(modelDieseltableHeader);
      // modified by Vihang
      // modified at 5 May 2022
      // modification: solidcolor data integration for pricelist pdf
      // modified by Vihang
      // modified at 16 May 2022
      // modification: solidcolor changes for pricelist pdf
      let solidColors = [];
      await catalogoueCarVariantDieselData.data.priceListItems.map((car) => solidColors.push(car.color));
      let uniqueColors = await Array.from(new Set(solidColors))
      let solidColorOnce = true;
      let carVariantDieselTableDataArray = [{ text: "PARTICULARS", fontSize: 12, bold: false }];
      let exShowroomDieselTableDataArray = [{ text: "EX - SHOWROOM PRICE", fontSize: 12, bold: false }];
      let tcsExShowroomDieselTableDataArray = [{ text: "TCS 1% EX-SHOWROOM", fontSize: 12, bold: false }];
      let insuranceDieselTableDataArray = [{ text: "INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize: 12, bold: false }];
      let rtoCompanyDieselTableDataArray = [{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize: 12, bold: false }];
      let rtoIndividualDieselTableDataArray = [{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize: 12, bold: false }];
      let rtoBHPassingDieselTableDataArray = [{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing', fontSize: 12, bold: false }];
      let fourFifthExtendedWarrantyDieselTableDataArray = [{ text: '4th & 5th YEAR EXTENDED WARRANTY', fontSize: 12, bold: false }];
      let rmkDieselTableDataArray = [{ text: 'RMK', fontSize: 12, bold: false }];
      let basicAccessoriesKitDieselTableDataArray = [{ text: 'BASIC ACCESSORIES KIT', fontSize: 12, bold: false }];
      let rsaDieselTableDataArray = [{ text: 'RSA', fontSize: 12, bold: false }];
      let additionalPremiumForEngineProtectionDieselTableDataArray = [{ text: 'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize: 12, bold: false }];
      let additionalPremiumforReturnToInvoiceDieselTableDataArray = [{ text: 'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize: 12, bold: false }];
      let totalIndividualDieselTableDataArray = [{ text: 'TOTAL INDIVIDUAL', fontSize: 12, bold: false }];
      let totalCompanyDieselTableDataArray = [{ text: 'TOTAL COMPANY', fontSize: 12, bold: false }];
      let sheildOfTrustDieselTableDataArray = [{ text: 'T5 YR/60K SHIELD OF TRUST', fontSize: 12, bold: false }];
      let effectiveDateDieselFromArray = [{ text: 'Effective Date', fontSize: 12, bold: false }];
      await catalogoueCarVariantDieselData.data.priceListItems.map(async (car) => {
        if (car && car.color) {
          if (solidColorOnce) {
            let solidColor;
            await uniqueColors.map((colors, index, colorArr) => {
              solidColor = colors[0].toUpperCase();
              solidColourDieselTableData[0].text = solidColourDieselTableData[0].text + solidColor + (colorArr.length === 1 || colorArr.length === index + 1 ? "" : ", ");
              solidColorOnce = false;
            });
          }
        }
        let carVariant;
        if (car && car.variantName) {
          carVariant = await car.variantName[0].toUpperCase() + car.variantName.substring(1);
        }
        // modified by Vihang
        // modified at 16/05/2022
        // modification : new amount format added for all the prices and solid color changes
        carVariantDieselTableDataArray.push({ text: car.variantName ? carVariant : "0", bold: false });
        exShowroomDieselTableDataArray.push(car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0");
        tcsExShowroomDieselTableDataArray.push(car.tcs ? getFormattedAmount(car.tcs) : "₹" + "0");
        insuranceDieselTableDataArray.push(car.insuranceInclude0DepCbKppbEpRtiTyrEahc ? getFormattedAmount(car.insuranceInclude0DepCbKppbEpRtiTyrEahc) : "₹" + "0");
        rtoCompanyDieselTableDataArray.push(car.rtoTaxIncludingFastagCompany ? getFormattedAmount(car.rtoTaxIncludingFastagCompany) : "₹" + "0");
        rtoIndividualDieselTableDataArray.push(car.rtoTaxIncludingFastagIndividual ? getFormattedAmount(car.rtoTaxIncludingFastagIndividual) : "₹" + "0");
        rtoBHPassingDieselTableDataArray.push(car.rtoTaxIncludingFastagBhPassing ? getFormattedAmount(car.rtoTaxIncludingFastagBhPassing) : "₹" + "0");
        fourFifthExtendedWarrantyDieselTableDataArray.push(car.extendedWarranty4Yr80K ? getFormattedAmount(car.extendedWarranty4Yr80K) : "₹" + "0");
        rmkDieselTableDataArray.push(car.rmKit ? getFormattedAmount(car.rmKit) : "₹" + "0");
        basicAccessoriesKitDieselTableDataArray.push(car.stdAccKit ? getFormattedAmount(car.stdAccKit) : "₹" + "0");
        rsaDieselTableDataArray.push(car.rsa ? getFormattedAmount(car.rsa) : "₹" + "0");
        additionalPremiumForEngineProtectionDieselTableDataArray.push(car.eahc ? getFormattedAmount(car.eahc) : "₹" + "0");
        additionalPremiumforReturnToInvoiceDieselTableDataArray.push(car.additionalPremiumForRTI ? getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0");
        totalIndividualDieselTableDataArray.push(car.totalOnRoadIndividual ? getFormattedAmount(car.totalOnRoadIndividual) : "₹" + "0");
        totalCompanyDieselTableDataArray.push(car.totalOnRoadCompany ? getFormattedAmount(car.totalOnRoadCompany) : "₹" + "0");
        sheildOfTrustDieselTableDataArray.push(car.shieldOfTrust3Yr45K ? getFormattedAmount(car.shieldOfTrust3Yr45K) : "₹" + "0");
        effectiveDateDieselFromArray.push(car.effectiveFrom ? formatDateTime(car.effectiveFrom) : "NA");

        // await setSolidColourDieselTableData(solidColourDieselTableDataArray);
        await setCarVariantDieselTableData(carVariantDieselTableDataArray);
        await setExShowroomDieselTableData(exShowroomDieselTableDataArray);
        await setTcsExShowroomDieselTableData(tcsExShowroomDieselTableDataArray);
        await setInsuranceDieselTableData(insuranceDieselTableDataArray);
        await setRtoCompanyDieselTableData(rtoCompanyDieselTableDataArray);
        await setRtoBHPassingDieselTableData(rtoBHPassingDieselTableDataArray);
        await setRtoIndividualDieselTableData(rtoIndividualDieselTableDataArray);
        await setFourFifthExtendedWarrantyDieselTableData(fourFifthExtendedWarrantyDieselTableDataArray);
        await setRmkDieselTableData(rmkDieselTableDataArray);
        await setBasicAccessoriesKitDieselTableData(basicAccessoriesKitDieselTableDataArray);
        await setRsaDieselTableData(rsaDieselTableDataArray);
        await setAdditionalPremiumForEngineProtectionDieselTableData(additionalPremiumForEngineProtectionDieselTableDataArray);
        await setAdditionalPremiumforReturnToInvoiceDieselTableData(additionalPremiumforReturnToInvoiceDieselTableDataArray);
        await setTotalIndividualDieselTableData(totalIndividualDieselTableDataArray);
        await setTotalCompanyDieselTableData(totalCompanyDieselTableDataArray);
        await setSheildOfTrustDieselTableData(sheildOfTrustDieselTableDataArray);
        await setEffectiveDateDieselFrom(effectiveDateDieselFromArray);


        // setCarVariantDieselTableData([{text:"PARTICULARS", fontSize:12,bold:false}, {text:car.variantName ? carVariant : "0",bold:false}]);
        // setExShowroomDieselTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}, car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0" ]);
        // setTcsExShowroomDieselTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}, car.tcs ? getFormattedAmount(car.tcs) : "₹" + "0"]);
        // setInsuranceDieselTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}, car.insuranceInclude0DepCbKppbEpRtiTyrEahc ? getFormattedAmount(car.insuranceInclude0DepCbKppbEpRtiTyrEahc) : "₹" + "0"]);
        // setRtoBHPassingDieselTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing', fontSize:12,bold:false}, car.rtoTaxIncludingFastagBhPassing ? getFormattedAmount(car.rtoTaxIncludingFastagBhPassing) : "₹" +  "0"]);
        // setRtoIndividualDieselTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}, car.rtoTaxIncludingFastagIndividual ? getFormattedAmount(car.rtoTaxIncludingFastagIndividual) : "₹" +  "0"]);
        // setRtoCompanyDieselTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}, car.rtoTaxIncludingFastagCompany ? getFormattedAmount(car.rtoTaxIncludingFastagCompany) : "₹" +  "0"]);
        // setFourFifthExtendedWarrantyDieselTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}, car.extendedWarranty4Yr80K ? getFormattedAmount(car.extendedWarranty4Yr80K) : "₹" + "0"]);
        // setRmkDieselTableData([{text:'RMK', fontSize:12,bold:false}, car.rmKit ? getFormattedAmount(car.rmKit) :  "₹" +"0"]);
        // setBasicAccessoriesKitDieselTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}, car.stdAccKit ? getFormattedAmount(car.stdAccKit) : "₹" + "0"]);
        // setRsaDieselTableData([{text:'RSA', fontSize:12,bold:false}, car.rsa ? getFormattedAmount(car.rsa) : "₹" + "0"]);
        // setAdditionalPremiumForEngineProtectionDieselTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}, car.eahc ? getFormattedAmount(car.eahc) :  "₹" + "0"]);
        // setAdditionalPremiumforReturnToInvoiceDieselTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}, car.additionalPremiumForRTI ? getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0"]);
        // setTotalIndividualDieselTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}, car.totalOnRoadIndividual ? getFormattedAmount(car.totalOnRoadIndividual) : "₹" + "0"]);
        // setTotalCompanyDieselTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}, car.totalOnRoadCompany ? getFormattedAmount(car.totalOnRoadCompany) : "₹" + "0"]);
        // setSheildOfTrustDieselTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}, car.shieldOfTrust3Yr45K ? getFormattedAmount(car.shieldOfTrust3Yr45K) : "₹" + "0"]);
        // setEffectiveDateDieselFrom([{text:'Effective Date', fontSize:12,bold:false}, car.effectiveFrom ? formatDateTime(car.effectiveFrom) : "NA"]);

      });
    }

    if (catalogoueCarVariantCNGData && catalogoueCarVariantCNGData.data && catalogoueCarVariantCNGData.data.priceListItems && catalogoueCarVariantCNGData.data.priceListItems.length > 0) {
      console.log(catalogoueCarVariantCNGData, '------------catalogoueCarVariantCNGData----------');

      let pdfWidth = await Array(catalogoueCarVariantCNGData.data.priceListItems.length + 1).fill("*");
      await setPdfWidthForCarVariantCNG(pdfWidth);
      modelCNGtableHeader[0].text = model + " CNG";
      await setModelCNGTableHeader(modelCNGtableHeader);
      // modified by Vihang
      // modified at 5 May 2022
      // modification: solidcolor data integration for pricelist pdf
      // modified by Vihang
      // modified at 16 May 2022
      // modification: solidcolor changes for pricelist pdf
      await catalogoueCarVariantCNGData.data.priceListItems.map((car) => solidColors.push(car.color));
      let uniqueColors = await Array.from(new Set(solidColors))
      let solidColorOnce = true;

      let carVariantCNGTableDataArray = [{ text: "PARTICULARS", fontSize: 12, bold: false }];
      let exShowroomCNGTableDataArray = [{ text: "EX - SHOWROOM PRICE", fontSize: 12, bold: false }];
      let tcsExShowroomCNGTableDataArray = [{ text: "TCS 1% EX-SHOWROOM", fontSize: 12, bold: false }];
      let insuranceCNGTableDataArray = [{ text: "INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize: 12, bold: false }];
      let rtoCompanyCNGTableDataArray = [{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize: 12, bold: false }];
      let rtoIndividualCNGTableDataArray = [{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize: 12, bold: false }];
      let rtoBHPassingCNGTableDataArray = [{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing', fontSize: 12, bold: false }];
      let fourFifthExtendedWarrantyCNGTableDataArray = [{ text: '4th & 5th YEAR EXTENDED WARRANTY', fontSize: 12, bold: false }];
      let rmkCNGTableDataArray = [{ text: 'RMK', fontSize: 12, bold: false }];
      let basicAccessoriesKitCNGTableDataArray = [{ text: 'BASIC ACCESSORIES KIT', fontSize: 12, bold: false }];
      let rsaCNGTableDataArray = [{ text: 'RSA', fontSize: 12, bold: false }];
      let additionalPremiumForEngineProtectionCNGTableDataArray = [{ text: 'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize: 12, bold: false }];
      let additionalPremiumforReturnToInvoiceCNGTableDataArray = [{ text: 'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize: 12, bold: false }];
      let totalIndividualCNGTableDataArray = [{ text: 'TOTAL INDIVIDUAL', fontSize: 12, bold: false }];
      let totalCompanyCNGTableDataArray = [{ text: 'TOTAL COMPANY', fontSize: 12, bold: false }];
      let sheildOfTrustCNGTableDataArray = [{ text: 'T5 YR/60K SHIELD OF TRUST', fontSize: 12, bold: false }];
      let effectiveDateCNGFromArray = [{ text: 'Effective Date', fontSize: 12, bold: false }];

      await catalogoueCarVariantCNGData.data.priceListItems.map(async (car) => {
        if (car && car.color) {
          let solidColors = await catalogoueCarVariantCNGData.data.priceListItems.filter((value, index, self) => index === self.findIndex((t) => t.color === car.color));
          if (solidColorOnce) {
            let solidColor;
            await uniqueColors.map((colors, index, colorArr) => {
              solidColor = colors[0].toUpperCase();
              solidColourCNGTableData[0].text = solidColourCNGTableData[0].text + solidColor + (colorArr.length === 1 || colorArr.length === index + 1 ? "" : ", ");
              solidColorOnce = false;
            });
          }
        }
        let carVariant;
        if (car && car.variantName) {
          carVariant = await car.variantName[0].toUpperCase() + car.variantName.substring(1);
        }
        console.log(car, "carcar");
        // modified by Vihang
        // modified at 16/05/2022
        // modification : removed rupees symbol from car variant data in CNG and new amount format added for all the prices

        carVariantCNGTableDataArray.push({ text: car.variantName ? carVariant : "0", bold: false });
        exShowroomCNGTableDataArray.push(car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0");
        tcsExShowroomCNGTableDataArray.push(car.tcs ? getFormattedAmount(car.tcs) : "₹" + "0");
        insuranceCNGTableDataArray.push(car.insuranceInclude0DepCbKppbEpRtiTyrEahc ? getFormattedAmount(car.insuranceInclude0DepCbKppbEpRtiTyrEahc) : "₹" + "0");
        rtoCompanyCNGTableDataArray.push(car.rtoTaxIncludingFastagCompany ? getFormattedAmount(car.rtoTaxIncludingFastagCompany) : "₹" + "0");
        rtoIndividualCNGTableDataArray.push(car.rtoTaxIncludingFastagIndividual ? getFormattedAmount(car.rtoTaxIncludingFastagIndividual) : "₹" + "0");
        rtoBHPassingCNGTableDataArray.push(car.rtoTaxIncludingFastagBhPassing ? getFormattedAmount(car.rtoTaxIncludingFastagBhPassing) : "₹" + "0");
        fourFifthExtendedWarrantyCNGTableDataArray.push(car.extendedWarranty4Yr80K ? getFormattedAmount(car.extendedWarranty4Yr80K) : "₹" + "0");
        rmkCNGTableDataArray.push(car.rmKit ? getFormattedAmount(car.rmKit) : "₹" + "0");
        basicAccessoriesKitCNGTableDataArray.push(car.stdAccKit ? getFormattedAmount(car.stdAccKit) : "₹" + "0");
        rsaCNGTableDataArray.push(car.rsa ? getFormattedAmount(car.rsa) : "₹" + "0");
        additionalPremiumForEngineProtectionCNGTableDataArray.push(car.eahc ? getFormattedAmount(car.eahc) : "₹" + "0");
        additionalPremiumforReturnToInvoiceCNGTableDataArray.push(car.additionalPremiumForRTI ? getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0");
        totalIndividualCNGTableDataArray.push(car.totalOnRoadIndividual ? getFormattedAmount(car.totalOnRoadIndividual) : "₹" + "0");
        totalCompanyCNGTableDataArray.push(car.totalOnRoadCompany ? getFormattedAmount(car.totalOnRoadCompany) : "₹" + "0");
        sheildOfTrustCNGTableDataArray.push(car.shieldOfTrust3Yr45K ? getFormattedAmount(car.shieldOfTrust3Yr45K) : "₹" + "0");
        effectiveDateCNGFromArray.push(car.effectiveFrom ? formatDateTime(car.effectiveFrom) : "NA");

        // await setSolidColourCNGTableData(solidColourCNGTableData);
        await setCarVariantCNGTableData(carVariantCNGTableDataArray);
        await setExShowroomCNGTableData(exShowroomCNGTableDataArray);
        await setTcsExShowroomCNGTableData(tcsExShowroomCNGTableDataArray);
        await setInsuranceCNGTableData(insuranceCNGTableDataArray);
        await setRtoCompanyCNGTableData(rtoCompanyCNGTableDataArray);
        await setRtoIndividualCNGTableData(rtoIndividualCNGTableDataArray);
        await setRtoBHPassingCNGTableData(rtoBHPassingCNGTableDataArray);
        await setFourFifthExtendedWarrantyCNGTableData(fourFifthExtendedWarrantyCNGTableDataArray);
        await setRmkCNGTableData(rmkCNGTableDataArray);
        await setBasicAccessoriesKitCNGTableData(basicAccessoriesKitCNGTableDataArray);
        await setRsaCNGTableData(rsaCNGTableDataArray);
        await setAdditionalPremiumForEngineProtectionCNGTableData(additionalPremiumForEngineProtectionCNGTableDataArray);
        await setAdditionalPremiumforReturnToInvoiceCNGTableData(additionalPremiumforReturnToInvoiceCNGTableDataArray);
        await setTotalIndividualCNGTableData(totalIndividualCNGTableDataArray);
        await setTotalCompanyCNGTableData(totalCompanyCNGTableDataArray);
        await setSheildOfTrustCNGTableData(sheildOfTrustCNGTableDataArray);
        await setCNGCarVariant(true);
        await setEffectiveDateCNGFrom(effectiveDateCNGFromArray);

        // setCarVariantCNGTableData([{text:"PARTICULARS", fontSize:12,bold:false}, {text:car.variantName ? carVariant : "0",bold:false}]);
        // setExShowroomCNGTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}, car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0" ]);
        // setTcsExShowroomCNGTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}, car.tcs ? getFormattedAmount(car.tcs) : "₹" + "0"]);
        // setInsuranceCNGTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}, car.insuranceInclude0DepCbKppbEpRtiTyrEahc ? getFormattedAmount(car.insuranceInclude0DepCbKppbEpRtiTyrEahc) : "₹" + "0"]);
        // setRtoBHPassingCNGTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing', fontSize:12,bold:false}, car.rtoTaxIncludingFastagBhPassing ? getFormattedAmount(car.rtoTaxIncludingFastagBhPassing) : "₹" +  "0"]);
        // setRtoIndividualCNGTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}, car.rtoTaxIncludingFastagIndividual ? getFormattedAmount(car.rtoTaxIncludingFastagIndividual) : "₹" +  "0"]);
        // setRtoCompanyCNGTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}, car.rtoTaxIncludingFastagCompany ? getFormattedAmount(car.rtoTaxIncludingFastagCompany) : "₹" +  "0"]);
        // setFourFifthExtendedWarrantyCNGTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}, car.extendedWarranty4Yr80K ? getFormattedAmount(car.extendedWarranty4Yr80K) : "₹" + "0"]);
        // setRmkCNGTableData([{text:'RMK', fontSize:12,bold:false}, car.rmKit ? getFormattedAmount(car.rmKit) :  "₹" +"0"]);
        // setBasicAccessoriesKitCNGTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}, car.stdAccKit ? getFormattedAmount(car.stdAccKit) : "₹" + "0"]);
        // setRsaCNGTableData([{text:'RSA', fontSize:12,bold:false}, car.rsa ? getFormattedAmount(car.rsa) : "₹" + "0"]);
        // setAdditionalPremiumForEngineProtectionCNGTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}, car.eahc ? getFormattedAmount(car.eahc) :  "₹" + "0"]);
        // setAdditionalPremiumforReturnToInvoiceCNGTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}, car.additionalPremiumForRTI ? getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0"]);
        // setTotalIndividualCNGTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}, car.totalOnRoadIndividual ? getFormattedAmount(car.totalOnRoadIndividual) : "₹" + "0"]);
        // setTotalCompanyCNGTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}, car.totalOnRoadCompany ? getFormattedAmount(car.totalOnRoadCompany) : "₹" + "0"]);
        // setSheildOfTrustCNGTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}, car.shieldOfTrust3Yr45K ? getFormattedAmount(car.shieldOfTrust3Yr45K) : "₹" + "0"]);
        // setEffectiveDateCNGFrom([{text:'Effective Date', fontSize:12,bold:false}, car.effectiveFrom ? formatDateTime(car.effectiveFrom) : "NA"]);

      });
    }

    if (catalogoueCarVariantEVData && catalogoueCarVariantEVData.data && catalogoueCarVariantEVData.data.priceListItems && catalogoueCarVariantEVData.data.priceListItems.length > 0) {
      console.log(catalogoueCarVariantEVData, '------------catalogoueCarVariantEVData----------');

      let pdfWidth = await Array(catalogoueCarVariantEVData.data.priceListItems.length + 1).fill("*");
      await setPdfWidthForCarVariantEV(pdfWidth);
      modelEVtableHeader[0].text = model + " EV";
      await setModelEVTableHeader(modelEVtableHeader);
      // modified by Vihang
      // modified at 5 May 2022
      // modification: solidcolor data integration for pricelist pdf
      // modified by Vihang
      // modified at 16 May 2022
      // modification: solidcolor changes for pricelist pdf
      await catalogoueCarVariantEVData.data.priceListItems.map((car) => solidColors.push(car.color));
      let uniqueColors = await Array.from(new Set(solidColors))
      let solidColorOnce = true;

      let carVariantEVTableDataArray = [{ text: "PARTICULARS", fontSize: 12, bold: false }];
      let exShowroomEVTableDataArray = [{ text: "EX - SHOWROOM PRICE", fontSize: 12, bold: false }];
      let tcsExShowroomEVTableDataArray = [{ text: "TCS 1% EX-SHOWROOM", fontSize: 12, bold: false }];
      let insuranceEVTableDataArray = [{ text: "INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize: 12, bold: false }];
      let rtoCompanyEVTableDataArray = [{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize: 12, bold: false }];
      let rtoIndividualEVTableDataArray = [{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize: 12, bold: false }];
      let rtoBHPassingEVTableDataArray = [{ text: 'RTO TAX+REG CHARGES+ FASTAG FOR BHPassing', fontSize: 12, bold: false }];
      let fourFifthExtendedWarrantyEVTableDataArray = [{ text: '4th & 5th YEAR EXTENDED WARRANTY', fontSize: 12, bold: false }];
      let rmkEVTableDataArray = [{ text: 'RMK', fontSize: 12, bold: false }];
      let basicAccessoriesKitEVTableDataArray = [{ text: 'BASIC ACCESSORIES KIT', fontSize: 12, bold: false }];
      let rsaEVTableDataArray = [{ text: 'RSA', fontSize: 12, bold: false }];
      let additionalPremiumForEngineProtectionEVTableDataArray = [{ text: 'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize: 12, bold: false }];
      let additionalPremiumforReturnToInvoiceEVTableDataArray = [{ text: 'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize: 12, bold: false }];
      let totalIndividualEVTableDataArray = [{ text: 'TOTAL INDIVIDUAL', fontSize: 12, bold: false }];
      let totalCompanyEVTableDataArray = [{ text: 'TOTAL COMPANY', fontSize: 12, bold: false }];
      let sheildOfTrustEVTableDataArray = [{ text: 'T5 YR/60K SHIELD OF TRUST', fontSize: 12, bold: false }];
      let effectiveDateEVFromArray = [{ text: 'Effective Date', fontSize: 12, bold: false }];


      await catalogoueCarVariantEVData.data.priceListItems.map(async (car) => {
        if (car && car.color) {
          let solidColors = await catalogoueCarVariantEVData.data.priceListItems.filter((value, index, self) => index === self.findIndex((t) => t.color === car.color));
          if (solidColorOnce) {
            let solidColor;
            await uniqueColors.map((colors, index, colorArr) => {
              solidColor = colors[0].toUpperCase();
              solidColourEVTableData[0].text = solidColourEVTableData[0].text + solidColor + (colorArr.length === 1 || colorArr.length === index + 1 ? "" : ", ");
              solidColorOnce = false;
            });
          }
        }
        let carVariant;
        if (car && car.variantName) {
          carVariant = await car.variantName[0].toUpperCase() + car.variantName.substring(1);
        }
        console.log(car, "carcar");

        carVariantEVTableDataArray.push({ text: car.variantName ? carVariant : "0", bold: false });
        exShowroomEVTableDataArray.push(car.exShowroom ? getFormattedAmount(car.exShowroom) : "₹" + "0");
        tcsExShowroomEVTableDataArray.push(car.tcs ? getFormattedAmount(car.tcs) : "₹" + "0");
        insuranceEVTableDataArray.push(car.insuranceInclude0DepCbKppbEpRtiTyrEahc ? getFormattedAmount(car.insuranceInclude0DepCbKppbEpRtiTyrEahc) : "₹" + "0");
        rtoCompanyEVTableDataArray.push(car.rtoTaxIncludingFastagCompany ? getFormattedAmount(car.rtoTaxIncludingFastagCompany) : "₹" + "0");
        rtoIndividualEVTableDataArray.push(car.rtoTaxIncludingFastagIndividual ? getFormattedAmount(car.rtoTaxIncludingFastagIndividual) : "₹" + "0");
        rtoBHPassingEVTableDataArray.push(car.rtoTaxIncludingFastagBhPassing ? getFormattedAmount(car.rtoTaxIncludingFastagBhPassing) : "₹" + "0");
        fourFifthExtendedWarrantyEVTableDataArray.push(car.extendedWarranty4Yr80K ? getFormattedAmount(car.extendedWarranty4Yr80K) : "₹" + "0");
        rmkEVTableDataArray.push(car.rmKit ? getFormattedAmount(car.rmKit) : "₹" + "0");
        basicAccessoriesKitEVTableDataArray.push(car.stdAccKit ? getFormattedAmount(car.stdAccKit) : "₹" + "0");
        rsaEVTableDataArray.push(car.rsa ? getFormattedAmount(car.rsa) : "₹" + "0");
        additionalPremiumForEngineProtectionEVTableDataArray.push(car.eahc ? getFormattedAmount(car.eahc) : "₹" + "0");
        additionalPremiumforReturnToInvoiceEVTableDataArray.push(car.additionalPremiumForRTI ? getFormattedAmount(car.additionalPremiumForRTI) : "₹" + "0");
        totalIndividualEVTableDataArray.push(car.totalOnRoadIndividual ? getFormattedAmount(car.totalOnRoadIndividual) : "₹" + "0");
        totalCompanyEVTableDataArray.push(car.totalOnRoadCompany ? getFormattedAmount(car.totalOnRoadCompany) : "₹" + "0");
        sheildOfTrustEVTableDataArray.push(car.shieldOfTrust3Yr45K ? getFormattedAmount(car.shieldOfTrust3Yr45K) : "₹" + "0");
        effectiveDateEVFromArray.push(car.effectiveFrom ? formatDateTime(car.effectiveFrom) : "NA");

        // await setSolidColourEVTableData(solidColourEVTableData);
        await setCarVariantEVTableData(carVariantEVTableDataArray);
        await setExShowroomEVTableData(exShowroomEVTableDataArray);
        await setTcsExShowroomEVTableData(tcsExShowroomEVTableDataArray);
        await setInsuranceEVTableData(insuranceEVTableDataArray);
        await setRtoCompanyEVTableData(rtoCompanyEVTableDataArray);
        await setRtoIndividualEVTableData(rtoIndividualEVTableDataArray);
        await setRtoBHPassingEVTableData(rtoBHPassingEVTableDataArray);
        await setFourFifthExtendedWarrantyEVTableData(fourFifthExtendedWarrantyEVTableDataArray);
        await setRmkEVTableData(rmkEVTableDataArray);
        await setBasicAccessoriesKitEVTableData(basicAccessoriesKitEVTableDataArray);
        await setRsaEVTableData(rsaEVTableDataArray);
        await setAdditionalPremiumForEngineProtectionEVTableData(additionalPremiumForEngineProtectionEVTableDataArray);
        await setAdditionalPremiumforReturnToInvoiceEVTableData(additionalPremiumforReturnToInvoiceEVTableDataArray);
        await setTotalIndividualEVTableData(totalIndividualEVTableDataArray);
        await setTotalCompanyEVTableData(totalCompanyEVTableDataArray);
        await setSheildOfTrustEVTableData(sheildOfTrustEVTableDataArray);
        // await setEVCarVariant(true);
        await setEffectiveDateEVFrom(effectiveDateEVFromArray);
      });
    }


    await setDisablePDFButton(false);
  }

  function VisitModalVisibility(e) {
    e.preventDefault();
    setProfileDetailVisibility(true);
  }

  async function getContactList() {
    let responseContact = await axios.get(`${CONSTANTS.API_URL}/api/v1/contact`);
    let contactList = responseContact.data
    setContactList(contactList)
  }

  let searchCustomer = async (number) => {
    // await setIsNextDisable(true)
    //setIsLoader(true)
    // let response = await axios.get(`${CONSTANTS.API_URL}/api/v1/contact`);
    let response = await callAPI(`get`, `/v1/contact`, `mobile=${number}`);
    // let registeredNumberData = await contactList.find((contact) => contact.mobile == number);
    let registeredNumberData = {};
    if (response && response.data) registeredNumberData = response.data[0];
    console.log(number, registeredNumberData, 'registeredNumberDataregisteredNumberDataregisteredNumberData', mobNumber);
    if (registeredNumberData) {
      /*
        Bug: T1930 - BG_FN - Even if all the details are filled out while creating a new case, sometimes the system does not allow the user to create a new case.
        Modification: Updated salutation, middlename and lastname along with customerName state
        By: Devang
        Date: 08/07/2024
      */
      if (registeredNumberData && registeredNumberData.isOTPverified === false) {
        setDisableVerificationMessageButton(false);
      } else {
        setDisableVerificationMessageButton(true);
      }
      await setContactCreatedUuid(registeredNumberData.uuid);
      await setContactData(registeredNumberData);

      setSalutation(registeredNumberData.salutation || 'Mr.');
      setCustomerName(registeredNumberData.firstName || '');
      setCustomerMiddleName(registeredNumberData.middleName || '');
      setCustomerLastName(registeredNumberData.lastName || '');
    } else {
      console.log("elseeeeeeeeeeeee", number);
      let obj = {
        mobile: number,
        /*
          Bug: T1818 -  BG_FN: Insurance-Contacts Page- Total counter Sales and Insurance Tabs counters and filters not working
          Modification: Added typeOfCase for contact distinction from sales and insurance
          By: Devang
          Date: 01/06/2024
        */
        typeOfCase: "Sales"
      }
      let responseCreateContact = await axios.post(`${CONSTANTS.API_URL}/api/v1/contact`, obj);
      let uuidContact = {
        contactID: responseCreateContact.data.uuid
      }
      await setContactCreatedUuid(responseCreateContact.data.uuid)
      await setContactData(responseCreateContact.data);
      setDisableVerificationMessageButton(false)

    }


  }

  //function to mask the mobile number
  let inputMask = (e) => {
    if (verificationCodeField) return;
    /*
      By: Yashvi
      On: 25th April 2024
      T1740: BG_FN: Add New Case - Mobile Number - Should be in Indian Format
      Changed the format to normal Indian Format
    */
    /*
      let x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
      let withoutMaskNumber = e.target.value.replace(/\D/g, '');
    */
    /*
     Bug: T1863 - Add New Case, Visit - Enter Mobile Number - Mobile Validation is missing
     Modification: added regex for mobile validation.
     By: Arun Singh
     Date: 20/05/2024
   */
    let withoutMaskNumber = e.target.value;
    const regex = /^(?!([0-9])\1{9})[2-9]\d{9}$/;
    let customerPhoneNumber = document.getElementById("customerPhoneNumber");
    // if (withoutMaskNumber.length === 10) {
    //   setIsNextDisable(false)
    // } else {
    //   setIsNextDisable(true)
    // }
    console.log(withoutMaskNumber, "withoutMaskNumberwithoutMaskNumber");
    if (regex.test(withoutMaskNumber) && withoutMaskNumber.length === 10) {
      setMobNumber(withoutMaskNumber);
      customerPhoneNumber.style.borderBottom = "1px solid #9e9e9e";
      searchCustomer(withoutMaskNumber);
    } else {
      setMobNumber(null);
      customerPhoneNumber.style.borderBottom = "2px solid red";
    }
  };

  let inputOTP = (e) => {
    setVerificationOTP(e.target.value);
  };

  let keyupOTP = (e) => {
    if (e.target.value.length >= 6) return;
  };

  async function sendOTP(type) {
    let obj = {
      mobile: mobNumber
    };
    console.log(obj, '%%%%%%%%%%%%%%%%%%');
    let responseCreateContact = await axios.post(`${CONSTANTS.API_URL}/api/v1/contact`, obj);
    let uuidContact = {
      contactID: responseCreateContact.data.uuid
    }
    await setContactCreatedUuid(responseCreateContact.data.uuid);
    setVerificationCodeField(true);
    setDisableVerificationMessageButton(true);
    if (type === "Resend") setDisableResendButtonMobile(true)
    // let uuidContact = {
    //   contactID: interactionForPdf.contactID
    // }
    let responseSendOtp = await axios.put(`${CONSTANTS.API_URL}/api/v1/sendTOTPOnSms`, uuidContact)
    if (responseSendOtp.status === 200) {
      setTimeout(() => {
        setDisableResendButtonMobile(false)
      }, 20000)

    }
    toastr.warning(`Verification OTP Sent to ${mobNumber}`);
  }

  async function verifyMobileOTP() {
    try {
      let obj = {
        totp: verificationOTP,
        contactID: contactCreatedUuid
      }

      let responseMobile = await axios.put(`${CONSTANTS.API_URL}/api/v1/verifyTOTPSmsAuthenticator`, obj)
      if (responseMobile.status === 200) {
        let obj1 = {
          isOTPverified: true
        }
        let responseVerifyOTP = await axios.put(`${CONSTANTS.API_URL}/api/v1/contact/${contactCreatedUuid}`, obj1);
        toastr.success("Mobile Number Verified");
        // setOpenEmailModal(false)
        setVerificationCodeField(false)
        // setDisableVerificationMessageButton(false)
        setMobileVerificationResendButton(false)
        setDisableMobileVerifyButton(true)
        setVerificationCodeMesage(false)
        if (responseVerifyOTP && responseVerifyOTP.data) {
          setDisableVerificationMessageButton(true)
          await setContactCreatedUuid(responseVerifyOTP.data.uuid)
          await setContactData(responseVerifyOTP.data);
        }


        // setInteractionObj(true, 'emailVerified');
      }
    } catch (error) {
      setDisableVerificationMessageButton(true)
      setMobileVerificationResendButton(true)
      setDisableMobileVerifyButton(true)
      setVerificationCodeMesage(true)
      setDisableResendButtonMobile(false)
    }
  }

  function toggleCreateCaseModal(e) {
    /*
      Bug: T1738 - BG_FN: Data is auto populated when add new case is added - Remark, Dealer code
      Modification: Commented reset of previous states with new one
      By: Devang
      Date: 15/04/2024
    */
    /*setIsCaseTypeSelected(false)
    setModel('')
    setFuelTypes([])
    setTypeOfFuel('')
    setVariantList([])
    setVariant('')
    setContactCreatedUuid('')
    setContactData({})
    setAssignResposiblePerson('')
    setAssignedTo('');
    setSelectedCaseTypes([])*/
    /*
      Modification: By Default selecting Mr. salutation
      By: Masum Raja
      Date: 23/04/2024
    */
    setType('First Time Buyer');
    setIsCaseTypeSelected(false);
    setSelectedCaseTypes([]);
    setContactData({});
    setSalutation('Mr.');
    setCustomerName('');
    setCustomerMiddleName('');
    setCustomerLastName('');
    setModel('');
    setFuelTypes([]);
    setTypeOfFuel('');
    setVariantList([]);
    setVariant('');
    setSelectedVariant([]);
    setRemark('');
    setRefferedBy(userInfo.displayName);
    setDealerCode('');
    setAssignedTo('');
    setAssignUserList([]);
    setAssignResposiblePerson('');
    setIsSubmitDisable(true);
    setWantsPriceList(false);
    setWantsBrochure(false);
    setIsVIPCustomer(false);
    setSkipPayment(false);

    setCreatedCase({});
    setVerificationCodeField(false);
    setContactCreatedUuid('');
    setMobileVerificationResendButton(false);
    setVerificationOTP('');
    setDisableMobileVerifyButton(true);

    if (isCreateCaseModalOpen) {
      setTypeOfCase('');
      setIsCaseCreated(false);
      setCaseCreationLoader(false);
      setSource('');
      setSubSources('')
      /*
        Bug: KH_BG_676 Receptionist , Sales Consultant	Sales Case View - Click here to view all tasks	When clicked on "Click here to view all tasks" icon, the process view takes more time to load
        Modification: set the state to declare the case and interaction not instantiated
        By: Devang
        Date: 31/01/2024
      */
      setIsCaseInteractionInstantiated(false);
    } else {
      // getContactList()
    }
    setCreateCaseModalOpen(!isCreateCaseModalOpen);
  }

  async function toggleCreateBookingModal(e) {
    console.log('in toggleCreateBookingModal');
    setIsCreateBookingCaseModalOpen(true)
    let task = await axios.post(`${CONSTANTS.API_URL}/api/v1/salesProcessInitiation`, { userBranchID: userInfo.userBranchID, userDealershipID: userInfo.userDealershipID });
    let taskDetails = await axios.get(`${CONSTANTS.API_URL}/api/v1/taskDetails?interactionID=${task.data.uuid}`);
    if (taskDetails.data) {
      currentRow = taskDetails.data;
      await setCurrentRow(currentRow);
      let designation = 'Insurance Agent';
      let exchangEvaluators = await axios.get(`${CONSTANTS.API_URL}/api/v1/userOrganization/caseManagement?dealershipID=${userInfo.userDealershipID}`);
      await setExchangeEvaluators(exchangEvaluators.data);
      let insuranceCompaniesList = await axios.get(` ${CONSTANTS.API_URL}/api/v1/thirdParty?type=insuranceCompany&dmsName=Hyundai`);
      if (insuranceCompaniesList.data && insuranceCompaniesList.data.length) {
        setInsuranceCompanies(insuranceCompaniesList.data);
      }
      await toggleFormPopover();
      // setCreateInsuranceCaseModalOpen(!isCreateInsuranceCaseModalOpen);
      setIsCreateBookingCaseModalOpen(false)
    }
  }

  function toggleViewCaseDetailsModal(e) {
    setIsViewCreatedCaseModalOpen(!isViewCreatedCaseModalOpen);
  }
  async function routeToCaseView(e) {
    // dispatch({type: ACTIONS.CURRENT_ROW, data: createdCase});
    await route(`/caseView/${createdCase.uuid}`);
    await toggleCreateCaseModal();
    await setIsCaseCreated(false);
    await setCaseCreationLoader(false);
  }
  {/*
    Modified By: Arun Singh
    Modification: Add OR condition when create a new case of source and subSource inside if block.
    Date: 14/june/2024
  */}
  async function createCase(e, typeOfAction) {
    if (!contactData.mobile || !customerName || !assignResposiblePerson || source === '' || subSource === '') {
      return;
    }
    setCaseCreationLoader(true);
    // setCreateCaseModalOpen(!isCreateCaseModalOpen);

    // let payload = {
    //   dealershipID: userInfo.dealership,
    //   contactID: contactData.uuid,
    //   visitID: '',
    //   assignedUserID: assignResposiblePerson,
    // };

    {/*
      Modified By: Arun Singh
      Modification: Add new value inside payload of source and subSource when case create.
      Date: 14/june/2024
    */}

    let payload = {
      contactID: contactCreatedUuid,
      visitID: '',
      assignedToID: assignResposiblePerson,
      catalogueID: model,
      typeOfFuel: typeOfFuel,
      variantID: variant,
      type,
      firstName: customerName ? customerName : "",
      /*
        Bug: T1687 - 24 - Add New Case - Middle Name field - Middle Name field is missing
        Modification: Sent middleName in payload
        By: Devang
        Date: 10/04/2024
      */
      middleName: customerMiddleName ? customerMiddleName : '',
      lastName: lastName ? lastName : "",
      salutation: salutation ? salutation : "",
      mobile: contactData.mobile ? contactData.mobile : "",
      wantsPriceList,
      wantsBrochure,
      isVIPCustomer,
      skipPayment,
      selectedCaseTypes,
      source,
      subSource
    };
    // console.log(payload, "ppppppppppppppppp");
    let CreatedCase = await axios.post(`${CONSTANTS.API_URL}/api/v1/case`, payload);
    if (CreatedCase && CreatedCase.data.uuid) {
      setCreatedCase(CreatedCase.data)
      let notificationObj2 = {
        typeOfNotification: "push",
        message: "New Case created and assigned to SC",
        group: "case",
        isSent: true,
        isRead: false,
        sendTo: assignResposiblePerson,
        caseID: CreatedCase.data.uuid
      };
      let newCaseMessage = await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, notificationObj2);
      await toastr.info('New Case Created');
      sendNotification('Case Updates', 'New Case Created', [assignResposiblePerson], '', '', '', CreatedCase.data.uuid);

      let userData = {
        userId: assignResposiblePerson,
        phoneNumber: CreatedCase.data.mobile,
        countryCode: "+91",
        "traits": {
          "title": CreatedCase.data.salutation ? CreatedCase.data.salutation : '',
          "name": CreatedCase.data.firstName
        }
      };
      /*
        modified : Ashutosh G
        modified : 15/03/2024
        modification : aws link change with awsBucketLink variable
      */
      let links = {
        alcazar: `${awsBucketLink}/ALCAZAR_PRICE_LIST_LATEST.pdf`,
        allnewi20: `${awsBucketLink}/ALL_NEW_i20_PRICE_LIST_LATEST.pdf`,
        aura: `${awsBucketLink}/AURA_PRICE_LIST_LATEST.pdf`,
        grandi10nios: `${awsBucketLink}/GRAND_I10_NIOS_CRETA_PRICE_LIST_LATEST.pdf`,
        i20Nline: '',
        konaev: '',
        newcreta: `${awsBucketLink}/NEW_CRETA_PRICE_LIST_LATEST.pdf`,
        nextgenverna: `${awsBucketLink}/NEXT_GEN_VERNA_CRETA_PRICE_LIST_LATEST.pdf`,
        santro: `${awsBucketLink}/SANTRO_PRICE_LIST_LATEST.pdf`,
        tucson: `${awsBucketLink}/TUCSON_CRETA_PRICE_LIST_LATEST.pdf`,
        newtucson: `${awsBucketLink}/TUCSON_CRETA_PRICE_LIST_LATEST.pdf`,
        venue: `${awsBucketLink}/VENUE_PRICE_LIST_LATEST.pdf`,
        venuenline: `${awsBucketLink}/VENUE_PRICE_LIST_LATEST.pdf`,
        xcentprime: ''
      };
      let brochureLinks = {
        alcazar: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/alcazar.pdf',
        allnewi20: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/i20-Hatchback-2020.pdf',
        aura: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/aura.pdf',
        grandi10nios: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/grand-i10-nios.pdf',
        i20Nline: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/N-Line.pdf',
        konaev: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Hyundai_KONA_SUV_brochure.pdf',
        newcreta: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/creta-suv-brochure.pdf',
        nextgenverna: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Verna-Brochure.pdf',
        santro: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/SANTRO_Hatchback_brochure.pdf',
        tucson: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Tucson_suv_brochure.pdf',
        newtucson: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Tucson_suv_brochure.pdf',
        venue: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Hyundai_VENUE_SUV_brochure.pdf',
        venuenline: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/brochure/Hyundai_VENUE_SUV_brochure.pdf',
        xcentprime: 'https://www.hyundai.com/content/dam/hyundai/in/en/data/build-a-car/download-e-broucher/Web-Brochure-Xcent-Prime-2020.pdf',
      };
      /*let eventData = {
        userId:  instantiate.data.uniqueID,
        event: "welcomeUser",
        traits: {
          "title": instantiate.data['dynamicProperties_salutation'],
          "name": instantiate.data['dynamicProperties_customerName'],
          "dealership": "Kothari Hyundai",
          "branch": "Shankar Sheth Road",
          "docUrl": links[instantiate.data['dynamicProperties_selectedModelName']]
        }
      }*/
      /*
        modified : Ashutosh G
        modified : 15/03/2024
        modification : eventData and brochureEventData object value merged and called sendWhatsappMessage only one time for only one message (unwanted code removed because brochure include in welcome message)
      */
      let eventData = {
        event: "welcomeUser",
        title: CreatedCase.data.salutation ? CreatedCase.data.salutation : '',
        name: CreatedCase.data.firstName,
        dealership: "Kothari Hyundai",
        branch: "Shankar Sheth Road",
        docUrl: links[CreatedCase.data.selectedModelName],
        fileName: "Pricelist.pdf",
        message: brochureLinks[CreatedCase.data.selectedModelName],
      }
      eventData["whatsappTemplateName"] = wantsBrochure ? "welocome_with_brochure" : "welcome_messagev4";
      eventData["whatsappTemplateParametes"] = wantsBrochure
        ? [`${eventData.title ? `${eventData.title} ` : ''}${eventData.name}`, `${eventData.dealership} - ${eventData.branch}`, brochureLinks[CreatedCase.data.selectedModelName] || ""]
        : [`${eventData.title ? `${eventData.title} ` : ''}${eventData.name}`, `${eventData.dealership} - ${eventData.branch}`];
      // await sendWhatsappMessage(userData, eventData, CreatedCase.data.contactID, wantsBrochure, wantsPriceList);
      if (wantsPriceList) {
        await priceList(CreatedCase.data.selectedModelName);
      }

      // if (newCaseMessage.status === 200) {
      //   props.triggerNotifications(true)
      // }
    }
    if (typeOfAction === "instantiate") {
      let payloadInteraction = {
        dealershipID: CreatedCase.data.dealershipID,
        contactID: CreatedCase.data.contactID,
        assignedUserID: assignResposiblePerson,
        caseID: CreatedCase.data.uuid
      }
      let instantiate = await axios.post(`${CONSTANTS.API_URL}/api/v1/interaction/instantiate`, payloadInteraction);

      if (instantiate && instantiate.data) {
        toastr.info('Fill Enquiry Form Task Created');
        sendNotification('Task Updates', 'Fill Enquiry Form Task Created', [assignResposiblePerson], '', '', '', instantiate.data.uuid);

      }
    }
    // setIsCaseCreated(true);
    // setCaseCreationLoader(false);
    setVerificationCodeField(false);
    setContactData({});
    setContactCreatedUuid('');
    setMobileVerificationResendButton(false);
    setVerificationOTP('');
    setDisableMobileVerifyButton(false);
    setSource('');
    setSubSource('');
    /*
      Bug: KH_BG_676 Receptionist , Sales Consultant	Sales Case View - Click here to view all tasks	When clicked on "Click here to view all tasks" icon, the process view takes more time to load
      Modification: set the state to declare the case and interaction instantiated
      By: Devang
      Date: 31/01/2024
    */
    setIsCaseInteractionInstantiated(true);
    // setCreateCaseModalOpen(false);
  }

  async function routeToCaseList() {
    route(`/workspaceCaseDetails`)
  }

  async function dynamicButtonClicked(e, buttonName) {
    e.preventDefault();

    /*
     modification : T319 (Change Taken From Comp's caseSemiDetailViewV3) isTaskCanComplete not exists then returning from function
     modified : Ashutosh G
     modified : 29/05/2024
   */
    const isTaskCanComplete = checkIfTaskCanComplete();
    if (!isTaskCanComplete) return;

    if (buttonName === "Call") {
      let Call;
      if (userDesignation === "SALES CONSULTANT") {
        Call = await axios.post(`${CONSTANTS.API_URL}/api/v1/originateCall/mobile`, {
          userID: userInfo.uuid,
          mobileNumber: interactionObj['dynamicProperties_mobile'],

        });
      } else {
        Call = await axios.post(`${CONSTANTS.API_URL}/api/v1/originateCall`, {
          userID: userInfo.uuid,
          mobileNumber: interactionObj['dynamicProperties_mobile'],
          // taskID: currentTask.uuid
        });
      }
      // let Call = await axios.post(`${CONSTANTS.API_URL}/api/v1/originateCall`, {
      //   userID: userInfo.uuid,
      //   mobileNumber: interactionObj['dynamicProperties_mobile'],
      //   taskID: currentTask.uuid
      // });
      if (Call.data) {
        interactionObj['dynamicProperties_latestCallID'] = Call.data.uuid;
        currentTask['dynamicProperties_callID'] = Call.data.uuid;
      }
      interactionObj['dynamicProperties_isCalled'] = "yes";
      currentTask['dynamicProperties_isCalled'] = "yes";
      setIsFormUpdated(true);
    } else if (buttonName === "Whatsapp") {
      interactionObj['dynamicProperties_isWhatsappClicked'] = "yes";
      currentTask['dynamicProperties_isWhatsappClicked'] = "yes";
      setIsFormUpdated(true);
    } else if (buttonName === "Message") {
      interactionObj['dynamicProperties_isSMSClicked'] = "yes";
      currentTask['dynamicProperties_isSMSClicked'] = "yes";
      setIsFormUpdated(true);
    } else if ((buttonName === "Register Request") || (buttonName === "Schedule")) {
      let TestDriveResponse = await axios.put(`${CONSTANTS.API_URL}/api/v1/scheduleTestDrive/${currentTask.uuid}`, {
        cartProducts
      });
      if (TestDriveResponse.data.testDriveQueueNumber) {
        setTestDriveQueue(TestDriveResponse.data.testDriveQueueNumber);
      }
    } else if (buttonName === "Approve") {
      /*
        Modification: Added old currentTask to get old status in notification payload
        By: Devang
        Date: 18/02/2023
      */
      let oldTaskObj = deepCopy(currentTask);

      let payload = currentTask;
      currentTask['status'] = "Approved";
      let Response = await axios.put(`${CONSTANTS.API_URL}/api/v2/task/${currentTask.uuid}/markComplete`, payload)
      let notificationObj = {
        typeOfNotification: "push",
        message: "Task " + currentTask.displayName + " approved",
        /*
          Modification: Added newly created keys in payload to be saved and used for notificationDashboard
          By: Devang
          Date: 18/02/2023
        */
        category: "Changed Status",
        currentStatus: "Approved",
        previousStatus: oldTaskObj.status,
        interactionID: currentTask.interactionID,
        createdFrom: 'frontend-rightPanel-dynamicButtonClicked-#1',

        taskID: currentTask.uuid,
        group: "task",
        isSent: true,
        isRead: false,
        sendTo: userInfo.uuid
      };
      // if (Response.data.triggeredTaskList.length) {
      //   await setTriggeredUnassignedTaskList(Response.data.triggeredTaskList);
      //   await toggleOpenAssignUsersTriggeredTask();
      // }
      // if (Response.data.triggeredTaskListForApproval.length) {
      //   await setTriggeredUnassignedApprovalTaskList(Response.data.triggeredTaskListForApproval);
      //   await toggleOpenAssignApprovalUsersTriggeredTask();
      // }
      let taskCompletionMessage = await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, notificationObj);
      // if (taskCompletionMessage.status === 200) {
      //   triggerNotifications(true)
      // }
      toastr.success('Task ' + currentTask.displayName + " approved");
      await axios.post(`${CONSTANTS.API_URL}/api/v1/sendWhatsappMessageWithMIM`, {
        "templateName": "task_approved_demo",
        "parameters": currentTask.displayName,
        "phoneNumber": "9130399605"
      });
      if (Response.data.messageResponses && Response.data.messageResponses.length) {
        await Promise.all(Response.data.messageResponses.map(async (messageObj) => {
          await axios.post(`${CONSTANTS.API_URL}/api/v1/sendWhatsappMessageWithMIM`, {
            "templateName": messageObj.whatsappTemplateName,
            "parameters": messageObj.whatsappTemplateParametes,
            "phoneNumber": "9130399605"
          });
          if (messageObj.sendTo) {
            let messageNotification = await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, messageObj);
            // if (messageNotification.status === 200) {
            //   triggerNotifications(true)
            // }
            toastr.info(messageObj.message);
          } else {
            toastr.info(messageObj.message);
          }
        }))
      }
      await toggleFormPopover();
      await getSelectedStageTasks(stages[activeStageIndex].uuid);

      // let ApproveTask = await axios.put(`${CONSTANTS.API_URL}/api/v2/task/${currentTask.uuid}/approve`, {
      //   status: 'Approved'
      // });
      // triggerNotifications(true)
      // toastr.info(`${currentTask.displayName} Approved`);
      // if (Response.data.messageResponses && ApproveTask.data.messageResponses.length) {
      //   await Promise.all(ApproveTask.data.messageResponses.map(async (messageObj) => {
      //     if (messageObj.sendTo) {
      //       let messageNotification = await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, messageObj);
      //       if (messageNotification.status === 200) {
      //         triggerNotifications(true)
      //       }
      //       toastr.info(messageObj.message);
      //     } else {
      //       toastr.info(messageObj.message);
      //     }
      //   }))
      // }
    } else if (buttonName === "Reject") {
      let payload = currentTask;
      currentTask['status'] = "Rejected";
      let Response = await axios.put(`${CONSTANTS.API_URL}/api/v2/task/${currentTask.uuid}/markComplete`, payload)
      // let notificationObj = {
      //   typeOfNotification: "push",
      //   message: "Task " + currentTask.displayName + " rejected",
      //   taskID: currentTask.uuid,
      //   group: "task",
      //   isSent: true,
      //   isRead: false,
      //   sendTo: userInfo.uuid
      // };
      // let taskCompletionMessage = await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, notificationObj);
      // if (taskCompletionMessage.status === 200) {
      //   triggerNotifications(true)
      // }
      await axios.post(`${CONSTANTS.API_URL}/api/v1/sendWhatsappMessageWithMIM`, {
        "templateName": "task_rejected_demo",
        "parameters": currentTask.displayName,
        "phoneNumber": "9130399605"
      });
      if (Response.data.messageResponses && Response.data.messageResponses.length) {
        await Promise.all(Response.data.messageResponses.map(async (messageObj) => {
          await axios.post(`${CONSTANTS.API_URL}/api/v1/sendWhatsappMessageWithMIM`, {
            "templateName": messageObj.whatsappTemplateName,
            "parameters": messageObj.whatsappTemplateParametes,
            "phoneNumber": "9130399605"
          });
          if (messageObj.sendTo) {
            let messageNotification = await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, messageObj);
            // if (messageNotification.status === 200) {
            //   triggerNotifications(true)
            // }
            toastr.info(messageObj.message);
          } else {
            toastr.info(messageObj.message);
          }
        }))
      }
      await toggleFormPopover();
      await getSelectedStageTasks(stages[activeStageIndex].uuid);

      // let ApproveTask = await axios.put(`${CONSTANTS.API_URL}/api/v2/task/${currentTask.uuid}/approve`, {
      //   status: 'Approved'
      // });
      // triggerNotifications(true)
      // toastr.info(`${currentTask.displayName} Approved`);
      // if (Response.data.messageResponses && ApproveTask.data.messageResponses.length) {
      //   await Promise.all(ApproveTask.data.messageResponses.map(async (messageObj) => {
      //     if (messageObj.sendTo) {
      //       let messageNotification = await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, messageObj);
      //       if (messageNotification.status === 200) {
      //         triggerNotifications(true)
      //       }
      //       toastr.info(messageObj.message);
      //     } else {
      //       toastr.info(messageObj.message);
      //     }
      //   }))
      // }
    } else if (buttonName === "Request Feedback") {
      // triggerNotifications(true)
      toastr.info('Feedback link sent to the Customer');
    } else if (buttonName === "Send Link for Digital Signature") {
      await DownloadDocket("customerSign");
      // triggerNotifications(true)
      toastr.success('Docket Sent to Customer for e-Signature successfully');
      let buttonElement = document.getElementById(e.target.id);
      buttonElement.setAttribute("disabled", true);
    } else if (buttonName === "Push to NDMS") {
      // triggerNotifications(true)
      toastr.info('Booking is being pushed to NDMS');
      let buttonElement = document.getElementById(e.target.id);
      buttonElement.setAttribute("disabled", true);
    } else if (buttonName === "Finance Quotation") {
      let payload = {
        taskID: currentTask.uuid,
        interactionID: currentTask.interactionID,
        customerName: interactionForPdf && interactionForPdf["dynamicProperties_customerName"] ? interactionForPdf["dynamicProperties_customerName"] : '',
        customerAddress: interactionForPdf && interactionForPdf && interactionForPdf["dynamicProperties_addressLine1"] && interactionForPdf["dynamicProperties_addressLine2"] && interactionForPdf["dynamicProperties_state"] && interactionForPdf["dynamicProperties_city"] && interactionForPdf["dynamicProperties_pincode"] ? (interactionForPdf["dynamicProperties_addressLine1"] + " " + interactionForPdf["dynamicProperties_addressLine2"] + ", " + interactionForPdf["dynamicProperties_state"] + ", " + interactionForPdf["dynamicProperties_city"] + ", " + interactionForPdf["dynamicProperties_pincode"]).charAt(0).toUpperCase() + (interactionForPdf["dynamicProperties_addressLine1"] + " " + interactionForPdf["dynamicProperties_addressLine2"] + ", " + interactionForPdf["dynamicProperties_state"] + ", " + interactionForPdf["dynamicProperties_city"] + ", " + interactionForPdf["dynamicProperties_pincode"]).slice(1) : "",
        customerMobile: interactionForPdf && interactionForPdf["dynamicProperties_mobile"] ? interactionForPdf["dynamicProperties_mobile"] : '',
        // modelID: currentTask.modelID,
        modelName: interactionForPdf && interactionForPdf["dynamicProperties_selectedModelName"] ? interactionForPdf["dynamicProperties_selectedModelName"] : "",
        color: interactionForPdf && interactionForPdf["dynamicProperties_selectedColor"] ? interactionForPdf["dynamicProperties_selectedColor"] : "",
        bankID: 'ec840b45-7eba-4366-a0a9-32f043e130a9',
        // onRoadPrice: interactionForPdf && interactionForPdf['dynamicProperties_onRoadPrice'] ? interactionForPdf['dynamicProperties_onRoadPrice'] : 0,
        exShowroomPrice: interactionForPdf && interactionForPdf['dynamicProperties_exShowroom'] ? interactionForPdf['dynamicProperties_exShowroom'] : 0,
        emi: 22000,
        tenure: 60,
        selectedConfigIDForStampDuty: 'ab848fdc-c78f-4305-97db-c264b022fed2',
        selectedConfigIDForProcessingFee: '636e98fb-538d-4752-8aa9-a54e0713ea98',
        selectedModelID: interactionForPdf['dynamicProperties_selectedModel'],
        selectedVariantID: interactionForPdf['dynamicProperties_selectedVariant']
      }
      let onRoadPrice = 0;
      if (interactionForPdf && interactionForPdf['dynamicProperties_exShowroom']) {
        onRoadPrice = onRoadPrice + interactionForPdf['dynamicProperties_exShowroom'];
      }
      if (interactionForPdf && interactionForPdf['dynamicProperties_exShowroom'] > 1000000) {
        onRoadPrice = onRoadPrice + interactionForPdf['dynamicProperties_tcsOnExShowroom'];
      }
      if (interactionForPdf && interactionForPdf['dynamicProperties_rtoIndividual']) {
        onRoadPrice = onRoadPrice + interactionForPdf['dynamicProperties_rtoIndividual'];
      }
      if (interactionForPdf && interactionForPdf['dynamicProperties_insuranceCalculatedl']) {
        onRoadPrice = onRoadPrice + interactionForPdf['dynamicProperties_insuranceCalculated'];
      }
      payload['onRoadPrice'] = onRoadPrice;
      let response = await axios.post(`${CONSTANTS.API_URL}/api/v1/financeQuotation`, payload);
    }
  }

  async function getVariantForSelectedModel(fuelType) {
    try {
      // Fetch active variants from variants collection based on model and fuel type
      const response = await axios.get(`${CONSTANTS.API_URL}/api/v1/variants?modelId=${model}&fuelType=${fuelType}&status=Active&noLimit=noLimit`);
      if (response.data) {
        setVariantList(response.data);
      }
    } catch (error) {
      console.error('Error fetching variants:', error);
      setVariantList([]);
    }
  }

  async function getFuelTypesForSelectedModel(id) {
    await axios.get((`${CONSTANTS.API_URL}/api/v1/catalogue/fuelTypes?selectedCatalogueItemID=${id}`)).then(async (response) => {
      let fuelTypesResponse = response.data;
      const result = [];
      const map = new Map();
      // for (const item of variantReponse) {
      await Promise.all(fuelTypesResponse.map(item => {
        if (!map.has(item.fuelType)) {
          map.set(item.fuelType, true);    // set any value to Map
          result.push(item);
        }
      }))
      console.log(result, '-----------result------------');
      await setFuelTypes(result);
      await setVariantList([]);
      await setVariant('')
    });
  }

  async function getVariantDetails(id) {
    // let variantReponse = await axios.get((`${CONSTANTS.API_URL}/api/v1/catalogue/variant?selectedVariantID=${id}`))
    let index = variantList.findIndex(variant => variant.uuid === id);
    if (index > -1) {
      await setSelectedVariant(variantList[index]);
    }
  }

  function toggleOpenAssignUsersTriggeredTask() {
    setIsOpenAssignUsersTriggeredTask(!isOpenAssignUsersTriggeredTask)
  }

  async function getAssignToUser(value) {
    // let userList = response.data.filter((user) => user.roleName === value)
    /*
      Bug: 76	KH_BG_146	Branch - Kondhwa - Roles which can create new cases	Add New Case , Visit Assigned To - Sales Manager - Dropdown list	The name of the "Sales Manager" - "Ravindra Dhumal" is displayed twice in the dropdown list
      Modification: Sent userID as uniqueKey to filter the final list with uniqueValue of that unique key only
      By: Devang
      Date: 04/07/2023
    */
    if (value) {
      let response = await axios.get(`${CONSTANTS.API_URL}/api/v1/userorganizations?dealershipIDs=${userInfo.dealership}&designation=${value}&branchIDs=${userInfo.userBranchID}&uniqueBy=userID`);
      await setAssignUserList(response.data)
    } else {
      await setAssignUserList([]);
      setAssignedTo('');
      setAssignResposiblePerson('')
    }
  }

  /*
    Bug: KH_BG_222 Renewal Insurance Generate Renewal Quotation - Previous Policy PDF	Upload File Validations missing
    Modification: Added file extension check before uploading the file
    By: Devang
    Date: 25/11/2023
  */
  async function uploadFile(e, fieldName, props, propIndex) {
    const fileTypeError = await isAllowedFileType(e.target.files[0]);
    if (!fileTypeError) {
      toastr.warning("This file cannot be uploaded either because this is not a supported file type. Please exclude such files and try again.");
      return;
    }

    console.log(e.target.files, "fileeeeeeee");
    const file = {
      name: e.target.files[0].name,
      size: e.target.files[0].size,
      type: e.target.files[0].type,
      value: e.target.files[0].name,
    };
    let payload = {
      file,
      interactionID: interactionObj.uuid
    }
    let fileDetails
    await axios.post(`${CONSTANTS.API_URL}/api/v1/file/getSignedUrl`, payload).then(async res => {
      if (res && res.data) {
        fileDetails = res.data;
        try {
          //  Save File on S3
          const opts = {
            headers: {
              name: 'Content-Type',
              value: 'multipart/form-data',
            }
          };
          /*
           By: Yashvi
           On: 21th July 2022
           If file type is image only then compress the file.
         */
          let fileData = e.target.files[0];
          let fileExtension = e.target.files[0].name.split('.').pop();
          if (imageTypeExtension.includes(fileExtension)) {
            fileData = await getCompressedImageFile(e.target);
          }
          /*
            By: Yashvi
            On: 21th July 2022
            Process files (PPT, PDF, DOC) into images using lambda function
          */
          const fileUpload = await axios.put(fileDetails.signedURL, fileData, opts);
          // if (fileUpload) {
          let processTimeStarted;
          let optsData = {
            onUploadProgress(progressEvent) {
              let processPercentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

              if (processPercentCompleted >= 0 && !processTimeStarted) {
                processTimeStarted = new Date();

              } else if (processPercentCompleted > 0 && processTimeStarted) {
                let timeElapsed = (new Date()) - processTimeStarted; // timeStarted is a Date Object
                let uploadSpeed = progressEvent.loaded / (timeElapsed / 1000); // Upload speed in second

                // `callback` is the function that shows the time to user.
                // The only argument is the number of remaining seconds.
                let time = (progressEvent.total - progressEvent.loaded) / uploadSpeed;
                let processTimeToUpload = Math.round(time);
                if (processTimeToUpload >= 60) {
                  processTimeToUpload = Math.round(processTimeToUpload / 60);
                  // that.state.processTimeValue = processTimeToUpload === 1 ? "minute" : "minutes";
                } else {
                  // that.state.processTimeValue = "seconds";
                }

                // that.setState({
                //   processTimeToUpload,
                //   processTimeValue: that.state.processTimeValue
                // });
              }
            }
          };

          if (fileExtension === 'pdf') {
            let process = await axios.put(`${CONSTANTS.API_URL}/api/file/processMultiple/pdf`, {
              fileName: file.name,
              fileID: fileDetails.uuid,
              interactionID: interactionObj.uuid,
            }, optsData);
            // if (process) {
            //   this.setState({isProcessingFile: false});
            // }
            // await axios.put(`${CONSTANTS.API_URL}/api/v1/user/pageVisitUserInformation`,{action:'Update PDF Content', email:this.state.userInfo.email});
          }
          if (fileExtension === 'ppt' || fileExtension === 'pptx') {
            let process = await axios.put(`${CONSTANTS.API_URL}/api/file/processMultiple`, {
              fileName: file.name,
              fileID: fileDetails.uuid,
              interactionID: interactionObj.uuid,
            }, optsData);
            // await axios.put(`${CONSTANTS.API_URL}/api/v1/user/pageVisitUserInformation`,{action:'Update PDT Content', email:this.state.userInfo.email});
          }
          if (fileExtension === 'docx') {
            let process = await axios.put(`${CONSTANTS.API_URL}/api/file/processMultiple/doc`, {
              fileName: file.name,
              fileID: fileDetails.uuid,
              interactionID: interactionObj.uuid,
            }, optsData);
            // await axios.put(`${CONSTANTS.API_URL}/api/v1/user/pageVisitUserInformation`,{action:'Update DOC Content', email:this.state.userInfo.email});
          }
          if (videoTypeExtension.includes(fileExtension)) {
            await axios.put(`${CONSTANTS.API_URL}/api/v1/courseContentMultiple/generateThumbnail/`, {
              fileName: file.name,
              fileID: fileDetails.uuid,
              interactionID: interactionObj.uuid,
            }, optsData);
            // await axios.put(`${CONSTANTS.API_URL}/api/v1/user/pageVisitUserInformation`,{action:'Update Video Content', email:this.state.userInfo.email});
          }
          // }
          currentTask['dynamicProperties_' + fieldName] = fileDetails.uuid;
          currentRow['dynamicProperties_' + fieldName] = fileDetails.uuid;
          interactionObj['dynamicProperties_' + fieldName] = fileDetails.uuid;

          await setIsFormUpdated(!isFormUpdated);

          /*
           Bug: KH_BG_293 After removing uploaded file, cannot upload again
           By: Devang
           Date: 25/11/2023
          */
          if (actions && actions.length && actions[selectedActionIndex] && actions[selectedActionIndex].dynamicProps && actions[selectedActionIndex].dynamicProps.length) {
            let dynamicPropIndex = actions[selectedActionIndex].dynamicProps.findIndex(dynamicProp => dynamicProp.name === fieldName);
            if (dynamicPropIndex > -1) {
              let signedUrl = await getImageSignedUrl(fieldName, interactionObj, currentTask);
              actions[selectedActionIndex].dynamicProps[dynamicPropIndex].signedUrl = signedUrl;
            }
          }
          /*
            By: Yashvi
            On: 20th July 2022
            Get images for tasks with no actions
          */
          let dynamicPropIndexWithoutaction = dynamicProps.findIndex(dynamicProp => dynamicProp.name === fieldName);
          if (dynamicPropIndexWithoutaction > -1) {
            let signedUrl = await getImageSignedUrl(fieldName, interactionObj, currentTask);
            dynamicProps[dynamicPropIndexWithoutaction].signedUrl = signedUrl;
          }
        } catch (e) {
          console.error(e);
        }
      }
    });
  }

  async function sendWhatsappMessage(userData, eventData, contactID, wantsBrochure, wantsPriceList) {
    /*
    // User Creation or Updation
    let res = await axios.post(`${CONSTANTS.API_URL}/api/v1/whatsappUser`, userData);
    if (res) {
      // Event Creation
      let response = await axios.post(`${CONSTANTS.API_URL}/api/v1/whatsappEvent`, eventData);
    }
    // Fetch all records
    // let res = await axios.get(`${CONSTANTS.API_URL}/api/v1/whatsappUsers`);
    */
    /*
      modified : Ashutosh G
      modified : 15/03/2024
      modification : called sendWhatsappMessageWithMIM to send selected modal brochure to case owner (unwanted code removed because brochure include in welcome message)
    */
    if (eventData.event === "welcomeUser") {
      await axios.post(`${CONSTANTS.API_URL}/api/v1/sendWhatsappMessageWithMIM`, {
        "templateName": eventData.whatsappTemplateName,
        "parameters": eventData.whatsappTemplateParametes,
        "phoneNumber": userData.phoneNumber
      });
      let communicationLogPayload = {
        typeOfMessage: "whatsapp",
        sentOn: new Date(),
        sentStatus: "Sent",
        sentTo: userData.phoneNumber,
        messageTitle: "Welcome to Kothari Hyundai",
        messageText: `Dear ${eventData.title ? eventData.title : ''} ${eventData.name}, welcome to ${eventData.dealership} - ${eventData.branch}.` + (wantsPriceList ? 'Please find attached the price list for your reference.' : ''),
        contactID
      };
      let responseLog = await axios.post(`${CONSTANTS.API_URL}/api/v1/communicationLog`, communicationLogPayload);
      // if (res1 && eventData.docUrl){
      //   let res2 = await axios.post(`${CONSTANTS.API_URL}/api/v1/whatsappMedia`, {
      //     number: userData.phoneNumber,
      //     mediaURL: eventData.docUrl,
      //     fileName: eventData.fileName
      //   });
      // }
    }
  }

  /*
    Bug: Images not getting in pdfmake in live server
    Modification: Added function to get images from URL
    By: Devang
    Date: 03/06/2023
  */
  function getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = error => {
        reject(error);
      };

      img.src = url;
    });
  }

  // async function priceList() {
  //   console.log(carVariantTableData,'carVariantTableDatacarVariantTableDatacarVariantTableDatacarVariantTableData');
  //   let pdfName = "price list" + ".pdf";
  //   let docDefinition = {
  //     pageSize: 'A1',
  //     pageOrientation: PDFSTYLE.pageSetup.pageOrientationPortrait,
  //     pageMargins: PDFSTYLE.pageSetup.pageMargins,

  //     // background: function (page) {
  //     //     if(page > 1)
  //     //     return {

  //     //             columns: [
  //     //               { image:hyundai, width: 600, height:1000},
  //     //             ]
  //     //     };
  //     // },
  //     // footer(currentPage, pageCount,page) {
  //     //   if(page > 1)
  //     //     return {
  //     //         style: "pageFooter",
  //     //         columns: [
  //     //             {
  //     //                 text: [{ text: "Created by KDMS\n", width: 50 }]
  //     //             },

  //     //             { text: currentPage.toString() + " of " + pageCount, alignment: "right" }
  //     //         ]
  //     //     }
  //     // },
  //     content: [
  //       {
  //         alignment: 'justify',
  //         columns: [
  //           {
  //             image: await getBase64ImageFromURL(hyundaiLogo),
  //             width:200,
  //             height:80
  //           },
  //           {
  //             text: 'KOTHARI CARS PVT LTD\nPRICE LIST W.E.F. 02ND May 2023\n' + modelVariantName,
  //             alignment:"center",
  //             bold:false,
  //             fontSize:18
  //           },
  //           {
  //             image: await getBase64ImageFromURL(PDFCarImages),
  //             width:150,
  //             height:80
  //           }
  //         ]
  //       },
  //       {
  //         fontSize:16,
  //         table: {
  //           widths: ['*'],
  //           body: [
  //             [{
  //               text: 'PRICE LIST FOR KDMS', alignment: 'center'
  //             }],
  //             [{
  //               text: allnewi20tableHeader, alignment: 'center'
  //             }]
  //           ]
  //         }
  //       },
  //       (carVariantTableData && carVariantTableData.length > 0) && (
  //         {
  //           fontSize:12,
  //           table: {
  //             widths:pdfWidthForCarVariant,
  //             body: [
  //               carVariantTableData,
  //               exShowroomTableData,
  //               tcsExShowroomTableData,
  //               insuranceTableData,
  //               rtoCompanyTableData,
  //               rtoIndividualTableData,
  //               fourFifthExtendedWarrantyTableData,
  //               rmkTableData,
  //               basicAccessoriesKitTableData,
  //               rsaTableData,
  //               additionalPremiumForEngineProtectionTableData,
  //               additionalPremiumforReturnToInvoiceTableData,
  //               totalIndividualTableData,
  //               totalCompanyTableData,
  //               sheildOfTrustTableData
  //             ]
  //           }
  //         }
  //       ),
  //       {
  //         fontSize:12,
  //         pageBreak: catalogueCarVariantDiesel && catalogueCarVariantDiesel.length > 0 ? "after" : "",
  //         table: {
  //           widths:["*"],
  //           body: [
  //             solidColourTableHeader,
  //             noCashPaymentTableHeader,
  //             termsAndConitionsTableHeader,
  //             termsAndConditionsTableData,
  //             termsAndConditionsDetailsTableData ,
  //             ShowroomITableData,
  //             ShowroomIITableData,
  //             ShowroomIIITableData,
  //             ShowroomIVTableData,
  //             ShowroomVTableData,
  //             ShowroomVITableData,
  //             work1TableData,
  //             work2TableData,
  //             work3TableData,
  //             work4TableData,
  //             depotTableData
  //           ]
  //         }
  //       },
  //       (catalogueCarVariantDiesel && catalogueCarVariantDiesel.length > 0) ? ({
  //         fontSize:16,
  //         table: {
  //           widths: ['*'],
  //           body: [
  //             [{
  //               text: 'PRICE LIST FOR KDMS', alignment: 'center'
  //             }],
  //             [{
  //               text: modelDieseltableHeader, alignment: 'center'
  //             }]
  //           ]
  //         }
  //       }) : {},
  //       (catalogueCarVariantDiesel && catalogueCarVariantDiesel.length > 0) ? (
  //         {
  //           fontSize:12,
  //           table: {
  //             widths:pdfWidthForCarVariantDiesel,
  //             body: [
  //               carVariantDieselTableData,
  //               exShowroomDieselTableData,
  //               tcsExShowroomDieselTableData,
  //               insuranceDieselTableData,
  //               rtoCompanyDieselTableData,
  //               rtoIndividualDieselTableData,
  //               fourFifthExtendedWarrantyDieselTableData,
  //               rmkDieselTableData,
  //               basicAccessoriesKitDieselTableData,
  //               rsaDieselTableData,
  //               additionalPremiumForEngineProtectionDieselTableData,
  //               additionalPremiumforReturnToInvoiceDieselTableData,
  //               totalIndividualDieselTableData,
  //               totalCompanyDieselTableData,
  //               sheildOfTrustDieselTableData
  //             ]
  //           }
  //         }
  //       ) : {},
  //       (catalogueCarVariantDiesel && catalogueCarVariantDiesel.length > 0) ? ({
  //         fontSize:12,
  //         pageBreak: catalogueCarVariantCNG && catalogueCarVariantCNG.length > 0 ? "after" : "",
  //         table: {
  //           widths:["*"],
  //           body: [
  //             solidColourDieselTableData,
  //             ["Note : NO CASH PAYMENT ABOVE RS 200000/- WILL BE ACCEPTED"],
  //             ["Terms & Conditions Details Overleaf"],
  //             ["TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi"],
  //             [{  ol: [
  //               'Payment by DD/PO to be drawn in the name of KOTHARI CARS PVT.LTD payable at Pune.',
  //               "Customer request is not to pay any advance / part payment in cash to the consultant. Any such trasaction's done will be customer at his own risk for which company will not be responsible.",
  //               "The prices mentioned are  subject to change without  prior notice and will be charged as applicable  at the time of Registration / delivery.",
  //               "Model specifiction, features & Colours are subject to change without prior notice.",
  //               "Delivery - Subject to realisation of  DD / Cheque.",
  //               "RMK=Cost of Rubber Mat kit include GST. +RSA -Road Service assistance include GST for 1 year",
  //               "Subject to jurisdiction of Pune Court only",
  //               "Two schemes cannot be clubbed together.",
  //               "Basic Accessories Kit Not Included Labour Charges",
  //               "Hyundai Motor India Ltd. reserves the right to change the booking procedure","equipment specifications and discontinue models without notice.",
  //               "Force majeure clause would be applicable to all deliveries.",
  //               "The retail schemes (If Any) given alongwith this pricelist will be applicable on the physical stock and scheme period only.",
  //               "Retail scheme,Price applicable will be valid only on receipt of full Ex showroom price. ",
  //               "The Insurance premium is calculated @ 95 %of Exshowroom Price.",
  //               "Incase of cancellation of booking, Cancellation charges will be charged as per written in  booking form",
  //               "Income tax Pan no and address proof in original are necessary at the time of Booking.",
  //               "Purchase of Insurance Policy and Accessories from Dealer are optional.",
  //               "Value of discount given shall be netted off from the vehicle invoice amount, insurance and registration.",
  //               "Vechicle Register in PCMC or OUT Side area then CRTM Charges Rs. 200 Extra.",
  //               "Extended Warranty & Miscellaneous Expenses amount includes GST @ 18%",              "RTO tax 2% charged extra as per intinmated by RTO department will be applied as per confirmation receive by RTO department as the time registation.",              "Shield of Trust Price for 5yr/60 km inclusing GST 18% also this product get single year also"
  //             ]} ],
  //             ["Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com."],
  //             ["Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com."],
  //             ["Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100"],
  //             ["Showroom IV: Gat No. 15,49/1 , Nagar-Pune road, Opp Manikchand Company, Saradwadi, Shirur 412210 Phone 02138-602525"],
  //             ["Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205"],
  //             ["Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com."],
  //             ["Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96"],
  //             ["Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237 "],
  //             ["Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506"],
  //             ["Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 "],
  //             ["Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  "]
  //           ]
  //         }
  //       }) : {},
  //       (catalogueCarVariantCNG && catalogueCarVariantCNG.length > 0) ? (
  //         {
  //           fontSize:16,
  //           table: {
  //             widths: ['*'],
  //             body: [
  //               [{
  //                 text: 'PRICE LIST FOR KDMS', alignment: 'center'
  //               }],
  //               [{
  //                 text: modelCNGtableHeader, alignment: 'center'
  //               }]
  //             ]
  //           }
  //         }
  //       ) : {},
  //       (catalogueCarVariantCNG && catalogueCarVariantCNG.length > 0) ? (
  //         {
  //           fontSize:12,
  //           table: {
  //             widths:pdfWidthForCarVariantCNG,
  //             body: [
  //               // addEmptyValuesForRecord(priceListForPmc,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(modelCNGtableHeader,catalogueCarVariantCNG.length),
  //               carVariantCNGTableData,
  //               exShowroomCNGTableData,
  //               tcsExShowroomCNGTableData,
  //               insuranceCNGTableData,
  //               rtoCompanyCNGTableData,
  //               rtoIndividualCNGTableData,
  //               fourFifthExtendedWarrantyCNGTableData,
  //               rmkCNGTableData,
  //               basicAccessoriesKitCNGTableData,
  //               rsaCNGTableData,
  //               additionalPremiumForEngineProtectionCNGTableData,
  //               additionalPremiumforReturnToInvoiceCNGTableData,
  //               totalIndividualCNGTableData,
  //               totalCompanyCNGTableData,
  //               sheildOfTrustCNGTableData
  //               // addEmptyValuesForRecord(solidColourTableHeader,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(noCashPaymentTableHeader,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(termsAndConitionsTableHeader,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(termsAndConditionsTableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(termsAndConditionsDetailsTableData,catalogueCarVariantCNG.length) ,
  //               // addEmptyValuesForRecord(ShowroomITableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(ShowroomIITableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(ShowroomIIITableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(ShowroomIVTableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(ShowroomVTableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(ShowroomVITableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(work1TableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(work2TableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(work3TableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(work4TableData,catalogueCarVariantCNG.length),
  //               // addEmptyValuesForRecord(depotTableData,catalogueCarVariantCNG.length)
  //             ]
  //           }
  //         }
  //       ) : {},
  //       (catalogueCarVariantCNG && catalogueCarVariantCNG.length > 0) ? (
  //         {
  //           fontSize:12,
  //           table: {
  //             widths:["*"],
  //             body: [
  //               solidColourCNGTableData,
  //               ["Note : NO CASH PAYMENT ABOVE RS 200000/- WILL BE ACCEPTED"],
  //               ["Terms & Conditions Details Overleaf"],
  //               ["TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi"],
  //               [{  ol: [
  //                 'Payment by DD/PO to be drawn in the name of KOTHARI CARS PVT.LTD payable at Pune.',
  //                 "Customer request is not to pay any advance / part payment in cash to the consultant. Any such trasaction's done will be customer at his own risk for which company will not be responsible.",
  //                 "The prices mentioned are  subject to change without  prior notice and will be charged as applicable  at the time of Registration / delivery.",
  //                 "Model specifiction, features & Colours are subject to change without prior notice.",
  //                 "Delivery - Subject to realisation of  DD / Cheque.",
  //                 "RMK=Cost of Rubber Mat kit include GST. +RSA -Road Service assistance include GST for 1 year",
  //                 "Subject to jurisdiction of Pune Court only",
  //                 "Two schemes cannot be clubbed together.",
  //                 "Basic Accessories Kit Not Included Labour Charges",
  //                 "Hyundai Motor India Ltd. reserves the right to change the booking procedure","equipment specifications and discontinue models without notice.",
  //                 "Force majeure clause would be applicable to all deliveries.",
  //                 "The retail schemes (If Any) given alongwith this pricelist will be applicable on the physical stock and scheme period only.",
  //                 "Retail scheme,Price applicable will be valid only on receipt of full Ex showroom price. ",
  //                 "The Insurance premium is calculated @ 95 %of Exshowroom Price.",
  //                 "Incase of cancellation of booking, Cancellation charges will be charged as per written in  booking form",
  //                 "Income tax Pan no and address proof in original are necessary at the time of Booking.",
  //                 "Purchase of Insurance Policy and Accessories from Dealer are optional.",
  //                 "Value of discount given shall be netted off from the vehicle invoice amount, insurance and registration.",
  //                 "Vechicle Register in PCMC or OUT Side area then CRTM Charges Rs. 200 Extra.",
  //                 "Extended Warranty & Miscellaneous Expenses amount includes GST @ 18%",              "RTO tax 2% charged extra as per intinmated by RTO department will be applied as per confirmation receive by RTO department as the time registation.",              "Shield of Trust Price for 5yr/60 km inclusing GST 18% also this product get single year also"
  //               ]} ],
  //               ["Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com."],
  //               ["Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com."],
  //               ["Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100"],
  //               ["Showroom IV: Gat No. 15,49/1 , Nagar-Pune road, Opp Manikchand Company, Saradwadi, Shirur 412210 Phone 02138-602525"],
  //               ["Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205"],
  //               ["Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com."],
  //               ["Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96"],
  //               ["Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237 "],
  //               ["Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506"],
  //               ["Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 "],
  //               ["Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  "]
  //             ]
  //           }
  //         }
  //       ) : {}

  //     ],
  //     styles: PDFSTYLE.styles,
  //     undertakingTable: {
  //       margin: [0, 0, 0, 10]
  //     },
  //     undertakingHeader: {
  //       fontSize: 18,
  //       bold:false,
  //       alignment:"center"
  //     }
  //   };
  //   console.log(docDefinition,"docDefinitiondocDefinition");
  //   await pdfMake.createPdf(docDefinition).open();
  //   setCatalogueCarVariant([]);
  //   await setCarVariantTableData([{text:"PARTICULARS", fontSize:12,bold:false}]);
  //   await setExShowroomTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}]);
  //   await setTcsExShowroomTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}]);
  //   await setInsuranceTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}]);
  //   await setRtoCompanyTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}]);
  //   await setRtoIndividualTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}]);
  //   await setFourFifthExtendedWarrantyTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}]);
  //   await setRmkTableData([{text:'RMK', fontSize:12,bold:false}]);
  //   await setBasicAccessoriesKitTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}]);
  //   await setRsaTableData([{text:'RSA', fontSize:12,bold:false}]);
  //   await setAdditionalPremiumForEngineProtectionTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}]);
  //   await setAdditionalPremiumforReturnToInvoiceTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}]);
  //   await setTotalIndividualTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}]);
  //   await setTotalCompanyTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}]);
  //   await setSheildOfTrustTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}]);
  //   await  setPriceListForPmc([{text:'PRICE LIST FOR KDMS', fontSize:12,bold:false,alignment:"center"}]);
  //   await setAllNewi20TableHeader([{text:'All New i20',alignment:"center",fontSize:15,bold:false}]);
  //   await setSolidColourTableHeader([{text:'COLOUR : SOLID COLOUR = ', fontSize:12,bold:false}]);
  //   await setNoCashPaymentTableHeader([{text:'Note : NO CASH PAYMENT ABOVE RS 200000/- WILL BE ACCEPTED', fontSize:12,bold:false}]);
  //   await setTermsAndConitionsTableHeader([{text:'Terms & Conditions Details Overleaf', fontSize:12,bold:false}]);
  //   await setTermsAndConitionsTableData([{text:'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi', fontSize:12,bold:false}]);
  //   await setTermsAndConitionsDetailsTableData([{
  //     colSpan:0,
  //     bold:false,
  //     ol: [
  //       'Payment by DD/PO to be drawn in the name of KOTHARI CARS PVT.LTD payable at Pune.',
  //       "Customer request is not to pay any advance / part payment in cash to the consultant. Any such trasaction's done will be customer at his own risk for which company will not be responsible.",
  //       "The prices mentioned are  subject to change without  prior notice and will be charged as applicable  at the time of Registration / delivery.",
  //       "Model specifiction, features & Colours are subject to change without prior notice.",
  //       "Delivery - Subject to realisation of  DD / Cheque.",
  //       "RMK=Cost of Rubber Mat kit include GST. +RSA -Road Service assistance include GST for 1 year",
  //       "Subject to jurisdiction of Pune Court only",
  //       "Two schemes cannot be clubbed together.",
  //       "Basic Accessories Kit Not Included Labour Charges",
  //       "Hyundai Motor India Ltd. reserves the right to change the booking procedure","equipment specifications and discontinue models without notice.",
  //       "Force majeure clause would be applicable to all deliveries.",
  //       "The retail schemes (If Any) given alongwith this pricelist will be applicable on the physical stock and scheme period only.",
  //       "Retail scheme,Price applicable will be valid only on receipt of full Ex showroom price. ",
  //       "The Insurance premium is calculated @ 95 %of Exshowroom Price.",
  //       "Incase of cancellation of booking, Cancellation charges will be charged as per written in  booking form",
  //       "Income tax Pan no and address proof in original are necessary at the time of Booking.",
  //       "Purchase of Insurance Policy and Accessories from Dealer are optional.",
  //       "Value of discount given shall be netted off from the vehicle invoice amount, insurance and registration.",
  //       "Vechicle Register in PCMC or OUT Side area then CRTM Charges Rs. 200 Extra.",
  //       "Extended Warranty & Miscellaneous Expenses amount includes GST @ 18%",              "RTO tax 2% charged extra as per intinmated by RTO department will be applied as per confirmation receive by RTO department as the time registation.",              "Shield of Trust Price for 5yr/60 km inclusing GST 18% also this product get single year also"
  //     ]

  //   }]);
  //   await setShowroomITableData([{text:'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.', fontSize:12,bold:false}]);
  //   await setShowroomIITableData([{text:'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.', fontSize:12,bold:false}]);
  //   await setShowroomIIITableData([{text:'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100', fontSize:12,bold:false}]);
  //   await setShowroomIVTableData([{text:'Showroom IV: Gat No. 15,49/1 , Nagar-Pune road, Opp Manikchand Company, Saradwadi, Shirur 412210 Phone 02138-602525', fontSize:12,bold:false}]);
  //   await setShowroomVTableData([{text:'"Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205', fontSize:12,bold:false}]);
  //   await setShowroomVITableData([{text:'"Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.', fontSize:12,bold:false}]);
  //   await setWork1TableData([{text:'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96', fontSize:12,bold:false}]);
  //   await setWork2TableData([{text:'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ', fontSize:12,bold:false}]);
  //   await setWork3TableData([{text:'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506', fontSize:12,bold:false}]);
  //   await setWork4TableData([{text:'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ', fontSize:12,bold:false}]);
  //   await setDepotTableData([{text:'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ', fontSize:12,bold:false}]);
  //   await setCarVariantDieselTableData([{text:"PARTICULARS", fontSize:12,bold:false}]);
  //   await setExShowroomDieselTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}]);
  //   await setTcsExShowroomDieselTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}]);
  //   await setInsuranceDieselTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}]);
  //   await setRtoCompanyDieselTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}]);
  //   await setRtoIndividualDieselTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}]);
  //   await setFourFifthExtendedWarrantyDieselTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}]);
  //   await setRmkDieselTableData([{text:'RMK', fontSize:12,bold:false}]);
  //   await setBasicAccessoriesKitDieselTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}]);
  //   await setRsaDieselTableData([{text:'RSA', fontSize:12,bold:false}]);
  //   await setAdditionalPremiumForEngineProtectionDieselTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}]);
  //   await setAdditionalPremiumforReturnToInvoiceDieselTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}]);
  //   await setTotalIndividualDieselTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}]);
  //   await setTotalCompanyDieselTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}]);
  //   await setSheildOfTrustDieselTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}]);
  //   await setModelDieselTableHeader([{text:'',alignment:"center",fontSize:12,bold:false}]);
  //   await setCarVariantCNGTableData([{text:"PARTICULARS", fontSize:12,bold:false}]);
  //   await setExShowroomCNGTableData([{text:"EX - SHOWROOM PRICE", fontSize:12,bold:false}]);
  //   await setTcsExShowroomCNGTableData([{text:"TCS 1% EX-SHOWROOM", fontSize:12,bold:false}]);
  //   await setInsuranceCNGTableData([{text:"INSURANCE (INCLUDE '0' DEP & CONSUMBALE)", fontSize:12,bold:false}]);
  //   await setRtoCompanyCNGTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Company', fontSize:12,bold:false}]);
  //   await setRtoIndividualCNGTableData([{text:'RTO TAX+REG CHARGES+ FASTAG FOR Individual', fontSize:12,bold:false}]);
  //   await setFourFifthExtendedWarrantyCNGTableData([{text:'4th & 5th YEAR EXTENDED WARRANTY', fontSize:12,bold:false}]);
  //   await setRmkCNGTableData([{text:'RMK', fontSize:12,bold:false}]);
  //   await setBasicAccessoriesKitCNGTableData([{text:'BASIC ACCESSORIES KIT', fontSize:12,bold:false}]);
  //   await setRsaCNGTableData([{text:'RSA', fontSize:12,bold:false}]);
  //   await setAdditionalPremiumForEngineProtectionCNGTableData([{text:'ADDL PREMIUM FOR ENGINE PROTECTION', fontSize:12,bold:false}]);
  //   await setAdditionalPremiumforReturnToInvoiceCNGTableData([{text:'ADDL PREMIUM FOR RETURN TO INVOICE(RTI)', fontSize:12,bold:false}]);
  //   await setTotalIndividualCNGTableData([{text:'TOTAL INDIVIDUAL', fontSize:12,bold:false}]);
  //   await setTotalCompanyCNGTableData([{text:'TOTAL COMPANY', fontSize:12,bold:false}]);
  //   await setSheildOfTrustCNGTableData([{text:'T5 YR/60K SHIELD OF TRUST', fontSize:12,bold:false}]);
  //   await setDisablePDFButton(true);
  // }

  async function priceList() {
    if (isEmptyPetrolData && isEmptyDieselData && isEmptyCNGData && isEmptyEVData) {
      toastr.warning("No data available to generate PDF");
      return;
    }



    /* ---------------------------------
       SAFE HELPERS
    ----------------------------------*/

    const safeRow = (row, colCount) => {
      if (!Array.isArray(row)) {
        return Array(colCount).fill('');
      }
      if (row.length < colCount) {
        return [...row, ...Array(colCount - row.length).fill('')];
      }
      if (row.length > colCount) {
        return row.slice(0, colCount);
      }
      return row;
    };

    const safeTable = (widths, rows) => {
      const colCount = widths.length;
      return {
        table: {
          widths,
          body: rows.map(r => safeRow(r, colCount))
        }
      };
    };

    const content = [];

    /* ---------------------------------
       HEADER
    ----------------------------------*/

    content.push({
      columns: [
        {
          image: await getBase64ImageFromURL(hyundaiLogo),
          width: 200,
          height: 80
        },
        {
          text:
            `KOTHARI CARS PVT LTD\n` +
            `PRICE LIST W.E.F. ${effectivePriceListDate}\n` +
            `${modelVariantName}`,
          alignment: "center",
          fontSize: 18
        },
        {
          image: await getBase64ImageFromURL(PDFCarImages),
          width: 150,
          height: 80
        }
      ]
    });

    /* ---------------------------------
       PETROL SECTION
    ----------------------------------*/

    if (catalogueCarVariant?.length) {
      content.push({
        fontSize: 16,
        // margin: [0, 0, 0, 25],
        table: {
          widths: ["*"],

          body: [
            [{ text: "PRICE LIST FOR KDMS", alignment: "center" }],
            [{ text: allnewi20tableHeader, alignment: "center" }]
          ]
        }
      });

      content.push({
        fontSize: 12,
        ...safeTable(pdfWidthForCarVariant, [
          effectiveDateFrom,
          carVariantTableData,
          exShowroomTableData,
          tcsExShowroomTableData,
          insuranceTableData,
          rtoCompanyTableData,
          rtoBHPassingTableData,
          rtoIndividualTableData,
          fourFifthExtendedWarrantyTableData,
          rmkTableData,
          basicAccessoriesKitTableData,
          rsaTableData,
          sheildOfTrustTableData,
          additionalPremiumForEngineProtectionTableData,
          additionalPremiumforReturnToInvoiceTableData,
          totalIndividualTableData,
          totalCompanyTableData,


        ])
      });

      /* ---------------------------------
        COMMON TERMS PAGE
      ----------------------------------*/

      content.push({
        fontSize: 12,
        table: {
          widths: ["*"],
          body: [
            // solidColourTableHeader,
            // noCashPaymentTableHeader,
            [{ text: 'Terms & Conditions Details Overleaf', bold: false }],
            [{ text: 'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi', bold: false }],
            [{
              colSpan: 0,
              bold: false,
              ol: termsAndConditionsData
            }],
            [{ text: 'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.', bold: false }],
            [{ text: 'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.', bold: false }],
            [{ text: 'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100', bold: false }],
            [{ text: "Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.", bold: false }],
            [{ text: "Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205", bold: false }],
            [{ text: "Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.", bold: false }],
            [{ text: 'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96', bold: false }],
            [{ text: 'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ', bold: false }],
            [{ text: 'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506', fontSize: 12, bold: false }],
            [{ text: 'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ', bold: false }],
            [{ text: 'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ', bold: false }]
          ].filter(Boolean)
        }
      });
    }

    /* ---------------------------------
     CNG SECTION
  ----------------------------------*/

    if (catalogueCarVariantCNG?.length) {
      console.log(rtoBHPassingCNGTableData, '-----------rtoBHPassingCNGTableData-----------');
      content.push({ text: '', margin: [0, 20] });
      // content.push({ pageBreak: "before", text: "" });

      content.push({
        fontSize: 16,
        table: {
          widths: ["*"],
          body: [
            [{ text: "PRICE LIST FOR KDMS", alignment: "center" }],
            [{ text: modelCNGtableHeader, alignment: "center" }]
          ]
        }
      });

      content.push({
        fontSize: 12,
        ...safeTable(pdfWidthForCarVariantCNG, [
          effectiveDateCNGFrom,
          carVariantCNGTableData,
          exShowroomCNGTableData,
          tcsExShowroomCNGTableData,
          insuranceCNGTableData,
          rtoCompanyCNGTableData,
          rtoIndividualCNGTableData,
          rtoBHPassingCNGTableData,
          fourFifthExtendedWarrantyCNGTableData,
          rmkCNGTableData,
          basicAccessoriesKitCNGTableData,
          rsaCNGTableData,
          sheildOfTrustCNGTableData,
          additionalPremiumForEngineProtectionCNGTableData,
          additionalPremiumforReturnToInvoiceCNGTableData,
          totalIndividualCNGTableData,
          totalCompanyCNGTableData,


        ])
      });

      /* ---------------------------------
        COMMON TERMS PAGE
      ----------------------------------*/

      content.push({
        fontSize: 12,
        table: {
          widths: ["*"],
          body: [
            // solidColourTableHeader,
            // noCashPaymentTableHeader,
            [{ text: 'Terms & Conditions Details Overleaf', bold: false }],
            [{ text: 'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi', bold: false }],
            [{
              colSpan: 0,
              bold: false,
              ol: termsAndConditionsDataCNG
            }],
            [{ text: 'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.', bold: false }],
            [{ text: 'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.', bold: false }],
            [{ text: 'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100', bold: false }],
            [{ text: "Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.", bold: false }],
            [{ text: "Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205", bold: false }],
            [{ text: "Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.", bold: false }],
            [{ text: 'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96', bold: false }],
            [{ text: 'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ', bold: false }],
            [{ text: 'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506', fontSize: 12, bold: false }],
            [{ text: 'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ', bold: false }],
            [{ text: 'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ', bold: false }]
          ].filter(Boolean)
        }
      });

    }

    /* ---------------------------------
       DIESEL SECTION
    ----------------------------------*/

    if (catalogueCarVariantDiesel?.length) {

      if (catalogueCarVariantCNG?.length || carVariantTableData?.length) {
        content.push({ pageBreak: "before", text: "" });
      }


      content.push({
        fontSize: 16,
        table: {
          widths: ["*"],
          body: [
            [{ text: "PRICE LIST FOR KDMS", alignment: "center" }],
            [{ text: modelDieseltableHeader, alignment: "center" }]
          ]
        }
      });

      content.push({
        fontSize: 12,
        ...safeTable(pdfWidthForCarVariantDiesel, [
          effectiveDateDieselFrom,
          carVariantDieselTableData,
          exShowroomDieselTableData,
          tcsExShowroomDieselTableData,
          insuranceDieselTableData,
          rtoCompanyDieselTableData,
          rtoIndividualDieselTableData,
          rtoBHPassingDieselTableData,
          fourFifthExtendedWarrantyDieselTableData,
          rmkDieselTableData,
          basicAccessoriesKitDieselTableData,
          rsaDieselTableData,
          sheildOfTrustDieselTableData,
          additionalPremiumForEngineProtectionDieselTableData,
          additionalPremiumforReturnToInvoiceDieselTableData,
          totalIndividualDieselTableData,
          totalCompanyDieselTableData,

          // effectiveDateDieselFrom
        ])
      });

      /* ---------------------------------
   COMMON TERMS PAGE
----------------------------------*/

      content.push({
        fontSize: 12,
        table: {
          widths: ["*"],
          body: [
            // solidColourTableHeader,
            // noCashPaymentTableHeader,
            [{ text: 'Terms & Conditions Details Overleaf', bold: false }],
            [{ text: 'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi', bold: false }],
            [{
              colSpan: 0,
              bold: false,
              ol: termsAndConditionsDataDiesel
            }],
            [{ text: 'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.', bold: false }],
            [{ text: 'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.', bold: false }],
            [{ text: 'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100', bold: false }],
            [{ text: "Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.", bold: false }],
            [{ text: "Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205", bold: false }],
            [{ text: "Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.", bold: false }],
            [{ text: 'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96', bold: false }],
            [{ text: 'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ', bold: false }],
            [{ text: 'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506', fontSize: 12, bold: false }],
            [{ text: 'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ', bold: false }],
            [{ text: 'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ', bold: false }]
          ].filter(Boolean)
        }
      });
    }

    /* ---------------------------------
       EV SECTION
    ----------------------------------*/

    if (catalogueCarVariantEV?.length) {
      console.log(rtoBHPassingEVTableData, '-----------rtoBHPassingEVTableData-----------');
      content.push({ text: '', margin: [0, 20] });
      // content.push({ pageBreak: "before", text: "" });

      content.push({
        fontSize: 16,
        table: {
          widths: ["*"],
          body: [
            [{ text: "PRICE LIST FOR KDMS", alignment: "center" }],
            [{ text: modelEVtableHeader, alignment: "center" }]
          ]
        }
      });

      content.push({
        fontSize: 12,
        ...safeTable(pdfWidthForCarVariantEV, [
          effectiveDateEVFrom,
          carVariantEVTableData,
          exShowroomEVTableData,
          tcsExShowroomEVTableData,
          insuranceEVTableData,
          rtoCompanyEVTableData,
          rtoIndividualEVTableData,
          rtoBHPassingEVTableData,
          fourFifthExtendedWarrantyEVTableData,
          rmkEVTableData,
          basicAccessoriesKitEVTableData,
          rsaEVTableData,
          sheildOfTrustEVTableData,
          additionalPremiumForEngineProtectionEVTableData,
          additionalPremiumforReturnToInvoiceEVTableData,
          totalIndividualEVTableData,
          totalCompanyEVTableData,


        ])
      });

      /* ---------------------------------
        COMMON TERMS PAGE
      ----------------------------------*/

      content.push({
        fontSize: 12,
        table: {
          widths: ["*"],
          body: [
            // solidColourTableHeader,
            // noCashPaymentTableHeader,
            [{ text: 'Terms & Conditions Details Overleaf', bold: false }],
            [{ text: 'TERMS & CONDITIONS:Model Features:Please refer separate sheet:  No extended warrenty Tourist Taxi', bold: false }],
            [{
              colSpan: 0,
              bold: false,
              ol: termsAndConditionsDataEV
            }],
            [{ text: 'Showroom I : CTS No. 45/1B/A,Shankarsheth Road,Near KumarPacific Mall,Gultekdi,Pune - 411037. Phone - 24338600 email : kotharihyundai@hotmail.com.', bold: false }],
            [{ text: 'Showroom II :-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27071100 Fax No 30478506  email : kotharihyundai@hotmail.com.', bold: false }],
            [{ text: 'Showroom III: Sylvan heights Opp Seasons Apt Hotel Sanewadi Aundh Pune 411007  email : kotharihyundai@hotmail.com.  Phone No.020-30174100', bold: false }],
            [{ text: "Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.", bold: false }],
            [{ text: "Showroom V: Gat No.414, At Post. Velu, Khed Shivapur, Near Joshi Wadewale, Taluka. Bhor Dist. Pune - 412 205", bold: false }],
            [{ text: "Showroom VI : Shop No 1 & 2 S.No.461,Tilak Road,Sadashiv Peth,Pune - 411030 Phone - 24338600 email : kotharihyundai@hotmail.com.", bold: false }],
            [{ text: 'Works I : 691/A-2,Pune-Satara Road,Bibwewadi,Pune 411 037 Phone : 30298612 / 24222090/96', bold: false }],
            [{ text: 'Works II : No.2 A / 8 Bhau Patil Road Near Pune IT Park Bopodi Pune 411 003 Phone :  30112740/41  FAX: 25815237  ', bold: false }],
            [{ text: 'Works III:-  Mundhwa Kharadi Bypass , Near Magar Patta City Next To Zensor Kharadi Pune 411 014  Phone  27014401/30478500      Fax No 30478506', fontSize: 12, bold: false }],
            [{ text: 'Works IV:- Sr.18 Dharmavat Corner , Opp Sai Services , Kalyan Mangal Karyalaya , Kondhwa Bk. , Pune - 411048 . Phone : 30402700 ', bold: false }],
            [{ text: 'Depot : Sr. No. 1 / 1 / 1 A  Bhilarewadi , Behind Leyland Petrol Pump , Pune - 411046   Phone  No : 30468600  ', bold: false }]
          ].filter(Boolean)
        }
      });

    }



    /* ---------------------------------
       FINAL DOC
    ----------------------------------*/

    const docDefinition = {
      pageSize: "A1",
      pageOrientation: "landscape",
      pageMargins: PDFSTYLE.pageSetup.pageMargins,
      content: content.filter(Boolean),
      styles: PDFSTYLE.styles
    };

    /* ---------------------------------
       CREATE PDF (state reset AFTER)
    ----------------------------------*/

    pdfMake.createPdf(docDefinition).open();

    setTimeout(() => {
      setCatalogueCarVariant([]);
      setCatalogueCarVariantDiesel([]);
      setCatalogueCarVariantCNG([]);
      setCatalogueCarVariantEV([]);
      setDisablePDFButton(true);
    }, 0);
  }


  async function togglePriceListModal() {
    setModelForPriceList('');
    let catalogoueItemResponse = await axios.get(`${CONSTANTS.API_URL}/api/v1/models/catalogue?brandType=Hyundai&isForInsurance=false&status=Active`);
    let array = catalogoueItemResponse.data
    console.log(array, 'arrayarray');

    const result = [];
    const map = new Map();
    for (const item of array) {
      if (!map.has(item.displayName)) {
        map.set(item.displayName, true);    // set any value to Map
        result.push({
          ...item
        });
      }
    }
    await setCatalogoueItemList(result);
    setIsPriceListModalOpen(!isPriceListModalOpen);
    if (!isPriceListModalOpen) {
      resetPriceListData();
    }
  }

  function resetPriceListData() {
    setCatalogueCarVariant([]);
    setCatalogueCarVariantDiesel([]);
    setCatalogueCarVariantCNG([]);

  }

  async function toggleNewFollowupModal(e) {
    if (!isFollowUpModalOpen) {
      //Get all interactions assigned to the logged in user
      let cases = await axios.get(`${CONSTANTS.API_URL}/api/v1/userCases?userID=${userInfo.uuid}`);
      console.log("casescases", cases);
      if (cases.data.length) {
        setCases(cases.data);
      } else {
        setCases([]);
      }
    } else {
      setSelectedCase('');
      setSelectedRemarkCategory('');
      setRemark('');
      setTypeofFollowup('');
      setFollowupDate(moment(new Date()).format('YYYY-MM-DD'));
      setIsFollowupDone(false);
      setIsCallOriginated(false);
    }
    setFollowUpModalOpen(!isFollowUpModalOpen);
  }

  async function toggleReceivePaymentModal(e) {
    setReceivePaymentModalOpen(!isReceivePaymentModalOpen);
  }

  async function toggleCallModal(e) {
    if (isCallModalOpen) {
      setCallResponse('')
      setCallResponseText('')
      setCallResponseObj({});
      setCallResponseData('');
      setIsCallOriginatedByUser(false);
      setMobileNumberEntered('');
      setCallNumberValidationError('');
      setIsCallNumberRejected(false);
      setOngoingCallID('');
      setCurrentCallStatus('');
      setIsCallFinished(false);
      setCallTimes({});
    }
    setCallModalOpen(!isCallModalOpen);
  }

    useEffect(async () => {
    if (!isCallModalOpen) return;
    if (!userInfo || !userInfo.uuid) {
      setUserExtension('');
      return;
    }
    setIsExtensionLoading(true);
    try {
      const response = await axios.get(`${CONSTANTS.API_URL}/api/v1/users?uuids=${userInfo.uuid}`);
      const loggedInUser = response.data && response.data[0] ? response.data[0] : null;
      console.log('loggedInUser for extension:', loggedInUser); // remove after confirming the field name
      setUserExtension(loggedInUser && loggedInUser.extension ? String(loggedInUser.extension).trim() : '');
    } catch (error) {
      console.error('Unable to load user extension', error);
      setUserExtension('');
    } finally {
      setIsExtensionLoading(false);
    }
  }, [isCallModalOpen]);

  async function toggleOnGoingCallWindow(e) {
    if (!isOngoingCallWindowOpen) {
      setOngoingCallWindowOpen(!isOngoingCallWindowOpen);
      // setOngoingCallWindowClose(!isOngoingCallWindowClose);
    } else if (isOngoingCallWindowClose) {
      setOngoingCallWindowClose(!isOngoingCallWindowClose);
    }
  }

  async function closeOnGoingCallWindow(e) {
    if (isOngoingCallWindowOpen) {
      setOngoingCallWindowClose(!isOngoingCallWindowClose);
    }
  }

  async function fillAssigneduser(value) {
    await setAssignResposiblePerson(value)
    if (value) {
      setIsSubmitDisable(false)
    } else {
      setIsSubmitDisable(true)
    }
  }

  async function originateCall(e) {
    await axios.post(`${CONSTANTS.API_URL}/api/v1/originateCall`, {
      userID: userInfo.uuid,
      mobileNumber: selectedCaseObj['dynamicProperties_mobile']
    });
    setIsCallOriginated(!isCallOriginated);
  }

   /*
  BN:
  Modification: Digital Calling
  Date: 13/10/26
  By: Priya
  */
  async function originateCallNew(e) {
    if (!mobileNumberEntered.trim() || isCallNumberRejected
      || isNewCallSubmitting || isCallOriginatedByUser) return;
    setIsNewCallSubmitting(true);
    setCallNumberValidationError('');
    try {
      let res;
      if (userDesignation === "SALES CONSULTANT") {
        res = await axios.post(`${CONSTANTS.API_URL}/api/v1/originateCall/mobile`, {
          userID: userInfo.uuid,
          mobileNumber: mobileNumberEntered,
          followUpFor,
          reasonForCalling
        });
      } else {
        res = await axios.post(`${CONSTANTS.API_URL}/api/v1/originateCall`, {
          userID: userInfo.uuid,
          mobileNumber: mobileNumberEntered,
          followUpFor,
          reasonForCalling
        });
      }
      // let res = await axios.post(`${CONSTANTS.API_URL}/api/v1/originateCall/mobile`, {
      //   userID: userInfo.uuid,
      //   mobileNumber: mobileNumberEntered
      // });
      console.log(res, "rrrrrrrrrrrrrrrrrrr");
      if (res.data && res.data.code === 'INTERACTION_NOT_FOUND') {
        setIsCallNumberRejected(true);
        setCallNumberValidationError(res.data.message);
        return;
      }
      if (res.data) {
        setCallResponse(res.data.response);
        setCallResponseText(res.data.responseText);
        setCallResponseObj(res.data);
        setCallResponseData(res.data.responseData);
      }
      if (res.data && res.data.uuid && (!res.data.responseData || res.data.responseData === "1|Success")) {
        setItem('ongoingCall', res.data);
        setOngoingCallID(res.data.uuid);
        setCurrentCallStatus(res.data.status || 'active');
        setIsCallFinished(false);
        setCallTimes({ initiated: new Date() });
        setIsCallOriginatedByUser(true);
      } else {
        setCallNumberValidationError(res.data && (res.data.message || res.data.responseData)
          ? String(res.data.message || res.data.responseData) : 'Unable to initiate the call. Please try again.');
      }
    } catch (error) {
      setCallNumberValidationError('Unable to initiate the call. Please try again.');
    } finally {
      setIsNewCallSubmitting(false);
    }
  }
  useEffect(() => {
    if (!isCallModalOpen || !ongoingCallID || isCallFinished) return;
    let cancelled = false;
    let isPolling = false;
    let lastCallStatus = currentCallStatus;
    const callInterval = setInterval(async () => {
      if (isPolling) return;
      isPolling = true;
      try {
        const callResponse = await axios.get(`${CONSTANTS.API_URL}/api/v1/callslist?uuid=${ongoingCallID}`);
        const call = Array.isArray(callResponse.data) ? callResponse.data[0] : null;
        if (cancelled || !call) return;
        setItem('ongoingCall', call);
        setCallResponseObj(call);
        if (call.status !== lastCallStatus) {
          lastCallStatus = call.status;
          setCurrentCallStatus(call.status);

          if (call.status === 'started')   stampCallTimes(['initiated', 'received']);
          if (call.status === 'connected') stampCallTimes(['initiated', 'received', 'connected']);
          if (call.status === 'finished')  stampCallTimes(['initiated', 'received', 'connected', 'finished']);
          if (call.status === 'missed')    stampCallTimes(['finished']); 

          
          if (call.status === 'finished' || call.status === 'missed') {
            setIsCallFinished(true);
            setOngoingCallID('');
            clearInterval(callInterval);
          }
        }
      } catch (HTTPException) {
        if (!cancelled) {
          await reportException({ HTTPException, fileName, functionName: 'pollRightPanelCall' });
        }
      } finally {
        isPolling = false;
      }
    }, 5000);
    return () => {
      cancelled = true;
      clearInterval(callInterval);
    };
  }, [isCallModalOpen, ongoingCallID, isCallFinished]);

  async function setCase(value) {
    setSelectedCase(value);
    let selectedCaseObject = cases.find(d => d.uuid === value);
    if (selectedCaseObject) {
      setSelectedCaseObj(selectedCaseObject);
    }
  }

  /*
    Bug: T1738 - BG_FN: Data is auto populated when add new case is added - Remark, Dealer code
    Modification: Updated function to set selectedCaseTypes from a deepCopied value
    By: Devang
    Date: 15/04/2024
  */
  const setCaseType = (caseType) => {
    let selectedCaseTypesObj = deepCopy(selectedCaseTypes);
    if (selectedCaseTypesObj.length) {
      if (!selectedCaseTypesObj.includes(caseType)) {
        selectedCaseTypesObj.push(caseType);
        if (caseType === "Car") {
          setType("Exchange Buyer")
        }
        /*let cardDiv = document.getElementById(caseType + "-Card");
        if (cardDiv) {
          cardDiv.style.background = "#CFE3C0";
        }*/
      } else if (selectedCaseTypesObj.includes(caseType)) {
        let id = selectedCaseTypesObj.findIndex(d => d === caseType);
        if (id > -1) {
          selectedCaseTypesObj.splice(id, 1);
          if (caseType === "Car") {
            setType("First Time Buyer")
          }
          /*let cardDiv = document.getElementById(caseType + "-Card");
          if (cardDiv) {
            cardDiv.style.background = "#ececec";
          }*/
        }
      }
    } else {
      selectedCaseTypesObj.push(caseType);
      /*let cardDiv = document.getElementById(caseType + "-Card");
      if (cardDiv) {
        cardDiv.style.background = "#CFE3C0";
      }*/
    }
    setIsCaseTypeSelected(true);
    setSelectedCaseTypes(selectedCaseTypesObj);
  }

  /*
    Bug: 5 KH_BG_75 Receptionist / Sales Consultant Add New Case Select Type of Case -  Vehicle , Finance , Accessories , Used Car , Vas Icons are not displayed as per standard
    Modification: Updated fill and stroke and height/width of svgs
    By: Devang
    Date: 06/07/2023
  */
  const getRowCardIcon = (button) => {
    if (button && button.toLowerCase() === 'hyundai') {
      return <Hyundai masterClasses="flex-c-m" width="25px" height="25px" fill="#808080" />;
    } else if (button && button.toLowerCase() === 'car') {
      return <Car masterClasses="flex-c-m" width="25px" height="22px" fill="#808080" />;
    } else if (button && button.toLowerCase() === 'accessories') {
      return <Chair2 masterClasses="flex-c-m" width="25px" height="20px" stroke="#808080" viewBox="0 0 13 16" />;
    } else if (button && button.toLowerCase() === 'vas2') {
      return <Vas2 masterClasses="flex-c-m" width="25px" height="25px" stroke="#808080" />;
    } else if (button && button.toLowerCase() === 'finance') {
      return <Rupee masterClasses="flex-c-m" width="25px" height="20px" fill="#808080" />;
    }
  };

  // modified by Manohar
  // modified at 13 Feb 2023
  // modification: Add Create new Courior and create new visit menu

  function toggleCreateVisitModal() {
    setVisitModalVisibility(!isVisitModalOpen);
  }
  function closeVisitModal(e) {
    e.preventDefault();
    setVisitModalVisibility(false);
  }

  // function toggleCreateDigitalLeadModal() {
  //   setDigitalLeadModalVisibility(!isDigitalLeadModalOpen);
  // }
  function closeDigitalLeadModal(e) {
    e.preventDefault();
    setDigitalLeadModalVisibility(false);
  }
  function CourierModalclose(e) {
    e.preventDefault();
    setCourierModalVisibility(!isCourierModalOpen);
  }
  function toggleCloseCourierModal() {
    setCourierModalVisibility(!isCourierModalOpen);
  }
  /*
    modified by Komal
    modified at 15 April 2023
    modification: Add toggleCalculatorModal
  */
  async function toggleCalculatorModal(e) {
    setCalculatorModalOpen(!isCalculatorModalOpen);
  }

  async function toggleRecentlyViewedModal(e) {
    setRecentlyViewedModalVisibility(!isRecentlyViewedModalVisible);
  }
  async function toggleFollowedCasesModal(e) {
    setFollowedCasesModalVisibility(!isFollowedCasesModalVisible);
  }

  async function toggleRecentlyViewedModal(e) {
    setRecentlyViewedModalVisibility(!isRecentlyViewedModalVisible);
  }
  async function toggleFollowedCasesModal(e) {
    setFollowedCasesModalVisibility(!isFollowedCasesModalVisible);
  }
  /*
    Modification: Added function to close socketBox
    By: Komal Wable
    Date: 18/04/2023
  */

  const slideNotificationRef = useOutsideClick(closeNotificationAlert);
  async function closeNotificationAlert() {
    setShowSlideNotification(false);
  }
  async function handleSlideNotification() {
    if (nudges) {
      let payload = nudges;
      payload.isAcknowledged = true;
      payload.message = `${payload.nudgedTo} acknowledge you on Notification`;
      let Response = await axios.put(`${CONSTANTS.API_URL}/api/v1/updateNudge/${nudges.uuid}`, payload);
    }
    setIsSound(false)
    setShowSlideNotification(false);
  }

  /**********************************************************************/
  let [isErrorMessage, setIsErrorMessage] = useState('');
  let [csvParsedListErros, setCsvParsedListErrors] = useState([]);
  let [isCSVDownloadButtonDisable, setIsCSVDownloadButtonDisable] = useState(false);
  let [uploadedCSVView, setUploadedCSVView] = useState(false);
  let [bulkUploadList, setBulkUploadList] = useState([]);
  let [errorFreeRecordCsv, setErrorFreeCsv] = useState([]);
  let [areAllRemoved, setAreAllRemoved] = useState(false);
  let [isSuccessfull, setIsSuccessfull] = useState(false);
  let [bulkUploadResult, setBulkUploadResult] = useState({});
  let [objParsedList, setObjParsedList] = useState([]);
  let [headers, setHeaders] = useState([]);
  let [uploadFilter, setUploadFilter] = useState('');
  let [isFileUploadModalOpen, setIsFileUploadModalOpen] = useState(false);
  let [selectedBulkUploadAction, setSelectedBulkUploadAction] = useState('');
  let [selectedUploadType, setSelectedUploadType] = useState('');


  async function inputClicked(e) {
    let textBox = document.getElementById(e.target.id);
    if (textBox) {
      await textBox.focus();
      // await textBox.select();
    }
  }

  async function setFormValueInputCase(e) {
    await setEndorsementObj({ ...endorsementObj, [e.target.name]: e.target.value });
    if (e.target.name === "correction") {
      await setEndorsementObj({ ...endorsementObj, [e.target.id]: e.target.checked });
    }
    // else if (e.target.name === "searchQuery") {
    //   searchCase('Input');
    // }
  }

  function toggleUploadFileModal(e, type) {
    // e.preventDefault();
    setIsFileUploadModalOpen(!isFileUploadModalOpen);
    setUploadedCSVView(false);
    setIsSuccessfull(false);
    setBulkUploadList([]);
    setDuplicateRecords([]);
    setIsErrorValidationInCsv(false);
    setErrorValidationInCsv([])
    if (type) {
      setSelectedBulkUploadAction(type);
    } else {
      setSelectedBulkUploadAction('');
    }
  }
  async function uploadBrowsedCSV(e) {
    e.preventDefault();
    let dt = e.target;
    let files = e.target.files[0];
    if (!files) return;
    let fileName = files.name;
    let extension = fileName.split('.').pop();
    if (e.target.files.length < 1) {
      setIsErrorMessage('No file is Selected');
      return;
    }
    if (e.target.files[0].size <= 8) {
      setIsErrorMessage('File is empty');
      return;
    }
    if (fileTypeExtension.includes(extension.toLowerCase())) {
      if (selectedBulkUploadAction === "Digital Lead") {
        makeCsvJsonAndCheckUniquenessForDigitalLead(dt);
      } else {
        makeCsvJsonAndCheckUniqueness(dt);
      }
      storedFileCsv = e.target.files[0];
    }
  }
  function uploadCSVByDragNDrop(ev) {
    ev.preventDefault();
    let dt = ev.dataTransfer;
    let files = dt.files[0];
    if (!files) return;
    let fileName = files.name;
    let extension = fileName.split('.').pop();
    if (fileTypeExtension.includes(extension)) {
      if (selectedBulkUploadAction === "Digital Lead") {
        makeCsvJsonAndCheckUniquenessForDigitalLead(dt);
      } else {
        makeCsvJsonAndCheckUniqueness(dt);
      }
      storedFileCsv = dt.files[0];
    }
  }
  async function makeCsvJsonAndCheckUniqueness(csvFile) {
    try {
      console.log(csvFile, "csvFilecsvFilecsvFile");
      // setIsErrorValidationInCsv(false)
      setDuplicateRecords([]);
      let file = csvFile.files[0];
      let reader = new FileReader();
      reader.onloadend = async (evt) => {
        if (evt.target.readyState === FileReader.DONE) {
          let result = await makeAndReturnJSONForCsv(evt.target.result);
          console.log(result, '-------------result------------');
          /*
            Bug: T2831 - BG_FN:<Upload Reports>: If the report CSV has duplicate VIN then duplicate cases are getting created. Duplicate VIN validation has to be added in the reports upload
            Modification: Added duplicate VIN validation in the reports upload and added a separate section to show duplicate records in the UI
            By: Manohar Sule
            Date: 26/02/2026
          */
          if (result.duplicateKeys && result.duplicateKeys.length) {
            // let errorInCsv = result.bulkUpload.filter((errors) => {
            //   return errors.error;
            // });
            // setCsvParsedListErrors(result.bulkUpload);
            // setBulkUploadList(result.bulkUpload);
            // if (errorInCsv.length > 0) {
            //   errorCountFile = errorInCsv.length;
            //   toggleUploadCSVView();

            // } else {

            // }
            // setIsErrorValidationInCsv(true)
            setDuplicateRecords(result.duplicateKeys);
            return;
          } else if ((result.repeatedItems && result.repeatedItems.length === 0) || !result.repeatedItems) {
            let errorInCsv = result.bulkUpload.filter((errors) => {
              return errors.error;
            });
            errorCountFile = errorInCsv.length;
            failRecordCount = errorInCsv.length;
            failRecordDetails = errorInCsv;
            let errorFreeCsv = result.bulkUpload.filter((errors) => {
              return !errors.error;
            });
            setErrorFreeCsv(errorFreeCsv);
            setCsvParsedListErrors(result.bulkUpload);
            console.log("errorInCsverrorInCsv", errorInCsv);
            if (errorInCsv.length > 0 || (result.errorItems && result.errorItems.length > 0)) {
              toggleUploadCSVView();
              setAreAllRemoved(false);
              if (result.errorItems) {
                setIsErrorValidationInCsv(true)
                setErrorValidationInCsv(result.errorItems)
                console.log(result.errorItems, 'result.errorItems-------result.errorItems');
                // User can now download error items as CSV file using the downloadErrorItemsAsCSV function
              }
            } else {
              const fileObj = {
                name: storedFileCsv.name,
                size: storedFileCsv.size,
                type: storedFileCsv.type,
                value: storedFileCsv.name,
                fileType: uploadFilter
              };
              console.log("result", result);
              /*
                By: Yashvi
                On: 16th August 2023
                Bug: KH_BG_261 The count is incorrect for "Already Closed Cases" & "Total"
                Added selectedBulkUploadAction condition for ACH Transactions as it was triggeered after 64VB API call
              */

              if (selectedBulkUploadAction === '64VB') {
                let response = await axios.put(`${CONSTANTS.API_URL}/api/v1/bulkUpload64VB`, result.arrayJson);
                await axios.put(`${CONSTANTS.API_URL}/api/v1/user/pageVisitUserInformation`, { action: '64VB Bulk Upload', email: userInfo.email });
                setBulkUploadResult(response.data);
                setIsSuccessfull(true);
                console.log(uploadedCSVView, isSuccessfull);
              } else if (selectedBulkUploadAction === 'Policy Summary') {
                // let response = await axios.put(`${CONSTANTS.API_URL}/api/v1/bulkUploadpolicySummary/${selectedUploadType}`, result.arrayJson);
                try {
                  const fileTypeError = await isAllowedFileType(fileObj, 'csv');
                  if (!fileTypeError) {
                    toastr.warning("This file cannot be uploaded either because this is not a supported file type. Please exclude such files and try again.");
                    return;
                  }

                  let payload = {
                    file: fileObj,
                    interactionID: selectedUploadType
                  }
                  let fileDetails
                  await axios.post(`${CONSTANTS.API_URL}/api/v1/file/getSignedUrl`, payload).then(async res => {
                    if (res && res.data) {
                      fileDetails = res.data;
                      try {
                        //  Save File on S3
                        const opts = {
                          headers: {
                            name: 'Content-Type',
                            value: 'multipart/form-data',
                          }
                        };
                        let fileData = file;
                        let fileExtension = fileObj.name.split('.').pop();

                        const fileUpload = await axios.put(fileDetails.signedURL, fileData, opts);
                        console.log(fileUpload);
                        let jsonPayload = {
                          data: result.arrayJson,
                          fileData: fileDetails
                        }
                        console.log(jsonPayload, '-----------jsonPayload----------');
                        let response = await axios.put(`${CONSTANTS.API_URL}/api/v1/bulkUploadpolicySummary/${selectedUploadType}`, jsonPayload);
                        // await axios.put(`${CONSTANTS.API_URL}/api/v1/user/pageVisitUserInformation`, { action: 'Policy Summary Bulk Upload', email: userInfo.email });
                        setBulkUploadResult(response.data);
                        setIsSuccessfull(true);
                        console.log(uploadedCSVView, isSuccessfull);
                      } catch (e) {
                        console.error(e);
                      }
                    }
                  });
                } catch (HTTPException) {
                  await reportException({
                    HTTPException,
                    fileName,
                    functionName: 'uploadFileCase',
                  });
                  return HTTPException;
                }
                // await axios.put(`${CONSTANTS.API_URL}/api/v1/user/pageVisitUserInformation`, { action: 'Policy Summary Bulk Upload', email: userInfo.email });
                // setBulkUploadResult(response.data);
                setIsSuccessfull(true);
                console.log(uploadedCSVView, isSuccessfull);
              } else {
                let response = await axios.put(`${CONSTANTS.API_URL}/api/v1/bulkUploadACH`, result.arrayJson);
                await axios.put(`${CONSTANTS.API_URL}/api/v1/user/pageVisitUserInformation`, { action: 'ACH Bulk Upload', email: userInfo.email });
                setBulkUploadResult(response.data);
                setIsSuccessfull(true);
                console.log(uploadedCSVView, isSuccessfull);
              }
            }
            return;
          }
          let arrayJson = result.arrayJson;
          if (!arrayJson) {
            return;
          }
          setObjParsedList(result.arrayJson);
          setBulkUploadList(bulkUploadList);
        }
      };
      await reader.readAsBinaryString(file);
    } catch (HTTPException) {
      await reportException({
        HTTPException,
        fileName,
        functionName: 'makeCsvJsonAndCheckUniqueness',
      });
      return HTTPException;
    }
  }
  //   function toCamelCase(str) {
  //   return str
  //     .toLowerCase()
  //     .replace(/[^a-z0-9]+(.)/g, (_, chr) => chr.toUpperCase());
  // }
  //   function makeAndReturnJSONForCsv(result) {
  //     result = result.trim();
  //     let splitOnNewline = result.split(/\r?\n/);
  //     console.log(splitOnNewline,'----splitOnNewline---');
  //     let headersArray = splitOnNewline[0].split(',');
  //     console.log(headersArray,'------headersArray------');
  //     // headersArray = headersArray.map(value =>{
  //     //   value.trim().replace(/[^a-zA-Z0-9 ]/g, "")
  //     // });
  //     headersArray = headersArray.map(h => toCamelCase(h));
  //     console.log(headersArray,'-------headersArrayheadersArray--');
  //     let response = {};
  //     let catalogueJson = [];
  //     splitOnNewline.shift();
  //     console.log(splitOnNewline,'------splitOnNewline------2222222222');
  //     splitOnNewline.forEach(row => {
  //       let valueArr = row.split(',');
  //       console.log(valueArr,'------valueArr');
  //       valueArr = valueArr.map(value => value.trim().replace(/"/g, ""));
  //       let itemObject = {};
  //       headersArray.map((key, index) => itemObject[key] = valueArr[index]);
  //       console.log(itemObject,'------itemObject--------');
  //       catalogueJson.push(itemObject);
  //     });
  //     setHeaders(headersArray);
  //     console.log("catalogueJsoncatalogueJson",catalogueJson);
  //     response['arrayJson'] = catalogueJson;
  //     let catalogueItems = catalogueJson.map((item) => {
  //       return item;
  //     });
  //
  //     let repeatedItems = [];
  //     let errorItems = [];
  //     let lookup;
  //     let bulkUpload = [];
  //     catalogueItems.map(item => {
  //       //------------
  //       lookup = catalogueItems.reduce((a, e) => {
  //         a[e.name] = ++a[e.name] || 0;
  //         return a;
  //       }, {});
  //       let object = Object.assign(item);
  //       // object['uuid'] = item.uuid ? item.uuid : '';
  //       if (lookup[item.uuid]) {
  //         // object['error'] = 'duplicate entry';
  //       }
  //       let regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]{2,}\.)+[a-zA-Z]{2,}))$/;
  //       const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/i;
  //       let isError = false;
  //       if (item.emailAddress && !item.emailAddress.match(regex)) {
  //
  //         if (!isError) {
  //           errorItems.push(object)
  //           object['error'] = 'invalid email';
  //           isError = true;
  //         } else {
  //           object['error'] += ' , invalid email';
  //         }
  //       }
  //
  //       if (item.vin && !item.vin.match(regex)) {
  //         if (!isError) {
  //           errorItems.push(object)
  //           isError = true;
  //           object['error'] = 'invalid VIN';
  //         } else {
  //           object['error'] += ' , invalid VIN';
  //         }
  //       }
  //
  //       object['displayName'] = item.model ? item.model : '';
  //       console.log(object,'----------object-----------');
  //       bulkUpload.push(object);
  //     });
  //
  //     // debugger;
  //     setBulkUploadList(bulkUpload); // got all records in 'bulkUpload' but unable to set
  //     if (!lookup) {
  //       setIsErrorMessage('File is empty');
  //     }
  //     let all = Object.keys(lookup);
  //     all.map((key) => {
  //       if (lookup[key] > 0) {
  //         // repeatedItems.push(key);
  //       }
  //     });
  //     // response['repeatedItems'] = repeatedItems;
  //     console.log("bulkUploadbulkUpload",bulkUpload);
  //     response['bulkUpload'] = bulkUpload;
  //     return response;
  //   }
  //

  function toCamelCase(str) {
    return str
      .toLowerCase()
      .replace(/[^a-z0-9]+(.)/g, (_, chr) => chr.toUpperCase());
  }

  //   function makeAndReturnJSONForCsv(result) {
  //     result = result.trim();
  //     let lines = result.split(/\r?\n/);
  //
  //     // ✅ Extract & normalize headers
  //     let headers = lines[0].split(',').map(h => toCamelCase(h.trim()));
  //     // ✅ Parse header row safely
  //       // let headers = parseCsvLine(lines[0]).map(h => toCamelCase(h.trim()));
  //
  //     // ✅ Remove header row
  //     lines.shift();
  //
  //     let catalogueJson = [];
  //
  //     // ✅ Process rows
  //     for (let row of lines) {
  //       // Before the loop
  // const csvSplitRegex = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/;
  //
  // // Inside the 'for (let row of lines)' loop:
  // let cols = row.split(csvSplitRegex) // Split by comma not inside quotes
  //              .map(v => v.trim().replace(/"/g, "")); // Trim and remove surrounding quotes
  //       // let cols = row.split(',').map(v => v.trim().replace(/"/g, ""));
  //       let obj = {};
  //
  //       headers.forEach((key, i) => {
  //         obj[key] = cols[i] ?? "";
  //       });
  //
  //       catalogueJson.push(obj);
  //     }
  //
  //     setHeaders(headers);
  //
  //     // -----------------------------------------------------
  //     // ✅ VALIDATIONS
  //     // -----------------------------------------------------
  //
  //     const emailRegex =
  //       /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //
  //     const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/i;
  //
  //     // ✅ Mobile number (10 digits or with +91, spaces, dashes)
  //     // const mobileRegex = /^(\+?\d{1,3}[- ]?)?\d{10}$/;
  //     const mobileRegex = /^[0-9]{10}$/;
  //
  //     let bulkUpload = [];
  //     let lookup = {};
  //     let errorItems = [];
  //     let possibleVinName = ['chassisNo', 'chassis', 'vin', 'vinNo', 'vin.'];
  //     let possibleMobileName = ['mobileNo', 'mobile', 'contactNumber', 'contactNo', 'contactNumber', 'customerNumber'];
  //     let possibleEmailName = ['email', 'emailAddress'];
  //
  //     // ✅ Duplicate check based on VIN (or UUID if needed)
  //     for (let item of catalogueJson) {
  //       const key = item.vin || item.uuid || item.id || item.name || "unknown";
  //
  //       lookup[key] = (lookup[key] || 0) + 1;
  //
  //       let obj = { ...item }; // ✅ safe copy
  //       const vinKey = Object.keys(item).find(k =>
  //         possibleVinName.some(v => k.toLowerCase() === v.toLowerCase())
  //       );
  //       const mobileKey = Object.keys(item).find(k =>
  //         possibleMobileName.some(v => k.toLowerCase() === v.toLowerCase())
  //       );
  //       const emailKey = Object.keys(item).find(k =>
  //         possibleEmailName.some(v => k.toLowerCase() === v.toLowerCase())
  //       );
  //
  //       const vinValue = vinKey ? item[vinKey] : "";
  //       const mobileValue = mobileKey ? item[mobileKey] : "";
  //       const emailValue = emailKey ? item[emailKey] : "";
  //       let isError = false;
  //
  //       // ✅ Email validation
  //       // if ((obj.emailAddress && obj.emailAddress !== '-') && !emailRegex.test(obj.emailAddress)) {
  //       //   obj.error = "Email";
  //       //   isError = true;
  //       //   errorItems.push(obj);
  //       // }
  //
  //       // ✅ Email validation (using detected key)
  //       if ((emailValue && emailValue !== '-') && !emailRegex.test(emailValue)) {
  //         if (!isError) {
  //           obj.error = "Email";
  //           obj.emailAddress= emailValue
  //           errorItems.push(obj);
  //         } else {
  //           obj.error += ", Email";
  //         }
  //       }
  //
  //       // ✅ VIN validation
  //       // if (obj.vin && !vinRegex.test(obj.vin)) {
  //       //   if (!isError) {
  //       //     obj.error = "VIN";
  //       //     errorItems.push(obj);
  //       //   } else {
  //       //     obj.error += ", VIN";
  //       //   }
  //       // }
  //
  //       // ✅ VIN validation (using detected key)
  //       if ((vinValue && vinValue !== '-') && !vinRegex.test(vinValue)) {
  //         if (!isError) {
  //           obj.error = "VIN";
  //           obj.vin= vinValue;
  //           errorItems.push(obj);
  //         } else {
  //           obj.error += ", VIN";
  //         }
  //       }
  //
  //       // ✅ VIN validation (using detected key)
  //     if ((mobileValue && mobileValue !== '-') && !mobileRegex.test(mobileValue)) {
  //       if (!isError) {
  //         obj.error = "Mobile";
  //         obj.customerNumber= mobileValue;
  //         errorItems.push(obj);
  //       } else {
  //         obj.error += ", Mobile";
  //       }
  //       }
  //       // ✅ Mobile validation
  //       // if ((obj.contactNumber && obj.contactNumber !== '-') && !mobileRegex.test(obj.contactNumber)) {
  //       //   if (!isError) {
  //       //     obj.error = "Mobile";
  //       //     errorItems.push(obj);
  //       //   } else {
  //       //     obj.error += ", Mobile";
  //       //   }
  //       // }
  //
  //       bulkUpload.push(obj);
  //     }
  //
  //     setBulkUploadList(bulkUpload);
  //
  //     if (!Object.keys(lookup).length) {
  //       setIsErrorMessage("File is empty");
  //     }
  //
  //     return {
  //       arrayJson: catalogueJson,
  //       bulkUpload,
  //       errorItems,
  //       duplicateKeys: Object.keys(lookup).filter(k => lookup[k] > 1)
  //     };
  //   }


  function makeAndReturnJSONForCsv(result) {
    result = result.trim();

    // ✅ Split by newlines
    let lines = result.split(/\r?\n/);

    // ✅ Parse header row safely
    let headers = lines[0].split(',').map(h => toCamelCase(h.trim()));
    // let headers = parseCsvLine(lines[0]).map(h => toCamelCase(h.trim()));
    lines.shift(); // remove header row

    let catalogueJson = [];

    // ✅ Parse each data row safely
    for (let row of lines) {
      if (!row.trim()) continue;
      // Before the loop
      const csvSplitRegex = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/;

      // Inside the 'for (let row of lines)' loop:
      let cols = row.split(csvSplitRegex) // Split by comma not inside quotes
        .map(v => v.trim().replace(/"/g, "")); // Trim and remove surrounding quotes
      // let cols = parseCsvLine(row).map(v => v.trim());
      let obj = {};

      headers.forEach((key, i) => {
        obj[key] = cols[i] ?? "";
      });

      catalogueJson.push(obj);
    }

    setHeaders(headers);

    // -----------------------------------------------------
    // ✅ VALIDATIONS
    // -----------------------------------------------------

    const emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/i;
    const mobileRegex = /^[0-9]{7,10}$/;

    let possibleVinName = ['chassisNo', 'chassis', 'vin', 'vinNo.', 'vinNo', 'vinNumber'];
    let possibleMobileName = ['mobileNo', 'mobile', 'contactNumber', 'contactNo', 'customerNumber', 'customerMobileNo'];
    let possibleEmailName = ['email', 'emailAddress', 'customerEmailID'];

    let bulkUpload = [];
    let lookup = {};
    let errorItems = [];

    for (let item of catalogueJson) {
      // Detect field names dynamically
      const vinKey = Object.keys(item).find(k =>
        possibleVinName.some(v => k.toLowerCase() === v.toLowerCase())
      );
      const mobileKey = Object.keys(item).find(k =>
        possibleMobileName.some(v => k.toLowerCase() === v.toLowerCase())
      );
      const emailKey = Object.keys(item).find(k =>
        possibleEmailName.some(v => k.toLowerCase() === v.toLowerCase())
      );

      const vinValue = vinKey ? item[vinKey].trim() : "";
      const mobileValue = mobileKey ? item[mobileKey].trim() : "";
      const emailValue = emailKey ? item[emailKey].trim() : "";

      const key = vinValue || item.uuid || item.id || item.name || "unknown";
      lookup[key] = (lookup[key] || 0) + 1;

      let obj = { ...item };
      let errors = [];

      // ✅ Email validation
      if (emailValue && emailValue !== "-" && !emailRegex.test(emailValue)) {
        errors.push("Email");
        // obj.emailAddress = emailValue;
      }

      // ✅ VIN validation
      if ((vinValue && !vinRegex.test(vinValue)) || !vinValue) {
        errors.push("VIN");
        // obj.vin = vinValue;
      }

      // ✅ Mobile validation (10-digit only)
      if (mobileValue && mobileValue !== "-" && !mobileRegex.test(mobileValue)) {
        errors.push("Mobile");
        // obj.customerNumber = mobileValue;
      }

      if (errors.length > 0) {
        obj.error = errors.join(", ");
        obj.emailAddress = emailValue;
        obj.vin = vinValue;
        obj.customerNumber = mobileValue;
        errorItems.push(obj);
      }

      bulkUpload.push(obj);
    }

    setBulkUploadList(bulkUpload);

    if (!Object.keys(lookup).length) {
      setIsErrorMessage("File is empty");
    }

    return {
      arrayJson: catalogueJson,
      bulkUpload,
      errorItems,
      duplicateKeys: Object.keys(lookup).filter(k => lookup[k] > 1)
    };
  }

  // ✅ Proper CSV parser (handles commas & quotes safely)
  // function parseCsvLine(line) {
  //   const result = [];
  //   let current = '';
  //   let insideQuotes = false;
  //
  //   for (let i = 0; i < line.length; i++) {
  //     const char = line[i];
  //
  //     if (char === '"' && line[i + 1] === '"') {
  //       // escaped quote
  //       current += '"';
  //       i++;
  //     } else if (char === '"') {
  //       insideQuotes = !insideQuotes;
  //     } else if (char === ',' && !insideQuotes) {
  //       result.push(current);
  //       current = '';
  //     } else {
  //       current += char;
  //     }
  //   }
  //   result.push(current);
  //   return result;
  // }

  function makeAndReturnJSONForDigitalCsv(result) {
    result = result.trim();

    // ✅ Split by newlines
    let lines = result.split(/\r?\n/);

    // ✅ Parse header row safely
    let headers = lines[0].split(',').map(h => toCamelCase(h.trim()));
    // let headers = parseCsvLine(lines[0]).map(h => toCamelCase(h.trim()));
    lines.shift(); // remove header row

    let catalogueJson = [];

    // ✅ Parse each data row safely
    for (let row of lines) {
      if (!row.trim()) continue;
      // Before the loop
      const csvSplitRegex = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/;

      // Inside the 'for (let row of lines)' loop:
      let cols = row.split(csvSplitRegex) // Split by comma not inside quotes
        .map(v => v.trim().replace(/"/g, "")); // Trim and remove surrounding quotes
      // let cols = parseCsvLine(row).map(v => v.trim());
      let obj = {};

      headers.forEach((key, i) => {
        obj[key] = cols[i] ?? "";
      });

      catalogueJson.push(obj);
    }

    setHeaders(headers);

    // -----------------------------------------------------
    // ✅ VALIDATIONS
    // -----------------------------------------------------

    const emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/i;
    const mobileRegex = /^[0-9]{7,10}$/;

    let possibleVinName = ['chassisNo', 'chassis', 'vin', 'vinNo.', 'vinNo', 'vinNumber'];
    let possibleMobileName = ['mobileNo', 'mobile', 'contactNumber', 'contactNo', 'customerNumber', 'customerMobileNo'];
    let possibleEmailName = ['email', 'emailAddress', 'customerEmailID'];

    let bulkUpload = [];
    let lookup = {};
    let errorItems = [];

    for (let item of catalogueJson) {
      const mobileKey = Object.keys(item).find(k =>
        possibleMobileName.some(v => k.toLowerCase() === v.toLowerCase())
      );
      const emailKey = Object.keys(item).find(k =>
        possibleEmailName.some(v => k.toLowerCase() === v.toLowerCase())
      );

      const mobileValue = mobileKey ? item[mobileKey].trim() : "";
      const emailValue = emailKey ? item[emailKey].trim() : "";

      const key = mobileValue || item.uuid || item.id || item.name || "unknown";
      lookup[key] = (lookup[key] || 0) + 1;

      let obj = { ...item };
      let errors = [];

      // ✅ Email validation
      // if (emailValue && emailValue !== "-" && !emailRegex.test(emailValue)) {
      //   errors.push("Email");
      //   // obj.emailAddress = emailValue;
      // }


      // ✅ Mobile validation (10-digit only)
      if (mobileValue && mobileValue !== "-" && !mobileRegex.test(mobileValue)) {
        errors.push("Mobile");
        // obj.customerNumber = mobileValue;
      }

      if (errors.length > 0) {
        obj.error = errors.join(", ");
        // obj.emailAddress = emailValue;
        obj.customerNumber = mobileValue;
        errorItems.push(obj);
      }

      bulkUpload.push(obj);
    }

    setBulkUploadList(bulkUpload);

    if (!Object.keys(lookup).length) {
      setIsErrorMessage("File is empty");
    }

    return {
      arrayJson: catalogueJson,
      bulkUpload,
      errorItems,
      duplicateKeys: Object.keys(lookup).filter(k => lookup[k] > 1)
    };
  }

  function makeCsvJsonAndCheckUniquenessForDigitalLead(csvFile) {
    console.log('csvFile', csvFile, selectedUploadType, 'in makeCsvJsonAndCheckUniquenessForDigitalLead');
    console.log(csvFile, "csvFilecsvFilecsvFile", storedFileCsv);
    // setIsErrorValidationInCsv(false)
    setDuplicateRecords([]);
    let file = csvFile.files[0];
    let reader = new FileReader();
    reader.onload = async (evt) => {
      let dt = evt.target.result;
      let result = await makeAndReturnJSONForDigitalCsv(dt);
      console.log(result, 'result in makeCsvJsonAndCheckUniquenessForDigitalLead');
    }
    reader.readAsText(file);
  }






  function toggleUploadCSVView() {
    setUploadedCSVView(true);
  }

  async function downloadErrorItemsAsCSV() {
    try {
      if (!errorValidationInCsv || errorValidationInCsv.length === 0) {
        toastr.warning("No error items to download");
        return;
      }

      // Get headers from the error items
      const errorHeaders = Object.keys(errorValidationInCsv[0]);

      // Create CSV content
      let csvContent = errorHeaders.join(',') + '\n';

      errorValidationInCsv.forEach(item => {
        let row = errorHeaders.map(header => {
          const value = item[header];
          // Handle values with commas or quotes by wrapping in quotes
          if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
            return `"${value.replace(/"/g, '""')}"`;
          }
          return value !== undefined && value !== null ? value : '';
        });
        csvContent += row.join(',') + '\n';
      });

      // Create blob and trigger download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute('download', `error-items-${moment().format('YYYY-MM-DD-HHmmss')}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toastr.success("Error items downloaded successfully");
    } catch (error) {
      console.error('Error downloading CSV:', error);
      toastr.error("Failed to download error items");
    }
  }

  async function initiateCSVReportDownload() {
    try {
      setIsCSVDownloadButtonDisable(true);
      let res = await axios.get(`${CONSTANTS.API_URL}/api/v1/policyReport?dealershipID=${userInfo.userDealershipID}`);
      const results = res.data.csvData.filter(element => {
        return element !== null;
      });
      if (results && results.length) {
        let response = await downloadCSV(results, res.data.fileName);
        toastr.success("Policy Report Downloaded");
      } else {
        toastr.error("No data");
      }
      setIsCSVDownloadButtonDisable(false);
    } catch (HTTPException) {
      await reportException({
        HTTPException,
        fileName,
        functionName: 'initiateCSVReportDownload',
      });
      return HTTPException;
    }
  }
  async function generateQuotation(e) {
    // e.preventDefault();
    try {
      let Response = await axios.post(`${CONSTANTS.API_URL}/api/v1/generateRenewalQuotations`, {});
      if (Response.data.messageResponses && Response.data.messageResponses.length) {
        await Promise.all(Response.data.messageResponses.map(async (messageObj) => {
          // if (messageObj.sendTo) {
          //   let messageNotification = await axios.post(`${CONSTANTS.API_URL}/api/v1/notification`, messageObj);
          //   if (messageNotification.status === 200) {
          //     triggerNotifications(true)
          //   }
          //   toastr.info(messageObj.message);
          // } else {
          toastr.info(messageObj.message);
          // }
        }))
      } else {
        toastr.info('No Pending Tasks');
      }
    } catch (HTTPException) {
      await reportException({
        HTTPException,
        fileName,
        functionName: 'generateQuotation',
      });
      return HTTPException;
    }
  }

  const logout = async (e) => {
    try {
      e.preventDefault();
      let res = await axios.post(`${CONSTANTS.API_URL}/api/v1/logout`);
      let email = getItem('userinfo').email;
      await axios.put(`${CONSTANTS.API_URL}/api/v1/user/pageVisitUserInformation`, { action: 'logout', typeOfVisit: 'success', email });
      if (res) {
        await removeAll();
        await route(`/`);
      }
    } catch (HTTPException) {
      await reportException({
        HTTPException,
        fileName,
        functionName: 'logout',
      });
      return HTTPException;
    }
  };
  {/*
    Modified By: Arun Singh
    Modification: Add two new function for change source and subSource.
    Date: 14/june/2024
  */}
  /* Add sourse and subSource in create new modal*/
  function changeSource(val) {
    let subSources = {
      'Walk-in': ["Hyundai Website", "Employee Referral", "Print Ad", "Radio Ad", "Referral", "Walkin", "Inter Branch"],
      'CRM': ["Car Wale", "CarDekho", "Dealer's Website", "Google Ads", "HMIL Call Center", "HyBuy", "Just Dial", "Lost Recovered", "Online", "SMS", "Social Media", "HMI Social Media", "Hyper Local", "Website", "Chatbot", "Click to Buy"],
      'Field Generation': ["Cold Call", "Float Activity", "Free Car Care Clinic", "Loan/Exchange Mela", "Sales & Service Camp", "Sales promotion", "SC own source", "Special Days Camps", "Corpoare Activity"],
      'Incoming Call': ["Digital Medium/Web", "Print Ad", "Radio Ad", "TV Ad", "Incoming Call"],
      'Referrals': ["Customer Referral", "DSA", "Employee Referral", "Finance Referral", "Happiness Checklist", "Referral", "Workshop Referral"]
    };
    setSource(val);
    setSubSource('');
    setSubSources(subSources[val]);
    setAssignedTo('');
    setAssignUserList([]);
  }

  /* end of Add sourse and subSource in create new modal */
  function changeSubSource(val) {
    setSubSource(val);
    setSubSubSources(["Employee Referral", "Customer Referral", "Finance Referral", "Service Referral", "Other"]);
  }

  /*
    Modification: added toggle modal function
    By: Masum Raja
    Date: 20/03/2024
  */

  const toggleStockDetailsModal = async (activeTab) => {
    activeTab ? setActiveStockTab(activeTab) : setActiveStockTab('Vehicle Stock Search');
    setSelectedStockType(`Total ${activeTab}`);
    await setIsStockDetailModal(!isStockDetailModalOpen);
  };

  const stockAvailability = async () => {
    try {
      const selectedVariantObj = variantList.filter(model => model.uuid === variant);

      let stockItems = await axios.get(`${CONSTANTS.API_URL}/api/v1/stockItem/count?variant=${selectedVariantObj[0].variant}&color=${exteriorColor}`);

      if (stockItems.data.COUNT) {
        setAvailableStock(stockItems.data.COUNT);
      } else {
        setAvailableStock(0);
      }
    } catch (HTTPException) {
      await reportException({
        HTTPException,
        fileName,
        functionName: 'logout',
      });
      return HTTPException;
    }
  }

  /**********************************************************************/

  /*
    Bug: T1843 - EN - Insurance -Add New Insurance Renewal Case - While adding a case System should check if VIN is already existing.
    Modification: Added function to handle vinNumber
    By: Devang
    Date: 02/07/2024
  */
  const handleVinNumber = async (e) => {
    setVinNumber(e.target.value);
    setIsCaseErrorMsg(false);
  };

  async function calculateCartValue() {
    cartValue = 0;
    if (cartProducts.length && cartProducts.length > 1) {
      await Promise.all(cartProducts.map(async (product) => {
        if (product.totalCompany && product.quantity >= 1) {
          cartValue = cartValue + (product.totalCompany * product.quantity);
        }
      }));
    } else if (cartProducts.length && cartProducts.length === 1) {
      if (cartProducts[0]['quantity']) {
        cartValue = cartValue + (cartProducts[0]['totalIndividual'] * cartProducts[0]['quantity']);
      } else {
        cartValue = cartValue + cartProducts[0]['totalIndividual']
      }
    }
    setCartValue(cartValue);
    interactionObj['dynamicProperties_cartValue'] = cartValue;
    currentTask['dynamicProperties_cartValue'] = cartValue;
    setIsFormUpdated(!isFormUpdated);
  }

  async function calculateCartValueAccessories() {
    cartValue = 0;
    if (cartProductsAccessories.length && cartProductsAccessories.length > 1) {
      await Promise.all(cartProductsAccessories.map(async (product) => {
        if (product.sellingCost && product.quantity >= 1) {
          cartValue = cartValue + (product.sellingCost * product.quantity);
        }
      }));
    } else if (cartProductsAccessories.length && cartProductsAccessories.length === 1) {
      if (cartProductsAccessories[0]['quantity']) {
        cartValue = cartValue + (cartProductsAccessories[0]['sellingCost'] * cartProductsAccessories[0]['quantity']);
      } else {
        cartValue = cartValue + cartProductsAccessories[0]['sellingCost']
      }
    }
    setCartValue(cartValue);
  }

  async function setFinalSelection(e, selectedExtraItem) {
    e.preventDefault();
    currentRow['dynamicProperties_' + selectedExtraItem] = e.target.checked ? "yes" : "no";
    interactionObj['dynamicProperties_' + selectedExtraItem] = e.target.checked ? "yes" : "no";
    if (selectedExtraItem === "isOptedFor3M" && e.target.checked) {
      let selectedPackages = '';
      let totalCost = 0;
      if (threeMPackages && threeMPackages.length) {
        await threeMPackages.map((packageObj, index) => {
          if (index === 0) {
            selectedPackages = packageObj.displayName;
          } else {
            selectedPackages = selectedPackages + ',' + packageObj.displayName;
          }
          totalCost = totalCost + packageObj.sellingCost;
        });
        interactionObj['dynamicProperties_3m'] = totalCost;
        interactionObj["dynamicProperties_selected3MPackages"] = selectedPackages;
        currentRow['dynamicProperties_3m'] = totalCost;
        currentTask["dynamicProperties_selected3MPackages"] = selectedPackages;
      }
    } else if (selectedExtraItem === "isOptedFor3M" && !e.target.checked) {
      interactionObj['dynamicProperties_3m'] = 0;
      interactionObj["dynamicProperties_selected3MPackages"] = '';
      currentTask['dynamicProperties_3m'] = 0;
      currentTask["dynamicProperties_selected3MPackages"] = '';
    }
    if (selectedExtraItem === "isOptedForAccessories" && e.target.checked) {
      let selectedPackages = '';
      let totalCost = 0;
      if (basicAccessoriesList && basicAccessoriesList.length) {
        await basicAccessoriesList.map((packageObj, index) => {
          if (index === 0) {
            selectedPackages = packageObj.displayName;
          } else {
            selectedPackages = selectedPackages + ',' + packageObj.displayName;
          }
          totalCost = totalCost + packageObj.sellingCost;
        });
        interactionObj['dynamicProperties_selectedAccessoriesCost'] = totalCost;
        interactionObj["dynamicProperties_selectedAccessories"] = selectedPackages;
        currentRow['dynamicProperties_selectedAccessoriesCost'] = totalCost;
        currentRow["dynamicProperties_selectedAccessories"] = selectedPackages;
      }
    } else if (selectedExtraItem === "isOptedFor3M" && !e.target.checked) {
      interactionObj['dynamicProperties_selectedAccessoriesCost'] = 0;
      interactionObj["dynamicProperties_selectedAccessories"] = '';
      currentRow['dynamicProperties_selectedAccessoriesCost'] = 0;
      currentRow["dynamicProperties_selectedAccessories"] = '';
    }
    setIsFormUpdated(!isFormUpdated);
  }
  async function setSelectedPackage(e, dynamicProp, amountToChange, packageList) {
    e.preventDefault();
    let selectedPackage = packageList.filter(d => d.uuid === e.target.value);
    currentRow['dynamicProperties_' + dynamicProp] = e.target.value;
    currentRow['dynamicProperties_' + amountToChange] = Number(selectedPackage[0]['sellingCost']);
    interactionObj['dynamicProperties_' + dynamicProp] = e.target.value;
    interactionObj['dynamicProperties_' + amountToChange] = Number(selectedPackage[0]['sellingCost']);
    setIsFormUpdated(!isFormUpdated);
  }
  async function setSelectedBasicAccessories(e, packageName, cost) {
    e.preventDefault()
    console.log(packageName, '--------packageName------', cost);
    if (!e.target.checked) {
      interactionObj['dynamicProperties_selectedAccessoriesCost'] = interactionObj['dynamicProperties_selectedAccessoriesCost'] - cost;
      let currentList = interactionObj["dynamicProperties_selectedAccessories"].split(',');
      let deselectedIndex = currentList.indexOf(packageName);
      currentList.splice(deselectedIndex, 1);
      interactionObj["dynamicProperties_selectedAccessories"] = currentList.join(',');
    } else {
      interactionObj['dynamicProperties_selectedAccessoriesCost'] = interactionObj['dynamicProperties_selectedAccessoriesCost'] + cost;
      /*
        Bug: 111 KH_BG_181 Accounts Assistant Visit List View - Enquiry -Create Proforma Invoice - Final Selection Tab - Take Action / Process View - Task View - Enquiry -Create Proforma Invoice - Final Selection Tab - Basic Accessories Kit - Accessories from Kit	If selected / deselected checkboxes, the count for the respective items in background is not correct
        Modification: Fixed the issue of comma at the start
        BY: Devang
        Date: 04/07/2023
      */
      const selectedAccessories = interactionObj["dynamicProperties_selectedAccessories"];
      interactionObj["dynamicProperties_selectedAccessories"] = `${selectedAccessories}${selectedAccessories ? ',' : ''}${packageName}`;
    }
    currentRow['dynamicProperties_selectedAccessoriesCost'] = interactionObj['dynamicProperties_selectedAccessoriesCost'];
    currentRow["dynamicProperties_selectedAccessories"] = interactionObj["dynamicProperties_selectedAccessories"];
    setIsFormUpdated(!isFormUpdated);
  }
  async function setSelected3MPackage(e, packageName, cost) {
    e.preventDefault()
    if (!e.target.checked) {
      interactionObj['dynamicProperties_3m'] = interactionObj['dynamicProperties_3m'] - cost;
      let currentList = interactionObj["dynamicProperties_selected3MPackages"].split(',');
      let deselectedIndex = currentList.indexOf(packageName);
      currentList.splice(deselectedIndex, 1);
      interactionObj["dynamicProperties_selected3MPackages"] = currentList.join(',');
    } else {
      interactionObj['dynamicProperties_3m'] = interactionObj['dynamicProperties_3m'] + cost;
      /*
        Bug: 114 KH_BG_184	Accounts Assistant Visit List View - Enquiry - Create Proforma Invoice - Final Selection Tab - Take Action / Process View - Task View - Enquiry - Create Proforma Invoice - Final Selection Tab - 3M	When selecting any 3M package from the list, the comma is displayed before the selected 3M package in the background.
        Modification: Fixed the issue of comma at the start
        BY: Devang
        Date: 04/07/2023
      */
      const selectedPackages = interactionObj["dynamicProperties_selected3MPackages"];
      interactionObj["dynamicProperties_selected3MPackages"] = `${selectedPackages}${selectedPackages ? ',' : ''}${packageName}`;
    }
    currentRow['dynamicProperties_3m'] = interactionObj['dynamicProperties_3m'];
    currentRow["dynamicProperties_selected3MPackages"] = interactionObj["dynamicProperties_selected3MPackages"];
    setIsFormUpdated(!isFormUpdated);
  }
  //
  // async function setSelectedProductColor(e, item, color) {
  //   e && e.preventDefault();
  //   if (selectedColor && item.uuid + "-" + color !== selectedColor) {
  //     let oldColorDiv = document.getElementById(selectedColor);
  //     if (oldColorDiv) {
  //       oldColorDiv.style.border = 'none';
  //     }
  //   }
  //   let colorDiv = document.getElementById(item.uuid + "-" + color);
  //   if (colorDiv && colorDiv.style.border && colorDiv.style.border === "none") {
  //     colorDiv.style.border = '2px dashed green';
  //     selectedColor = item.uuid + "-" + color;
  //     let stockItems = await axios.get(`${CONSTANTS.API_URL}/api/v1/stockItem/count?variant=${item.variant}&color=${color.split("-").join(" ")}`);
  //     if (stockItems.data.COUNT) {
  //       setAvailableStock(stockItems.data.COUNT);
  //     } else {
  //       setAvailableStock(0);
  //     }
  //     // setSelectedColor(selectedColor);
  //     setSelectedDisplayColor(color)
  //     let indexOfSelectedItem = selectedProducts.findIndex(d => d.productID === item.uuid && d.color && (item.uuid + "-" + d.color.split(" ").join("-")) === selectedColor);
  //     if (indexOfSelectedItem > -1) {
  //       selectedProducts[indexOfSelectedItem]['color'] = color.split("-").join(" ");
  //       // setSelectedProducts([...selectedProducts]);
  //     } else {
  //       let obj = {
  //         productID: item.uuid,
  //         model: item.model,
  //         variant: item.variant
  //       };
  //       obj['color'] = color.split("-").join(" ");
  //
  //       selectedColor = item.uuid + "-" + color;
  //       // setSelectedColor(selectedColor);
  //       setSelectedDisplayColor(color)
  //       selectedProducts.push(obj);
  //     }
  //   } else if (colorDiv && colorDiv.style.border && colorDiv.style.border !== "none") {
  //     colorDiv.style.border = 'none';
  //     selectedColor = '';
  //     setAvailableStock(0);
  //   }
  //   setSelectedProducts([...selectedProducts]);
  //   setSelectedColor(selectedColor);
  //
  // }
  async function updateQuantity(e, item) {
    e.preventDefault();
    let indexOfSelectedItem = selectedProducts.findIndex(d => d.productID === item.uuid);
    if (indexOfSelectedItem > -1 && Number(e.target.value)) {
      let oldQuantity = selectedProducts[indexOfSelectedItem]['quantity'];
      selectedProducts[indexOfSelectedItem]['quantity'] = Number(e.target.value);
      setSelectedProducts([...selectedProducts]);
      let indexOfCartItem = cartProducts.findIndex(d => d.productID === item.uuid && (d.color && (item.uuid + "-" + d.color.split(" ").join("-")) === selectedColor));
      if (indexOfCartItem > -1) {
        cartProducts[indexOfCartItem]['quantity'] = selectedProducts[indexOfSelectedItem]['quantity'];
        cartNumber = cartNumber - oldQuantity + selectedProducts[indexOfSelectedItem]['quantity'];
      } else {
        let obj = {
          productID: item.uuid,
          model: item.model,
          variant: item.variant,
          quantity: selectedProducts[indexOfSelectedItem]['quantity'],
          totalIndividual: item.totalIndividual,
          exShowroom: item.exShowroom,
          basicAccessoriesKit: item.basicAccessoriesKit,
          rsa: item.rsa,
          rmk: item.rmk,
          sheildOfTrust: item.sheildOfTrust,
          fourthAnd5thYearExtendedWarranty: item.fourthAnd5thYearExtendedWarranty,
          totalCompany: item.totalCompany,
          waitingPeriodMin: item.waitingPeriodMin,
          waitingPeriodMax: item.waitingPeriodMax,
          bookingAmount: item.bookingAmount
        };
        cartProducts.push(obj);
        cartNumber = cartNumber + selectedProducts[indexOfSelectedItem]['quantity'];
      }
      setCartProducts(cartProducts);

      interactionObj['dynamicProperties_cartProducts'] = cartProducts;
      currentRow['dynamicProperties_cartProducts'] = cartProducts;
      calculateCartValue();
      setCartNumber(cartNumber);
      interactionObj['dynamicProperties_cartNumber'] = cartNumber;
      currentRow['dynamicProperties_cartNumber'] = cartNumber;
      setIsFormUpdated(!isFormUpdated);
    } else if (indexOfSelectedItem > -1 && !Number(e.target.value)) {
      let oldQuantity = selectedProducts[indexOfSelectedItem]['quantity'];
      selectedProducts[indexOfSelectedItem]['quantity'] = 0;
      setSelectedProducts([...selectedProducts]);

      /*
        Bug: T1709 - BG_FN:KDMS Sales: Quotation task-quotation for multiple variants not showing in quotation document generated
        Modification: Commented previous handling of cartProducts and number and added a new method
        By: Devang
        Date: 04/06/2024
      */
      /*let indexOfCartItem = cartProducts.findIndex(d => d.productID === item.uuid && (d.color && (item.uuid + "-" + d.color.split(" ").join("-")) === selectedColor));
      if (indexOfCartItem > -1) {
        cartProducts.splice(indexOfCartItem, 1);
        cartNumber = cartNumber - oldQuantity;
      }*/
      cartProducts = cartProducts.filter(d => !(d.productID === item.uuid && (d.color && (item.uuid + "-" + d.color.split(" ").join("-")) === selectedColor)));
      cartNumber = cartProducts.reduce((accumulator, cartProductObj) => { return accumulator + (cartProductObj.quantity || 0); }, 0)
      setCartProducts(cartProducts);

      interactionObj['dynamicProperties_cartProducts'] = cartProducts;
      currentRow['dynamicProperties_cartProducts'] = cartProducts;
      calculateCartValue();
      setCartNumber(cartNumber);
      interactionObj['dynamicProperties_cartNumber'] = cartNumber;
      currentRow['dynamicProperties_cartNumber'] = cartNumber;
    } else {
      let obj = {
        productID: item.uuid,
        model: item.model,
        variant: item.variant,
        quantity: Number(e.target.value),
        totalIndividual: item.totalIndividual,
        exShowroom: item.exShowroom,
        basicAccessoriesKit: item.basicAccessoriesKit,
        rsa: item.rsa,
        rmk: item.rmk,
        sheildOfTrust: item.sheildOfTrust,
        fourthAnd5thYearExtendedWarranty: item.fourthAnd5thYearExtendedWarranty,
        fourthAnd5thYearExtendedWarranty: item.fourthAnd5thYearExtendedWarranty,
        totalCompany: item.totalCompany,
        waitingPeriodMin: item.waitingPeriodMin,
        waitingPeriodMax: item.waitingPeriodMax,
        bookingAmount: item.bookingAmount
      };
      cartProducts.push(obj);
      cartNumber = cartNumber + Number(e.target.value);
      selectedProducts.push(obj);
      setSelectedProducts([...selectedProducts]);
      setCartProducts(cartProducts);

      interactionObj['dynamicProperties_cartProducts'] = cartProducts;
      currentRow['dynamicProperties_cartProducts'] = cartProducts;
      calculateCartValue();
      setCartNumber(cartNumber);
      interactionObj['dynamicProperties_cartNumber'] = cartNumber;
      currentRow['dynamicProperties_cartNumber'] = cartNumber;
      setIsFormUpdated(!isFormUpdated);
    }

    let minusBtn = document.getElementById("qty-count--minus");
    let qty = Number(e.target.value);

    if (isNaN(qty) || qty <= 1) {
      e.target.value = 1;
      minusBtn.disabled = true;
    } else {
      minusBtn.disabled = false;
    }
  }

  async function addQuantity(e, item, index) {
    e.preventDefault();
    let indexOfSelectedItem = selectedProducts.findIndex(d => d.productID === item.uuid && d.color && (item.uuid + "-" + d.color.split(" ").join("-")) === selectedColor);
    if (indexOfSelectedItem > -1) {
      if (selectedProducts[indexOfSelectedItem]['quantity']) {
        selectedProducts[indexOfSelectedItem]['quantity'] = selectedProducts[indexOfSelectedItem]['quantity'] + 1;
        let elem = document.getElementById('product-qty' + index);
        if (elem) {
          elem.value = selectedProducts[indexOfSelectedItem]['quantity'];
        }
        let indexOfCartItem = cartProducts.findIndex(d => d.productID === item.uuid && (d.color && (item.uuid + "-" + d.color.split(" ").join("-")) === selectedColor));
        if (indexOfCartItem > -1) {
          cartProducts[indexOfCartItem]['quantity'] = selectedProducts[indexOfSelectedItem]['quantity'];
          cartNumber = cartNumber + 1;
        } else {
          let obj = {
            productID: item.uuid,
            model: item.model,
            variant: item.variant,
            color: selectedProducts[indexOfSelectedItem]['color'],
            quantity: selectedProducts[indexOfSelectedItem]['quantity'],
            totalIndividual: item.totalIndividual,
            exShowroom: item.exShowroom,
            basicAccessoriesKit: item.basicAccessoriesKit,
            rsa: item.rsa,
            rmk: item.rmk,
            sheildOfTrust: item.sheildOfTrust,
            fourthAnd5thYearExtendedWarranty: item.fourthAnd5thYearExtendedWarranty,
            totalCompany: item.totalCompany,
            waitingPeriodMin: item.waitingPeriodMin,
            waitingPeriodMax: item.waitingPeriodMax,
            bookingAmount: item.bookingAmount
          };
          cartProducts.push(obj);
          cartNumber = cartNumber + selectedProducts[indexOfSelectedItem]['quantity'];
        }
      } else {
        selectedProducts[indexOfSelectedItem]['quantity'] = 1;
        let elem = document.getElementById('product-qty' + index);
        if (elem) {
          elem.value = 1;
        }
        let indexOfCartItem = cartProducts.findIndex(d => d.productID === item.uuid && (d.color && (item.uuid + "-" + d.color.split(" ").join("-")) === selectedColor));
        if (indexOfCartItem > -1) {
          cartProducts[indexOfCartItem]['quantity'] = selectedProducts[indexOfSelectedItem]['quantity'];
          cartNumber = cartNumber + 1;
        } else {
          let obj = {
            productID: item.uuid,
            model: item.model,
            variant: item.variant,
            quantity: selectedProducts[indexOfSelectedItem]['quantity'],
            color: selectedProducts[indexOfSelectedItem]['color'],
            totalIndividual: item.totalIndividual,
            exShowroom: item.exShowroom,
            basicAccessoriesKit: item.basicAccessoriesKit,
            rsa: item.rsa,
            rmk: item.rmk,
            sheildOfTrust: item.sheildOfTrust,
            fourthAnd5thYearExtendedWarranty: item.fourthAnd5thYearExtendedWarranty,
            totalCompany: item.totalCompany,
            waitingPeriodMin: item.waitingPeriodMin,
            waitingPeriodMax: item.waitingPeriodMax,
            bookingAmount: item.bookingAmount
          };
          cartProducts.push(obj);
          cartNumber = cartNumber + selectedProducts[indexOfSelectedItem]['quantity'];
        }
      }
      setSelectedProducts([...selectedProducts]);
      setCartProducts(cartProducts);
      interactionObj['dynamicProperties_cartProducts'] = cartProducts;
      currentRow['dynamicProperties_cartProducts'] = cartProducts;
      calculateCartValue();
      setCartNumber(cartNumber);
      interactionObj['dynamicProperties_cartNumber'] = cartNumber;
      currentRow['dynamicProperties_cartNumber'] = cartNumber;
      setIsFormUpdated(!isFormUpdated);
      setIsNextModalDisable(false)
    } else {
      let obj = {
        productID: item.uuid,
        model: item.model,
        variant: item.variant,
        quantity: 1,
        color: selectedProducts[indexOfSelectedItem]['color'],
        totalIndividual: item.totalIndividual,
        exShowroom: item.exShowroom,
        basicAccessoriesKit: item.basicAccessoriesKit,
        rsa: item.rsa,
        rmk: item.rmk,
        sheildOfTrust: item.sheildOfTrust,
        fourthAnd5thYearExtendedWarranty: item.fourthAnd5thYearExtendedWarranty,
        totalCompany: item.totalCompany,
        waitingPeriodMin: item.waitingPeriodMin,
        waitingPeriodMax: item.waitingPeriodMax,
        bookingAmount: item.bookingAmount
      };
      let elem = document.getElementById('product-qty' + index);
      if (elem) {
        elem.value = 1;
      }
      selectedProducts.push(obj);
      cartProducts.push(obj);
      setSelectedProducts([...selectedProducts]);
      setCartProducts(cartProducts);

      interactionObj['dynamicProperties_cartProducts'] = cartProducts;
      currentRow['dynamicProperties_cartProducts'] = cartProducts;
      calculateCartValue();
      cartNumber = cartNumber + 1;
      setCartNumber(cartNumber);
      interactionObj['dynamicProperties_cartNumber'] = cartNumber;
      currentRow['dynamicProperties_cartNumber'] = cartNumber;
      setIsFormUpdated(!isFormUpdated);
      setIsNextModalDisable(false)
    }
  }

  async function removeQuantity(e, item, index) {
    e.preventDefault();
    let indexOfSelectedItem = selectedProducts.findIndex(d => d.productID === item.uuid && d.color && (item.uuid + "-" + d.color.split(" ").join("-")) === selectedColor);
    if (indexOfSelectedItem > -1) {
      if (selectedProducts[indexOfSelectedItem]['quantity'] > 1) {
        selectedProducts[indexOfSelectedItem]['quantity'] = selectedProducts[indexOfSelectedItem]['quantity'] - 1;
        let elem = document.getElementById('product-qty' + index);
        elem.value = selectedProducts[indexOfSelectedItem]['quantity'];
        let indexOfCartItem = cartProducts.findIndex(d => d.productID === item.uuid && (d.color && (item.uuid + "-" + d.color.split(" ").join("-")) === selectedColor));
        if (indexOfCartItem > -1) {
          cartProducts[indexOfCartItem]['quantity'] = selectedProducts[indexOfSelectedItem]['quantity'];
          cartNumber = cartNumber - 1;
        }
      } else if (selectedProducts[indexOfSelectedItem]['quantity'] === 1) {
        selectedProducts[indexOfSelectedItem]['quantity'] = selectedProducts[indexOfSelectedItem]['quantity'] - 1;
        let elem = document.getElementById('product-qty' + index);
        elem.value = selectedProducts[indexOfSelectedItem]['quantity'];

        /*
          Bug: T1709 - BG_FN:KDMS Sales: Quotation task-quotation for multiple variants not showing in quotation document generated
          Modification: Commented previous handling of cartProducts and number and added a new method
          By: Devang
          Date: 04/06/2024
        */
        /*let indexOfCartItem = cartProducts.findIndex(d => d.productID === item.uuid && (d.color && (item.uuid + "-" + d.color.split(" ").join("-")) === selectedColor));
        if (indexOfCartItem > -1) {
          cartProducts.splice(indexOfCartItem, 1);
          cartNumber = cartNumber - 1;
        }*/
        cartProducts = cartProducts.filter(d => !(d.productID === item.uuid && (d.color && (item.uuid + "-" + d.color.split(" ").join("-")) === selectedColor)));
        cartNumber = cartProducts.reduce((accumulator, cartProductObj) => { return accumulator + (cartProductObj.quantity || 0); }, 0)
      }
      setSelectedProducts([...selectedProducts]);
      setCartProducts(cartProducts);

      interactionObj['dynamicProperties_cartProducts'] = cartProducts;
      currentRow['dynamicProperties_cartProducts'] = cartProducts;
      interactionObj['dynamicProperties_cartNumber'] = cartNumber;
      currentRow['dynamicProperties_cartNumber'] = cartNumber;
      calculateCartValue();
      setCartNumber(cartNumber);
      setIsFormUpdated(!isFormUpdated);
      cartNumber == 0 ? setIsNextModalDisable(true) : null
    }

    /*
     Modification: Renamed selectedProducts form selectedProdstuckucts to prevent error
     By: Devang
     Date: 03/06/2024
    */
    /*
      Bug: T1709 - BG_FN:KDMS Sales: Quotation task-quotation for multiple variants not showing in quotation document generated
      Modification: Added validations on selectedProducts and its length
      By: Devang
      Date: 04/06/2024
    */
    if (selectedProducts.length && selectedProducts[indexOfSelectedItem] && selectedProducts[indexOfSelectedItem]['quantity'] === 0) {
      e.target.disabled = true;
    }
  }

  async function updateQuantityAccessories(e, item) {
    e.preventDefault();
    let indexOfSelectedItem = selectedAccessories.findIndex(d => d.productID === item.uuid);
    if (indexOfSelectedItem > -1 && Number(e.target.value)) {
      let oldQuantity = selectedAccessories[indexOfSelectedItem]['quantity'];
      selectedAccessories[indexOfSelectedItem]['quantity'] = Number(e.target.value);
      setSelectedAccessories([...selectedAccessories]);
      let indexOfCartItem = cartProductsAccessories.findIndex(d => d.productID === item.uuid);
      if (indexOfCartItem > -1) {
        cartProductsAccessories[indexOfCartItem]['quantity'] = selectedAccessories[indexOfSelectedItem]['quantity'];
        cartNumber = cartNumber - oldQuantity + selectedAccessories[indexOfSelectedItem]['quantity'];
      } else {
        let obj = {
          productID: item.uuid,
          model: item.modelName,
          variant: item.variant,
          quantity: selectedAccessories[indexOfSelectedItem]['quantity'],
          nameOfPart: item.nameOfPart,
          purchaseCost: item.purchaseCost,
          unit: item.unit,
          sellingCost: item.sellingCost,
          finalSellingPrice: item.finalSellingPrice,
          description: item.description,
          typeofAccessory: item.typeofAccessory
        };
        cartProductsAccessories.push(obj);
        cartNumber = cartNumber + selectedAccessories[indexOfSelectedItem]['quantity'];
      }
      setCartProductsAccessories(cartProductsAccessories);
      calculateCartValueAccessories();
      setCartNumber(cartNumber);
    } else if (indexOfSelectedItem > -1 && !Number(e.target.value)) {
      let oldQuantity = selectedAccessories[indexOfSelectedItem]['quantity'];
      selectedAccessories[indexOfSelectedItem]['quantity'] = 0;
      setSelectedAccessories([...selectedAccessories]);
      let indexOfCartItem = cartProducts.findIndex(d => d.productID === item.uuid);
      if (indexOfCartItem > -1) {
        cartProductsAccessories.splice(indexOfCartItem, 1);
        cartNumber = cartNumber - oldQuantity;
      }
      setCartProductsAccessories(cartProductsAccessories);
      calculateCartValueAccessories();
      setCartNumber(cartNumber);
    } else {
      let obj = {
        productID: item.uuid,
        model: item.modelName,
        variant: item.variant,
        nameOfPart: item.nameOfPart,
        purchaseCost: item.purchaseCost,
        unit: item.unit,
        sellingCost: item.sellingCost,
        finalSellingPrice: item.finalSellingPrice,
        description: item.description,
        typeofAccessory: item.typeofAccessory,
        quantity: Number(e.target.value)
      };
      cartProductsAccessories.push(obj);
      cartNumber = cartNumber + Number(e.target.value);
      selectedAccessories.push(obj);
      setSelectedAccessories([...selectedAccessories]);
      setCartProductsAccessories(cartProductsAccessories);
      calculateCartValueAccessories();
      setCartNumber(cartNumber);
    }

    let minusBtn = document.getElementById("qty-count--minus");
    // let addBtn = document.getElementById("qty-count--add");
    let qty = Number(e.target.value);

    if (isNaN(qty) || qty <= 1) {
      e.target.value = 1;
      minusBtn.disabled = true;
    } else {
      minusBtn.disabled = false;
    }
  }

  async function addQuantityAccessories(e, item, index) {
    e.preventDefault();
    let indexOfSelectedItem = selectedAccessories.findIndex(d => d.productID === item.uuid);
    if (indexOfSelectedItem > -1) {
      if (selectedAccessories[indexOfSelectedItem]['quantity']) {
        selectedAccessories[indexOfSelectedItem]['quantity'] = selectedAccessories[indexOfSelectedItem]['quantity'] + 1;
        let elem = document.getElementById('product-qty' + index);
        if (elem) {
          elem.value = selectedAccessories[indexOfSelectedItem]['quantity'];
        }
        let indexOfCartItem = cartProductsAccessories.findIndex(d => d.productID === item.uuid);
        if (indexOfCartItem > -1) {
          cartProductsAccessories[indexOfCartItem]['quantity'] = selectedAccessories[indexOfSelectedItem]['quantity'];
          cartNumber = cartNumber + 1;
        } else {
          let obj = {
            productID: item.uuid,
            model: item.modelName,
            variant: item.variant,
            nameOfPart: item.nameOfPart,
            purchaseCost: item.purchaseCost,
            unit: item.unit,
            sellingCost: item.sellingCost,
            finalSellingPrice: item.finalSellingPrice,
            description: item.description,
            typeofAccessory: item.typeofAccessory,
            quantity: selectedAccessories[indexOfSelectedItem]['quantity']
          };
          cartProductsAccessories.push(obj);
          cartNumber = cartNumber + selectedAccessories[indexOfSelectedItem]['quantity'];
        }
      } else {
        selectedAccessories[indexOfSelectedItem]['quantity'] = 1;
        let elem = document.getElementById('product-qty' + index);
        if (elem) {
          elem.value = 1;
        }
        let indexOfCartItem = cartProductsAccessories.findIndex(d => d.productID === item.uuid);
        if (indexOfCartItem > -1) {
          cartProductsAccessories[indexOfCartItem]['quantity'] = selectedAccessories[indexOfSelectedItem]['quantity'];
          cartNumber = cartNumber + 1;
        } else {
          let obj = {
            productID: item.uuid,
            model: item.modelName,
            variant: item.variant,
            nameOfPart: item.nameOfPart,
            purchaseCost: item.purchaseCost,
            unit: item.unit,
            sellingCost: item.sellingCost,
            finalSellingPrice: item.finalSellingPrice,
            description: item.description,
            typeofAccessory: item.typeofAccessory,
            quantity: selectedAccessories[indexOfSelectedItem]['quantity']
          };
          cartProductsAccessories.push(obj);
          cartNumber = cartNumber + selectedAccessories[indexOfSelectedItem]['quantity'];
        }
      }
      setSelectedAccessories([...selectedAccessories]);
      setCartProductsAccessories(cartProductsAccessories);
      calculateCartValueAccessories();
      setCartNumber(cartNumber);
      setIsNextModalDisable(false)
    } else {
      let obj = {
        productID: item.uuid,
        model: item.modelName,
        variant: item.variant,
        nameOfPart: item.nameOfPart,
        purchaseCost: item.purchaseCost,
        unit: item.unit,
        sellingCost: item.sellingCost,
        finalSellingPrice: item.finalSellingPrice,
        description: item.description,
        typeofAccessory: item.typeofAccessory,
        quantity: 1
      };
      let elem = document.getElementById('product-qty' + index);
      if (elem) {
        elem.value = 1;
      }
      selectedAccessories.push(obj);
      cartProductsAccessories.push(obj);
      setSelectedAccessories([...selectedAccessories]);
      setCartProductsAccessories(cartProductsAccessories);
      calculateCartValueAccessories();
      cartNumber = cartNumber + 1;
      setCartNumber(cartNumber);
      setIsNextModalDisable(false)
    }
  }

  async function removeQuantityAccessories(e, item, index) {
    e.preventDefault();
    let indexOfSelectedItem = selectedAccessories.findIndex(d => d.productID === item.uuid);
    if (indexOfSelectedItem > -1) {
      if (selectedAccessories[indexOfSelectedItem]['quantity'] > 1) {
        selectedAccessories[indexOfSelectedItem]['quantity'] = selectedAccessories[indexOfSelectedItem]['quantity'] - 1;
        let elem = document.getElementById('product-qty' + index);
        elem.value = selectedAccessories[indexOfSelectedItem]['quantity'];
        let indexOfCartItem = cartProductsAccessories.findIndex(d => d.productID === item.uuid);
        if (indexOfCartItem > -1) {
          cartProductsAccessories[indexOfCartItem]['quantity'] = selectedAccessories[indexOfSelectedItem]['quantity'];
          cartNumber = cartNumber - 1;
        }
      } else if (selectedAccessories[indexOfSelectedItem]['quantity'] === 1) {
        selectedAccessories[indexOfSelectedItem]['quantity'] = selectedAccessories[indexOfSelectedItem]['quantity'] - 1;
        let elem = document.getElementById('product-qty' + index);
        elem.value = selectedAccessories[indexOfSelectedItem]['quantity'];
        let indexOfCartItem = cartProductsAccessories.findIndex(d => d.productID === item.uuid);
        if (indexOfCartItem > -1) {
          cartProductsAccessories.splice(indexOfCartItem, 1);
          cartNumber = cartNumber - 1;
        }
      }
      setSelectedAccessories([...selectedAccessories]);
      setCartProductsAccessories(cartProductsAccessories);
      calculateCartValueAccessories();
      setCartNumber(cartNumber);
      cartNumber == 0 ? setIsNextModalDisable(true) : null
    }
    // let elem = document.getElementById('product-qty'+ index);
    // let qty = Number(elem.value);
    // qty = qty < 1 ? 0 : (qty -= 1);

    if (selectedAccessories[indexOfSelectedItem]['quantity'] === 0) {
      e.target.disabled = true;
    }
  }

  async function toggleCreateDigitalLeadModal(e) {
    console.log('in toggleCreateDigitalLeadModal');
    setDigitalLeadModalVisibility(true);
    let task = await axios.post(`${CONSTANTS.API_URL}/api/v1/salesDigitalProcessInitiation`, { userBranchID: userInfo.userBranchID, userDealershipID: userInfo.userDealershipID });
    let taskDetails = await axios.get(`${CONSTANTS.API_URL}/api/v1/taskDetails?interactionID=${task.data.uuid}`);
    if (taskDetails.data) {
      currentRow = taskDetails.data;
      await setCurrentRow(currentRow);
      let designation = 'Insurance Agent';
      let exchangEvaluators = await axios.get(`${CONSTANTS.API_URL}/api/v1/userOrganization/caseManagement?dealershipID=${userInfo.userDealershipID}`);
      await setExchangeEvaluators(exchangEvaluators.data);
      let insuranceCompaniesList = await axios.get(` ${CONSTANTS.API_URL}/api/v1/thirdParty?type=insuranceCompany&dmsName=Hyundai`);
      // let creData = await axios.get(`${CONSTANTS.API_URL}/api/v1/userOrganization?designation=SALES CONSULTANT&departmentName=DIGITAL`);
      let creData = await axios.get(`${CONSTANTS.API_URL}/api/v1/userOrganization?designations=TELECALLER&departmentNames=MARKETING,DIGITAL`);
      console.log(creData, '---------------creData1---------------');

      await setCREList(creData.data);
      if (insuranceCompaniesList.data && insuranceCompaniesList.data.length) {
        setInsuranceCompanies(insuranceCompaniesList.data);
      }
      await toggleFormPopover();
      // setCreateInsuranceCaseModalOpen(!isCreateInsuranceCaseModalOpen);
      setDigitalLeadModalVisibility(false)
    }
  }

  /*
    Modification: Applied Inline-style to rightPanel container
    Date: Jan-17-22
    By: Vipin
  */
  /*
    By: Yashvi
    On: 16th August 2023
    - [x] Show the icons based on Roles / Designations
    Remove Sales consultant condition from the navigation options
  */
  /*
    Modification: Added new style for mobile footer
    Date: 07-11-2023
    By: Masum Raja
  */
  /*
    BY: Prasannadatta Kawadkar
    ON: 13 March 2024
    Modification: color changed for the leftInfo Panel and Right Panel
  */
  /*
    By: Yashvi Chaudhary
    On: 02nd July 2024
    T1917: BG_UI: Global Search - Overlay is displayed when clicked on Search icon
    Removed scroll as it was restricting the component
  */
  return (

    <div style='border-left: 1px solid #e1e1e1;' class={`${props.isMobileView ? '' : 'rightPanel-tab w-60px'}`}>
      {props.isMobileView && <div class={`${props.showMobileFooter ? 'mobile-bottom-nav ' : ' mobile-bottom-nav-hide-transition '}  is-hide-Desktop`}>
        {!props.isMobileView && (
          <div title='Home' style='padding: 0 5px' class={pathName === "/salesHomeV2" ? 'leftInfoPanel-menu-icon-active' : 'leftInfoPanel-menu-icon'} onClick={() => {
            setPathName(`/salesHomeV2`);
            route(`/salesHomeV2`);
          }}>
            <div class="gap-16px p-l-6 p-t-5 p-r-5">
              <Home height="22px" width="22px" viewBox="0 0 552 552" fill={pathName === "/salesHomeV2" ? '#000' : '#808080'} />
              <div style={`color: ${pathName === "/salesHomeV2" ? '#000' : '#808080'};`} class='menu-name flex-c-m fs-12'>Workspace</div>
            </div>
          </div>
        )}

        {/*
        !isOngoingCallWindowOpen && !isOngoingCallWindowClose && (
        <div
          title='Add New Call'
          style='padding: 0 5px'
          class={isCallModalOpen ? 'leftInfoPanel-menu-icon-active ' : 'leftInfoPanel-menu-icon'}
          onClick={() => {
            toggleCallModal()
          }}
        >
          <div class="gap-16px p-l-10 p-t-5 p-r-10">
            <AddCall height="22px" width="22px" viewBox="0 0 442 545" fill={isCallModalOpen ? '#000' : '#808080'} />
            <div style={`color: ${isCallModalOpen ? '#000' : '#808080'};`} class='menu-name fs-12'>Add Call</div>
          </div>
        </div>
      )
    */}

        {/*
        isOngoingCallWindowOpen && (
            <div
              title='View Call'
              style='padding: 0 5px'
              class={isOngoingCallWindowOpen ? 'leftInfoPanel-menu-icon-active ' : 'leftInfoPanel-menu-icon'}
              onClick={() => {
                toggleOnGoingCallWindow()
              }}
            >
            <span class='call-notify-span' />
            <div class="gap-16px p-l-10 p-t-5 p-r-10">
              <OngoingCall height="22px" width="22px" viewBox="0 0 442 545" fill={isOngoingCallWindowOpen ? '#000' : '#808080'} />
              <div style={`color: ${isOngoingCallWindowOpen ? '#000' : '#808080'};`} class='menu-name flex-c-m fs-12'>View Call</div>
            </div>
          </div>
        )
      */}
        {/*
        Modification: remove price list and all collaborator
        Date: 20/02/2024
        By: Masum Raja
      */}
        {userDesignation.toLowerCase() === "sales consultant" && (
          <div title='Collaborator' style='padding: 0 5px' class={pathName === "/workspace" ? 'leftInfoPanel-menu-icon-active' : 'leftInfoPanel-menu-icon'} onClick={() => {
            setPathName(`/collaborator`);
            route(`/collaborator`);
          }}
          >
            <div class="gap-16px p-l-5 p-t-5 p-r-5">
              <ChatIcon fill="white" height="25px" width="25px" stroke='1.5' fill={pathName === "/collaborator" ? '#000' : '#808080'} />
              <div style={`color: ${pathName === "/collaborator" ? '#000' : '#808080'};`} class='menu-name flex-c-m fs-12'>Collaborator</div>
            </div>
          </div>
        )}
        {
          userDesignation === "RECEPTIONIST" && (
            <div
              title='Create a Courier'
              style='padding: 0 5px'
              class={isCourierModalOpen ? 'leftInfoPanel-menu-icon-active ' : 'leftInfoPanel-menu-icon'}
              onClick={() => {
                toggleCloseCourierModal()
              }}
            >
              <div class="gap-16px p-l-10 p-t-5 p-r-10">
                <Courior height="22px" width="22px" fill={isCourierModalOpen ? '#000' : '#808080'} stroke={`${isCourierModalOpen ? '#000' : '#808080'}`} />
                <div style={`color: ${isCourierModalOpen ? '#000' : '#808080'};`} class='menu-name flex-c-m fs-12'>Create Courier</div>
              </div>
            </div>
          )
        }
        {(userDesignation.toLowerCase() === "back-office executive" || userDesignation.toLowerCase() === "insurance team lead" || userDesignation.toLowerCase() === "insurance head" || userDesignation.toLowerCase() === "insurance agent") && (
          <div
            title='Endorsement'
            style='padding: 0 5px'
            class={isOpenCaseFormPopover ? 'leftInfoPanel-menu-icon-active ' : 'leftInfoPanel-menu-icon'}
            onClick={() => {
              toggleEndorsementFormPopover()
            }}
          >
            <div class="gap-16px p-l-10 p-t-5 p-r-10">
              <Clipboard height="24px" width="24px" fill={isOpenCaseFormPopover ? '#000' : '#808080'} />
              <div style={`color: ${isOpenCaseFormPopover ? '#000' : '#808080'};`} class='menu-name flex-c-m fs-12'>Endorsement</div>
            </div>
          </div>
        )}
        {/*(userDesignation.toLowerCase() === "insurance head" || userDesignation.toLowerCase() === "back-office executive") &&
        <div
          title='Bulk Upload for ACH Transactions'
          style='padding: 0 5px'
          class={isReceivePaymentModalOpen ? 'leftInfoPanel-menu-icon-active ' : 'leftInfoPanel-menu-icon'}
          onClick={() => {
            toggleUploadFileModal(e, 'ACH Transactions')
          }}
        >
         <div class="gap-16px p-l-10 p-t-5 p-r-10">
            <Upload height="24px" width="24px" fill={isReceivePaymentModalOpen ? '#000' : '#808080'} title='Bulk Upload for ACH Transactions'/>
            <div style={`color: ${isOpenCaseFormPopover ? '#000' : '#808080'};`} class='menu-name flex-c-m fs-12'>ACH Transactions</div>
          </div>
        </div>
      */}
        {/*(userDesignation.toLowerCase() === "insurance head" || userDesignation.toLowerCase() === "back-office executive") &&
        <div
          title='Bulk Upload 64VB'
          style='padding: 0 5px'
          class={isReceivePaymentModalOpen ? 'leftInfoPanel-menu-icon-active ' : 'leftInfoPanel-menu-icon'}
          onClick={() => {
            toggleUploadFileModal(e, '64VB')
          }}
        >
         <div class="gap-16px p-l-10 p-t-5 p-r-10">
            <VB height="24px" width="24px" fill={isReceivePaymentModalOpen ? '#000' : '#808080'} title='Bulk Upload 64VB'/>
            <div style={`color: ${isReceivePaymentModalOpen ? '#000' : '#808080'};`} class='menu-name flex-c-m fs-12'>64VB</div>
          </div>
        </div>
      */}
        {/*(userDesignation.toLowerCase() === "insurance head" || userDesignation.toLowerCase() === "back-office executive") &&
        <div
          title='Bulk Upload Policy Summary'
          style='padding: 0 5px'
          class={isReceivePaymentModalOpen ? 'leftInfoPanel-menu-icon-active ' : 'leftInfoPanel-menu-icon'}
          onClick={() => {
            toggleUploadFileModal(e, 'Policy Summary')
          }}
        >
          <div class="gap-16px p-l-10 p-t-5 p-r-10">
            <Upload height="24px" width="24px" fill={isReceivePaymentModalOpen ? '#000' : '#808080'} action={(e)=> toggleUploadFileModal(e, 'Policy Summary')} title='Bulk Upload Policy Summary'/>
            <div style={`color: ${isReceivePaymentModalOpen ? '#000' : '#808080'};`} class='menu-name flex-c-m fs-12'>Policy Summary</div>
          </div>
        </div>
      */}
        {
          userDesignation === "RECEPTIONIST" && (
            <div
              title='Create a Visit'
              style='padding: 0 5px'
              class={isVisitModalOpen ? 'leftInfoPanel-menu-icon-active ' : 'leftInfoPanel-menu-icon'}
              onClick={() => {
                toggleCreateVisitModal()
              }}
            >
              <div class="gap-16px p-l-10 p-t-5 p-r-10">
                <Visit height="22px" width="22px" fill={`${isVisitModalOpen ? '#000' : '#808080'}`} stroke={`${isVisitModalOpen ? '#000' : '#808080'}`} title='Create a Visit' />
                <div style={`color: ${isVisitModalOpen ? '#000' : '#808080'};`} class='menu-name flex-c-m fs-12'>Create Visit</div>
              </div>
            </div>
          )
        }

        {!props.isMobileView && (
          (userDesignation.toLowerCase() === "sales consultant") && (
            <div
              title='Add New Case'
              style='padding: 0 5px'
              class={isCreateCaseModalOpen ? 'leftInfoPanel-menu-icon-active ' : 'leftInfoPanel-menu-icon'}
              onClick={() => {
                toggleCreateCaseModal()
              }}
            >
              <div class="gap-3px p-l-0 p-t-8 p-r-0 flex-col-c">
                {/*
              Bug: T1687 - 35 - Add New Case Icon should be changed to "+" icon
              Modification: Updated new case icon
              By: Devang
              Date: 10/04/2024
            */}
                <AddCaseV2 masterClasses="flex-c-m" height="24px" width="24px" fill={`${isCreateCaseModalOpen ? '#000' : '#808080'}`} title='Add New Case' />
                <div style={`color: ${isCreateCaseModalOpen ? '#000' : '#808080'};`} class='menu-name flex-c-m fs-12'>New Case</div>
              </div>
            </div>
          )
        )}

        {/*
        Modification: added stock modal in mobile navbar
        By: Masum Raja
        Date: 27/03/2024
      */}
        {
          (userDesignation && (userDesignation.toLowerCase() === "sales consultant")) && (
            <div
              title='Sales Followups'
              style='padding: 0 5px'
              class={pathName.includes('/salesFollowups') ? 'leftInfoPanel-menu-icon-active' : 'leftInfoPanel-menu-icon'}
              onClick={() => {
                setPathName('/salesFollowups');
                route('/salesFollowups');
              }}
            >
              <div class="gap-16px p-l-5 p-t-5 p-r-5">
                <AllV2 height="24px" width="24px" fill={pathName.includes('/salesFollowups') ? '#000' : '#808080'} title='Sales Followups' />
                <div style={`color: ${pathName.includes('/salesFollowups') ? '#000' : '#808080'};`} class='menu-name flex-c-m fs-12'>Sales Followups</div>
              </div>
            </div>
          )
        }
        {
          (userDesignation && (userDesignation.toLowerCase() === "sales consultant")) && (
            <div
              title='Stock'
              style='padding: 0 5px'
              class={isStockDetailModalOpen ? 'leftInfoPanel-menu-icon-active ' : 'leftInfoPanel-menu-icon'}
              onClick={() => {
                toggleStockDetailsModal()
              }}
            >
              <div class="gap-16px p-l-5 p-t-5 p-r-5">
                <Stock height="24px" width="24px" fill={`${isStockDetailModalOpen ? '#000' : '#808080'}`} title='Stock' />
                <div style={`color: ${isStockDetailModalOpen ? '#000' : '#808080'};`} class='menu-name flex-c-m fs-12'>Stock</div>
              </div>
            </div>
          )
        }
        {(userDesignation.toLowerCase() === "insurance agent" || userDesignation.toLowerCase() === "back-office executive" || userDesignation.toLowerCase() === "insurance team lead" || userDesignation.toLowerCase() === "accounts manager" || userDesignation.toLowerCase() === "accounts executive" || userDesignation.toLowerCase() === "sales accounts executive" || userDesignation.toLowerCase() === "insurance head") && (
          <div
            title='Add Insurance Renewal Case'
            style='padding: 0 5px'
            class={isCreateInsuranceCaseModalOpen ? 'leftInfoPanel-menu-icon-active ' : 'leftInfoPanel-menu-icon'}
            onClick={() => {
              toggleInsuranceCreateCaseModal()
            }}
          >
            <div class="gap-16px p-l-10 p-t-5 p-r-10">
              <AddCall height="24px" width="24px" fill={`${isCreateInsuranceCaseModalOpen ? '#000' : '#808080'}`} title='Add Insurance Renewal Case' />
              <div style={`color: ${isCreateInsuranceCaseModalOpen ? '#000' : '#808080'};`} class='menu-name flex-c-m fs-12'>Renewal Case</div>
            </div>
          </div>
        )}
        <div
          title='Logout'
          style='padding: 0 5px'
          onClick={(e) => {
            logout(e)
          }}
        >
          <div class="gap-16px p-l-5 p-t-2 p-r-6">
            <em class="cursor-pointer icon-sign-out w-22px h-22px text-white fs-22" style='color:#808080 !important' />
            <div style={`color: ${isCreateCaseModalOpen ? '#000' : '#808080'}; margin-top: -3px !important;`} class='menu-name flex-c-m fs-12'>Logout</div>
          </div>
        </div>
      </div>
      }
      {
        !props.isMobileView &&
        <Fragment>
          {/*
           Modification: Added Global Search Fragment
           By: Devang
           Date: 03/02/2022
          */}
          {/*
            Modification: Updated z-index of background and search icon
            By: Devang
            Date: 22/03/2023
          */}
          <Fragment>
            {isGlobalSearchVisible &&
              <div class="pos-fixed top-0 left-0 bottom-0 right-0 z-index-9997 bg-black-75" onclick={() => setIsGlobalSearchVisible(e => !e)} />
            }
            <div class={`flex-c flip-card-inner m-r-10 h-fit-content pos-relative ${isGlobalSearchVisible ? 'z-index-9998' : 'z-index-2'}`}>
              {
                isGlobalSearchVisible &&
                <SearchInputSuggestion
                  setIsGlobalSearchVisible={setIsGlobalSearchVisible}
                />
              }
              <div class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m`} onclick={() => setIsGlobalSearchVisible(e => !e)}>
                {
                  !isGlobalSearchVisible ?
                    <span>
                      <Search height="24px" width="24px" fill="#fff" title='Click Here to Search' />
                    </span>
                    :
                    <span style="width: 24px; height: 30.5px;" />
                }
              </div>
            </div>
          </Fragment>
          <Fragment>
            {/*
              Bug: T1894 - BG_FN - Login Page - Blank Page Displayed After Cache Clear and Page does not Reload on Login page view
              Modification: Handled condition to check userInfo.userDesignation before invoking toLowerCase on it
              By: Devang
              Date: 30/05/2024
            */}
            {
              userInfo && !userInfo.isSiloAdmin && userInfo.userDesignation && !['insurance team lead', 'insurance head', 'insurance agent'].includes(userInfo.userDesignation.toLowerCase()) && (
                <div class="flex-c flip-card-inner m-r-10 h-fit-content">
                  <div class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m ${isPriceListModalOpen ? 'rightPanel-menu-active' : ''}`}>
                    <span>
                      <PriceList height="24px" width="24px" fill="#fff" action={(e) => togglePriceListModal()} title='Price List' />
                    </span>
                  </div>
                </div>
              )
            }
            {/*
              Bug: T1894 - BG_FN - Login Page - Blank Page Displayed After Cache Clear and Page does not Reload on Login page view
              Modification: Handled condition to check userInfo.userDesignation before invoking toLowerCase on it
              By: Devang
              Date: 30/05/2024
            */}
            {/* BN:
            Modification:
            By: Priya
            Date: 15/10/26
             */}
            {
            hasDigitalRightAccess('newCase') && 
              userInfo && !userInfo.isSiloAdmin && userInfo.userDesignation && !['insurance team lead', 'insurance head', 'insurance agent', 'back-office executive', 'telecaller', 'digital marketing'].includes(userInfo.userDesignation.toLowerCase()) && (
                <div class="flex-c flip-card-inner m-r-10 h-fit-content">
                  <div class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m ${isCreateCaseModalOpen ? 'rightPanel-menu-active' : ''}`}>
                    <span>
                      {/*
                      Bug: T1687 - 35 - Add New Case Icon should be changed to "+" icon
                      Modification: Updated new case icon
                      By: Devang
                      Date: 10/04/2024
                    */}
                      <AddCaseV2 masterClasses="flex-c-m" height="24px" width="24px" fill="#fff" action={(e) => toggleCreateCaseModal()} title='Add New Case' />
                    </span>
                  </div>
                </div>
              )
            }
            {
              /*
                Add New Booking
              */
            }

            {/* {
              userInfo && !userInfo.isSiloAdmin && (
                <div class="flex-c flip-card-inner m-r-10 h-fit-content">
                 <div class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m ${ isCreateCaseModalOpen ? 'rightPanel-menu-active' : ''}`}>
                   <span>
                     <AddCaseV2 masterClasses="flex-c-m" height="24px" width="24px" fill="#fff"action={(e)=> toggleCreateBookingModal()} title='Add New Booking'/>
                   </span>
                 </div>
                </div>
              )
            } */}
            {
              /*
              End of Add new booking
              */
            }
            {(userDesignation.toLowerCase() === "insurance agent" || userDesignation.toLowerCase() === "back-office executive" || userDesignation.toLowerCase() === "insurance team lead" || userDesignation.toLowerCase() === "accounts manager" || userDesignation.toLowerCase() === "accounts executive" || userDesignation.toLowerCase() === "sales accounts executive" || userDesignation.toLowerCase() === "insurance head") && (
              <div class="flex-c flip-card-inner m-r-10 h-fit-content">
                <div class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m ${isCreateInsuranceCaseModalOpen ? 'rightPanel-menu-active' : ''}`}>
                  <span>
                    <AddCall height="24px" width="24px" fill="#fff" action={(e) => toggleInsuranceCreateCaseModal()} title='Add Insurance Renewal Case' />
                  </span>
                </div>
              </div>
            )}
            {/*
              <div class="flex-c flip-card-inner m-r-10 h-fit-content">
                <div title='Create Nuclear Task' class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m `}>
                  <span>
                    <NuclearTaskIcon width="17" height="22" action={(e)=> setIsAddNuclearTaskModalVisible(true)} />
                  </span>
                </div>
              </div>
            */}
            {/*
              modified by Manohar
              modified at 13 Feb 2023
              modification: Add Create new visit menu
            */}
            {
              userDesignation === "RECEPTIONIST" && (
                <div class="flex-c flip-card-inner m-r-10 h-fit-content">
                  <div class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m ${isVisitModalOpen ? 'rightPanel-menu-active' : ''}`} >
                    <span>
                      <Visit height="24px" width="24px" fill="#fff" action={(e) => toggleCreateVisitModal()} title='Create a Visit' />
                    </span>
                  </div>
                </div>
              )
            }
            {
              userDesignation === "TELECALLER" && (userDepartmentName === "DIGITAL MARKETING" || userDepartmentName === "MARKETING") && (
                <div class="flex-c flip-card-inner m-r-10 h-fit-content">
                  <div class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m ${isDigitalLeadModalOpen ? 'rightPanel-menu-active' : ''}`} >
                    <span>
                      <Digital height="24px" width="24px" fill="#fff" action={(e) => toggleCreateDigitalLeadModal()} title='Create Digital Lead' />
                    </span>
                  </div>
                </div>
              )
            }
            {/*
              modified by Manohar
              modified at 13 Feb 2023
              modification: Add Create new Courior menu
            */}
            {
              userDesignation === "RECEPTIONIST" && (
                <div class="flex-c flip-card-inner m-r-10 h-fit-content">
                  <div class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m ${isCourierModalOpen ? 'rightPanel-menu-active' : ''}`} >
                    <span>
                      <Courior height="24px" width="24px" fill="#fff" action={(e) => toggleCloseCourierModal()} title='Create a Courier' />
                    </span>
                  </div>
                </div>
              )
            }
            {
              userDesignation === "SALES CONSULTANT" && (
                <div class="flex-c flip-card-inner m-r-10 h-fit-content">
                  <div class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m ${isReceivePaymentModalOpen ? 'rightPanel-menu-active' : ''}`} >
                    <span>
                      <ReceivePayment height="24px" width="24px" fill="#fff" action={toggleReceivePaymentModal} title='Receive Payment' />
                    </span>
                  </div>
                </div>
              )
            }
            {/*
              Modification: added stock list
              By: Masum Raja
              Date: 20/03/2024
            */}
            {/*
            Bug: T2003 - BG_UI: Chat button overlapp issue
            Modification: Removed second instance of the 'Stock' icon for insurance roles, retaining it only for sales consultant roles.
            By: Yashashri Pawar
            Date: 21 Aug 2024
            */}
            {/* 
            BN:
            Modification:
            By:Priya 
            Date:15/10/26
            */}
            {
              // (userDesignation && (userDesignation.toLowerCase() === "sales consultant")) && (
              (digitalRightAccess ? digitalRightAccess.includes('stock') : (userDesignation && (userDesignation.toLowerCase() === "sales consultant"))) && (
                <div class="flex-c flip-card-inner m-r-10 h-fit-content">
                  <div class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m ${isStockDetailModalOpen ? 'rightPanel-menu-active' : ''}`} >
                    <span>
                      <Stock height="24px" width="24px" fill="#fff" action={(e) => toggleStockDetailsModal(e)} title='Stock' />
                    </span>
                  </div>
                </div>
              )
            }

            {/*
              modified : Ashutosh G
              modified : 10/08/2023
              modification : icon changed addCallV2
            */}
            {/* 
            BN:
            Modification: Right Panel Access 
            By: Priya
            Date: 15/10/26
            */}
            {
              hasDigitalRightAccess('newCall') && 
              !isOngoingCallWindowOpen && !isOngoingCallWindowClose && (
                <div class="flex-c flip-card-inner m-r-10 h-fit-content">
                  <div class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m ${isCallModalOpen ? 'rightPanel-menu-active' : ''}`}>
                    <span>
                      <AddCallV2 fill="#fff" height="24px" width="24px" action={(e) => toggleCallModal(e)} title='New Call' />
                    </span>
                  </div>
                </div>
              )
            }
            {
              isOngoingCallWindowOpen && (
                <div class="flex-c flip-card-inner m-r-10 h-fit-content ">
                  <span class='call-notify-span' />
                  <div class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m ${isOngoingCallWindowOpen ? 'rightPanel-menu-active' : ''}`}>
                    <span>
                      <OngoingCall fill="#fff" height="22px" width="22px" action={(e) => toggleOnGoingCallWindow(e)} title='Click to view call' />
                    </span>
                  </div>
                </div>
              )
            }
            {(userDesignation.toLowerCase() === "branch manager" || userDesignation.toLowerCase() === "back-office executive" || userDesignation.toLowerCase() === "insurance team lead" || userDesignation.toLowerCase() === "insurance head" || userDesignation.toLowerCase() === "insurance agent") && (
              <div class="flex-c flip-card-inner m-r-10 h-fit-content">
                <div class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m ${isOpenCaseFormPopover ? 'rightPanel-menu-active' : ''}`}>
                  <span>
                    <Clipboard height="24px" width="24px" fill="#fff" action={(e) => toggleEndorsementFormPopover()} title='Endorsement' />
                  </span>
                </div>
              </div>
            )}
            {(userDesignation.toLowerCase() === "insurance head" || userDesignation.toLowerCase() === "accounts executive") &&
              <div class="flex-c flip-card-inner m-r-10 h-fit-content">
                <div class="leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m">
                  <span>
                    <Upload height="24px" width="24px" fill="#fff" action={(e) => toggleUploadFileModal(e, 'ACH Transactions')} title='Bulk Upload for ACH Transactions' />
                  </span>
                </div>
              </div>
            }
            {(userDesignation.toLowerCase() === "insurance head" || userDesignation.toLowerCase() === "back-office executive") &&
              <div class="flex-c flip-card-inner m-r-10 h-fit-content">
                <div class="leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m">
                  <span>
                    <VB height="24px" width="24px" fill="#fff" action={(e) => toggleUploadFileModal(e, '64VB')} title='Bulk Upload 64VB' />
                  </span>
                </div>
              </div>
            }
            {/*
              By: Yashvi
              On: 09th Aug 2023
              Bug: KH_BG_219	Price list, and Generate Quotation having a same logo.
              Modification: Changed the icon for Generate Quotation
            }
            {(userDesignation.toLowerCase() === "insurance head") && (
              <div class="flex-c flip-card-inner m-r-10 h-fit-content">
                <div class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m`}>
                  <span>
                    <Generate height="26px" width="26px" fill="#fff" action={(e)=> generateQuotation(e)} title='Generate Quotation'/>
                  </span>
                </div>
              </div>
            )*/}
            {(userDesignation.toLowerCase() === "insurance head" || userDesignation.toLowerCase() === "back-office executive") &&
              <div class={`mobile-bottom-nav__item ${isReceivePaymentModalOpen ? ' bor-t-479393 ' : ''}`} >
                <div class={`leftInfoPanel-cards m-t-7 p-8-imp h-fit-content cursor-pointer flex-c-m `} >
                  <span>
                    <Upload height="24px" width="24px" fill="#fff" action={(e) => toggleUploadFileModal(e, 'Policy Summary')} title='Bulk Upload Policy Summary' />
                  </span>
                </div>
              </div>
            }
            {
              /*
                Bulk upload for digital leads
              */
            }
            {/* {userInfo && (
              (userInfo.userRoleName && ['branch manager', 'team lead', 'manager', 'asst manager', 'managing director'].includes(userInfo.userRoleName.toLowerCase()) && (userInfo.userDepartmentName && ['marketing'].includes(userInfo.userDepartmentName.toLowerCase())) && (userInfo.userDesignation && ['marketing manager', 'team leader'].includes(userInfo.userDesignation.toLowerCase())))
            ) &&
              <div class={`mobile-bottom-nav__item `} >
                <div class={`leftInfoPanel-cards m-t-7 p-8-imp h-fit-content cursor-pointer flex-c-m `} >
                  <span>
                    <Upload height="24px" width="24px" fill="#fff" action={(e) => toggleUploadFileModal(e, 'Digital Lead')} title='Bulk Upload Digital Leads' />
                  </span>
                </div>
              </div>
            } */}
            {/*
              modified by Komal
              modified at 15 April 2023
              modification: Add Calculator
            */}
            {/*<div class="flex-c flip-card-inner m-r-10 h-fit-content">
              <div class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m ${ isCalculatorModalOpen ? 'rightPanel-menu-active' : ''}`}>
                <span>
                <Calculator fill="#fff" height="22px" width="22px"  action={(e)=> toggleCalculatorModal(e)} title='Calculator' />
                </span>
              </div>
            </div>*/}
            {
              userInfo && !userInfo.isSiloAdmin && (
                <div class="flex-c flip-card-inner m-r-10 h-fit-content">
                  <div class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m`}>
                    <span>
                      <ViewedRecently height="26px" width="26px" fill="#fff" action={(e) => toggleRecentlyViewedModal(e)} title='Recently Viewed Cases' />
                    </span>
                  </div>
                </div>
              )
            }
            {
              userInfo && !userInfo.isSiloAdmin && (
                <div class="flex-c flip-card-inner m-r-10 h-fit-content">
                  <div class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m`}>
                    <span>
                      <RoundStar height="26px" width="26px" fill="#fff" action={(e) => toggleFollowedCasesModal(e)} title='Favorite / Important Cases' />
                    </span>
                  </div>
                </div>
              )
            }
            {/*
              userInfo && (
                <TicketGeneration setIsTicketListUpdated={props.setIsTicketListUpdated} />
              )
            */}
            {/*
              modified : Prasannadatta Kawadkar
              modified : 04 April 2024
              modification :  added add Request in rightPanel
              Modification: Add Generate Legacy Active Case Functionality.
              By: Arun Singh
              Date: 23/04/2024
            */}
            {(userDesignation.toLowerCase() === "insurance head") && (
              <div class="flex-c flip-card-inner m-r-10 m-b-81 h-fit-content">
                <div class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m`} onClick={(e) => toggleEditSchedulerLegacyFormPopover(e)}>
                  <span>
                    <PriceList height="26px" width="26px" fill="#fff" title='Generate Legacy Active Case' />
                  </span>
                </div>
              </div>
            )}
            {/*
              Modification: T2102 - Uncommented ticket generation button
              By: Devang
              Date: 26/11/2024
            */}
            <TicketGenerationV2 />
            {/*<div class="flex-c flip-card-inner m-r-10 h-fit-content">
              <div style='border: 1px solid #fff; position: relative;' class={`leftInfoPanel-cards p-8-imp h-fit-content cursor-pointer flex-c-m`}>
                <span style="color: #fff;font-size: 10px;">
                Cases
                </span>
                <div class="circles">
                  <div class="circle1"></div>
                  <div class="circle2"></div>
                  <div class="circle3"></div>
                </div>
              </div>
            </div>*/}
            {
              /*
                Modification: Added socketBox
                By: Komal Wable
                Date: 18/04/2023
              */
            }
            {/*<SocketAlert messageTextClasses='flex-l-m w-full left-0' isIconClasses='flex-c-m w-50px' slideNotificationRef = {slideNotificationRef} showSlideNotification = {showSlideNotification} handleSlideNotification = {handleSlideNotification} isSound = {isSound} message={message} isNudgeRequired={true} isAcknowledgeRequired={true} isIconRequiredFor={socketTriggeredFor} />*/}
          </Fragment>
        </Fragment>
      }
      {isEditCaseFormPopover &&
        <NewPopupModal classes="formModal" modalWidth={"65%"} modalDisplay={('show-formPopover')} onClose={(e) => toggleEditCaseFormPopover(e)}>
          <div class="enquiryForm background-transparent h-full">
            <div class="row p-t-10 p-l-30 p-r-30 p-b-10" style="background:#f7f7f7;border-bottom:1px solid lightgrey">
              <div class="col-xs-8">
                <span class="formHeader display-flex">
                  {
                    endorsementObj.typeOfEndorsement && (
                      <h4 class="m-t-5 m-b-0 text-up">New Request: <span class="fw-600 input-like-header"> {requestTypes[endorsementObj.typeOfEndorsement]} </span></h4>
                    )
                  }
                  {
                    !endorsementObj.typeOfEndorsement && (
                      <h4 class="m-t-5 m-b-0 text-up">New Request</h4>
                    )
                  }
                  {/*<h4 class="m-t-5 m-b-0">{endorsementObj.typeOfEndorsement === 'policy' ? 'New Policy Endorsement' : endorsementObj.typeOfEndorsement === 'ncbCertificate' ? 'New No Claim Bonus' : endorsementObj.typeOfEndorsement === 'cancellationApproval' ? 'Policy Cancellation' : 'New NCB Recovery Request'}</h4>*/}
                </span>
              </div>
            </div>
            {endorsementLoader ?
              <div class="text-center sizefull flex-col-c-m">
                <img src="/assets/images/gifs/done.gif" width="300" height="300" />
                <p>Creating a new request</p>
              </div> :
              <div id="formModalContainer" class="formModalContainer">
                {(!interactionObj || !interactionObj.dynamicProperties_customerName) &&
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-t-15">
                    <p class="formLabel fs-15">Select Fields to Update
                      <span class="star-mandatory-entry p-l-2">*</span>
                    </p>
                    <select class='select'
                      style="text-transform:capitalize"
                      type="text"
                      id="typeOfCase"
                      name="typeOfCase"
                      value={endorsementObj.typeOfCase}
                      onChange={e => setFormValueInputCase(e)}
                    >
                      <option class="first-letter-capital" value="" disabled selected>Select Fields to Update</option>
                      <option class="first-letter-capital" selected="Pay-in Slip" value="Pay-in Slip">Pay-in Slip</option>
                      <option class="first-letter-capital" selected="Payment Details" value="Payment Details">Payment Details</option>
                      <option class="first-letter-capital" selected="Inspection Details" value="Inspection Details">Inspection Details</option>
                    </select>
                  </div>
                }
                {(!endorsementObj.typeOfEndorsement || (!interactionObj || !interactionObj.dynamicProperties_customerName)) &&
                  <div class="w-full display-flex">
                    <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8 m-t-15">
                      <p class="formLabel fs-15 p-b-3">Search VIN / Mobile No. / Policy No.
                        <span class="star-mandatory-entry p-l-2">*</span>
                      </p>
                      <input autocomplete="off" class="first-letter-capital"
                        onClick={(e) => inputClicked(e)}
                        name="searchQuery"
                        id="searchQuery"
                        type="text"
                        value={endorsementObj.searchQuery}
                        required="true"
                        onInput={(e) => setFormValueInputCase(e)}
                      />
                      <div class="dropdown-filter-container">
                        {
                          searchResults.length > 0 && searchResults.map((result) => (
                            result.dynamicProperties_customerName &&
                            <div class="dropdown-menu grey-on-hover display-flex flex-direction-column cursor-pointer" onClick={() => searchCase('Select', result.uuid)}>
                              <span>
                                <span class="fs-14" >{result.dynamicProperties_uniqueID}</span>
                                <span class="fs-12">| {result.dynamicProperties_customerName}</span>
                              </span>
                            </div>
                          ))
                        }
                      </div>
                      {/*<span id={`error-`+dynamicProp.name} class="text-color-red fs-10" style="display:none;">Please enter {dynamicProp.displayName}</span>*/}
                    </div>
                    <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 m-t-15" style="align-self: center">
                      <button onClick={() => searchCase()} class="primary-button m-l-10" disabled={!endorsementObj.typeOfCase || !endorsementObj.searchQuery}>Search Insurance Case</button>
                    </div>
                  </div>
                }
              </div>}
          </div>
        </NewPopupModal>
      }
      {isOpenCaseFormPopover &&
        <NewPopupModal classes="formModal" modalWidth={"65%"} modalDisplay={('show-formPopover')} onClose={(e) => toggleEndorsementFormPopover(e)}>
          <div class="enquiryForm background-transparent h-full">
            <div class="row p-t-10 p-l-30 p-r-30 p-b-10" style="background:#f7f7f7;border-bottom:1px solid lightgrey">
              <div class="col-xs-8">
                <span class="formHeader display-flex">
                  {
                    endorsementObj.typeOfEndorsement && (
                      <h4 class="m-t-5 m-b-0 text-up">New Request: <span class="fw-600 input-like-header"> {requestTypes[endorsementObj.typeOfEndorsement]} </span></h4>
                    )
                  }
                  {
                    !endorsementObj.typeOfEndorsement && (
                      <h4 class="m-t-5 m-b-0 text-up">New Request</h4>
                    )
                  }
                  {/*<h4 class="m-t-5 m-b-0">{endorsementObj.typeOfEndorsement === 'policy' ? 'New Policy Endorsement' : endorsementObj.typeOfEndorsement === 'ncbCertificate' ? 'New No Claim Bonus' : endorsementObj.typeOfEndorsement === 'cancellationApproval' ? 'Policy Cancellation' : 'New NCB Recovery Request'}</h4>*/}
                </span>
              </div>
              {/*<div class="col-xs-4 display-flex justify-flex-end align-center p-r-2">
                 <button onClick={(e) => createEndorsement(e)} class="primary-button m-l-10"
                   disabled={(endorsementObj.typeOfEndorsement === 'policy' && (!endorsementObj.endorsementFileID || !endorsementObj.endorsementRemark || !endorsementObj.selectedManagerID) ||
                     (endorsementObj.typeOfEndorsement === 'ncbCertificate' && (!endorsementObj.ncbPercentage || !endorsementObj.ncbCertificateID || endorsementObj.isNoClaimBonus === "no" || !endorsementObj.selectedManagerID)) ||
                       (endorsementObj.typeOfEndorsement === 'ncbRecoveryRequest' && (!endorsementObj.ncbPercentage || !endorsementObj.reasonForNCBRecovery || !endorsementObj.recoveryAmount || !endorsementObj.selectedManagerID)) ||
                         (endorsementObj.typeOfEndorsement === 'cancellationApproval' && (!endorsementObj.cancellationReason || (endorsementObj.cancellationReason && endorsementObj.cancellationReason === 'Other' && !endorsementObj.otherCancellationReason) || !endorsementObj.selectedManagerID)))}>
                   {(endorsementObj.typeOfEndorsement === 'ncbRecoveryRequest') ? 'Create Recovery Request' : (endorsementObj.typeOfEndorsement === 'cancellationApproval') ? 'Initiate Policy Cancellation' : 'Create Endorsement'}
                 </button>
               </div>*/}
            </div>
            {endorsementLoader ?
              <div class="text-center sizefull flex-col-c-m">
                <img src="/assets/images/gifs/done.gif" width="300" height="300" />
                <p>Creating a new request</p>
              </div>
              :
              <div id="formModalContainer" class="formModalContainer">
                {(!interactionObj || !interactionObj.dynamicProperties_customerName) &&
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-t-15">
                    <p class="formLabel fs-15">Select Type of Case
                      <span class="star-mandatory-entry p-l-2">*</span>
                    </p>
                    <select class='select'
                      style="text-transform:capitalize"
                      type="text"
                      id="typeOfCase"
                      name="typeOfCase"
                      value={endorsementObj.typeOfCase}
                      onChange={e => setFormValueInputCase(e)}
                    >
                      <option class="first-letter-capital" value="" disabled selected>Select Type of Case</option>
                      <option class="first-letter-capital" selected="New Case" value="New Case">New Case</option>
                      <option class="first-letter-capital" selected="Renewal" value="Renewal">Renewal</option>
                    </select>
                  </div>
                }
                {/*
                    New NCB, Cancellation, NCB Refund, Correction, Accessories, New Vehicle No, CNG
                 */}
                {(!interactionObj || !interactionObj.dynamicProperties_customerName) && (endorsementObj.typeOfCase === 'New Case') &&
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-t-15">
                    <p class="formLabel fs-15">Select Endorsement
                      <span class="star-mandatory-entry p-l-2">*</span>
                    </p>
                    <select class='select'
                      style="text-transform:capitalize"
                      type="text"
                      id="typeOfEndorsement"
                      name="typeOfEndorsement"
                      value={endorsementObj.typeOfEndorsement}
                      onChange={e => setFormValueInputCase(e)}
                    >
                      <option class="first-letter-capital" value="" disabled selected>Select Endorsement</option>
                      {/*<option class="first-letter-capital" selected="policy" value="policy">Policy Endorsement</option>
                       <option class="first-letter-capital" selected="ncbCertificate" value="ncbCertificate">New NCB</option>*/}
                      <option class="first-letter-capital" selected="cancellationApproval" value="cancellationApproval">Cancellation</option>
                      <option class="first-letter-capital" selected="ncbCertificate" value="ncbCertificate">NCB Refund</option>
                      <option class="first-letter-capital" selected="correction" value="correction">Correction</option>
                      <option class="first-letter-capital" selected="accessories" value="accessories">Accessories</option>
                      <option class="first-letter-capital" selected="cng" value="cng">CNG</option>
                      <option class="first-letter-capital" selected="newVehicleNo" value="newVehicleNo">New vehicle no.</option>
                    </select>
                  </div>
                }
                {/*
                   NCB Recovery, New NCB, NCB Refund, Cancellation, Correction, Owner Transfer, Accessories, CNG
                 */}
                {(!interactionObj || !interactionObj.dynamicProperties_customerName) && (endorsementObj.typeOfCase === 'Renewal') &&
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-t-15">
                    <p class="formLabel fs-15">Select Endorsement
                      <span class="star-mandatory-entry p-l-2">*</span>
                    </p>
                    <select class='select'
                      style="text-transform:capitalize"
                      type="text"
                      id="typeOfEndorsement"
                      name="typeOfEndorsement"
                      value={endorsementObj.typeOfEndorsement}
                      onChange={e => setFormValueInputCase(e)}
                    >
                      <option class="first-letter-capital" value="" disabled selected>Select Endorsement</option>
                      {/*<option class="first-letter-capital" selected="ncbCertificate" value="ncbCertificate">New NCB</option>*/}
                      <option class="first-letter-capital" selected="ncbRecoveryRequest" value="ncbRecoveryRequest">NCB Recovery</option>
                      <option class="first-letter-capital" selected="cancellationApproval" value="cancellationApproval">Cancellation</option>
                      <option class="first-letter-capital" selected="ncbCertificate" value="ncbCertificate">NCB Refund</option>
                      <option class="first-letter-capital" selected="correction" value="correction">Correction</option>
                      <option class="first-letter-capital" selected="ownerTransfer" value="ownerTransfer">Owner Transfer</option>
                      <option class="first-letter-capital" selected="accessories" value="accessories">Accessories</option>
                      <option class="first-letter-capital" selected="cng" value="cng">CNG</option>
                    </select>
                  </div>
                }
                {(!endorsementObj.typeOfEndorsement || (!interactionObj || !interactionObj.dynamicProperties_customerName)) &&
                  <div class="w-full display-flex">
                    <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8 m-t-15">
                      <p class="formLabel fs-15 p-b-3">Search VIN / Mobile No. / Policy No.
                        <span class="star-mandatory-entry p-l-2">*</span>
                      </p>
                      <input autocomplete="off" class="first-letter-capital"
                        onClick={(e) => inputClicked(e)}
                        name="searchQuery"
                        id="searchQuery"
                        type="text"
                        value={endorsementObj.searchQuery}
                        required="true"
                        onInput={(e) => setFormValueInputCase(e)}
                      />
                      <div class="dropdown-filter-container">
                        {
                          searchResults.length > 0 && searchResults.map((result) => (
                            result.dynamicProperties_customerName &&
                            <div class="dropdown-menu grey-on-hover display-flex flex-direction-column cursor-pointer" onClick={() => searchCase('Select', result.uuid)}>
                              <span>
                                <span class="fs-14" >{result.dynamicProperties_uniqueID}</span>
                                <span class="fs-12">| {result.dynamicProperties_customerName}</span>
                              </span>
                            </div>
                          ))
                        }
                      </div>
                      {/*<span id={`error-`+dynamicProp.name} class="text-color-red fs-10" style="display:none;">Please enter {dynamicProp.displayName}</span>*/}
                    </div>
                    <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 m-t-15" style="align-self: center">
                      <button onClick={() => searchCase()} class="primary-button m-l-10" disabled={!endorsementObj.typeOfEndorsement || !endorsementObj.searchQuery}>Search Insurance Case</button>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </NewPopupModal>
      }
      {isCreateEditFormPopover &&
        <CreateEditForm
          operation={formOperation}
          entityName={formEntityName}
          entityObject={formEntityObject}
          setFormEntityObject={setFormEntityObject}
          dynamicProps={formDynamicProps}
          toggleFormPopover={toggleComponentFormPopover}
          backgroundColor={"#f7f7f7"}
          inputClicked={inputClicked}
          submitForm={submitComponentForm}
          toggleEditForm={toggleEditForm}

          setFormValueInput={setComponentFormValueInput}
          saveFormInputRadioDefault={saveComponentFormInputRadioDefault}
          saveFormInputRadio={saveComponentFormInputRadio}
          saveFormInputCheckbox={saveComponentFormInputCheckbox}
          saveAreaFromForm={saveAreaFromComponentForm}
          saveFormInput={saveComponentFormInput}
          uploadFile={uploadFileCase}
          deleteUploadedFile={deleteUploadedFileCase}

          setFormStageValueInput={setFormStageValueInput}
          setFormArrayValueInput={setFormArrayValueInput}
          removeFormArrayValueInput={removeFormArrayValueInput}
        />
      }
      {/*
         Bug: 182 KH_BG_252 Renewal Insurance Lead Followup Variant dropdown is missing
         Modification: Sent saveSelectedModel and saveSelectedVariant with FormWizard
         By: Devang
         Date: 15/08/2023
       */}
      {isOpenFormPopover &&
        <FormWizard
          modelMapping={modelMapping}
          isScrolledToTheBottom={isScrolledToTheBottom}
          cartNumber={cartNumber}
          progress={progress}
          actions={actions}
          dynamicProps={dynamicProps}
          dynamicPropsData={dynamicPropsData}
          areaList={areaList}
          cityList={cityList}
          stateList={stateList}
          exchangEvaluators={exchangEvaluators}
          creList={creList}
          schemes={schemes}
          offers={offers}
          interactionObj={interactionObj}
          listofManufacturers={listofManufacturers}
          catalogoueItemList={catalogoueItemList}
          variantList={variantList}
          testDriveCars={testDriveCars}
          cartProducts={cartProducts}
          assignUserList={assignUserList}
          selectedModel={selectedModel}
          currentAction={currentAction}
          currentRow={currentRow}
          courierData={courierData}
          testDriveQueue={testDriveQueue}
          selectedProducts={selectedProducts}
          selectedColor={selectedColor}
          availableStock={availableStock}
          allUserList={allUserList}
          isHandoverDocket={isHandoverDocket}
          isEditDocket={isEditDocket}
          setCourierImgDelete={setCourierImgDelete}
          setSelectedActionIndex={setSelectedActionIndex}
          selectedActionIndex={selectedActionIndex}
          setCurrentAction={setCurrentAction}
          isBackModalDisable={isBackModalDisable}
          isNextModalDisable={isNextModalDisable}
          isSaveModalDisable={isSaveModalDisable}
          financeExecutives={financeExecutives}
          toggleFormPopover={toggleFormPopover}
          scrollToTheBottom={scrollToTheBottom}
          setIsScrolledToTheBottom={setIsScrolledToTheBottom}
          setIsSaveModalDisable={setIsSaveModalDisable}
          setIsNextModalDisable={setIsNextModalDisable}
          setIsBackModalDisable={setIsBackModalDisable}
          submitFormNew={submitFormNew}
          setFormValueInput={setFormValueInput}
          /*
          Modification: Added handleKeyDown and handlePaste
          By: Priya
          Date: 05/09/26
          */
          handleNumberKeyDown={handleNumberKeyDown}
          handleNumberPaste={handleNumberPaste}
          saveFormInput={saveFormInput}
          inputClicked={inputClicked}
          deleteUploadedFile={deleteUploadedFile}
          saveFormInputCheckbox={saveFormInputCheckbox}
          saveAreaFromForm={saveAreaFromForm}
          uploadFile={uploadFile}
          dynamicButtonClicked={dynamicButtonClicked}
          getSelectedTypeUserList={getSelectedTypeUserList}
          /*submitFormOnStep={submitFormOnStep}*/
          saveFormInputRadio={saveFormInputRadio}
          saveFormInputRadioDefault={saveFormInputRadioDefault}
          isFormEditable={isFormEditable}
          setFormEditable={setFormEditable}
          setBorderOnFocus={setBorderOnFocus}
          completedActions={completedActions}
          backgroundColor={"#f7f7f7"}
          selectedArrayForDynamicProps={selectedArrayForDynamicProps}
          insuranceCompanies={insuranceCompanies}
          setIsFormUpdated={setIsFormUpdated}
          isFormUpdated={isFormUpdated}
          isDataSaving={isDataSaving}
          saveSelectedModel={saveSelectedModel}
          saveSelectedBrand={saveSelectedBrand}
          saveSelectedSalesLeadType={saveSelectedSalesLeadType}
          saveSelectedTypeOfBuyer={saveSelectedTypeOfBuyer}
          saveSelectedVariant={saveSelectedVariant}
          saveSelectedFuelType={saveSelectedFuelType}
          fuelTypes={fuelTypes}
          /*
            Modification: T319 (Change Taken From Comp's caseSemiDetailViewV3) - Added isBlur prop to blue the component on task completion error, isSaveDisabled, updateFormAPICancelToken, setIsDataSaving, handleSaveTaskOnStep added
            By: Ashutosh G
            Date: 21/05/2024
          */
          isBlur={isShowTaskCompletionError}
          isSaveDisabled={isSaveDisabled}
          updateFormAPICancelToken={cancelTokenSource}
          setIsDataSaving={setIsDataSaving}
          handleSaveTaskOnStep={handleSaveTaskOnStep}

          threeMPackages={threeMPackages}
          setFinalSelection={setFinalSelection}
          setSelectedPackage={setSelectedPackage}
          setSelectedBasicAccessories={setSelectedBasicAccessories}
          setSelected3MPackage={setSelected3MPackage}
          updateQuantityAccessories={updateQuantityAccessories}
          addQuantityAccessories={addQuantityAccessories}
          removeQuantityAccessories={removeQuantityAccessories}
          basicAccessoriesList={basicAccessoriesList}
        />
      }
      {isFileUploadModalOpen &&
        <div class='orgChartModal'>
          <div id="modelCaseModal" style="display:block;" class="org-chart-modal">
            <div class="card org-chart-modal-content org-chart-width p-b-16 p-t-0 p-r-0 p-l-0">
              <div class="pos-relative">
                <div class={`modal-header`}>
                  <span class='fs-12'>
                    <div class="display-flex">
                      <ul class='breadrcrumb_arrows_inverted m-r-8'>
                        <li>Upload {selectedBulkUploadAction === '64VB' ? '64VB' : selectedBulkUploadAction === "Policy Summary" ? 'Policy Summary' : selectedBulkUploadAction === "Digital Lead" ? 'Digital Lead' : 'ACH Transactions'}</li>
                      </ul>
                    </div>
                  </span>
                  <span class="modal-close" onClick={(e) => { toggleUploadFileModal(e); }}>&times;</span>
                </div>
                <div class="org-chart-modal-body background-transparent" style="height:40vh; overflow:auto">
                  <div class="w-full">
                    {
                      !uploadedCSVView && !isSuccessfull && (
                        <div class="w-full">
                          {/*
                             Bug: KH_BG_691 While hovering on "Download a .CSV file" button, the text is not readable
                             Modification: remove style attribute and add in style in class
                             By: Masum Raja
                             Date: 19/02/2024
                           */}
                          <div>
                            {
                              selectedBulkUploadAction === "Policy Summary" && (
                                <select
                                  class="dropdown w-half"
                                  style="right: 2rem;"
                                  onChange={(e) => { setSelectedUploadType(e.target.value); setDuplicateRecords([]); setIsErrorValidationInCsv(false); }}
                                  value={selectedUploadType}>
                                  <option value="" disabled>Select Type of file to upload</option>
                                  <option value="Policy_Summary">Delivery Data Format - Monthly</option>
                                  <option value="Invidual_Report">Individual Reports - Daily</option>
                                  <option value="Renewal_Notice">Renewal Notice - 90 Days Before</option>
                                  <option value="offline_data">Offline Data</option>
                                  <option value="Lost_data">Lost Data</option>
                                  <option value="Bodyshop_and_HI_other">Body shop and Other Than HI Data</option>
                                  <option value="Update_CRE_NAME">Update_CRE_NAME</option>
                                </select>
                              )
                            }
                            {
                              selectedBulkUploadAction === "Digital Lead" && (
                                <select
                                  class="dropdown w-half"
                                  style="right: 2rem;"
                                  // onChange={(e) => { setSelectedUploadType(e.target.value); setDuplicateRecords([]); setIsErrorValidationInCsv(false); }}
                                  value={selectedUploadType}>
                                  <option value="" disabled>Select Type of file to upload</option>
                                  <option value="Digital_lead_bulk_upload">Digital lead bulk upload</option>
                                </select>
                              )
                            }
                            <button class="primary-button" disabled={selectedBulkUploadAction === "Policy Summary" && !selectedUploadType}>
                              <a href={`${selectedBulkUploadAction === '64VB' ? "/assets/static/BulkUpload64VB.csv" : (selectedBulkUploadAction === "Policy Summary" && selectedUploadType === "Policy_Summary") ? "/assets/static/PolicySummary.csv" : selectedUploadType ? `/assets/static/${selectedUploadType}.csv` : "/assets/static/BulkUpload.csv"}`} class="noClick" download={`${selectedBulkUploadAction === '64VB' ? "BulkUpload64VB.csv" : (selectedBulkUploadAction === "Policy Summary" && selectedUploadType === "Policy_Summary") ? "PolicySummary.csv" : selectedUploadType ? `${selectedUploadType}.csv` : "BulkUpload.csv"}`} target="_blank"><p style="font-size: 15px;" class='header-text noClick'>Download Sample .CSV file</p></a>
                            </button>
                          </div>
                          <p style="font-size:12px; color: red; margin-top:10px">{isErrorMessage}</p>
                          <div class="flex-c-m p-0" onDrop={(e) => uploadCSVByDragNDrop(e)} onDragOver={ev => ev.preventDefault()} >
                            <input type="file" id="file-upload" required style="display: none;" onChange={(e) => uploadBrowsedCSV(e)} accept='.csv' />
                            <label class="file-upload text-align-center cursor-pointer" for="file-upload" style="padding: 15px; width:100%" >
                              <p><img src="/assets/images/09_File_Upload.svg" /> Choose a CSV file(s) to upload</p>
                              <p>or drag & drop a CSV File here</p>
                            </label>
                          </div>
                        </div>
                      )
                    }
                    {
                      isSuccessfull && (
                        <div style="padding: 0px;" >
                          <label class="file-upload" for="file-upload" style="padding: 15px; width:100%" >
                            <p>File Uploaded Successfully!</p>
                            <div>
                              <table>
                                <thead>
                                  <tr>
                                    <td>Updated Renewal Cases</td>
                                    <td>Already Closed Cases</td>
                                    <td>Created Renewal Cases</td>
                                    <td>Created New Cases</td>
                                    {selectedBulkUploadAction === 'ACH Transactions' && <td>Non ACH Cases</td>}
                                    <td>Total</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{bulkUploadResult.updatedInteractionsCount}</td>
                                    <td>{bulkUploadResult.alreadyClosedInteractionsCount}</td>
                                    <td>{bulkUploadResult.renewalCreatedCasesCount}</td>
                                    <td>{bulkUploadResult.newCasesCreatedCount}</td>
                                    {selectedBulkUploadAction === 'ACH Transactions' && <td>{bulkUploadResult.nonACHInteractionsCount}</td>}
                                    <td>{bulkUploadResult.total}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </label>
                        </div>
                      )
                    }
                    {
                      isSuccessfull && bulkUploadResult && bulkUploadResult.notFoundInteractionsCount > 0 && (
                        <div style="padding: 0px;" >
                          <label class="file-upload" for="file-upload" style="padding: 15px; width:100%" >
                            <p>Created Renewal Cases</p>
                            <div>
                              <table>
                                <thead>
                                  <tr>
                                    <td>Chassis No</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  {bulkUploadResult.notFoundInteractions && bulkUploadResult.notFoundInteractions.map(item => (
                                    <tr>
                                      <td>{item.dynamicProperties_vin}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </label>
                        </div>
                      )
                    }
                    {
                      isSuccessfull && bulkUploadResult && bulkUploadResult.nonACHInteractionsCount > 0 && (
                        <div style="padding: 0px;" >
                          <label class="file-upload" for="file-upload" style="padding: 15px; width:100%" >
                            <p>Non ACH Cases</p>
                            <div>
                              <table>
                                <thead>
                                  <tr>
                                    <td>Customer Name</td>
                                    <td>Chassis No</td>
                                    <td>Policy Type</td>
                                    <td>Enquiry Source</td>
                                    <td>Payment Mode</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  {bulkUploadResult.nonACHInteractions && bulkUploadResult.nonACHInteractions.map(item => (
                                    <tr>
                                      <td>{item.dynamicProperties_customerName}</td>
                                      <td>{item.dynamicProperties_vin}</td>
                                      <td>{item.dynamicProperties_typeOfPolicy}</td>
                                      <td>{item.dynamicProperties_source}</td>
                                      <td>{item.dynamicProperties_paymentModeSMC}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </label>
                        </div>
                      )
                    }

                    {
                      isErrorValidationInCsv && errorValidationInCsv && (
                        <div style="padding: 0px;" >
                          <label class="file-upload" for="file-upload" style="padding: 15px; width:100%" >
                            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
                              <p style="margin: 0;">Error in csv</p>
                              <button
                                onClick={downloadErrorItemsAsCSV}
                                style="padding: 8px 16px; background-color: #4CAF50; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 14px; font-weight: 500;"
                                onMouseOver={(e) => e.target.style.backgroundColor = '#45a049'}
                                onMouseOut={(e) => e.target.style.backgroundColor = '#4CAF50'}
                              >
                                Download Errors
                              </button>
                            </div>
                            <div>
                              <table>
                                <thead>
                                  <tr>
                                    <td>Error</td>
                                    <td>Vin</td>
                                    <td>Mobile</td>
                                    <td>Email</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  {errorValidationInCsv && errorValidationInCsv.map(item => (
                                    <tr>
                                      <td>{item.error}</td>
                                      <td>{item.vin}</td>
                                      <td>{item.customerNumber}</td>
                                      <td>{item.emailAddress}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </label>
                        </div>
                      )
                    }
                    {duplicateRecords && duplicateRecords.length > 0 && (
                      <div style="padding: 0px; z-index: 1000; position: relative; background: #fff;" >
                        <p>Duplicate Records in the uploaded file</p>
                        <div>
                          <table>
                            <thead>
                              <tr>
                                <td>Vin</td>
                              </tr>
                            </thead>
                            <tbody>
                              {duplicateRecords && duplicateRecords.map(item => (
                                <tr>
                                  <td>{item}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {
        isCalculatorModalOpen && (
          <DraggableCalculator id="floating-new-assignee" right="55" ripple={false} name="New Assignee" classes="drag-drop-floating-calculator" clickEvent={toggleCalculatorModal} />
        )
      }
      {
        isFollowUpModalOpen && (
          <div class='orgChartModal'>
            <div id="modelCaseModal" style="display:block;" class="org-chart-modal">
              <div class="org-chart-modal-content org-chart-width">
                <div>
                  <div class="org-chart-modal-header">
                    <span class="org-chart-close" onClick={(e) => toggleNewFollowupModal(e)}>&times;</span>
                  </div>
                  <div class="org-chart-modal-body background-transparent">
                    <div class="row">
                      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        {
                          (selectedCaseObj && selectedCaseObj.uuid) && (
                            <div class="row">
                              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 justify-center">
                                <div class="form-flex flex-direction-column align-baseline">
                                  <label class="form-group w-full m-b-0 text-gray" style="height: fit-content;">Customer Name: </label><a class="form-group w-full fs-1-25rem m-b-15 first-letter-capital">{selectedCaseObj["dynamicProperties_customerName"]}</a>
                                </div>
                                <div class="form-flex flex-direction-column align-baseline">
                                  <label class="form-group w-full m-b-0 text-gray" style="height: fit-content;">Source: </label><a class="form-group w-full fs-1-25rem m-b-15 ">{selectedCaseObj["dynamicProperties_source"]}</a>
                                </div>
                                <div class="form-flex flex-direction-column align-baseline">
                                  <label class="form-group w-full m-b-0 text-gray" style="height: fit-content;">Model: </label><a class="form-group w-full fs-1-25rem m-b-15 ">{selectedCaseObj["modelName"] ? modelMapping[selectedCaseObj["modelName"]] : "--"}</a>
                                </div>
                                <div class="form-flex flex-direction-column align-baseline">
                                  <label class="form-group w-full m-b-0 text-gray" style="height: fit-content;">Variant: </label><a class="form-group w-full fs-1-25rem m-b-15 ">{selectedCaseObj["variantName"] ? selectedCaseObj["variantName"] : "--"}</a>
                                </div>
                              </div>
                            </div>
                          )
                        }
                        {
                          (selectedCaseObj && !selectedCaseObj.uuid) && (
                            <div class="row">
                              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 display-flex justify-center">
                                <p>Please select a case to add follow-up</p>
                              </div>
                            </div>
                          )
                        }
                      </div>
                      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 m-t-5 display-flex justify-center flex-column">
                        <div class="m-b-10">
                          <div class="p-b-10 text-gray" >
                            <p> Select Case <span class="star-mandatory-entry p-l-2">*</span></p>
                            <select class="p-l-r-0-2rem text-4b4d51 fs-1rem h-2rem text-4b4d51 background-white border-none" type="text" name="case" value={selectedCase} onChange={async (e) => {
                              // await setSelectedCase(e.target.value);
                              await setCase(e.target.value);
                            }} style="text-shadow:none">
                              <option value=''>Select Case</option>
                              {
                                cases.map(caseObj => (
                                  <option value={caseObj.uuid}>{caseObj.caseID}</option>
                                ))
                              }
                            </select>
                          </div>
                          {
                            selectedCase && (
                              <div class="m-b-10">
                                <div class="p-b-10" >
                                  <p>Follow-up Date <span class="star-mandatory-entry p-l-2">*</span></p>
                                  <input autocomplete="off" type="date" value={followupDate} onChange={e => setFollowupDate(e.target.value)} />
                                </div>
                              </div>
                            )
                          }
                          {
                            selectedCase && (
                              <div class="m-b-10">
                                <div class="p-b-10" >
                                  <p>Type of Follow-up <span class="star-mandatory-entry p-l-2">*</span></p>
                                  <select class="p-l-r-0-2rem text-4b4d51 fs-1rem h-2rem text-4b4d51 background-white border-none" type="text" name="case" value={typeofFollowup} onChange={(e) => setTypeofFollowup(e.target.value)} style="text-shadow:none">
                                    <option value=''>Select Type of Follow-up</option>
                                    <option value='Call'>Call</option>
                                    <option value='Whatsapp'>Whatsapp</option>
                                    <option value='Home Visit'>Home Visit</option>
                                    <option value='Showroom Visit'>Showroom Visit</option>
                                  </select>
                                </div>
                              </div>
                            )
                          }
                          {
                            (selectedCase && typeofFollowup === "Call") && (
                              <div class="p-b-10">
                                {
                                  !isCallOriginated && (
                                    <button class="primary-button m-t-20 m-b-20" onClick={e => originateCall(e)}>Call</button>
                                  )
                                }
                                {
                                  (isCallOriginated && !isFollowupDone) && (
                                    <button class="primary-button m-t-20 m-b-20" onClick={e => setIsFollowupDone(true)}>End Call</button>
                                  )
                                }
                              </div>
                            )
                          }
                          {
                            (selectedCase && typeofFollowup === "Whatsapp") && (
                              <div class="p-b-10">
                                <button class="primary-button m-t-20 m-b-20" onClick={e => setIsFollowupDone(true)}>Send Whatsapp Message</button>
                              </div>
                            )
                          }
                          {
                            (selectedCase && typeofFollowup === "Whatsapp" && isFollowupDone) && (
                              <div class="p-b-10">
                                <p>Please update the following details regarding follow-up</p>
                              </div>
                            )
                          }
                          {
                            selectedCase && isFollowupDone && (
                              <div class="p-b-10" >
                                <p> Remark Category <span class="star-mandatory-entry p-l-2">*</span></p>
                                <select class="p-l-r-0-2rem text-4b4d51 fs-1rem h-2rem text-4b4d51 background-white border-none" type="text" name="category" value={selectedRemarkCatagory} onChange={(e) => setSelectedRemarkCategory(e.target.value)} style="text-shadow:none">
                                  <option value='' selected>Select Remark Category</option>
                                  <option value="1st Remark">1st Remark</option>
                                  <option value="Planning">Planning</option>
                                  <option value="Payment Confirmation">Payment Confirmation</option>
                                  <option value="Test Drive">Test Drive</option>
                                  <option value="Home Visit">Home Visit</option>
                                  <option value="Lost">Lost</option>
                                  <option value="Drop">Drop</option>
                                </select>
                              </div>
                            )
                          }
                          {
                            selectedCase && isFollowupDone && (
                              <div class="p-b-10" >
                                <p> Remark <span class="star-mandatory-entry p-l-2">*</span></p>
                                <input autocomplete="off" type="text" value={remark} onInput={e => setRemark(e.target.value)} placeholder="Enter Remark" />
                              </div>
                            )
                          }
                          <div class="p-b-10">
                            <button disabled={!selectedRemarkCatagory && !remark} class="primary-button m-l-10">Save</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
      {
        isReceivePaymentModalOpen &&
        <ReceivePaymentModal
          handleClose={toggleReceivePaymentModal}
          handleSubmit={toggleReceivePaymentModal}
        />
      }
      {
        isCallModalOpen && (
          <div class='orgChartModal'>
            <div id="modelCaseModal" style="display:block;" class="org-chart-modal overflow-unset">
              <div class="org-chart-modal-content org-chart-width" style='padding: 0px !important'>
                <div>
                  <div class={`modal-header`}>
                    <span class='fs-12'>
                      <div class="display-flex">
                        <ul class='breadrcrumb_arrows_inverted m-r-8'>
                          <li>Add Call</li>
                        </ul>
                      </div>
                    </span>
                    <span class="modal-close" onClick={(e) => toggleCallModal(e)}>&times;</span>
                  </div>
                  <div class="org-chart-modal-body background-transparent" style="height:80vh; overflow:auto; padding: 30px 0px !important">
                    <div class="row followup">
                      <div class="col-xs-12 col-sm-12 col-md-12 m-t-16">
                        <span title="Follow up for" class="p-0 accordion-category-heading fs-13 flex-l-m">
                          Follow up for
                        </span>
                        <select class="p-l-0 fs-15" type="text" value={followUpFor ? followUpFor : ''} id="followUpFor" onChange={(e) => {
                          setFollowUpFor(e.target.value);
                        }}
                        >
                          <option value="" >Select Follow up for</option>
                          <option value={'All'}>{'All'}</option>
                          <option value={'Vehicle'}>{'Vehicle'}</option>
                          <option value={'Finance'}>{'Finance'}</option>
                          <option value={'Used Car'}>{'Used Car'}</option>
                          <option value={'Accessories'}>{'Accessories'}</option>
                        </select>
                      </div>
                      <div class="col-xs-12 col-sm-12 col-md-12 m-t-8 follow-up">
                        <span title="Follow up for" class="p-0 accordion-category-heading fs-13 flex-l-m">
                          Reason
                        </span>
                        <select class="p-l-0 fs-15" type="text" value={reasonForCalling ? reasonForCalling : ''} id="reasonForCalling" onChange={(e) => {
                          setReasonForCalling(e.target.value);
                        }}
                        >
                          <option value="" >Select Reason</option>
                          <option value={'Booking Amount'}>{'Booking Amount'}</option>
                          <option value={'Finalise Finance Option'}>{'Finalise Finance Option'}</option>
                          <option value={'Finalise Used Car Price'}>{'Finalise Used Car Price'}</option>
                           <option value={'Vehicle Follow-up '}>{'Vehicle Follow-up '}</option>
                                <option value={'Payment follow-up  '}>{'Payment follow-up '}</option>
                                <option value={'Documenst Follow-up '}>{'Documenst Follow-up '}</option>
                                <option value={'Accessories Follow-up'}>{'Accessories Follow-up'}</option>
                          <option value={'Other'}>{'Other'}</option>
                        </select>
                      </div>
                      <div class="col-xs-12 col-sm-12 col-md-12 m-t-8 display-grid">
                        <span title="Remark" class="p-0 m-t-0 accordion-category-heading fs-13">
                          Remark
                        </span>
                        <input class="textarea-height m-t-8" type="textarea" id="remark" rows="4" />
                      </div>
                      {
                        reasonForCalling === "Other" && (
                          <div class="col-xs-12 col-sm-12 col-md-12 m-t-8 display-grid">
                            <span title="Reason" class="p-0 m-t-0 accordion-category-heading fs-13">
                              Enter Reason
                            </span>
                            <input required class="textarea-height m-t-8" type="textarea" id="remark" rows="4" />
                          </div>
                        )
                      }
                      <div class="col-xs-12 col-sm-12 col-md-12 m-t-8 display-grid">
                        <span title="Mobile Number" class="p-0 m-t-0 accordion-category-heading fs-13">
                          Enter Mobile Number
                        </span>
                        <input autocomplete="off" type='text' value={mobileNumberEntered} disabled={isNewCallSubmitting} onInput={(e) => {
                          setIsCallNumberRejected(false);
                          setCallNumberValidationError('');
                          setMobileNumberEntered(e.target.value);
                        }} />
                        {callNumberValidationError && <span role="alert" class="text-color-red">{callNumberValidationError}</span>}
                      </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 m-t-8 display-grid">
                        <span title="User Extension" class="p-0 m-t-0 accordion-category-heading fs-13">
                          User Extension
                        </span>
                        <input
                          type="text"
                          id="userExtension"
                          autocomplete="off"
                          value={userExtension}
                          disabled
                          onCopy={(e) => e.preventDefault()}
                          onCut={(e) => e.preventDefault()}
                          onContextMenu={(e) => e.preventDefault()}
                          onDragStart={(e) => e.preventDefault()}
                          onSelectStart={(e) => e.preventDefault()}
                        />
                        {!isExtensionLoading && !userExtension && (
                          <span role="alert" class="fs-14 f-w-300 text-color-red m-t-2">Extension field cannot be empty. Please ask admin for your extension.</span>
                        )}
                      </div>
                      <div class="col-xs-12">
                        <div class="p-b-10">
                          <button disabled={isCallOriginatedByUser || isNewCallSubmitting || isCallNumberRejected || !mobileNumberEntered.trim()|| isExtensionLoading || !userExtension} class="primary-button m-t-20 m-b-20" onClick={e => originateCallNew(e)}>Call</button>
                        </div>
                        {/* Previous call response details replaced by the call timeline.
                        {
                          isCallOriginatedByUser && !callResponseData && (
                            <div class="p-b-10">
                              <p class="form-label">Call Request Status</p>
                              <span>{callResponse} {callResponseText}</span>
                            </div>
                          )
                        }
                        {
                          isCallOriginatedByUser && callResponseData && (
                            <div class="p-b-10">
                              <p class="form-label">Call Request: Error</p>
                              <span class="text-color-red">{callResponseData}</span>
                            </div>
                          )
                        }
                        {
                          isCallOriginatedByUser && !callResponseData && (
                            <div class="p-b-10">
                              <p class="form-label">Call Initiated From</p>
                              <span>{callResponseObj.extension}</span>
                            </div>
                          )
                        }
                        {
                          isCallOriginatedByUser && !callResponseData && (
                            <div class="p-b-10">
                              <p class="form-label">Call Initiated To</p>
                              <span>{callResponseObj.mobileNumber}</span>
                            </div>
                          )
                        }
                        */}
                        {/* 
                        BN:
                        Modification:
                        Date: 13/10/26
                        By: Priya
                        */}
                        {isCallOriginatedByUser && (
                          <div class="h-full bg-white bor-rad-all-5 p-16 overflow-auto">
                            <div class="container-timeline">
                              <div class="timeline-block timeline-block-right m-b-16">
                                <div class="marker active"><i class="fa fa-check active" aria-hidden="true" /></div>
                                <div class="timeline-content">
                                  <div style="background: rgb(226 226 226 / 39%);padding: 8px;border-radius: 5px;">
                                    <p class={"fs-12"}>Call Initiated</p>
                                  </div>
                                 <div class="float-right"><span class="fs-10">{callTimes.initiated ? formatDateTime(callTimes.initiated, true) : ''}</span></div>
                                </div>
                              </div>

                              <div class="timeline-block timeline-block-left m-b-16">
                                <div class={`marker ${callTimes.received ? 'active' : ''}`}><i class="fa fa-check" aria-hidden="true" /></div>
                                <div class="timeline-content">
                                  <div class="display-flex" style="background: rgb(226 226 226 / 39%);padding: 8px;border-radius: 5px;">
                                    <p class={"fs-12"}>Call Received by Caller</p>
                                  </div>
                                  <div class="float-right"><span class="fs-10">{callTimes.received ? formatDateTime(callTimes.received, true) : ''}</span></div>
                                </div>
                              </div>

                              <div class="timeline-block timeline-block-right m-b-16 active">
                                <div class={`marker ${callTimes.connected ? 'active' : ''}`}><i class="fa fa-check" aria-hidden="true" /></div>
                                <div class="timeline-content">
                                  <div style="background: rgb(226 226 226 / 39%);padding: 8px;border-radius: 5px;">
                                    <p class={"fs-12"}>Call Initiated to Dialed Number</p>
                                  </div>
                                 <div class="float-right"><span class="fs-10">{callTimes.connected ? formatDateTime(callTimes.connected, true) : ''}</span></div>
                                </div>
                              </div>

                              <div class="timeline-block timeline-block-right m-b-0">
                                <div class={`marker ${callTimes.finished ? 'active' : ''}`}><i class="fa fa-check" aria-hidden="true" /></div>
                                <div class="timeline-content">
                                  <div style="background: rgb(226 226 226 / 39%);padding: 8px;border-radius: 5px;">
                                    <p class={"fs-12"}>{currentCallStatus === 'missed' ? 'Call Missed' : 'Call Finished'}</p>
                                  </div>
                                  <div class="float-right"><span class="fs-10">{callTimes.finished ? formatDateTime(callTimes.finished, true) : ''}</span></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
      {
        isOngoingCallWindowOpen && !isOngoingCallWindowClose && (
          <CallingCard
            cardBgColor='#000000bf'
            // cardHeight={!props.isTaskView ? '50%' : '100%'}
            cardHeight={'50%'}
            iconText={props.currentInteraction['dynamicProperties_customerName']}
            // iconContainerClasses={!props.isTaskView ? "display-none": ""}
            header={'Calling...'}
            cardHeader={props.currentInteraction['dynamicProperties_customerName']}
            mainHeaderClasses={"row justify-between"}
            truecallerName={props.trueCallerData.name}
            subHeader={'Mobile ' + props.trueCallerData.phones[0]['e164Format']}
            state={props.trueCallerData.addresses[0]['city']}
            country={props.trueCallerData.addresses[0]['countryCode']}
            isTaskView={false}
            action={(e) => closeOnGoingCallWindow(e)}
          />
        )
      }
      {
        isCreateCaseModalOpen && (
          <div class='orgChartModal'>
            <div id="modelCaseModal" style="display:block;" class="org-chart-modal">
              <div class="card org-chart-modal-content org-chart-width p-b-16 p-t-0 p-r-0 p-l-0">
                <div class="pos-relative">
                  {/*<div class="right-drawer-label" onClick={(e) => toggleCreateCaseModal(e)}>
                    <div class="right-drawer-close-btn" title="Close">
                      <div class="right-drawer-close-btn-inner" />
                    </div>
                  </div>*/}
                  <div class={`modal-header`}>
                    <span class='fs-12'>
                      <div class="display-flex">
                        <ul class='breadrcrumb_arrows_inverted m-r-8'>
                          <li>Add New Case</li>
                        </ul>
                      </div>
                    </span>
                    <span class="modal-close" onClick={(e) => { toggleCreateCaseModal(e); }}>&times;</span>
                  </div>
                  {/*
                    Suggestion(16): T1692 - Mobile Task View - Add New Case
                    Description: The create case modal is not user friendly. For mobile it can be one line item per line.
                    By: Arun Singh
                    Date: 15/04/2024
                  */}
                  <div class={`${props.isMobileView ? 'm-0' : ''} org-chart-modal-body background-transparent pos-relative`} style="height:75vh; overflow:auto">
                    <div class="row">
                      {
                        !isCaseCreationLoaderShown && !isCaseCreated && (
                          <div class={`${props.isMobileView ? 'p-l-0 p-r-0' : ''} col-xs-12 col-sm-12 col-md-12 col-lg-12 m-t-5 display-flex justify-center flex-column`}>
                            <div class="m-b-10">
                              <div class="row p-b-10 text-gray" >
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                  <p class="fs-11"> Select Type of Case <span class="star-mandatory-entry p-l-2">*</span></p>
                                  <div class={`${props.isMobileView ? 'gap-10px flex-sb' : ''} display-flex m-t-8`}>
                                    {/*
                                      Bug: 5 KH_BG_75 Receptionist / Sales Consultant Add New Case Select Type of Case -  Vehicle , Finance , Accessories , Used Car , Vas Icons are not displayed as per standard
                                      Modification: Updated props and classes
                                      By: Devang
                                      Date: 06/07/2023
                                    */}
                                    {
                                      caseTypes.map((caseType, index) => (
                                        <div class={`${props.isMobileView ? 'm-0' : 'm-r-16'} flex-c-m flex-direction-column`}>
                                          <SemiInfoDetailCard
                                            /*
                                              Bug: T1738 - BG_FN: Data is auto populated when add new case is added - Remark, Dealer code
                                              Modification: Updated cardBgColor with a condition
                                              By: Devang
                                              Date: 15/04/2024
                                            */
                                            cardBgColor={selectedCaseTypes.includes(caseType.name) ? '#CFE3C0' : '#ececec'}
                                            cardHeight='44px'
                                            /*
                                              Bug: T1738 - BG_FN: Data is auto populated when add new case is added - Remark, Dealer code
                                              Modification: Commented previous action with new one
                                              By: Devang
                                              Date: 15/04/2024
                                            */
                                            // action={(e)=> caseType.action(e)}
                                            action={() => setCaseType(caseType.name)}
                                            cardHeaderClasses="fs-12 f-w-400 text-black"
                                            cardPadding="8px"
                                            masterCardClasses="m-l-0"
                                            masterCardStyle={props.isMobileView ? 'width: 50px;' : 'width: 44px; min-width: 44px; min-height: 44px;'}
                                            // masterClasses="p-t-0 p-b-0 display-flex justify-flex-start flex-direction-column h-full first-letter-capital align-center"
                                            // iconMasterClasses="bottom-neg-4 right-0"
                                            masterClasses="h-0"
                                            iconMasterClasses="h-full flex-c-m"
                                            isCardIconFaded
                                            // cardHeader={''}
                                            title={caseType.text}
                                            cardIcon={getRowCardIcon(caseType.icon)}
                                            identifier={caseType.identifier}
                                            isMobileView={props.isMobileView}
                                          />
                                          {/*
                                            Bug: T1692 - 6 - Mobile - Alignment of add new case is not right on Android and iPhone
                                            Modification: Added w-max-content class
                                            By: Devang
                                            Date: 14/04/2024
                                          */}
                                          <div class="display-flex word-wrap-break m-t-5 w-max-content">
                                            <p class="fs-11 f-w-300 text-primary" style="align-self: baseline;"><span>{caseType.text}</span></p>
                                          </div>
                                        </div>

                                      ))
                                    }
                                  </div>
                                </div>

                              </div>
                              {/*
                                Bug: T1863 - Add New Case, Visit - Enter Mobile Number - Mobile Validation is missing
                                Modification: added maxLength 10
                                By: Masum Raja
                                Date: 20/05/2024
                              */}
                              {
                                isCaseTypeSelected && (
                                  <div class="row p-b-10 text-gray">
                                    <div class={`${props.isMobileView ? 'col-xs-12' : 'col-xs-6'}`}>
                                      <div class="display-flex">
                                        <p class="fs-11 p-b-4">Enter Mobile Number</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                      </div>
                                      <input id='customerPhoneNumber' class="fs-13 first-letter-capital" type="text" placeholder="+91-XXXXXXXXXX" disabled={verificationCodeField} onInput={e => inputMask(e)} onBlur={(e) => {
                                        setContactData({
                                          ...contactData,
                                          mobile: mobNumber
                                        })
                                      }}
                                        maxlength='10'
                                      />
                                    </div>
                                    <div class={`${props.isMobileView ? 'col-xs-12' : 'col-xs-6'} form-group m-b-8`}>
                                      <div class="display-flex">
                                        <p class="fs-11 p-b-5 text-gray">Customer Salutation</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                      </div>
                                      <select class="fs-1rem h-2rem background-white border-none" type="text" id="salutation" value={(contactData && contactData.salutation) || salutation} onChange={(e) => {
                                        setSalutation(e.target.value)
                                      }} style="text-shadow:none">
                                        <option value="Mr.">Mr.</option>
                                        <option value="Ms.">Ms.</option>
                                        <option value="Mrs.">Mrs.</option>
                                        <option value="Dr.">Dr.</option>
                                      </select>
                                    </div>
                                    <div class={`${props.isMobileView ? 'col-xs-12' : 'col-xs-6'} form-group m-b-8`}>
                                      <div class="display-flex">
                                        <p class="fs-11 p-b-5 text-gray">Customer First Name</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                      </div>
                                      <input onInput={e => setCustomerName(e.target.value)} autocomplete="off" class="fs-13 h-2rem background-white border-none" type="text" name="first_name" defaultValue={(contactData && contactData.firstName) || customerName} id="first_name" placeholder="First Name" />
                                    </div>
                                    {/*
                                      Bug: T1687 - 24 - Add New Case - Middle Name field - Middle Name field is missing
                                      Modification: Added field for middleName
                                      By: Devang
                                      Date: 10/04/2024
                                    */}
                                    {/*
                                      Bug: T1809 - Unable to Modify Customer Last Name, Middle name with Existing Mobile Number
                                      Modification: Added value as defaultValue
                                      By: Masum Raja
                                      Date: 20/05/2024
                                    */}
                                    <div class={`${props.isMobileView ? 'col-xs-12' : 'col-xs-6'} form-group m-b-8`}>
                                      <div class="display-flex">
                                        <p class="fs-11 p-b-5 text-gray">Customer Middle Name</p>
                                      </div>
                                      <input onInput={e => setCustomerMiddleName(e.target.value)} autocomplete="off" class="fs-13 h-2rem background-white border-none" type="text" name="middle_name" defaultValue={(contactData && contactData.middleName) || customerMiddleName} id="middle_name" placeholder="Middle Name" />
                                    </div>
                                    <div class={`${props.isMobileView ? 'col-xs-12' : 'col-xs-6'} form-group m-b-8`}>
                                      <div class="display-flex">
                                        <p class="fs-11 p-b-5 text-gray">Customer Last Name</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                      </div>
                                      <input onInput={e => setCustomerLastName(e.target.value)} autocomplete="off" class="fs-13 h-2rem background-white border-none" type="text" name="last_name" defaultValue={(contactData && contactData.lastName) || lastName} id="last_name" placeholder="Last Name" />
                                    </div>
                                    <div class={`${props.isMobileView ? 'col-xs-12' : 'col-xs-6'} form-group m-b-8`}>
                                      <div class="display-flex">
                                        <p class="fs-11 p-b-5 text-gray">Model</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                      </div>
                                      <select class="p-l-r-0-2rem fs-1rem  h-2rem background-white border-none" style="text-transform:capitalize" type="text" id="orderSourceModel" value={model} onChange={e => {
                                        setModel(e.target.value)
                                        setFuelTypes([])
                                        setTypeOfFuel('')
                                        setVariantList([])
                                        setVariant('')
                                        // getFuelTypesForSelectedModel(e.target.value)
                                      }} required>
                                        <option class="first-letter-capital" value="" selected>Select Model</option>
                                        {modelsList.map((item) => (
                                          <option class="first-letter-capital" value={item.uuid}>{item.model}</option>
                                        ))}
                                      </select>
                                    </div>
                                    <div class={`${props.isMobileView ? 'col-xs-12' : 'col-xs-6'} form-group m-b-8`}>
                                      <p class="fs-11 p-b-5">Fuel Type</p>
                                      <select class="p-l-r-0-2rem fs-1rem  h-2rem background-white border-none first-letter-capital" type="text" id='typeOfFuel' value={typeOfFuel} onChange={e => {
                                        setTypeOfFuel(e.target.value)
                                        getVariantForSelectedModel(e.target.value)
                                      }
                                      } style="text-shadow:none">
                                        <option class="first-letter-capital" value="" selected>Select Fuel Type</option>
                                        {
                                          ['Petrol', 'CNG', 'Diesel', 'EV'].map((catalogueItemFuelType) => (
                                            /*
                                              Bug: 75	KH_BG_145	Sales Manager / Sales Assistant Manager / Sales Consultant	Add New Case Fuel Type	Rewording "Cng" - "CNG"
                                              Modification: Added a fuelTypeMapper to map the value of each distinct fuel type and cng as CNG.
                                              By: Devang
                                              Date: 04/07/2023
                                            */
                                            <option class="first-letter-capital" value={catalogueItemFuelType}>{fuelTypeMapper[catalogueItemFuelType.toLowerCase()] || catalogueItemFuelType.toLowerCase()}</option>
                                          ))
                                        }
                                        {/*<option value="CNG">CNG</option>
                                        <option value="Petrol">Petrol</option>
                                        <option value="Diesel">Diesel</option>*/}
                                      </select>
                                    </div>
                                    <div class={`${props.isMobileView ? 'col-xs-12' : 'col-xs-6'} form-group m-b-8`}>
                                      <p class="fs-12 p-b-5">Variant</p>
                                      <select class="p-l-r-0-2rem fs-1rem  h-2rem background-white border-none" style="text-transform:capitalize" type="text" id='variant' value={variant} onChange={e => {
                                        getVariantDetails(e.target.value)
                                        setVariant(e.target.value)
                                      }}>
                                        <option value="" selected>Select Variant</option>
                                        {
                                          variantList.map((variant) => (
                                            <option class="first-letter-capital" value={variant.uuid}>{variant.variantName}</option>
                                          ))
                                        }
                                      </select>
                                    </div>
                                    <div class={`${props.isMobileView ? 'col-xs-12' : 'col-xs-6'} form-group m-b-8`}>
                                      <div class="display-flex">
                                        <p class="fs-11 p-b-5 text-gray">Remark</p>
                                      </div>
                                      <input autocomplete="off" class="fs-13 h-2rem background-white border-none" type="text" name="remark" value={remark} id="remark" placeholder="Remark" onInput={(e) => setRemark(e.target.value)} />
                                    </div>
                                    <div class={`${props.isMobileView ? 'col-xs-12' : 'col-xs-6'} form-group m-b-8`}>
                                      <div class="display-flex">
                                        <p class="fs-11 p-b-5 text-gray">Reference</p>
                                      </div>
                                      <input autocomplete="off" class="fs-13 h-2rem background-white border-none" type="text" name="reference" value={referredBy} id="reference" placeholder="Reference" onInput={(e) => setRefferedBy(e.target.value)} />
                                    </div>
                                    <div class={`${props.isMobileView ? 'col-xs-12' : 'col-xs-6'} form-group m-b-8`}>
                                      <div class="display-flex">
                                        <p class="fs-11 p-b-5 text-gray">Dealer Code</p>
                                      </div>
                                      <select class="p-l-r-0-2rem fs-1rem  h-2rem background-white border-none" style="text-transform:capitalize" type="text" id='variant' value={dealerCode} onChange={e => {
                                        setDealerCode(e.target.value)
                                      }}>
                                        <option value="" selected>Select Dealer Code</option>
                                        <option class="first-letter-capital" value="W2203">W2203</option>
                                        <option class="first-letter-capital" value="W2230">W2230</option>
                                      </select>
                                    </div>
                                    {/*
                                      Modified By: Arun Singh.
                                      Modification: Add Source and subSource in create case modal.
                                      Date: 14/06/2024
                                    */}
                                    <div class={`${props.isMobileView ? 'col-xs-12' : 'col-xs-6'} form-group m-b-8`}>
                                      <div class="display-flex">
                                        <p class="fs-11 p-b-5">Source</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                      </div>
                                      <select required class="p-l-0 fs-1rem  h-2rem background-white border-none" type="text" id="source" value={source} onChange={e => {
                                        changeSource(e.target.value)
                                        if (e.target.value) {
                                          let subSourceEle = document.getElementById("source");
                                          if (subSourceEle) {
                                            subSourceEle.style.borderBottom = "1px solid #d1d1d1d1";
                                          }
                                        }
                                      }} style="text-shadow:none" required>
                                        <option value="" selected>Select Source</option>
                                        <option value="Walk-in">Walk-in</option>
                                        <option value="CRM">CRM</option>
                                        <option value="Field Generation">Field Generation</option>
                                        <option value="Incoming Call">Incoming Call</option>
                                        <option value="Referrals">Referrals</option>
                                      </select>
                                    </div>

                                    {/*
                                      Bug: T1692 - The create case modal is not user friendly. For mobile it can be one line item per line
                                      Modification: Handled sub-source and assign to role to one line each
                                      By: Devang
                                      Date: 10/07/2024
                                    */}
                                    <div class={`${props.isMobileView ? 'col-xs-12' : 'col-xs-6'} form-group m-b-8`}>
                                      <div class="display-flex">
                                        <p class="fs-11 p-b-5">Sub Source</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                      </div>
                                      <select required class="p-l-0 fs-1rem  h-2rem background-white border-none" type="text" id="subSource" value={subSource} onChange={e => {
                                        changeSubSource(e.target.value)
                                        if (e.target.value) {
                                          let subSourceEle = document.getElementById("subSource");
                                          if (subSourceEle) {
                                            subSourceEle.style.borderBottom = "1px solid #d1d1d1d1";
                                          }
                                        }
                                      }}
                                        style="text-shadow:none" required>
                                        <option value="" selected>Select Sub Source</option>
                                        {
                                          subSources && subSources.map((subSourceName) => (
                                            <option value={subSourceName}>{subSourceName}</option>
                                          ))
                                        }
                                      </select>
                                    </div>
                                    <div class={`${props.isMobileView ? 'col-xs-12' : 'col-xs-6'} form-group m-b-8`}>
                                      <div class="display-flex">
                                        <p class="fs-11 p-b-5 text-gray">Assign to Role</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                      </div>
                                      <select class=" background-white border-none" type="text" id="employee2" value={assignedTo} onChange={e => {
                                        setAssignedTo(e.target.value)
                                        getAssignToUser(e.target.value)
                                      }}
                                        style="text-shadow:none"
                                      >
                                        <option disabled={source === 'Incoming Call'} value=''>{'Select Responsible Role'}</option>
                                        <option disabled={source === 'Incoming Call'} value={'SALES MANAGER'}>{'Sales Manager'}</option>
                                        <option disabled={source === 'Incoming Call'} value={'ASST.SALES MANAGER'}>{'Sales Assistant Manager'}</option>
                                        <option disabled={source === 'Incoming Call'} value={'SALES CONSULTANT'}>{'Sales Consultant'}</option>
                                        <option disabled={source !== 'Incoming Call'} value={'CUSTOMER CARE EXECUTIVE'}>{'Customer Care Executive'}</option>
                                      </select>
                                    </div>
                                    <div class={`${props.isMobileView ? 'col-xs-12' : 'col-xs-6'} form-group m-b-8`}>
                                      <div class="display-flex">
                                        <p class="fs-11 p-b-5 text-gray">Assigned To</p><sup class="star-mandatory-entry p-l-2">*</sup>
                                      </div>
                                      <select disabled={assignedTo === ''} type="text" id="employee" class="first-letter-capital background-white border-none " onChange={(e => fillAssigneduser(e.target.value))} style="text-shadow:none">
                                        <option class="first-letter-capital" value='' selected={assignedTo === ''}>{`Select ${assignedTo ? assignedTo.toLowerCase() : 'Responsible Person'}`}</option>
                                        {assignUserList.map((user) => (
                                          <option value={user.userID} >{user.userName}</option>
                                        ))}
                                      </select>
                                    </div>
                                    <div class={`${props.isMobileView ? 'col-xs-12' : 'col-xs-6'} form-group m-b-8`} />
                                    <div class={`${props.isMobileView ? 'p-l-0 p-r-0' : ''} col-xs-3 form-group m-b-8`}>
                                      <div class={`${props.isMobileView ? 'flex-col-l p-10' : 'display-flex'}`}>
                                        <input autocomplete="off" class="fs-13 h-2rem pos-relative left-0 op-1-0" checked={wantsPriceList} type="checkbox" name="wantsPriceList" value={wantsPriceList} id="wantsPriceList" onInput={(e) => setWantsPriceList(e.target.checked)} />
                                        <p class={`${props.isMobileView ? 'p-l-0 p-t-0' : 'p-t-8 p-l-8'} fs-11 text-gray`}>Wants Price List?</p>
                                      </div>
                                    </div>
                                    <div class={`${props.isMobileView ? 'p-l-0 p-r-0' : ''} col-xs-3 form-group m-b-8`}>
                                      <div class={`${props.isMobileView ? 'flex-col-l p-10' : 'display-flex'}`}>
                                        <input autocomplete="off" class="fs-13 h-2rem pos-relative left-0 op-1-0" checked={wantsBrochure} type="checkbox" name="wantsBrochure" value={wantsBrochure} id="wantsBrochure" onInput={(e) => setWantsBrochure(e.target.checked)} />
                                        <p class={`${props.isMobileView ? 'p-l-0 p-t-0' : 'p-t-8 p-l-8'} fs-11 text-gray`}>Wants Brochure?</p>
                                      </div>
                                    </div>
                                    <div class={`${props.isMobileView ? 'p-l-0 p-r-0' : ''} col-xs-3 form-group m-b-8`}>
                                      <div class={`${props.isMobileView ? 'flex-col-l p-10' : 'display-flex'}`}>
                                        <input autocomplete="off" class="fs-13 h-2rem pos-relative left-0 op-1-0" checked={isVIPCustomer} type="checkbox" name="isVIPCustomer" value={isVIPCustomer} id="isVIPCustomer" onInput={(e) => setIsVIPCustomer(e.target.checked)} />
                                        <p class={`${props.isMobileView ? 'p-l-0 p-t-0' : 'p-t-8 p-l-8'} fs-11 text-gray`}>Is VIP Customer?</p>
                                      </div>
                                    </div>
                                    <div class={`${props.isMobileView ? 'p-l-0 p-r-0' : ''} col-xs-3 form-group m-b-8`}>
                                      <div class={`${props.isMobileView ? 'flex-col-l p-10' : 'display-flex'}`}>
                                        <input autocomplete="off" class="fs-13 h-2rem pos-relative left-0 op-1-0" checked={skipPayment} type="checkbox" name="skipPayment" value={skipPayment} id="skipPayment" onInput={(e) => setSkipPayment(e.target.checked)} />
                                        {/*
                                          Bug: T1655(2) -  BG_UI KDMS Sales Mobile - Nabanita M.
                                          Modification: Change font color of Skip payment is red.
                                          By: Arun Singh
                                          Date: 06/06/2024
                                        */}
                                        <p class={`${props.isMobileView ? 'p-l-0 p-t-0' : 'p-t-8 p-l-8'} fs-11 text-gray`}>Skip Payment?</p>
                                      </div>
                                    </div>
                                  </div>
                                )
                              }
                            </div>
                          </div>
                        )
                      }
                      {
                        isCaseCreationLoaderShown && !isCaseCreated && (
                          <div class="col-xs-12 m-t-40">
                            <div class="row p-b-10 text-gray w-full flex-c-m">
                              <img src="/assets/images/gifs/done.gif" width="192" height="192" />
                            </div>
                            <div class="col-lg-12 col-sm-12 col-md-12 m-t-40 flex-c-m">
                              <SemiInfoDetailCardV2
                                cardCaseNo={createdCase.caseID ? createdCase.caseID : "ID Not Generated"}
                                cardBgColor='#fff'
                                /*
                                  Bug: T1687 21. Add New Case Modal - Customer Name is overlapped with icons when added a new case
                                  22. Add New Case Modal - Cross icon alignment is not correct
                                  Modification: Updated cardHeight to handle and removed lh-1-0 from cardHeaderClasses
                                  By: Devang
                                  Date: 09/04/2024
                                */
                                /*
                                  Bug: T1655(1) -  BG_UI KDMS Sales Mobile - Nabanita M.
                                  Modification: Add cardHeight for mobile view.
                                  By: Arun Singh
                                  Date: 03/06/2024
                                */
                                cardHeight={props.isMobileView ? 'auto' : '116px;'}
                                masterCardStyle={props.isMobileView ? 'width: 100%;' : ''}
                                cardPadding='14px 10px 8px 32px;'
                                masterCardClasses="bor-rad-all-5 "
                                masterClasses={`${props.isMobileView ? 'w-full p-l-8' : 'p-l-32 p-r-0 w-500px'} p-t-14 p-b-8`}
                                cardTextTopClasses={"text-theme-color m-b-2 "}
                                cardHeaderClasses={"text-theme-color f-w-500 fs-14 m-t-8 "}
                                cardSubHeaderClasses={"text-orange  "}
                                /*
                                  Bug: T1687 - 24 - Add New Case - Middle Name field - Middle Name field is missing
                                  Modification: Added middleName if present
                                  By: Devang
                                  Date: 10/04/2024
                                */
                                cardHeader={createdCase && `${createdCase.salutation ? createdCase.salutation : ''} ${createdCase.firstName} ${createdCase.middleName || ''} ${createdCase.lastName ? createdCase.lastName : ''}`}
                                cardSubHeader={createdCase && createdCase.selectedModelName ? modelMapping[createdCase.selectedModelName.toLowerCase()] : '-'}
                                cardTextTop={'Individual Customer'}
                                /*
                                  Bug - T1750 - VAS is getting selected after clicking on Create Enquiry
                                  Modification - Updated active condition for vehicle and vas
                                  By: Devang
                                  Date: 15/04/2024
                                */
                                cardIcons={[
                                  { text: "Vehicle", svg: <Hyundai width="25px" height="25px" fill="#3C3C3C" />, active: createdCase && createdCase.isInterestedInVehicle ? true : false },
                                  { text: "Finance", svg: <Rupee width="23px" height="20px" fill="#3C3C3C" />, active: createdCase && createdCase.isInterestedInFinance ? true : false },
                                  { text: "Accessories", svg: <Chair2 />, active: createdCase && createdCase.isInterestedInAccessories ? true : false },
                                  { text: "Used Car", svg: <Car classes="m-b-neg-2" width="25px" height="25px" fill="#3C3C3C" />, active: createdCase && createdCase.isInterestedInExchange ? true : false },
                                  { text: "VAS", svg: <Vas2 classes="m-l-4 m-b-neg-3" height="22" width="25" />, active: createdCase && createdCase.isInterestedInVas ? true : false }]}
                                isMobileView={props.isMobileView}
                              />
                            </div>
                            <div class="col-lg-12 col-sm-12 col-md-12 m-t-15 flex-c-m gap-15px">
                              {/*
                                  Bug: KH_BG_676 Receptionist , Sales Consultant	Sales Case View - Click here to view all tasks	When clicked on "Click here to view all tasks" icon, the process view takes more time to load
                                  Modification: Disabled go to case until case and interaction are instantiated
                                  By: Devang
                                  Date: 31/01/2024
                                */}
                              <button class={`${props.isMobileView ? 'w-full m-l-0 h-40px' : 'm-l-30'} primary-button`} disabled={!isCaseInteractionInstantiated} onClick={(e) => routeToCaseView(e)}>Go to Case</button>
                              <button class={`${props.isMobileView ? 'w-full m-l-0 h-40px' : 'm-l-30'} primary-button`} onClick={(e) => toggleCreateCaseModal(e)}>Done</button>
                            </div>
                          </div>
                        )
                      }

                    </div>
                  </div>
                  {
                    /*
                      Modification: Create Enquiry button overrides with the scroll bar
                      Developer: Manohar sule
                      Date: 21/08/2023
                    */
                  }
                  {
                    /*
                      Modification: masum added mandatory sign and button disabled condition
                      Developer: Masum Raja
                      Date: 19/04/2024
                    */
                  }
                  {
                    !isCaseCreationLoaderShown && !isCaseCreated && (

                      <div class={`${props.isMobileView ? 'p-10' : 'p-t-5'} pos-relative h-40px`}>
                        {/*<button class="primary-button m-l-10" onClick={(e) => createCase(e, "details")}>Create Lead</button>*/}
                        {/*
                          Bug: KH_BG_674 Receptionist , Sales Consultant Sales Actionable - Accountibility - Case Entry	If the user does not enter a mobile number while creating a case, a case is created, but the entry is not reflected in the respective role.
                          Modification: Added condition to disable create enquiry button if number is not entered
                          By: Devang
                          Date: 31/01/2024
                        */}
                        {/*
                          Modification: Remove Duplicate disabled and add disabled condition
                          By: Masum Raja
                          Date: 23/04/2024
                        */}
                        <button class={`${props.isMobileView ? 'w-full' : 'm-l-10 right-40px pos-absolute'} primary-button`} disabled={(!mobNumber || mobNumber && mobNumber.length !== 10) || !contactCreatedUuid || assignResposiblePerson === "" || customerName === '' || lastName === "" || model === "" || assignedTo === ""} onClick={(e) => createCase(e, "instantiate")}>Create Enquiry</button>
                      </div>
                    )
                  }

                </div>
              </div>
            </div>
          </div>
        )
      }
      {
        isCreateInsuranceCaseModalOpen && (
          <div class='orgChartModal'>
            <div id="modelCaseModal" style="display:block;" class="org-chart-modal">
              <div class="card org-chart-modal-content org-chart-width p-b-16 p-t-0 p-r-0 p-l-0">
                <div class="pos-relative">
                  <div class={`modal-header`}>
                    <span class='fs-12'>
                      <div class="display-flex">
                        <ul class='breadrcrumb_arrows_inverted m-r-8'>
                          <li>Add New Insurance Case</li>
                        </ul>
                      </div>
                    </span>
                    <span class="modal-close" onClick={(e) => { toggleInsuranceCreateCaseModal(e); }}>&times;</span>
                  </div>
                  <div class="org-chart-modal-body background-transparent" style="height:40vh; overflow:auto">
                    <div class="row">
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-t-5 display-flex justify-center flex-column">
                        {createInsuranceCaseLoader ?
                          <div class="text-center m-t-20">
                            <img src="/assets/images/gifs/done.gif" width="160" height="160" />
                            {caseDetail == "New" ? <p>Creating a New Case</p> : <p>Creating a New Renewal Case</p>}
                          </div>
                          :
                          <div class="m-b-10">
                            {/*
                              Bug: T1843 - EN - Insurance -Add New Insurance Renewal Case - While adding a case System should check if VIN is already existing.
                              Modification: Updated UI for accepting and validating vin
                              By: Devang
                              Date: 02/07/2024
                            */}
                            <div class="p-b-10" >
                              <p> Select Type of Case <span class="star-mandatory-entry p-l-2">*</span></p>
                              <select class="p-l-r-0-2rem text-4b4d51 fs-1rem h-2rem text-4b4d51 background-white" type="text" name="case" value={typeOfCaseInsurance} onChange={(e) => {
                                setTypeOfCaseInsurance(e.target.value); setCaseDetail(e.target.value);
                              }} style="text-shadow:none">
                                <option value=''>Select Type of Case</option>
                                {/*<option value="New">New</option>*/}
                                {(userDesignation.toLowerCase() !== "accounts manager" && userDesignation.toLowerCase() !== "accounts executive" && userDesignation.toLowerCase() !== "sales accounts executive") && <option value="Renewal">Renewal</option>}
                              </select>
                            </div>
                            <div class="p-b-10">
                              <p>Search VIN
                                <span class="star-mandatory-entry p-l-2">*</span>
                              </p>
                              <input autocomplete="off" class="first-letter-capital"
                                name="searchVin"
                                id="searchVin"
                                type="text"
                                value={vinNumber}
                                required="true"
                                placeholder='Search VIN Number'
                                onInput={handleVinNumber}
                              />
                            </div>
                            <div class={`${!props.isMobileView && 'flex-sb'} p-b-10`}>
                              <div class={`${props.isMobileView ? 'w-full m-b-10' : 'w-auto'}`}>
                                {
                                  isCaseErrorMsg &&
                                  <>
                                    <p className='fs-15 red-text'>{`There is a ${typeOfCase} case which already exists with the entered VIN in our system.`}</p>
                                    <p className='fs-15 red-text'>{'If you want to create a new case for this existing VIN, please search the VIN via Global search and reopen the case from the Process View.'}</p>
                                  </>
                                }
                              </div>
                              <button disabled={!typeOfCaseInsurance || !vinNumber} class={`${props.isMobileView && 'w-full'} primary-button`} onClick={(e) => createInsuranceCase(e)}>Create Insurance Renewal Case</button>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
      {
        isCreateBookingCaseModalOpen && (
          <div class='orgChartModal'>
            <div id="modelCaseModal" style="display:block;" class="org-chart-modal">
              <div class="card org-chart-modal-content org-chart-width p-b-16 p-t-0 p-r-0 p-l-0">
                <div class="pos-relative">
                  <div class={`modal-header`}>
                    <span class='fs-12'>
                      <div class="display-flex">
                        <ul class='breadrcrumb_arrows_inverted m-r-8'>
                          <li>Add New Bookinggg</li>
                        </ul>
                      </div>
                    </span>
                  </div>
                  <div class="org-chart-modal-body background-transparent" style="height:40vh; overflow:auto">
                    <div class="row">
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-t-5 display-flex justify-center flex-column">
                        <div class="text-center m-t-20">
                          <img src="/assets/images/Loading_icon.gif" width="160" height="160" />
                          <p>Creating a New Booking Case</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
      {
        isDigitalLeadModalOpen && (
          <div class='orgChartModal'>
            <div id="modelCaseModal" style="display:block;" class="org-chart-modal">
              <div class="card org-chart-modal-content org-chart-width p-b-16 p-t-0 p-r-0 p-l-0">
                <div class="pos-relative">
                  <div class={`modal-header`}>
                    <span class='fs-12'>
                      <div class="display-flex">
                        <ul class='breadrcrumb_arrows_inverted m-r-8'>
                          <li>Add New Digital Lead</li>
                        </ul>
                      </div>
                    </span>
                  </div>
                  <div class="org-chart-modal-body background-transparent" style="height:40vh; overflow:auto">
                    <div class="row">
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-t-5 display-flex justify-center flex-column">
                        <div class="text-center m-t-20">
                          <img src="/assets/images/Loading_icon.gif" width="150" height="100" />
                          <p>Creating a New Digital Lead</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
      {
        isViewCreatedCaseModalOpen && (
          <div class='orgChartModal'>
            <div id="modelCaseModal" style="display:block;" class="org-chart-modal">
              <div class="card org-chart-modal-content org-chart-width">
                <div>
                  <div class="right-drawer-label" onClick={(e) => toggleViewCaseDetailsModal(e)}>
                    <div class="right-drawer-close-btn" title="Close">
                      <div class="right-drawer-close-btn-inner" />
                    </div>
                  </div>
                  <div class="org-chart-modal-body background-transparent pos-relative" style="height:75vh; overflow:auto">
                    <div class="row">
                      <div class="col-lg-4 col-xs-12 p-l-0 p-r-8 h-78px">
                        <SemiInfoDetailCard
                          cardBgColor='#fff'
                          cardHeight='inherit'
                          ribbons={[
                            { text: createdInteraction && createdInteraction.dynamicProperties_typeOfEnquiry, color: typeOfEnquiryMappingClassColor[createdInteraction && createdInteraction.dynamicProperties_typeOfEnquiry], type: 'rotated', variant: '', isTextNotVisible: true },
                            { text: createdInteraction && createdInteraction.dynamicProperties_source, color: 'green', type: 'folded', variant: 'primary' },
                            { text: createdInteraction && createdInteraction.dynamicProperties_typeOfCustomer, color: 'yellow', type: 'folded', variant: 'secondary' },
                          ]}
                          cardHeader={createdInteraction && `${createdInteraction.dynamicProperties_salutation && createdInteraction.dynamicProperties_salutation} ${createdInteraction.dynamicProperties_firstName} ${createdInteraction.dynamicProperties_lastName}`}
                          cardSubHeader={createdInteraction && createdInteraction.dynamicProperties_typeOfBuyer ? createdInteraction.dynamicProperties_typeOfBuyer : '-'}
                          //cardText2={createdInteraction && `${createdInteraction.dynamicProperties_area && createdInteraction.dynamicProperties_area}, ${(createdInteraction && createdInteraction.dynamicProperties_city) && createdInteraction.dynamicProperties_city}`}
                          cardIcon={<Folder width="40px" height="40px" viewBox="-33 -40 512 512" fill="#ddf0f3" bgFill="#fff" />}
                        />
                      </div>
                      <div class="col-lg-4 col-xs-12 p-l-0 p-r-8 h-78px">
                        <SemiInfoDetailCard
                          cardBgColor='#fff'
                          cardHeight='inherit'
                          ribbons={[
                            { text: "Delivered", color: 'green', type: 'folded', variant: 'primary' },
                          ]}
                          cardHeader={createdInteraction && createdInteraction.dynamicProperties_selectedVariantName ? createdInteraction.dynamicProperties_selectedVariantName : createdInteraction.dynamicProperties_selectedModelName ? modelMapping[createdInteraction.dynamicProperties_selectedModelName] : '-'}
                          cardText1={`${createdInteraction && createdInteraction.dynamicProperties_selectedFuelType ? createdInteraction.dynamicProperties_selectedFuelType : '-'} | ${createdInteraction && createdInteraction.dynamicProperties_transmissionType ? createdInteraction.dynamicProperties_transmissionType : '-'} | ${createdInteraction && createdInteraction.dynamicProperties_selectedColor ? createdInteraction.dynamicProperties_selectedColor : '-'}`}
                          //cardSubHeader={`${createdInteraction && createdInteraction.dynamicProperties_customerExpectedDeliveryDate ? `Expected Date of Delivery - ${formatDateTime(createdInteraction.dynamicProperties_customerExpectedDeliveryDate)}` : 'No Expected Date of Delivery'}`}
                          cardIcon={<Hyundai width="60px" height="60px" fill="#ddf0f3" viewBox="-17 -39 150 150" />}
                        />
                      </div>
                      <div class="col-lg-4 col-xs-12 p-l-0 p-r-8 h-78px">
                        <SemiInfoDetailCard
                          cardBgColor='#fff'
                          cardHeight='inherit'
                          ribbons={[
                            { text: "Sales Executive", color: 'green', type: 'folded', variant: 'primary' },
                            { text: "W2203", color: 'yellow', type: 'folded', variant: 'secondary' },
                          ]}
                          cardHeader={createdInteraction && createdInteraction.dynamicProperties_salesConsultant ? createdInteraction.dynamicProperties_salesConsultant : '-'}
                          cardSubHeader={userInfo?.userBranchName || 'Shankar Sheth Road'}
                          cardIcon={<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="45px" height="45px" viewBox="-175 -21 463.291 545.291" style="enable-background:new 0 0 481.291 481.291;" style="float: right;" fill="#ddf0f3"><g><g id="Layer_2_16_"><g><path d="M138.814,146.22c3.12,40.976,19.417,23.314,22.779,41.27c5.59,29.848,32.016,51.436,48.466,58.893     c9.597,4.348,19.48,6.53,29.871,6.704v0.009c0.036,0,0.072-0.004,0.108-0.004s0.072,0.004,0.108,0.004v-0.009     c10.39-0.174,20.272-2.355,29.871-6.704c16.45-7.457,42.876-29.045,48.466-58.893c3.362-17.955,19.659-0.294,22.779-41.27     c0-16.33-8.898-20.394-8.898-20.394s4.523-24.171,6.295-42.77C340.854,59.877,325.129,0,241.25,0     c-0.367,0-0.707,0.02-1.065,0.024c-0.013,0-0.025,0-0.038-0.001V0.019c-0.036,0.001-0.072,0.002-0.108,0.002     s-0.072-0.001-0.108-0.002v0.005c-0.013,0.001-0.025,0.001-0.038,0.001c-0.358-0.005-0.698-0.024-1.065-0.024     c-83.878,0-99.604,59.877-97.409,83.056c1.771,18.599,6.295,42.77,6.295,42.77S138.814,129.89,138.814,146.22z"></path><path d="M430.313,347.371c-42.308-21.523-103.63-48.406-106.573-49.355c-0.033-0.012-0.058-0.014-0.09-0.024     c-1.721-0.613-3.571-0.953-5.504-0.953c-7.188,0-13.285,4.604-15.547,11.021c-0.012-0.008-0.024-0.013-0.036-0.021     c-10.92,26.315-30.979,73.223-43.434,95.842l-3-63.413c0,0,18.705-39.699,20.752-43.336c4.82-8.525,0.479-15.783-8.557-15.783     c-4.482,0-15.695,0-26.926,0c-0.013,0-0.025,0-0.038,0c-0.072,0-0.144,0-0.216,0c-0.013,0-0.025,0-0.038,0     c-0.154,0-0.308,0-0.462,0s-0.308,0-0.462,0c-0.013,0-0.025,0-0.038,0c-0.072,0-0.144,0-0.216,0c-0.013,0-0.025,0-0.038,0     c-11.23,0-22.442,0-26.926,0c-9.036,0-13.376,7.258-8.557,15.783c2.048,3.637,20.752,43.336,20.752,43.336l-2.999,63.413     c-12.455-22.619-32.514-69.524-43.434-95.842c-0.012,0.008-0.024,0.013-0.036,0.021c-2.262-6.414-8.359-11.021-15.547-11.021     c-1.933,0-3.783,0.34-5.504,0.953c-0.032,0.012-0.057,0.015-0.09,0.024c-2.942,0.949-64.265,27.832-106.573,49.355     c-19,9.666-30.467,21.688-30.467,34.34c0,41.826,0,99.58,0,99.58h219.227h0.191h0.105h0.006h0.107h0.191h0.309h0.309h0.191h0.105     h0.006h0.105h0.191H460.78c0,0,0-57.754,0-99.58C460.779,369.059,449.313,357.037,430.313,347.371z"></path></g></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }
      {/*
        Modification: stock drawer component
        By: Masum Raja
        Date: 20/03/2024
      */}
      {
        isStockDetailModalOpen &&
        <StockRightDrawer
          isStockDetailModalOpen={isStockDetailModalOpen}
          setIsStockDetailModal={setIsStockDetailModal}
          activeStockTab={activeStockTab}
          setActiveStockTab={setActiveStockTab}
          selectedStockType={selectedStockType}
          setSelectedStockType={setSelectedStockType}
          toggleStockDetailsModal={toggleStockDetailsModal}
          catalogoueItemList={catalogoueItemList}
          isMobileView={props.isMobileView}
        />
      }
      <div class='orgChartModal'>
        <div id="floatingModal" class={`org-chart-modal`} style={`display: ${isPriceListModalOpen ? "block" : "none"}`}>
          <div class="org-chart-modal-content org-chart-width" style='padding: 0px !important'>
            <div>
              <div class={`modal-header`}>
                <span class='fs-12'>
                  <div class="display-flex">
                    <ul class='breadrcrumb_arrows_inverted m-r-8'>
                      <li>Price List</li>
                    </ul>
                  </div>
                </span>
                <span class="modal-close" onClick={(e) => togglePriceListModal(e)}>&times;</span>
              </div>
              <div class="org-chart-modal-body background-transparent" style='padding: 30px 0px !important'>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 m-t-5 display-flex justify-center flex-column">
                    <div class="row">
                      <div class="col-xs-12">
                        <div class="row">
                          <div class="col-xs-12">
                            <p for="interestedCar" class="form-label ">Model</p>
                            <select style="width:100%" type="text" id="interestedCar" onChange={e => selectedCarModel(e.target.value)}>
                              <option class="first-letter-capital" value="" selected={modelForPriceList === ''}>Select Model</option>
                              {catalogoueItemList.map((item) => (
                                <option class="first-letter-capital" value={item.model} selected={modelForPriceList === item.model}>{item.displayName}</option>
                              ))}
                            </select>
                            <button onClick={(e) => priceList()} disabled={disablePDFButton}>Download PDF</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="visitmodalslide">
        <Modal title="New Visit" modalSize="is-large-medium" isProfileModal
          modalDisplay={(isVisitModalOpen ? 'show-modal' : 'hide-modal')} onClose={(e) => closeVisitModal(e)} closeID={'CustomerVisitMenu'}
        >
          {
            isVisitModalOpen && (
              <Createvisitmodal triggerNotifications={props.triggerNotifications} open={isVisitModalOpen} onClose={(e) => closeVisitModal(e)} toggleCreateVisitModal={toggleCreateVisitModal} />
            )
          }
        </Modal>
      </div>
      {
        isCourierModalOpen && (
          <div class="couriermodalslide">
            <Courierworkspacemodal open={isCourierModalOpen} toggleCloseCourierModal={toggleCloseCourierModal} onClose={(e) => CourierModalclose(e)} />
          </div>
        )
      }
      {
        isAddNuclearTaskModalVisible &&
        <AddNuclearTaskModal isAddNuclearTaskModalVisible={isAddNuclearTaskModalVisible} setIsAddNuclearTaskModalVisible={setIsAddNuclearTaskModalVisible} />
      }
      <div class="visitmodalslide">
        <Modal title="Recently Viewed List" modalSize="is-small-filter" isProfileModal
          modalDisplay={(isRecentlyViewedModalVisible ? 'show-modal' : 'hide-modal')} onClose={(e) => toggleRecentlyViewedModal(e)} >
          <RecentlyViewed isVisible={isRecentlyViewedModalVisible} userID={userInfo.uuid} listType='recentlyViewed' title='Recently Viewed List' />
        </Modal>
      </div>
      <div class="visitmodalslide">
        <Modal title="Followed Cases List" modalSize="is-small-filter" isProfileModal
          modalDisplay={(isFollowedCasesModalVisible ? 'show-modal' : 'hide-modal')} onClose={(e) => toggleFollowedCasesModal(e)} >
          <RecentlyViewed isVisible={isFollowedCasesModalVisible} userID={userInfo.uuid} listType='followedCases' title="Followed Cases List" />
        </Modal>
      </div>
      {/*
        Modification: T319 (Change Taken From Comp's caseSemiDetailViewV3) - Added task completion error modal
        By: Ashutosh G
        Date: 21/05/2024
      */}
      {
        isShowTaskCompletionError &&
        <TaskErrorModal
          isShowTaskCompletionError={isShowTaskCompletionError}
          taskCompletionErrorHeader={taskCompletionErrorHeader}
          taskCompletionError={taskCompletionError}
          currentTask={currentRow}
          toggleTaskCompletionError={toggleTaskCompletionError}
        />
      }
      {/* 
      BN: T3945
      Feature: Unsaved Changes Warning
      By: Priya
      Date: 04/08/26*/}

      {
        showUnsavedChangesWarning &&
        <div
          class="unsaved-changes-overlay"
          style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(6, 20, 31, 0.45); z-index: 900000; display: flex; align-items: center; justify-content: center;"
        >
          <div
            class="unsaved-changes-dialog"
            style="background: #ffffff; width: 420px; max-width: 90vw; border-radius: 8px; padding: 24px; box-shadow: 0 4px 24px rgba(0,0,0,0.3);"
          >
            <div class="fs-16 f-w-600 m-b-8" style="color: #06141f;">Unsaved Changes</div>
            <div class="fs-14 m-b-16" style="color: #555555; line-height: 1.4;">
              You have unsaved changes on this form. If you leave now, these changes will be lost. Do you want to continue?
            </div>
            <div style="display: flex; justify-content: flex-end; gap: 8px;">
              <button style="padding: 8px 16px; border-radius: 4px; border: 1px solid #d1d1d1; background: #ffffff; color: #06141f; cursor: pointer; font-size: 14px;" onClick={stayOnDigitalLeadForm}>Stay on this page</button>
              <button style="padding: 8px 16px; border-radius: 4px; border: none; background: #d9534f; color: #ffffff; cursor: pointer; font-size: 14px;" onClick={confirmCloseDigitalLeadForm}>Leave without saving</button>
            </div>
          </div>
        </div>
      }
      {/*
        BN:13
        Modification: Duplicate Lead Popup
        By: Priya Gupta
        Date: 01/10/26
      */}
      {
        isDuplicateLeadModalOpen &&
        <div
          class="duplicate-lead-overlay"
          style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(6, 20, 31, 0.45); z-index: 900000; display: flex; align-items: center; justify-content: center;"
        >
          <div
            class="duplicate-lead-dialog"
            style="background: #ffffff; width: 760px; max-width: 94vw; border-radius: 8px; padding: 24px; box-shadow: 0 4px 24px rgba(0,0,0,0.3);"
          >
            <div class="fs-16 f-w-600 m-b-8" style="color: #06141f;">Lead Already Exists</div>
            <div class="fs-14 m-b-16" style="color: #555555; line-height: 1.4;">
              A lead with the same mobile number, model, and variant already exists. This lead has been saved as a duplicate.
            </div>
            {
              duplicateLeadInfo.duplicateInteractions && duplicateLeadInfo.duplicateInteractions.length ?
                <div style="max-height: 320px; overflow: auto; border: 1px solid #e5e5e5; border-radius: 6px; margin-bottom: 16px;">
                  <table style="width: 100%; border-collapse: collapse; font-size: 13px; color: #333333;">
                    <thead>
                      <tr style="background: #f7f8fa; color: #06141f;">
                        <th style="text-align: left; padding: 10px 8px; border-bottom: 1px solid #e5e5e5;">Case</th>
                        <th style="text-align: left; padding: 10px 8px; border-bottom: 1px solid #e5e5e5;">Mobile</th>
                        <th style="text-align: left; padding: 10px 8px; border-bottom: 1px solid #e5e5e5;">Model</th>
                        <th style="text-align: left; padding: 10px 8px; border-bottom: 1px solid #e5e5e5;">Variant</th>
                        <th style="text-align: left; padding: 10px 8px; border-bottom: 1px solid #e5e5e5;">Sub Source</th>
                        <th style="text-align: left; padding: 10px 8px; border-bottom: 1px solid #e5e5e5;">CRE</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        duplicateLeadInfo.duplicateInteractions.map((interaction) => (
                          <tr key={interaction.uuid} style={interaction.isNewDuplicate ? 'background: #fff8e8;' : ''}>
                            <td style="padding: 10px 8px; border-bottom: 1px solid #eeeeee;">
                              {interaction.caseID || '-'}
                              {interaction.isNewDuplicate && <span style="display: inline-block; margin-left: 6px; padding: 2px 6px; border-radius: 4px; background: #f0b429; color: #06141f; font-size: 11px;">New</span>}
                            </td>
                            <td style="padding: 10px 8px; border-bottom: 1px solid #eeeeee;">{interaction.mobile || '-'}</td>
                            <td style="padding: 10px 8px; border-bottom: 1px solid #eeeeee;">{interaction.selectedModelName || '-'}</td>
                            <td style="padding: 10px 8px; border-bottom: 1px solid #eeeeee;">{interaction.selectedVariantName || '-'}</td>
                            <td style="padding: 10px 8px; border-bottom: 1px solid #eeeeee;">{interaction.subSource || '-'}</td>
                            <td style="padding: 10px 8px; border-bottom: 1px solid #eeeeee;">{interaction.creName || '-'}</td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                </div>
                :
                <div class="fs-14 m-b-16" style="color: #555555; line-height: 1.6;">
                  <div><span class="f-w-600">Sub Source:</span> {duplicateLeadInfo.subSource || '-'}</div>
                  <div><span class="f-w-600">CRE:</span> {duplicateLeadInfo.creName || '-'}</div>
                </div>
            }
            <div style="display: flex; justify-content: flex-end;">
              <button
                style="padding: 8px 16px; border-radius: 4px; border: none; background: #06141f; color: #ffffff; cursor: pointer; font-size: 14px;"
                onClick={closeDuplicateLeadModal}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      }
      {/*
        By: Arun Singh
        On: 22nd June 2024
        Modification: Modal for searching and creating the legacy active case.
      */}
      {isSchedulerLegacyFormPopover &&
        <NewPopupModal classes="formModal" modalWidth={"65%"} modalDisplay={('show-formPopover')} onClose={(e) => toggleEditSchedulerLegacyFormPopover(e)}>
          <div class="enquiryForm background-transparent h-full">
            <div class="row p-t-10 p-l-30 p-r-30 p-b-10" style="background:#f7f7f7;border-bottom:1px solid lightgrey">
              <div class="col-xs-8">
                <span class="formHeader display-flex">
                  <h4 class="m-t-5 m-b-0 text-up">Create Legacy Active Legacy</h4>
                </span>
              </div>
            </div>
            {
              (!schedulerCreationLoader && schedulerLegacyCases && schedulerLegacyCases.rows && schedulerLegacyCases.rows.length > 0) && (
                <div>
                  <NewListV2 entityTitle={`Legacy Case`} entityName={`Interaction`} dataset={schedulerLegacyCases} headClasses={`bor-rad-t-r-5 bor-rad-t-l-5 shadow1`} lastColumnClasses={`bor-rad-b-r-5 bor-rad-b-l-5`} rowAction={routeToResultRowPage} isFirstColumnEntityNameIcon isShowHighlightText highlightedText={searchQuery} />
                  {!schedulerCaseCreatedLoader && (schedulerLegacyCases && schedulerLegacyCases.rows && schedulerLegacyCases.rows.length === 1) && <button onClick={(e) => runSchedulerForLegacyCase(e)} class="primary-button m-r-16 float-right" disabled={!searchQuery}>Create an active case</button>}
                  {!schedulerCaseCreatedLoader && (schedulerLegacyCases && schedulerLegacyCases.rows && schedulerLegacyCases.rows.length > 1) && <p class="text-color-red fs-10">There are more than one case found for your query. Please make sure you are creating a case whose active case does not exist.</p>}
                </div>
              )
            }
            {(schedulerSearchLoader && (!schedulerLegacyCases || !schedulerLegacyCases.rows || schedulerLegacyCases.rows.length === 0)) &&
              <div class="text-center sizefull flex-col-c-m">
                <img src="/assets/images/gifs/done.gif" width="300" height="300" />
                <p>Searching Your Case</p>
              </div>
            }
            {(schedulerCreationLoader) &&
              <div class="text-center sizefull flex-col-c-m">
                <img src="/assets/images/gifs/done.gif" width="300" height="300" />
                <p>Creating Your Case</p>
              </div>
            }
            {(!schedulerSearchLoader && (!schedulerLegacyCases || !schedulerLegacyCases.rows || schedulerLegacyCases.rows.length === 0)) &&
              <div id="formModalContainer" class="formModalContainer">
                <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8 m-t-15">
                  <p class="formLabel fs-15 p-b-3">Search Case ID
                    <span class="star-mandatory-entry p-l-2">*</span>
                  </p>
                  <input autocomplete="off" class="first-letter-capital"
                    onClick={(e) => inputClicked(e)}
                    name="searchQuery"
                    id="searchQuery"
                    type="text"
                    value={searchQuery}
                    required="true"
                    onInput={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
                <button onClick={() => searchCaseForScheduler()} class="primary-button m-r-16 float-right" disabled={!searchQuery}>Search Case</button>
              </div>}
          </div>
        </NewPopupModal>
      }
    </div>
  );
};

export default RightPanel;
